import '../BarChart.css';var t0 = Object.defineProperty;
var r0 = (e, t, r) => t in e ? t0(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Oi = (e, t, r) => r0(e, typeof t != "symbol" ? t + "" : t, r);
import { jsx as G, jsxs as Wt, Fragment as Ih } from "react/jsx-runtime";
import * as A from "react";
import dn, { isValidElement as yt, forwardRef as Le, createContext as Ge, useContext as rt, useMemo as Ve, useState as be, useRef as X, useCallback as ne, useEffect as se, useImperativeHandle as kh, useLayoutEffect as Ue, cloneElement as $a, createElement as Ch, Children as n0, memo as Ku, PureComponent as i0 } from "react";
import { S as a0 } from "../Slider-DqW9wmIz.js";
import { T as o0, b as u0, c as Si } from "../Tabs-C2xwXioF.js";
import { c as le } from "../clsx-OuTLNxxd.js";
import { g as l0 } from "../_commonjsHelpers-DaMA6jEr.js";
import { createPortal as Th } from "react-dom";
import { r as c0 } from "../index-CV3qP_xA.js";
var s0 = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
function Vu(e) {
  if (typeof e != "string")
    return !1;
  var t = s0;
  return t.includes(e);
}
var f0 = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it, and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], d0 = new Set(f0);
function Mh(e) {
  return typeof e != "string" ? !1 : d0.has(e);
}
function jh(e) {
  return typeof e == "string" && e.startsWith("data-");
}
function ur(e) {
  if (typeof e != "object" || e === null)
    return {};
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (Mh(r) || jh(r)) && (t[r] = e[r]);
  return t;
}
function Hu(e) {
  if (e == null)
    return null;
  if (/* @__PURE__ */ yt(e) && typeof e.props == "object" && e.props !== null) {
    var t = e.props;
    return ur(t);
  }
  return typeof e == "object" && !Array.isArray(e) ? ur(e) : null;
}
function Tt(e) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (Mh(r) || jh(r) || Vu(r)) && (t[r] = e[r]);
  return t;
}
var h0 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Jo() {
  return Jo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Jo.apply(null, arguments);
}
function v0(e, t) {
  if (e == null) return {};
  var r, n, i = p0(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function p0(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var Dh = /* @__PURE__ */ Le((e, t) => {
  var r = e.children, n = e.width, i = e.height, a = e.viewBox, o = e.className, u = e.style, l = e.title, c = e.desc, s = v0(e, h0), f = a || {
    width: n,
    height: i,
    x: 0,
    y: 0
  }, d = le("recharts-surface", o);
  return /* @__PURE__ */ A.createElement("svg", Jo({}, Tt(s), {
    className: d,
    width: n,
    height: i,
    style: u,
    viewBox: "".concat(f.x, " ").concat(f.y, " ").concat(f.width, " ").concat(f.height),
    ref: t
  }), /* @__PURE__ */ A.createElement("title", null, l), /* @__PURE__ */ A.createElement("desc", null, c), r);
}), m0 = ["children", "className"];
function eu() {
  return eu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, eu.apply(null, arguments);
}
function y0(e, t) {
  if (e == null) return {};
  var r, n, i = g0(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function g0(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var gt = /* @__PURE__ */ A.forwardRef((e, t) => {
  var r = e.children, n = e.className, i = y0(e, m0), a = le("recharts-layer", n);
  return /* @__PURE__ */ A.createElement("g", eu({
    className: a
  }, Tt(i), {
    ref: t
  }), r);
});
function tu(e) {
  return e === "__proto__";
}
const b0 = /\.|(\[(?:[^[\]]*|(["'])(?:(?!\2)[^\\]|\\.)*?\2)\])/;
function Nh(e) {
  switch (typeof e) {
    case "number":
    case "symbol":
      return !1;
    case "string":
      return e === "" || e.startsWith(".") || e.endsWith(".") ? !1 : b0.test(e);
    default:
      return !1;
  }
}
function Gu(e) {
  var t;
  return typeof e == "string" || typeof e == "symbol" ? e : Object.is((t = e == null ? void 0 : e.valueOf) == null ? void 0 : t.call(e), -0) ? "-0" : String(e);
}
function x0(e) {
  return e == null ? "" : $h(e);
}
function $h(e) {
  if (typeof e == "string") return e;
  if (Array.isArray(e)) return e.map($h).join(",");
  const t = String(e);
  return t === "0" && Object.is(Number(e), -0) ? "-0" : t;
}
function Yu(e) {
  if (Array.isArray(e)) return e.map(Gu);
  if (typeof e == "symbol") return [e];
  e = x0(e);
  const t = [], r = e.length;
  if (r === 0) return t;
  let n = 0, i = "", a = "", o = !1, u = !1;
  const l = /^-?\d+(?:\.\d+)?$/;
  for (e.charCodeAt(0) === 46 && t.push(""); n < r; ) {
    const c = e[n];
    if (a) c === "\\" && n + 1 < r ? (n++, i += e[n]) : c === a ? a = "" : i += c;
    else if (o) if (c === '"' || c === "'")
      a = c, u = !0;
    else if (c === "]") {
      if (o = !1, !u && i.includes(".") && !l.test(i)) {
        const s = i.split(".");
        for (let f = 0; f < s.length; f++) s[f] !== "" && t.push(s[f]);
      } else t.push(i);
      i = "";
    } else i += c;
    else if (c === "[")
      o = !0, u = !1, i && (t.push(i), i = "");
    else if (c === ".") {
      i && (t.push(i), i = "");
      const s = e[n + 1];
      (s === void 0 || s === ".") && t.push("");
    } else i += c;
    n++;
  }
  return i && t.push(i), t;
}
function Kt(e, t, r) {
  if (e == null) return r;
  switch (typeof t) {
    case "string": {
      if (tu(t)) return r;
      const n = e[t];
      return n === void 0 ? Nh(t) && !Object.hasOwn(e, t) ? Kt(e, Yu(t), r) : r : n;
    }
    case "number":
    case "symbol": {
      typeof t == "number" && (t = Gu(t));
      const n = e[t];
      return n === void 0 ? r : n;
    }
    default: {
      if (Array.isArray(t)) return w0(e, t, r);
      if (Object.is(t == null ? void 0 : t.valueOf(), -0) ? t = "-0" : t = String(t), tu(t)) return r;
      const n = e[t];
      return n === void 0 ? r : n;
    }
  }
}
function w0(e, t, r) {
  if (t.length === 0) return r;
  let n = e;
  for (let i = 0; i < t.length; i++) {
    if (n == null || tu(t[i])) return r;
    n = n[t[i]];
  }
  return n === void 0 ? r : n;
}
var A0 = 4;
function ir(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : A0, r = 10 ** t, n = Math.round(e * r) / r;
  return Object.is(n, -0) ? 0 : n;
}
function Ce(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return e.reduce((i, a, o) => {
    var u = r[o - 1];
    return typeof u == "string" ? i + u + a : u !== void 0 ? i + ir(u) + a : i + a;
  }, "");
}
var Je = (e) => e === 0 ? 0 : e > 0 ? 1 : -1, Mt = (e) => typeof e == "number" && e != +e, Tr = (e) => typeof e == "string" && e.length > 1 && e.indexOf("%") === e.length - 1, $ = (e) => (typeof e == "number" || e instanceof Number) && !Mt(e), ut = (e) => $(e) || typeof e == "string", O0 = 0, Un = (e) => {
  var t = ++O0;
  return "".concat(e || "").concat(t);
}, bt = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!$(t) && typeof t != "string")
    return n;
  var a;
  if (Tr(t)) {
    if (r == null)
      return n;
    var o = t.indexOf("%");
    a = r * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return Mt(a) && (a = n), i && r != null && a > r && (a = r), a;
}, Lh = (e) => {
  if (!Array.isArray(e))
    return !1;
  for (var t = e.length, r = {}, n = 0; n < t; n++)
    if (!r[String(e[n])])
      r[String(e[n])] = !0;
    else
      return !0;
  return !1;
};
function De(e, t, r) {
  return $(e) && $(t) ? ir(e + r * (t - e)) : t;
}
function S0(e, t, r) {
  if (!(!e || !e.length))
    return e.find((n) => n && (typeof t == "function" ? t(n) : Kt(n, t)) === r);
}
var xe = (e) => e === null || typeof e > "u", qu = (e) => xe(e) ? e : "".concat(e.charAt(0).toUpperCase()).concat(e.slice(1));
function _t(e) {
  return e != null;
}
function hn() {
}
function Xu(e) {
  if (e)
    return {
      x: e.x,
      y: e.y,
      upperWidth: "upperWidth" in e ? e.upperWidth : e.width,
      lowerWidth: "lowerWidth" in e ? e.lowerWidth : e.width,
      width: e.width,
      height: e.height
    };
}
function Pc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pc(Object(r), !0).forEach(function(n) {
      E0(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pc(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E0(e, t, r) {
  return (t = _0(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _0(e) {
  var t = P0(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function P0(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var I0 = (e) => {
  var t = e.viewBox, r = e.position, n = e.offset, i = n === void 0 ? 0 : n, a = e.parentViewBox, o = Xu(t), u = o.x, l = o.y, c = o.height, s = o.upperWidth, f = o.lowerWidth, d = u, h = u + (s - f) / 2, v = (d + h) / 2, p = (s + f) / 2, m = d + s / 2, y = c >= 0 ? 1 : -1, b = y * i, w = y > 0 ? "end" : "start", x = y > 0 ? "start" : "end", O = s >= 0 ? 1 : -1, g = O * i, S = O > 0 ? "end" : "start", P = O > 0 ? "start" : "end", k = a;
  if (r === "top") {
    var T = {
      x: d + s / 2,
      y: l - b,
      horizontalAnchor: "middle",
      verticalAnchor: w
    };
    return k && (T.height = Math.max(l - k.y, 0), T.width = s), T;
  }
  if (r === "bottom") {
    var I = {
      x: h + f / 2,
      y: l + c + b,
      horizontalAnchor: "middle",
      verticalAnchor: x
    };
    return k && (I.height = Math.max(k.y + k.height - (l + c), 0), I.width = f), I;
  }
  if (r === "left") {
    var _ = {
      x: v - g,
      y: l + c / 2,
      horizontalAnchor: S,
      verticalAnchor: "middle"
    };
    return k && (_.width = Math.max(_.x - k.x, 0), _.height = c), _;
  }
  if (r === "right") {
    var L = {
      x: v + p + g,
      y: l + c / 2,
      horizontalAnchor: P,
      verticalAnchor: "middle"
    };
    return k && (L.width = Math.max(k.x + k.width - L.x, 0), L.height = c), L;
  }
  var D = k ? {
    width: p,
    height: c
  } : {};
  return r === "insideLeft" ? Ot({
    x: v + g,
    y: l + c / 2,
    horizontalAnchor: P,
    verticalAnchor: "middle"
  }, D) : r === "insideRight" ? Ot({
    x: v + p - g,
    y: l + c / 2,
    horizontalAnchor: S,
    verticalAnchor: "middle"
  }, D) : r === "insideTop" ? Ot({
    x: d + s / 2,
    y: l + b,
    horizontalAnchor: "middle",
    verticalAnchor: x
  }, D) : r === "insideBottom" ? Ot({
    x: h + f / 2,
    y: l + c - b,
    horizontalAnchor: "middle",
    verticalAnchor: w
  }, D) : r === "insideTopLeft" ? Ot({
    x: d + g,
    y: l + b,
    horizontalAnchor: P,
    verticalAnchor: x
  }, D) : r === "insideTopRight" ? Ot({
    x: d + s - g,
    y: l + b,
    horizontalAnchor: S,
    verticalAnchor: x
  }, D) : r === "insideBottomLeft" ? Ot({
    x: h + g,
    y: l + c - b,
    horizontalAnchor: P,
    verticalAnchor: w
  }, D) : r === "insideBottomRight" ? Ot({
    x: h + f - g,
    y: l + c - b,
    horizontalAnchor: S,
    verticalAnchor: w
  }, D) : r && typeof r == "object" && ($(r.x) || Tr(r.x)) && ($(r.y) || Tr(r.y)) ? Ot({
    x: u + bt(r.x, p),
    y: l + bt(r.y, c),
    horizontalAnchor: "end",
    verticalAnchor: "end"
  }, D) : Ot({
    x: m,
    y: l + c / 2,
    horizontalAnchor: "middle",
    verticalAnchor: "middle"
  }, D);
}, k0 = ["top", "left", "right", "bottom"];
function C0(e) {
  return e == null ? !1 : typeof e == "object" ? !0 : k0.includes(e);
}
var T0 = /* @__PURE__ */ Ge(null);
function fe(e) {
  return function() {
    return e;
  };
}
const ru = Math.PI, nu = 2 * ru, gr = 1e-6, M0 = nu - gr;
function Rh(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function j0(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return Rh;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let i = 1, a = n.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + n[i];
  };
}
class D0 {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Rh : j0(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, i) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
  }
  bezierCurveTo(t, r, n, i, a, o) {
    this._append`C${+t},${+r},${+n},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, r, n, i, a) {
    if (t = +t, r = +r, n = +n, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, u = this._y1, l = n - t, c = i - r, s = o - t, f = u - r, d = s * s + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > gr) if (!(Math.abs(f * l - c * s) > gr) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let h = n - o, v = i - u, p = l * l + c * c, m = h * h + v * v, y = Math.sqrt(p), b = Math.sqrt(d), w = a * Math.tan((ru - Math.acos((p + d - m) / (2 * y * b))) / 2), x = w / b, O = w / y;
      Math.abs(x - 1) > gr && this._append`L${t + x * s},${r + x * f}`, this._append`A${a},${a},0,0,${+(f * h > s * v)},${this._x1 = t + O * l},${this._y1 = r + O * c}`;
    }
  }
  arc(t, r, n, i, a, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let u = n * Math.cos(i), l = n * Math.sin(i), c = t + u, s = r + l, f = 1 ^ o, d = o ? i - a : a - i;
    this._x1 === null ? this._append`M${c},${s}` : (Math.abs(this._x1 - c) > gr || Math.abs(this._y1 - s) > gr) && this._append`L${c},${s}`, n && (d < 0 && (d = d % nu + nu), d > M0 ? this._append`A${n},${n},0,1,${f},${t - u},${r - l}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = s}` : d > gr && this._append`A${n},${n},0,${+(d >= ru)},${f},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function Bh(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new D0(t);
}
function Zu(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function zh(e) {
  this._context = e;
}
zh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function La(e) {
  return new zh(e);
}
function Fh(e) {
  return e[0];
}
function Wh(e) {
  return e[1];
}
function Uh(e, t) {
  var r = fe(!0), n = null, i = La, a = null, o = Bh(u);
  e = typeof e == "function" ? e : e === void 0 ? Fh : fe(e), t = typeof t == "function" ? t : t === void 0 ? Wh : fe(t);
  function u(l) {
    var c, s = (l = Zu(l)).length, f, d = !1, h;
    for (n == null && (a = i(h = o())), c = 0; c <= s; ++c)
      !(c < s && r(f = l[c], c, l)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(f, c, l), +t(f, c, l));
    if (h) return a = null, h + "" || null;
  }
  return u.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : fe(+l), u) : e;
  }, u.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : fe(+l), u) : t;
  }, u.defined = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : fe(!!l), u) : r;
  }, u.curve = function(l) {
    return arguments.length ? (i = l, n != null && (a = i(n)), u) : i;
  }, u.context = function(l) {
    return arguments.length ? (l == null ? n = a = null : a = i(n = l), u) : n;
  }, u;
}
function Ei(e, t, r) {
  var n = null, i = fe(!0), a = null, o = La, u = null, l = Bh(c);
  e = typeof e == "function" ? e : e === void 0 ? Fh : fe(+e), t = typeof t == "function" ? t : fe(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? Wh : fe(+r);
  function c(f) {
    var d, h, v, p = (f = Zu(f)).length, m, y = !1, b, w = new Array(p), x = new Array(p);
    for (a == null && (u = o(b = l())), d = 0; d <= p; ++d) {
      if (!(d < p && i(m = f[d], d, f)) === y)
        if (y = !y)
          h = d, u.areaStart(), u.lineStart();
        else {
          for (u.lineEnd(), u.lineStart(), v = d - 1; v >= h; --v)
            u.point(w[v], x[v]);
          u.lineEnd(), u.areaEnd();
        }
      y && (w[d] = +e(m, d, f), x[d] = +t(m, d, f), u.point(n ? +n(m, d, f) : w[d], r ? +r(m, d, f) : x[d]));
    }
    if (b) return u = null, b + "" || null;
  }
  function s() {
    return Uh().defined(i).curve(o).context(a);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : fe(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : fe(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : fe(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : fe(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : fe(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : fe(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return s().x(e).y(t);
  }, c.lineY1 = function() {
    return s().x(e).y(r);
  }, c.lineX1 = function() {
    return s().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : fe(!!f), c) : i;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, a != null && (u = o(a)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? a = u = null : u = o(a = f), c) : a;
  }, c;
}
class Kh {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function N0(e) {
  return new Kh(e, !0);
}
function $0(e) {
  return new Kh(e, !1);
}
function qi() {
}
function Xi(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function Vh(e) {
  this._context = e;
}
Vh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Xi(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Xi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function L0(e) {
  return new Vh(e);
}
function Hh(e) {
  this._context = e;
}
Hh.prototype = {
  areaStart: qi,
  areaEnd: qi,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Xi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function R0(e) {
  return new Hh(e);
}
function Gh(e) {
  this._context = e;
}
Gh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      default:
        Xi(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function B0(e) {
  return new Gh(e);
}
function Yh(e) {
  this._context = e;
}
Yh.prototype = {
  areaStart: qi,
  areaEnd: qi,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function z0(e) {
  return new Yh(e);
}
function Ic(e) {
  return e < 0 ? -1 : 1;
}
function kc(e, t, r) {
  var n = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (n || i < 0 && -0), o = (r - e._y1) / (i || n < 0 && -0), u = (a * i + o * n) / (n + i);
  return (Ic(a) + Ic(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(u)) || 0;
}
function Cc(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function Ao(e, t, r) {
  var n = e._x0, i = e._y0, a = e._x1, o = e._y1, u = (a - n) / 3;
  e._context.bezierCurveTo(n + u, i + u * t, a - u, o - u * r, a, o);
}
function Zi(e) {
  this._context = e;
}
Zi.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Ao(this, this._t0, Cc(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Ao(this, Cc(this, r = kc(this, e, t)), r);
          break;
        default:
          Ao(this, this._t0, r = kc(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function qh(e) {
  this._context = new Xh(e);
}
(qh.prototype = Object.create(Zi.prototype)).point = function(e, t) {
  Zi.prototype.point.call(this, t, e);
};
function Xh(e) {
  this._context = e;
}
Xh.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, i, a) {
    this._context.bezierCurveTo(t, e, n, r, a, i);
  }
};
function F0(e) {
  return new Zi(e);
}
function W0(e) {
  return new qh(e);
}
function Zh(e) {
  this._context = e;
}
Zh.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = Tc(e), i = Tc(t), a = 0, o = 1; o < r; ++a, ++o)
          this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function Tc(e) {
  var t, r = e.length - 1, n, i = new Array(r), a = new Array(r), o = new Array(r);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / a[t - 1], a[t] -= n, o[t] -= n * o[t - 1];
  for (i[r - 1] = o[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function U0(e) {
  return new Zh(e);
}
function Ra(e, t) {
  this._context = e, this._t = t;
}
Ra.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function K0(e) {
  return new Ra(e, 0.5);
}
function V0(e) {
  return new Ra(e, 0);
}
function H0(e) {
  return new Ra(e, 1);
}
function Mr(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, i, a = e[t[0]], o, u = a.length; r < o; ++r)
      for (i = a, a = e[t[r]], n = 0; n < u; ++n)
        a[n][1] += a[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
}
function iu(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function G0(e, t) {
  return e[t];
}
function Y0(e) {
  const t = [];
  return t.key = e, t;
}
function q0() {
  var e = fe([]), t = iu, r = Mr, n = G0;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), Y0), u, l = o.length, c = -1, s;
    for (const f of a)
      for (u = 0, ++c; u < l; ++u)
        (o[u][c] = [0, +n(f, o[u].key, c, a)]).data = f;
    for (u = 0, s = Zu(t(o)); u < l; ++u)
      o[s[u]].index = u;
    return r(o, s), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : fe(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : fe(+a), i) : n;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? iu : typeof a == "function" ? a : fe(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (r = a ?? Mr, i) : r;
  }, i;
}
function X0(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = r = 0; r < n; ++r) o += e[r][i][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][i][1] /= o;
    }
    Mr(e, t);
  }
}
function Z0(e, t) {
  if ((i = e.length) > 0) {
    for (var r = 0, n = e[t[0]], i, a = n.length; r < a; ++r) {
      for (var o = 0, u = 0; o < i; ++o) u += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -u / 2;
    }
    Mr(e, t);
  }
}
function Q0(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, i, a, o; n < a; ++n) {
      for (var u = 0, l = 0, c = 0; u < o; ++u) {
        for (var s = e[t[u]], f = s[n][1] || 0, d = s[n - 1][1] || 0, h = (f - d) / 2, v = 0; v < u; ++v) {
          var p = e[t[v]], m = p[n][1] || 0, y = p[n - 1][1] || 0;
          h += m - y;
        }
        l += f, c += h * f;
      }
      i[n - 1][1] += i[n - 1][0] = r, l && (r -= c / l);
    }
    i[n - 1][1] += i[n - 1][0] = r, Mr(e, t);
  }
}
var Qh = (e) => "radius" in e && "startAngle" in e && "endAngle" in e, J0 = (e, t) => {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var r = e;
  if (/* @__PURE__ */ yt(e) && (r = e.props), typeof r != "object" && typeof r != "function")
    return null;
  var n = {};
  return Object.keys(r).forEach((i) => {
    Vu(i) && typeof r[i] == "function" && (n[i] = (a) => r[i](r, a));
  }), n;
}, eb = (e, t, r) => (n) => (e(t, r, n), null), Qu = (e, t, r) => {
  if (e === null || typeof e != "object" && typeof e != "function")
    return null;
  var n = null;
  return Object.keys(e).forEach((i) => {
    var a = e[i];
    Vu(i) && typeof a == "function" && (n || (n = {}), n[i] = eb(a, t, r));
  }), n;
};
function Mc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mc(Object(r), !0).forEach(function(n) {
      rb(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mc(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function rb(e, t, r) {
  return (t = nb(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function nb(e) {
  var t = ib(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ib(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function st(e, t) {
  var r = tb({}, e), n = t, i = Object.keys(t), a = i.reduce((o, u) => (o[u] === void 0 && n[u] !== void 0 && (o[u] = n[u]), o), r);
  return a;
}
function ab(e, t) {
  const r = /* @__PURE__ */ new Map();
  for (let n = 0; n < e.length; n++) {
    const i = e[n], a = t(i, n, e);
    r.has(a) || r.set(a, i);
  }
  return Array.from(r.values());
}
function ob(e, t) {
  return function(...r) {
    return e.apply(this, r.slice(0, t));
  };
}
function Jh(e) {
  return e;
}
function ub(e) {
  return Number.isSafeInteger(e) && e >= 0;
}
function Ju(e) {
  return e != null && typeof e != "function" && ub(e.length);
}
function lb(e) {
  return function(t) {
    return Kt(t, e);
  };
}
function ev(e) {
  return e == null || typeof e != "object" && typeof e != "function";
}
function cb(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function au(e) {
  return Object.getOwnPropertySymbols(e).filter((t) => Object.prototype.propertyIsEnumerable.call(e, t));
}
function en(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
const tv = "[object RegExp]", el = "[object String]", tl = "[object Number]", rl = "[object Boolean]", rv = "[object Arguments]", nv = "[object Symbol]", iv = "[object Date]", av = "[object Map]", ov = "[object Set]", uv = "[object Array]", sb = "[object Function]", lv = "[object ArrayBuffer]", Ki = "[object Object]", fb = "[object Error]", cv = "[object DataView]", sv = "[object Uint8Array]", fv = "[object Uint8ClampedArray]", dv = "[object Uint16Array]", hv = "[object Uint32Array]", db = "[object BigUint64Array]", vv = "[object Int8Array]", pv = "[object Int16Array]", mv = "[object Int32Array]", hb = "[object BigInt64Array]", yv = "[object Float32Array]", gv = "[object Float64Array]", jc = typeof globalThis == "object" && globalThis || typeof window == "object" && window || typeof self == "object" && self || typeof global == "object" && global || /* @__PURE__ */ function() {
  return this;
}();
function ou(e) {
  return typeof jc.Buffer < "u" && jc.Buffer.isBuffer(e);
}
function vb(e, t) {
  return Ar(e, void 0, e, /* @__PURE__ */ new Map(), t);
}
function Ar(e, t, r, n = /* @__PURE__ */ new Map(), i = void 0) {
  const a = i == null ? void 0 : i(e, t, r, n);
  if (a !== void 0) return a;
  if (ev(e)) return e;
  if (n.has(e)) return n.get(e);
  if (Array.isArray(e)) {
    const o = new Array(e.length);
    n.set(e, o);
    for (let u = 0; u < e.length; u++) o[u] = Ar(e[u], u, r, n, i);
    return Object.hasOwn(e, "index") && (o.index = e.index), Object.hasOwn(e, "input") && (o.input = e.input), o;
  }
  if (e instanceof Date) return new Date(e.getTime());
  if (e instanceof RegExp) {
    const o = new RegExp(e.source, e.flags);
    return o.lastIndex = e.lastIndex, o;
  }
  if (e instanceof Map) {
    const o = /* @__PURE__ */ new Map();
    n.set(e, o);
    for (const [u, l] of e) o.set(u, Ar(l, u, r, n, i));
    return o;
  }
  if (e instanceof Set) {
    const o = /* @__PURE__ */ new Set();
    n.set(e, o);
    for (const u of e) o.add(Ar(u, void 0, r, n, i));
    return o;
  }
  if (ou(e)) return e.subarray();
  if (cb(e)) {
    const o = new (Object.getPrototypeOf(e)).constructor(e.length);
    n.set(e, o);
    for (let u = 0; u < e.length; u++) o[u] = Ar(e[u], u, r, n, i);
    return o;
  }
  if (e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer) return e.slice(0);
  if (e instanceof DataView) {
    const o = new DataView(e.buffer.slice(0), e.byteOffset, e.byteLength);
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (typeof File < "u" && e instanceof File) {
    const o = new File([e], e.name, { type: e.type });
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (typeof Blob < "u" && e instanceof Blob) {
    const o = new Blob([e], { type: e.type });
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (e instanceof Error) {
    const o = structuredClone(e);
    return n.set(e, o), o.message = e.message, o.name = e.name, o.stack = e.stack, o.cause = e.cause, o.constructor = e.constructor, pt(o, e, r, n, i), o;
  }
  if (e instanceof Boolean) {
    const o = new Boolean(e.valueOf());
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (e instanceof Number) {
    const o = new Number(e.valueOf());
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (e instanceof String) {
    const o = new String(e.valueOf());
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  if (typeof e == "object" && pb(e)) {
    const o = Object.create(Object.getPrototypeOf(e));
    return n.set(e, o), pt(o, e, r, n, i), o;
  }
  return e;
}
function pt(e, t, r = e, n, i) {
  const a = [...Object.keys(t), ...au(t)];
  for (let o = 0; o < a.length; o++) {
    const u = a[o], l = Object.getOwnPropertyDescriptor(e, u);
    (l == null || l.writable) && (e[u] = Ar(t[u], u, r, n, i));
  }
}
function pb(e) {
  switch (en(e)) {
    case rv:
    case uv:
    case lv:
    case cv:
    case rl:
    case iv:
    case yv:
    case gv:
    case vv:
    case pv:
    case mv:
    case av:
    case tl:
    case Ki:
    case tv:
    case ov:
    case el:
    case nv:
    case sv:
    case fv:
    case dv:
    case hv:
      return !0;
    default:
      return !1;
  }
}
function mb(e) {
  return Ar(e, void 0, e, /* @__PURE__ */ new Map(), void 0);
}
function Bn(e, t) {
  return e === t || Number.isNaN(e) && Number.isNaN(t);
}
function bv(e) {
  return e !== null && (typeof e == "object" || typeof e == "function");
}
function xv(e, t, r) {
  return typeof r != "function" ? xv(e, t, () => {
  }) : uu(e, t, function n(i, a, o, u, l, c) {
    const s = r(i, a, o, u, l, c);
    return s !== void 0 ? !!s : uu(i, a, n, c, !1);
  }, /* @__PURE__ */ new Map(), !0);
}
function uu(e, t, r, n, i = !1) {
  if (t === e) return !0;
  switch (typeof t) {
    case "object":
      return yb(e, t, r, n, i);
    case "function":
      return Object.keys(t).length > 0 ? uu(e, { ...t }, r, n, i) : Bn(e, t);
    default:
      return bv(e) && i ? typeof t == "string" ? t === "" : !0 : Bn(e, t);
  }
}
function yb(e, t, r, n, i = !1) {
  if (t == null) return !0;
  if (Array.isArray(t)) return wv(e, t, r, n);
  if (t instanceof Map) return gb(e, t, r, n);
  if (t instanceof Set) return bb(e, t, r, n);
  const a = Object.keys(t);
  if (e == null) return i && a.length === 0;
  if (i)
    ev(e) && (e = Object(e));
  else {
    const o = en(e);
    if (o !== "[object Object]" && o !== "[object Arguments]") return !1;
  }
  if (a.length === 0) return !0;
  if (n != null && n.has(t)) return n.get(t) === e;
  n == null || n.set(t, e);
  try {
    for (let o = 0; o < a.length; o++) {
      const u = a[o];
      if (!(u in e) || t[u] === void 0 && e[u] !== void 0 || t[u] === null && e[u] !== null || !r(e[u], t[u], u, e, t, n)) return !1;
    }
    return !0;
  } finally {
    n == null || n.delete(t);
  }
}
function gb(e, t, r, n) {
  if (t.size === 0) return !0;
  if (!(e instanceof Map)) return !1;
  for (const [i, a] of t.entries()) if (r(e.get(i), a, i, e, t, n) === !1) return !1;
  return !0;
}
function wv(e, t, r, n) {
  if (t.length === 0) return !0;
  if (!Array.isArray(e)) return !1;
  const i = /* @__PURE__ */ new Set();
  for (let a = 0; a < t.length; a++) {
    const o = t[a];
    let u = !1;
    for (let l = 0; l < e.length; l++) {
      if (i.has(l)) continue;
      const c = e[l];
      let s = !1;
      if (r(c, o, a, e, t, n) && (s = !0), s) {
        i.add(l), u = !0;
        break;
      }
    }
    if (!u) return !1;
  }
  return !0;
}
function bb(e, t, r, n) {
  return t.size === 0 ? !0 : e instanceof Set ? wv([...e], [...t], r, n) : !1;
}
function Av(e, t) {
  return xv(e, t, () => {
  });
}
function xb(e) {
  return e = mb(e), (t) => Av(t, e);
}
function wb(e, t) {
  return vb(e, (r, n, i, a) => {
    if (typeof e == "object") {
      if (en(e) === "[object Object]" && typeof e.constructor != "function") {
        const o = {};
        return a.set(e, o), pt(o, e, i, a), o;
      }
      switch (Object.prototype.toString.call(e)) {
        case tl:
        case el:
        case rl: {
          const o = new e.constructor(e == null ? void 0 : e.valueOf());
          return pt(o, e), o;
        }
        case rv: {
          const o = {};
          return pt(o, e), o.length = e.length, o[Symbol.iterator] = e[Symbol.iterator], o;
        }
        default:
          return;
      }
    }
  });
}
function Ab(e) {
  return wb(e);
}
const Ob = /^(?:0|[1-9]\d*)$/;
function Ov(e, t = Number.MAX_SAFE_INTEGER) {
  switch (typeof e) {
    case "number":
      return Number.isInteger(e) && e >= 0 && e < t;
    case "symbol":
      return !1;
    case "string":
      return Ob.test(e);
  }
}
function Sb(e) {
  return e !== null && typeof e == "object" && en(e) === "[object Arguments]";
}
function Eb(e, t) {
  let r;
  if (Array.isArray(t) ? r = t : typeof t == "string" && Nh(t) && !(t in Object(e)) ? r = Yu(t) : r = [t], r.length === 0) return !1;
  let n = e;
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if ((n == null || !Object.hasOwn(n, a)) && !((Array.isArray(n) || Sb(n)) && Ov(a) && a < n.length))
      return !1;
    n = n[a];
  }
  return !0;
}
function _b(e, t) {
  switch (typeof e) {
    case "object":
      Object.is(e == null ? void 0 : e.valueOf(), -0) && (e = "-0");
      break;
    case "number":
      e = Gu(e);
      break;
  }
  return t = Ab(t), function(r) {
    const n = Kt(r, e);
    return n === void 0 ? Eb(r, e) : t === void 0 ? n === void 0 : Av(n, t);
  };
}
function Pb(e) {
  if (e == null) return Jh;
  switch (typeof e) {
    case "function":
      return e;
    case "object":
      return Array.isArray(e) && e.length === 2 ? _b(e[0], e[1]) : xb(e);
    default:
      return lb(e);
  }
}
function Ib(e) {
  return e === 0 ? 0 : e;
}
function Dc(e, t = Jh) {
  return Ju(e) ? ab(Array.from(e), ob(Pb(t), 1)).map(Ib) : [];
}
function kb(e, t, r) {
  return t === !0 ? Dc(e, r) : typeof t == "function" ? Dc(e, t) : e;
}
var lu = { exports: {} }, Oo = {}, _i = { exports: {} }, So = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nc;
function Cb() {
  if (Nc) return So;
  Nc = 1;
  var e = dn;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, i = e.useEffect, a = e.useLayoutEffect, o = e.useDebugValue;
  function u(f, d) {
    var h = d(), v = n({ inst: { value: h, getSnapshot: d } }), p = v[0].inst, m = v[1];
    return a(
      function() {
        p.value = h, p.getSnapshot = d, l(p) && m({ inst: p });
      },
      [f, h, d]
    ), i(
      function() {
        return l(p) && m({ inst: p }), f(function() {
          l(p) && m({ inst: p });
        });
      },
      [f]
    ), o(h), h;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var h = d();
      return !r(f, h);
    } catch {
      return !0;
    }
  }
  function c(f, d) {
    return d();
  }
  var s = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : u;
  return So.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : s, So;
}
var Eo = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $c;
function Tb() {
  return $c || ($c = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, v) {
      return h === v && (h !== 0 || 1 / h === 1 / v) || h !== h && v !== v;
    }
    function t(h, v) {
      s || i.startTransition === void 0 || (s = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var p = v();
      if (!f) {
        var m = v();
        a(p, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      m = o({
        inst: { value: p, getSnapshot: v }
      });
      var y = m[0].inst, b = m[1];
      return l(
        function() {
          y.value = p, y.getSnapshot = v, r(y) && b({ inst: y });
        },
        [h, p, v]
      ), u(
        function() {
          return r(y) && b({ inst: y }), h(function() {
            r(y) && b({ inst: y });
          });
        },
        [h]
      ), c(p), p;
    }
    function r(h) {
      var v = h.getSnapshot;
      h = h.value;
      try {
        var p = v();
        return !a(h, p);
      } catch {
        return !0;
      }
    }
    function n(h, v) {
      return v();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = dn, a = typeof Object.is == "function" ? Object.is : e, o = i.useState, u = i.useEffect, l = i.useLayoutEffect, c = i.useDebugValue, s = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    Eo.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Eo;
}
var Lc;
function Sv() {
  return Lc || (Lc = 1, process.env.NODE_ENV === "production" ? _i.exports = Cb() : _i.exports = Tb()), _i.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rc;
function Mb() {
  if (Rc) return Oo;
  Rc = 1;
  var e = dn, t = Sv();
  function r(c, s) {
    return c === s && (c !== 0 || 1 / c === 1 / s) || c !== c && s !== s;
  }
  var n = typeof Object.is == "function" ? Object.is : r, i = t.useSyncExternalStore, a = e.useRef, o = e.useEffect, u = e.useMemo, l = e.useDebugValue;
  return Oo.useSyncExternalStoreWithSelector = function(c, s, f, d, h) {
    var v = a(null);
    if (v.current === null) {
      var p = { hasValue: !1, value: null };
      v.current = p;
    } else p = v.current;
    v = u(
      function() {
        function y(g) {
          if (!b) {
            if (b = !0, w = g, g = d(g), h !== void 0 && p.hasValue) {
              var S = p.value;
              if (h(S, g))
                return x = S;
            }
            return x = g;
          }
          if (S = x, n(w, g)) return S;
          var P = d(g);
          return h !== void 0 && h(S, P) ? (w = g, S) : (w = g, x = P);
        }
        var b = !1, w, x, O = f === void 0 ? null : f;
        return [
          function() {
            return y(s());
          },
          O === null ? void 0 : function() {
            return y(O());
          }
        ];
      },
      [s, f, d, h]
    );
    var m = i(c, v[0], v[1]);
    return o(
      function() {
        p.hasValue = !0, p.value = m;
      },
      [m]
    ), l(m), m;
  }, Oo;
}
var _o = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bc;
function jb() {
  return Bc || (Bc = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, s) {
      return c === s && (c !== 0 || 1 / c === 1 / s) || c !== c && s !== s;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = dn, r = Sv(), n = typeof Object.is == "function" ? Object.is : e, i = r.useSyncExternalStore, a = t.useRef, o = t.useEffect, u = t.useMemo, l = t.useDebugValue;
    _o.useSyncExternalStoreWithSelector = function(c, s, f, d, h) {
      var v = a(null);
      if (v.current === null) {
        var p = { hasValue: !1, value: null };
        v.current = p;
      } else p = v.current;
      v = u(
        function() {
          function y(g) {
            if (!b) {
              if (b = !0, w = g, g = d(g), h !== void 0 && p.hasValue) {
                var S = p.value;
                if (h(S, g))
                  return x = S;
              }
              return x = g;
            }
            if (S = x, n(w, g))
              return S;
            var P = d(g);
            return h !== void 0 && h(S, P) ? (w = g, S) : (w = g, x = P);
          }
          var b = !1, w, x, O = f === void 0 ? null : f;
          return [
            function() {
              return y(s());
            },
            O === null ? void 0 : function() {
              return y(O());
            }
          ];
        },
        [s, f, d, h]
      );
      var m = i(c, v[0], v[1]);
      return o(
        function() {
          p.hasValue = !0, p.value = m;
        },
        [m]
      ), l(m), m;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), _o;
}
process.env.NODE_ENV === "production" ? lu.exports = Mb() : lu.exports = jb();
var Db = lu.exports, nl = /* @__PURE__ */ Ge(null), Nb = (e) => e, oe = () => {
  var e = rt(nl);
  return e ? e.store.dispatch : Nb;
}, Vi = () => {
}, $b = () => Vi, Lb = (e, t) => e === t;
function N(e) {
  var t = rt(nl), r = Ve(() => t ? (n) => {
    if (n != null)
      return e(n);
  } : Vi, [t, e]);
  return Db.useSyncExternalStoreWithSelector(t ? t.subscription.addNestedSub : $b, t ? t.store.getState : Vi, t ? t.store.getState : Vi, r, Lb);
}
var Rb = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const i = {};
      e(i) === i && (n = !0);
    } catch {
    }
    if (n) {
      let i;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: i } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: i }
      );
    }
  }
}, Bb = (e, t, r) => {
  const { memoize: n, memoizeOptions: i } = t, { inputSelectorResults: a, inputSelectorResultsCopy: o } = e, u = n(() => ({}), ...i);
  if (!(u.apply(null, a) === u.apply(null, o))) {
    let c;
    try {
      throw new Error();
    } catch (s) {
      ({ stack: c } = s);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: o,
        stack: c
      }
    );
  }
}, zb = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function Fb(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function Wb(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var zc = (e) => Array.isArray(e) ? e : [e];
function Ub(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Wb(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function Fc(e, t) {
  const r = [], { length: n } = e;
  for (let i = 0; i < n; i++)
    r.push(e[i].apply(null, t));
  return r;
}
var Kb = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...zb,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: Rb
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: Bb
    }
  };
}, Vb = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Hb = () => typeof WeakRef > "u" ? Vb : WeakRef, Ev = /* @__PURE__ */ Hb(), Gb = 0, Wc = 1;
function Pi() {
  return {
    s: Gb,
    v: void 0,
    o: null,
    p: null
  };
}
function Yb(e) {
  return e instanceof Ev ? e.deref() : e;
}
function _v(e, t = {}) {
  let r = Pi();
  const { resultEqualityCheck: n } = t;
  let i, a = 0;
  function o() {
    let u = r;
    const { length: l } = arguments;
    for (let f = 0, d = l; f < d; f++) {
      const h = arguments[f];
      if (typeof h == "function" || typeof h == "object" && h !== null) {
        let v = u.o;
        v === null && (u.o = v = /* @__PURE__ */ new WeakMap());
        const p = v.get(h);
        p === void 0 ? (u = Pi(), v.set(h, u)) : u = p;
      } else {
        let v = u.p;
        v === null && (u.p = v = /* @__PURE__ */ new Map());
        const p = v.get(h);
        p === void 0 ? (u = Pi(), v.set(h, u)) : u = p;
      }
    }
    const c = u;
    let s;
    if (u.s === Wc)
      s = u.v;
    else if (s = e.apply(null, arguments), a++, n) {
      const f = Yb(i);
      f != null && n(f, s) && (s = f, a !== 0 && a--), i = typeof s == "object" && s !== null || typeof s == "function" ? /* @__PURE__ */ new Ev(s) : s;
    }
    return c.s = Wc, c.v = s, s;
  }
  return o.clearCache = () => {
    r = Pi(), o.resetResultsCount();
  }, o.resultsCount = () => a, o.resetResultsCount = () => {
    a = 0;
  }, o;
}
function qb(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...i) => {
    let a = 0, o = 0, u, l = {}, c = i.pop();
    typeof c == "object" && (l = c, c = i.pop()), Fb(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const s = {
      ...r,
      ...l
    }, {
      memoize: f,
      memoizeOptions: d = [],
      argsMemoize: h = _v,
      argsMemoizeOptions: v = []
    } = s, p = zc(d), m = zc(v), y = Ub(i), b = f(function() {
      return a++, c.apply(
        null,
        arguments
      );
    }, ...p);
    let w = !0;
    const x = h(function() {
      o++;
      const g = Fc(
        y,
        arguments
      );
      if (u = b.apply(null, g), process.env.NODE_ENV !== "production") {
        const { devModeChecks: S = {} } = s, { identityFunctionCheck: P, inputStabilityCheck: k } = Kb(w, S);
        if (P.shouldRun && P.run(
          c,
          g,
          u
        ), k.shouldRun) {
          const T = Fc(
            y,
            arguments
          );
          k.run(
            { inputSelectorResults: g, inputSelectorResultsCopy: T },
            { memoize: f, memoizeOptions: p },
            arguments
          );
        }
        w && (w = !1);
      }
      return u;
    }, ...m);
    return Object.assign(x, {
      resultFunc: c,
      memoizedResultFunc: b,
      dependencies: y,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => u,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: f,
      argsMemoize: h
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var E = /* @__PURE__ */ qb(_v);
function Xb(e, t = 1) {
  const r = [], n = Math.floor(t), i = (a, o) => {
    for (let u = 0; u < a.length; u++) {
      const l = a[u];
      Array.isArray(l) && o < n ? i(l, o + 1) : r.push(l);
    }
  };
  return i(e, 0), r;
}
function cu(e, t, r) {
  return bv(r) && (typeof t == "number" && Ju(r) && Ov(t) && t < r.length || typeof t == "string" && t in r) ? Bn(r[t], e) : !1;
}
function Uc(e) {
  return typeof e == "symbol" ? 1 : e === null ? 2 : e === void 0 ? 3 : e !== e ? 4 : 0;
}
const Zb = (e, t, r) => {
  if (e !== t) {
    const n = Uc(e), i = Uc(t);
    if (n === i && n === 0) {
      if (e < t) return r === "desc" ? 1 : -1;
      if (e > t) return r === "desc" ? -1 : 1;
    }
    return r === "desc" ? i - n : n - i;
  }
  return 0;
};
function Pv(e) {
  return typeof e == "symbol" || e instanceof Symbol;
}
const Qb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Jb = /^\w*$/;
function ex(e, t) {
  return Array.isArray(e) ? !1 : typeof e == "number" || typeof e == "boolean" || e == null || Pv(e) ? !0 : typeof e == "string" && (Jb.test(e) || !Qb.test(e)) || t != null;
}
function tx(e, t, r, n) {
  if (e == null) return [];
  r = r, Array.isArray(e) || (e = Ju(e) ? Array.from(e) : Object.values(e)), Array.isArray(t) || (t = t == null ? [null] : [t]), t.length === 0 && (t = [null]), Array.isArray(r) || (r = r == null ? [] : [r]), r = r.map((u) => String(u));
  const i = (u, l) => {
    let c = u, s = 0;
    for (; s < l.length && c != null; ++s) c = c[l[s]];
    return s > 0 && s === l.length ? c : void 0;
  }, a = (u, l) => {
    if (u == null) return l;
    if (l != null)
      return typeof u == "object" && "key" in u ? Object.hasOwn(l, u.key) ? l[u.key] : i(l, u.path) : typeof u == "function" ? u(l) : Array.isArray(u) ? i(l, u) : l[u];
  }, o = t.map((u) => (Array.isArray(u) && u.length === 1 && (u = u[0]), u == null || typeof u == "function" || Array.isArray(u) || ex(u) ? u : {
    key: u,
    path: Yu(u)
  }));
  return e.map((u) => ({
    original: u,
    criteria: o.map((l) => a(l, u))
  })).slice().sort((u, l) => {
    for (let c = 0; c < o.length; c++) {
      const s = Zb(u.criteria[c], l.criteria[c], r[c]);
      if (s !== 0) return s;
    }
    return 0;
  }).map((u) => u.original);
}
function Ba(e, ...t) {
  const r = t.length;
  return r > 1 && cu(e, t[0], t[1]) ? t = [] : r > 2 && cu(t[0], t[1], t[2]) && (t = [t[0]]), tx(e, Xb(t), ["asc"]);
}
var Iv = (e) => e.legend.settings, rx = (e) => e.legend.size, nx = (e) => e.legend.payload;
E([nx, Iv], (e, t) => {
  var r = t.itemSorter, n = e.flat(1);
  return r ? Ba(n, r) : n;
});
function ix(e, t) {
  return lx(e) || ux(e, t) || ox(e, t) || ax();
}
function ax() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ox(e, t) {
  if (e) {
    if (typeof e == "string") return Kc(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Kc(e, t) : void 0;
  }
}
function Kc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function ux(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function lx(e) {
  if (Array.isArray(e)) return e;
}
var Ii = 1;
function Vc(e, t) {
  return Math.abs(e.height - t.height) > Ii || Math.abs(e.left - t.left) > Ii || Math.abs(e.top - t.top) > Ii || Math.abs(e.width - t.width) > Ii;
}
function Hc(e) {
  var t = e.getBoundingClientRect();
  return {
    height: t.height,
    left: t.left,
    top: t.top,
    width: t.width
  };
}
function cx() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = be({
    height: 0,
    left: 0,
    top: 0,
    width: 0
  }), r = ix(t, 2), n = r[0], i = r[1], a = X(null), o = X(n);
  o.current = n;
  var u = ne(
    (l) => {
      if (a.current != null && (a.current.disconnect(), a.current = null), l != null) {
        var c = Hc(l);
        if (Vc(c, o.current) && i(c), typeof ResizeObserver < "u") {
          var s = new ResizeObserver(() => {
            var f = Hc(l);
            Vc(f, o.current) && i(f);
          });
          s.observe(l), a.current = s;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...e]
  );
  return se(() => () => {
    var l;
    (l = a.current) === null || l === void 0 || l.disconnect();
  }, []), [n, u];
}
function ke(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var sx = typeof Symbol == "function" && Symbol.observable || "@@observable", Gc = sx, Po = () => Math.random().toString(36).substring(7).split("").join("."), fx = {
  INIT: `@@redux/INIT${/* @__PURE__ */ Po()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ Po()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Po()}`
}, _r = fx;
function ni(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function dx(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (px(e))
    return "date";
  if (vx(e))
    return "error";
  const r = hx(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function hx(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function vx(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function px(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function tr(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = dx(e)), t;
}
function kv(e, t, r) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ke(2) : `Expected the root reducer to be a function. Instead, received: '${tr(e)}'`);
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? ke(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ke(1) : `Expected the enhancer to be a function. Instead, received: '${tr(r)}'`);
    return r(kv)(e, t);
  }
  let n = e, i = t, a = /* @__PURE__ */ new Map(), o = a, u = 0, l = !1;
  function c() {
    o === a && (o = /* @__PURE__ */ new Map(), a.forEach((m, y) => {
      o.set(y, m);
    }));
  }
  function s() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ke(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return i;
  }
  function f(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ke(4) : `Expected the listener to be a function. Instead, received: '${tr(m)}'`);
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ke(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let y = !0;
    c();
    const b = u++;
    return o.set(b, m), function() {
      if (y) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? ke(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        y = !1, c(), o.delete(b), a = null;
      }
    };
  }
  function d(m) {
    if (!ni(m))
      throw new Error(process.env.NODE_ENV === "production" ? ke(7) : `Actions must be plain objects. Instead, the actual type was: '${tr(m)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof m.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ke(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof m.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? ke(17) : `Action "type" property must be a string. Instead, the actual type was: '${tr(m.type)}'. Value was: '${m.type}' (stringified)`);
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? ke(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, i = n(i, m);
    } finally {
      l = !1;
    }
    return (a = o).forEach((b) => {
      b();
    }), m;
  }
  function h(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? ke(10) : `Expected the nextReducer to be a function. Instead, received: '${tr(m)}`);
    n = m, d({
      type: _r.REPLACE
    });
  }
  function v() {
    const m = f;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? ke(11) : `Expected the observer to be an object. Instead, received: '${tr(y)}'`);
        function b() {
          const x = y;
          x.next && x.next(s());
        }
        return b(), {
          unsubscribe: m(b)
        };
      },
      [Gc]() {
        return this;
      }
    };
  }
  return d({
    type: _r.INIT
  }), {
    dispatch: d,
    subscribe: f,
    getState: s,
    replaceReducer: h,
    [Gc]: v
  };
}
function Yc(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function mx(e, t, r, n) {
  const i = Object.keys(t), a = r && r.type === _r.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (i.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!ni(e))
    return `The ${a} has unexpected type of "${tr(e)}". Expected argument to be an object with the following keys: "${i.join('", "')}"`;
  const o = Object.keys(e).filter((u) => !t.hasOwnProperty(u) && !n[u]);
  if (o.forEach((u) => {
    n[u] = !0;
  }), !(r && r.type === _r.REPLACE) && o.length > 0)
    return `Unexpected ${o.length > 1 ? "keys" : "key"} "${o.join('", "')}" found in ${a}. Expected to find one of the known reducer keys instead: "${i.join('", "')}". Unexpected keys will be ignored.`;
}
function yx(e) {
  Object.keys(e).forEach((t) => {
    const r = e[t];
    if (typeof r(void 0, {
      type: _r.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ke(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: _r.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? ke(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${_r.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function Cv(e) {
  const t = Object.keys(e), r = {};
  for (let o = 0; o < t.length; o++) {
    const u = t[o];
    process.env.NODE_ENV !== "production" && typeof e[u] > "u" && Yc(`No reducer provided for key "${u}"`), typeof e[u] == "function" && (r[u] = e[u]);
  }
  const n = Object.keys(r);
  let i;
  process.env.NODE_ENV !== "production" && (i = {});
  let a;
  try {
    yx(r);
  } catch (o) {
    a = o;
  }
  return function(u = {}, l) {
    if (a)
      throw a;
    if (process.env.NODE_ENV !== "production") {
      const f = mx(u, r, l, i);
      f && Yc(f);
    }
    let c = !1;
    const s = {};
    for (let f = 0; f < n.length; f++) {
      const d = n[f], h = r[d], v = u[d], p = h(v, l);
      if (typeof p > "u") {
        const m = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? ke(14) : `When called with an action of type ${m ? `"${String(m)}"` : "(unknown type)"}, the slice reducer for key "${d}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      s[d] = p, c = c || p !== v;
    }
    return c = c || n.length !== Object.keys(u).length, c ? s : u;
  };
}
function Qi(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, r) => (...n) => t(r(...n)));
}
function gx(...e) {
  return (t) => (r, n) => {
    const i = t(r, n);
    let a = () => {
      throw new Error(process.env.NODE_ENV === "production" ? ke(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const o = {
      getState: i.getState,
      dispatch: (l, ...c) => a(l, ...c)
    }, u = e.map((l) => l(o));
    return a = Qi(...u)(i.dispatch), {
      ...i,
      dispatch: a
    };
  };
}
function il(e) {
  return ni(e) && "type" in e && typeof e.type == "string";
}
var Tv = Symbol.for("immer-nothing"), qc = Symbol.for("immer-draftable"), $e = Symbol.for("immer-state"), bx = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Ze(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = bx[e], n = wr(r) ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var et = Object, tn = et.getPrototypeOf, Ji = "constructor", za = "prototype", su = "configurable", ea = "enumerable", Hi = "writable", Kn = "value", Vt = (e) => !!e && !!e[$e];
function lt(e) {
  var t;
  return e ? Mv(e) || Wa(e) || !!e[qc] || !!((t = e[Ji]) != null && t[qc]) || Ua(e) || Ka(e) : !1;
}
var xx = et[za][Ji].toString(), Xc = /* @__PURE__ */ new WeakMap();
function Mv(e) {
  if (!e || !al(e))
    return !1;
  const t = tn(e);
  if (t === null || t === et[za])
    return !0;
  const r = et.hasOwnProperty.call(t, Ji) && t[Ji];
  if (r === Object)
    return !0;
  if (!wr(r))
    return !1;
  let n = Xc.get(r);
  return n === void 0 && (n = Function.toString.call(r), Xc.set(r, n)), n === xx;
}
function Fa(e, t, r = !0) {
  ii(e) === 0 ? (r ? Reflect.ownKeys(e) : et.keys(e)).forEach((i) => {
    t(i, e[i], e);
  }) : e.forEach((n, i) => t(i, n, e));
}
function ii(e) {
  const t = e[$e];
  return t ? t.type_ : Wa(e) ? 1 : Ua(e) ? 2 : Ka(e) ? 3 : 0;
}
var Io = (e, t, r = ii(e)) => r === 2 ? e.has(t) : et[za].hasOwnProperty.call(e, t), fu = (e, t, r = ii(e)) => (
  // @ts-ignore
  r === 2 ? e.get(t) : e[t]
), ta = (e, t, r, n = ii(e)) => {
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
};
function wx(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Wa = Array.isArray, Ua = (e) => e instanceof Map, Ka = (e) => e instanceof Set, al = (e) => typeof e == "object", wr = (e) => typeof e == "function", ko = (e) => typeof e == "boolean";
function Ax(e) {
  const t = +e;
  return Number.isInteger(t) && String(t) === e;
}
var Lt = (e) => e.copy_ || e.base_, ol = (e) => e.modified_ ? e.copy_ : e.base_;
function du(e, t) {
  if (Ua(e))
    return new Map(e);
  if (Ka(e))
    return new Set(e);
  if (Wa(e))
    return Array[za].slice.call(e);
  const r = Mv(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = et.getOwnPropertyDescriptors(e);
    delete n[$e];
    let i = Reflect.ownKeys(n);
    for (let a = 0; a < i.length; a++) {
      const o = i[a], u = n[o];
      u[Hi] === !1 && (u[Hi] = !0, u[su] = !0), (u.get || u.set) && (n[o] = {
        [su]: !0,
        [Hi]: !0,
        // could live with !!desc.set as well here...
        [ea]: u[ea],
        [Kn]: e[o]
      });
    }
    return et.create(tn(e), n);
  } else {
    const n = tn(e);
    if (n !== null && r)
      return { ...e };
    const i = et.create(n);
    return et.assign(i, e);
  }
}
function ul(e, t = !1) {
  return Va(e) || Vt(e) || !lt(e) || (ii(e) > 1 && et.defineProperties(e, {
    set: ki,
    add: ki,
    clear: ki,
    delete: ki
  }), et.freeze(e), t && Fa(
    e,
    (r, n) => {
      ul(n, !0);
    },
    !1
  )), e;
}
function Ox() {
  Ze(2);
}
var ki = {
  [Kn]: Ox
};
function Va(e) {
  return e === null || !al(e) ? !0 : et.isFrozen(e);
}
var ra = "MapSet", hu = "Patches", Zc = "ArrayMethods", jv = {};
function jr(e) {
  const t = jv[e];
  return t || Ze(0, e), t;
}
var Qc = (e) => !!jv[e], Vn, Dv = () => Vn, Sx = (e, t) => ({
  drafts_: [],
  parent_: e,
  immer_: t,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: !0,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: Qc(ra) ? jr(ra) : void 0,
  arrayMethodsPlugin_: Qc(Zc) ? jr(Zc) : void 0
});
function Jc(e, t) {
  t && (e.patchPlugin_ = jr(hu), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function vu(e) {
  pu(e), e.drafts_.forEach(Ex), e.drafts_ = null;
}
function pu(e) {
  e === Vn && (Vn = e.parent_);
}
var es = (e) => Vn = Sx(Vn, e);
function Ex(e) {
  const t = e[$e];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function ts(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  if (e !== void 0 && e !== r) {
    r[$e].modified_ && (vu(t), Ze(4)), lt(e) && (e = rs(t, e));
    const { patchPlugin_: i } = t;
    i && i.generateReplacementPatches_(
      r[$e].base_,
      e,
      t
    );
  } else
    e = rs(t, r);
  return _x(t, e, !0), vu(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Tv ? e : void 0;
}
function rs(e, t) {
  if (Va(t))
    return t;
  const r = t[$e];
  if (!r)
    return na(t, e.handledSet_, e);
  if (!Ha(r, e))
    return t;
  if (!r.modified_)
    return r.base_;
  if (!r.finalized_) {
    const { callbacks_: n } = r;
    if (n)
      for (; n.length > 0; )
        n.pop()(e);
    Lv(r, e);
  }
  return r.copy_;
}
function _x(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && ul(t, r);
}
function Nv(e) {
  e.finalized_ = !0, e.scope_.unfinalizedDrafts_--;
}
var Ha = (e, t) => e.scope_ === t, Px = [];
function $v(e, t, r, n) {
  const i = Lt(e), a = e.type_;
  if (n !== void 0 && fu(i, n, a) === t) {
    ta(i, n, r, a);
    return;
  }
  if (!e.draftLocations_) {
    const u = e.draftLocations_ = /* @__PURE__ */ new Map();
    Fa(i, (l, c) => {
      if (Vt(c)) {
        const s = u.get(c) || [];
        s.push(l), u.set(c, s);
      }
    });
  }
  const o = e.draftLocations_.get(t) ?? Px;
  for (const u of o)
    ta(i, u, r, a);
}
function Ix(e, t, r) {
  e.callbacks_.push(function(i) {
    var u;
    const a = t;
    if (!a || !Ha(a, i))
      return;
    (u = i.mapSetPlugin_) == null || u.fixSetContents(a);
    const o = ol(a);
    $v(e, a.draft_ ?? a, o, r), Lv(a, i);
  });
}
function Lv(e, t) {
  var n;
  if (e.modified_ && !e.finalized_ && (e.type_ === 3 || e.type_ === 1 && e.allIndicesReassigned_ || (((n = e.assigned_) == null ? void 0 : n.size) ?? 0) > 0)) {
    const { patchPlugin_: i } = t;
    if (i) {
      const a = i.getPath(e);
      a && i.generatePatches_(e, a, t);
    }
    Nv(e);
  }
}
function kx(e, t, r) {
  const { scope_: n } = e;
  if (Vt(r)) {
    const i = r[$e];
    Ha(i, n) && i.callbacks_.push(function() {
      Gi(e);
      const o = ol(i);
      $v(e, r, o, t);
    });
  } else lt(r) && e.callbacks_.push(function() {
    const a = Lt(e);
    e.type_ === 3 ? a.has(r) && na(r, n.handledSet_, n) : fu(a, t, e.type_) === r && n.drafts_.length > 1 && (e.assigned_.get(t) ?? !1) === !0 && e.copy_ && na(
      fu(e.copy_, t, e.type_),
      n.handledSet_,
      n
    );
  });
}
function na(e, t, r) {
  return !r.immer_.autoFreeze_ && r.unfinalizedDrafts_ < 1 || Vt(e) || t.has(e) || !lt(e) || Va(e) || (t.add(e), Fa(e, (n, i) => {
    if (Vt(i)) {
      const a = i[$e];
      if (Ha(a, r)) {
        const o = ol(a);
        ta(e, n, o, e.type_), Nv(a);
      }
    } else lt(i) && na(i, t, r);
  })), e;
}
function Cx(e, t) {
  const r = Wa(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Dv(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let i = n, a = ia;
  r && (i = [n], a = Hn);
  const { revoke: o, proxy: u } = Proxy.revocable(i, a);
  return n.draft_ = u, n.revoke_ = o, [u, n];
}
var ia = {
  get(e, t) {
    if (t === $e)
      return e;
    let r = e.scope_.arrayMethodsPlugin_;
    const n = e.type_ === 1 && typeof t == "string";
    if (n && r != null && r.isArrayOperationMethod(t))
      return r.createMethodInterceptor(e, t);
    const i = Lt(e);
    if (!Io(i, t, e.type_))
      return Mx(e, i, t);
    const a = i[t];
    if (e.finalized_ || !lt(a) || n && e.operationMethod && (r != null && r.isMutatingArrayMethod(
      e.operationMethod
    )) && Ax(t))
      return a;
    if (a === Co(e.base_, t) || Tx(e, t, a)) {
      Gi(e);
      const o = e.type_ === 1 ? +t : t, u = yu(e.scope_, a, e, o);
      return e.copy_[o] = u;
    }
    return a;
  },
  has(e, t) {
    return t in Lt(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(Lt(e));
  },
  set(e, t, r) {
    const n = Rv(Lt(e), t);
    if (n != null && n.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const i = Co(Lt(e), t), a = i == null ? void 0 : i[$e];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_.set(t, !1), !0;
      if (wx(r, i) && (r !== void 0 || Io(e.base_, t, e.type_)))
        return !0;
      Gi(e), mu(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || Io(e.copy_, t, e.type_)) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_.set(t, !0), kx(e, t, r)), !0;
  },
  deleteProperty(e, t) {
    return Gi(e), Co(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_.set(t, !1), mu(e)) : e.assigned_.delete(t), e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = Lt(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      [Hi]: !0,
      [su]: e.type_ !== 1 || t !== "length",
      [ea]: n[ea],
      [Kn]: r[t]
    };
  },
  defineProperty() {
    Ze(11);
  },
  getPrototypeOf(e) {
    return tn(e.base_);
  },
  setPrototypeOf() {
    Ze(12);
  }
}, Hn = {};
for (let e in ia) {
  let t = ia[e];
  Hn[e] = function() {
    const r = arguments;
    return r[0] = r[0][0], t.apply(this, r);
  };
}
Hn.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Ze(13), Hn.set.call(this, e, t, void 0);
};
Hn.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Ze(14), ia.set.call(this, e[0], t, r, e[0]);
};
function Co(e, t) {
  const r = e[$e];
  return (r ? Lt(r) : e)[t];
}
function Tx(e, t, r) {
  var n;
  return e.type_ !== 1 || !e.allIndicesReassigned_ || (n = e.assigned_) != null && n.get(t) || !lt(r) || r[$e] ? !1 : e.baseRefs_.has(r);
}
function Mx(e, t, r) {
  var i;
  const n = Rv(t, r);
  return n ? Kn in n ? n[Kn] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = n.get) == null ? void 0 : i.call(e.draft_)
  ) : void 0;
}
function Rv(e, t) {
  if (!(t in e))
    return;
  let r = tn(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = tn(r);
  }
}
function mu(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && mu(e.parent_));
}
function Gi(e) {
  e.copy_ || (e.assigned_ = /* @__PURE__ */ new Map(), e.copy_ = du(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var jx = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (t, r, n) => {
      if (wr(t) && !wr(r)) {
        const a = r;
        r = t;
        const o = this;
        return function(l = a, ...c) {
          return o.produce(l, (s) => r.call(this, s, ...c));
        };
      }
      wr(r) || Ze(6), n !== void 0 && !wr(n) && Ze(7);
      let i;
      if (lt(t)) {
        const a = es(this), o = yu(a, t, void 0);
        let u = !0;
        try {
          i = r(o), u = !1;
        } finally {
          u ? vu(a) : pu(a);
        }
        return Jc(a, n), ts(i, a);
      } else if (!t || !al(t)) {
        if (i = r(t), i === void 0 && (i = t), i === Tv && (i = void 0), this.autoFreeze_ && ul(i, !0), n) {
          const a = [], o = [];
          jr(hu).generateReplacementPatches_(t, i, {
            patches_: a,
            inversePatches_: o
          }), n(a, o);
        }
        return i;
      } else
        Ze(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (wr(t))
        return (o, ...u) => this.produceWithPatches(o, (l) => t(l, ...u));
      let n, i;
      return [this.produce(t, r, (o, u) => {
        n = o, i = u;
      }), n, i];
    }, ko(e == null ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze), ko(e == null ? void 0 : e.useStrictShallowCopy) && this.setUseStrictShallowCopy(e.useStrictShallowCopy), ko(e == null ? void 0 : e.useStrictIteration) && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    lt(e) || Ze(8), Vt(e) && (e = at(e));
    const t = es(this), r = yu(t, e, void 0);
    return r[$e].isManual_ = !0, pu(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[$e];
    (!r || !r.isManual_) && Ze(9);
    const { scope_: n } = r;
    return Jc(n, t), ts(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const i = t[r];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = jr(hu).applyPatches_;
    return Vt(e) ? n(e, t) : this.produce(
      e,
      (i) => n(i, t)
    );
  }
};
function yu(e, t, r, n) {
  const [i, a] = Ua(t) ? jr(ra).proxyMap_(t, r) : Ka(t) ? jr(ra).proxySet_(t, r) : Cx(t, r);
  return ((r == null ? void 0 : r.scope_) ?? Dv()).drafts_.push(i), a.callbacks_ = (r == null ? void 0 : r.callbacks_) ?? [], a.key_ = n, r && n !== void 0 ? Ix(r, a, n) : a.callbacks_.push(function(l) {
    var s;
    (s = l.mapSetPlugin_) == null || s.fixSetContents(a);
    const { patchPlugin_: c } = l;
    a.modified_ && c && c.generatePatches_(a, [], l);
  }), i;
}
function at(e) {
  return Vt(e) || Ze(10, e), Bv(e);
}
function Bv(e) {
  if (!lt(e) || Va(e))
    return e;
  const t = e[$e];
  let r, n = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = du(e, t.scope_.immer_.useStrictShallowCopy_), n = t.scope_.immer_.shouldUseStrictIteration();
  } else
    r = du(e, !0);
  return Fa(
    r,
    (i, a) => {
      ta(r, i, Bv(a));
    },
    n
  ), t && (t.finalized_ = !1), r;
}
var Dx = new jx(), zv = Dx.produce, Z = (e) => e;
function Fv(e) {
  return ({ dispatch: r, getState: n }) => (i) => (a) => typeof a == "function" ? a(r, n, e) : i(a);
}
var Nx = Fv(), $x = Fv, Lx = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? Qi : Qi.apply(null, arguments);
}, Rx = (e) => e && typeof e.match == "function";
function tt(e, t) {
  function r(...n) {
    if (t) {
      let i = t(...n);
      if (!i)
        throw new Error(process.env.NODE_ENV === "production" ? J(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: i.payload,
        ..."meta" in i && {
          meta: i.meta
        },
        ..."error" in i && {
          error: i.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => il(n) && n.type === e, r;
}
function Bx(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  Rx(e);
}
function zx(e) {
  const t = e ? `${e}`.split("/") : [], r = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`;
}
function Fx(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (r) => (n) => r(n);
  const {
    isActionCreator: t = Bx
  } = e;
  return () => (r) => (n) => (t(n) && console.warn(zx(n.type)), r(n));
}
function Wv(e, t) {
  let r = 0;
  return {
    measureTime(n) {
      const i = Date.now();
      try {
        return n();
      } finally {
        const a = Date.now();
        r += a - i;
      }
    },
    warnIfExceeded() {
      r > e && console.warn(`${t} took ${r}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var Uv = class $n extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, $n.prototype);
  }
  static get [Symbol.species]() {
    return $n;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new $n(...t[0].concat(this)) : new $n(...t.concat(this));
  }
};
function ns(e) {
  return lt(e) ? zv(e, () => {
  }) : e;
}
function Ci(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Wx(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Ux(e, t, r) {
  const n = Kv(e, t, r);
  return {
    detectMutations() {
      return Vv(e, t, n, r);
    }
  };
}
function Kv(e, t = [], r, n = "", i = /* @__PURE__ */ new Set()) {
  const a = {
    value: r
  };
  if (!e(r) && !i.has(r)) {
    i.add(r), a.children = {};
    const o = t.length > 0;
    for (const u in r) {
      const l = n ? n + "." + u : u;
      o && t.some((s) => s instanceof RegExp ? s.test(l) : l === s) || (a.children[u] = Kv(e, t, r[u], l));
    }
  }
  return a;
}
function Vv(e, t = [], r, n, i = !1, a = "") {
  const o = r ? r.value : void 0, u = o === n;
  if (i && !u && !Number.isNaN(n))
    return {
      wasMutated: !0,
      path: a
    };
  if (e(o) || e(n))
    return {
      wasMutated: !1
    };
  const l = {};
  for (let s in r.children)
    l[s] = !0;
  for (let s in n)
    l[s] = !0;
  const c = t.length > 0;
  for (let s in l) {
    const f = a ? a + "." + s : s;
    if (c && t.some((v) => v instanceof RegExp ? v.test(f) : f === v))
      continue;
    const d = Vv(e, t, r.children[s], n[s], u, f);
    if (d.wasMutated)
      return d;
  }
  return {
    wasMutated: !1
  };
}
function Kx(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    let t = function(u, l, c, s) {
      return JSON.stringify(u, r(l, s), c);
    }, r = function(u, l) {
      let c = [], s = [];
      return l || (l = function(f, d) {
        return c[0] === d ? "[Circular ~]" : "[Circular ~." + s.slice(0, c.indexOf(d)).join(".") + "]";
      }), function(f, d) {
        if (c.length > 0) {
          var h = c.indexOf(this);
          ~h ? c.splice(h + 1) : c.push(this), ~h ? s.splice(h, 1 / 0, f) : s.push(f), ~c.indexOf(d) && (d = l.call(this, f, d));
        } else c.push(d);
        return u == null ? d : u.call(this, f, d);
      };
    }, {
      isImmutable: n = Wx,
      ignoredPaths: i,
      warnAfter: a = 32
    } = e;
    const o = Ux.bind(null, n, i);
    return ({
      getState: u
    }) => {
      let l = u(), c = o(l), s;
      return (f) => (d) => {
        const h = Wv(a, "ImmutableStateInvariantMiddleware");
        h.measureTime(() => {
          if (l = u(), s = c.detectMutations(), c = o(l), s.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? J(19) : `A state mutation was detected between dispatches, in the path '${s.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const v = f(d);
        return h.measureTime(() => {
          if (l = u(), s = c.detectMutations(), c = o(l), s.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? J(20) : `A state mutation was detected inside a dispatch, in the path: ${s.path || ""}. Take a look at the reducer(s) handling the action ${t(d)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), h.warnIfExceeded(), v;
      };
    };
  }
}
function Hv(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || ni(e);
}
function gu(e, t = "", r = Hv, n, i = [], a) {
  let o;
  if (!r(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || a != null && a.has(e)) return !1;
  const u = n != null ? n(e) : Object.entries(e), l = i.length > 0;
  for (const [c, s] of u) {
    const f = t ? t + "." + c : c;
    if (!(l && i.some((h) => h instanceof RegExp ? h.test(f) : f === h))) {
      if (!r(s))
        return {
          keyPath: f,
          value: s
        };
      if (typeof s == "object" && (o = gu(s, f, r, n, i, a), o))
        return o;
    }
  }
  return a && Gv(e) && a.add(e), !1;
}
function Gv(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !Gv(t))
      return !1;
  return !0;
}
function Vx(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    const {
      isSerializable: t = Hv,
      getEntries: r,
      ignoredActions: n = [],
      ignoredActionPaths: i = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: a = [],
      warnAfter: o = 32,
      ignoreState: u = !1,
      ignoreActions: l = !1,
      disableCache: c = !1
    } = e, s = !c && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (f) => (d) => (h) => {
      if (!il(h))
        return d(h);
      const v = d(h), p = Wv(o, "SerializableStateInvariantMiddleware");
      return !l && !(n.length && n.indexOf(h.type) !== -1) && p.measureTime(() => {
        const m = gu(h, "", t, r, i, s);
        if (m) {
          const {
            keyPath: y,
            value: b
          } = m;
          console.error(`A non-serializable value was detected in an action, in the path: \`${y}\`. Value:`, b, `
Take a look at the logic that dispatched this action: `, h, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), u || (p.measureTime(() => {
        const m = f.getState(), y = gu(m, "", t, r, a, s);
        if (y) {
          const {
            keyPath: b,
            value: w
          } = y;
          console.error(`A non-serializable value was detected in the state, in the path: \`${b}\`. Value:`, w, `
Take a look at the reducer(s) handling this action type: ${h.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), p.warnIfExceeded()), v;
    };
  }
}
function Ti(e) {
  return typeof e == "boolean";
}
var Hx = () => function(t) {
  const {
    thunk: r = !0,
    immutableCheck: n = !0,
    serializableCheck: i = !0,
    actionCreatorCheck: a = !0
  } = t ?? {};
  let o = new Uv();
  if (r && (Ti(r) ? o.push(Nx) : o.push($x(r.extraArgument))), process.env.NODE_ENV !== "production") {
    if (n) {
      let u = {};
      Ti(n) || (u = n), o.unshift(Kx(u));
    }
    if (i) {
      let u = {};
      Ti(i) || (u = i), o.push(Vx(u));
    }
    if (a) {
      let u = {};
      Ti(a) || (u = a), o.unshift(Fx(u));
    }
  }
  return o;
}, Yv = "RTK_autoBatch", ie = () => (e) => ({
  payload: e,
  meta: {
    [Yv]: !0
  }
}), is = (e) => (t) => {
  setTimeout(t, e);
}, Gx = (e, t) => (r) => {
  let n = !1;
  const i = () => {
    n || (n = !0, cancelAnimationFrame(a), clearTimeout(o), r());
  }, a = e(i), o = setTimeout(i, t);
}, qv = (e = {
  type: "raf"
}) => (t) => (...r) => {
  const n = t(...r);
  let i = !0, a = !1, o = !1;
  const u = /* @__PURE__ */ new Set(), l = e.type === "tick" ? queueMicrotask : e.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? Gx(window.requestAnimationFrame, 100) : is(10)
  ) : e.type === "callback" ? e.queueNotification : is(e.timeout), c = () => {
    o = !1, a && (a = !1, u.forEach((s) => s()));
  };
  return Object.assign({}, n, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(s) {
      const f = () => i && s(), d = n.subscribe(f);
      return u.add(s), () => {
        d(), u.delete(s);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(s) {
      var f;
      try {
        return i = !((f = s == null ? void 0 : s.meta) != null && f[Yv]), a = !i, a && (o || (o = !0, l(c))), n.dispatch(s);
      } finally {
        i = !0;
      }
    }
  });
}, Yx = (e) => function(r) {
  const {
    autoBatch: n = !0
  } = r ?? {};
  let i = new Uv(e);
  return n && i.push(qv(typeof n == "object" ? n : void 0)), i;
};
function qx(e) {
  const t = Hx(), {
    reducer: r = void 0,
    middleware: n,
    devTools: i = !0,
    duplicateMiddlewareCheck: a = !0,
    preloadedState: o = void 0,
    enhancers: u = void 0
  } = e || {};
  let l;
  if (typeof r == "function")
    l = r;
  else if (ni(r))
    l = Cv(r);
  else
    throw new Error(process.env.NODE_ENV === "production" ? J(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (process.env.NODE_ENV !== "production" && n && typeof n != "function")
    throw new Error(process.env.NODE_ENV === "production" ? J(2) : "`middleware` field must be a callback");
  let c;
  if (typeof n == "function") {
    if (c = n(t), process.env.NODE_ENV !== "production" && !Array.isArray(c))
      throw new Error(process.env.NODE_ENV === "production" ? J(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    c = t();
  if (process.env.NODE_ENV !== "production" && c.some((p) => typeof p != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? J(4) : "each middleware provided to configureStore must be a function");
  if (process.env.NODE_ENV !== "production" && a) {
    let p = /* @__PURE__ */ new Set();
    c.forEach((m) => {
      if (p.has(m))
        throw new Error(process.env.NODE_ENV === "production" ? J(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      p.add(m);
    });
  }
  let s = Qi;
  i && (s = Lx({
    // Enable capture of stack traces for dispatched Redux actions
    trace: process.env.NODE_ENV !== "production",
    ...typeof i == "object" && i
  }));
  const f = gx(...c), d = Yx(f);
  if (process.env.NODE_ENV !== "production" && u && typeof u != "function")
    throw new Error(process.env.NODE_ENV === "production" ? J(5) : "`enhancers` field must be a callback");
  let h = typeof u == "function" ? u(d) : d();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(h))
    throw new Error(process.env.NODE_ENV === "production" ? J(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && h.some((p) => typeof p != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? J(7) : "each enhancer provided to configureStore must be a function");
  process.env.NODE_ENV !== "production" && c.length && !h.includes(f) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const v = s(...h);
  return kv(l, o, v);
}
function Xv(e) {
  const t = {}, r = [];
  let n;
  const i = {
    addCase(a, o) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? J(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? J(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const u = typeof a == "string" ? a : a.type;
      if (!u)
        throw new Error(process.env.NODE_ENV === "production" ? J(28) : "`builder.addCase` cannot be called with an empty action type");
      if (u in t)
        throw new Error(process.env.NODE_ENV === "production" ? J(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${u}'`);
      return t[u] = o, i;
    },
    addAsyncThunk(a, o) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? J(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return o.pending && (t[a.pending.type] = o.pending), o.rejected && (t[a.rejected.type] = o.rejected), o.fulfilled && (t[a.fulfilled.type] = o.fulfilled), o.settled && r.push({
        matcher: a.settled,
        reducer: o.settled
      }), i;
    },
    addMatcher(a, o) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? J(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: a,
        reducer: o
      }), i;
    },
    addDefaultCase(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? J(31) : "`builder.addDefaultCase` can only be called once");
      return n = a, i;
    }
  };
  return e(i), [t, r, n];
}
function Xx(e) {
  return typeof e == "function";
}
function Zx(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? J(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, i] = Xv(t), a;
  if (Xx(e))
    a = () => ns(e());
  else {
    const u = ns(e);
    a = () => u;
  }
  function o(u = a(), l) {
    let c = [r[l.type], ...n.filter(({
      matcher: s
    }) => s(l)).map(({
      reducer: s
    }) => s)];
    return c.filter((s) => !!s).length === 0 && (c = [i]), c.reduce((s, f) => {
      if (f)
        if (Vt(s)) {
          const h = f(s, l);
          return h === void 0 ? s : h;
        } else {
          if (lt(s))
            return zv(s, (d) => f(d, l));
          {
            const d = f(s, l);
            if (d === void 0) {
              if (s === null)
                return s;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return d;
          }
        }
      return s;
    }, u);
  }
  return o.getInitialState = a, o;
}
var Qx = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Jx = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += Qx[Math.random() * 64 | 0];
  return t;
}, ew = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function tw(e, t) {
  return `${e}/${t}`;
}
function rw({
  creators: e
} = {}) {
  var r;
  const t = (r = e == null ? void 0 : e.asyncThunk) == null ? void 0 : r[ew];
  return function(i) {
    const {
      name: a,
      reducerPath: o = a
    } = i;
    if (!a)
      throw new Error(process.env.NODE_ENV === "production" ? J(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && i.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const u = (typeof i.reducers == "function" ? i.reducers(iw()) : i.reducers) || {}, l = Object.keys(u), c = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, s = {
      addCase(x, O) {
        const g = typeof x == "string" ? x : x.type;
        if (!g)
          throw new Error(process.env.NODE_ENV === "production" ? J(12) : "`context.addCase` cannot be called with an empty action type");
        if (g in c.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? J(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + g);
        return c.sliceCaseReducersByType[g] = O, s;
      },
      addMatcher(x, O) {
        return c.sliceMatchers.push({
          matcher: x,
          reducer: O
        }), s;
      },
      exposeAction(x, O) {
        return c.actionCreators[x] = O, s;
      },
      exposeCaseReducer(x, O) {
        return c.sliceCaseReducersByName[x] = O, s;
      }
    };
    l.forEach((x) => {
      const O = u[x], g = {
        reducerName: x,
        type: tw(a, x),
        createNotation: typeof i.reducers == "function"
      };
      ow(O) ? lw(g, O, s, t) : aw(g, O, s);
    });
    function f() {
      if (process.env.NODE_ENV !== "production" && typeof i.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? J(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [x = {}, O = [], g = void 0] = typeof i.extraReducers == "function" ? Xv(i.extraReducers) : [i.extraReducers], S = {
        ...x,
        ...c.sliceCaseReducersByType
      };
      return Zx(i.initialState, (P) => {
        for (let k in S)
          P.addCase(k, S[k]);
        for (let k of c.sliceMatchers)
          P.addMatcher(k.matcher, k.reducer);
        for (let k of O)
          P.addMatcher(k.matcher, k.reducer);
        g && P.addDefaultCase(g);
      });
    }
    const d = (x) => x, h = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new WeakMap();
    let p;
    function m(x, O) {
      return p || (p = f()), p(x, O);
    }
    function y() {
      return p || (p = f()), p.getInitialState();
    }
    function b(x, O = !1) {
      function g(P) {
        let k = P[x];
        if (typeof k > "u") {
          if (O)
            k = Ci(v, g, y);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? J(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return k;
      }
      function S(P = d) {
        const k = Ci(h, O, () => /* @__PURE__ */ new WeakMap());
        return Ci(k, P, () => {
          const T = {};
          for (const [I, _] of Object.entries(i.selectors ?? {}))
            T[I] = nw(_, P, () => Ci(v, P, y), O);
          return T;
        });
      }
      return {
        reducerPath: x,
        getSelectors: S,
        get selectors() {
          return S(g);
        },
        selectSlice: g
      };
    }
    const w = {
      name: a,
      reducer: m,
      actions: c.actionCreators,
      caseReducers: c.sliceCaseReducersByName,
      getInitialState: y,
      ...b(o),
      injectInto(x, {
        reducerPath: O,
        ...g
      } = {}) {
        const S = O ?? o;
        return x.inject({
          reducerPath: S,
          reducer: m
        }, g), {
          ...w,
          ...b(S, !0)
        };
      }
    };
    return w;
  };
}
function nw(e, t, r, n) {
  function i(a, ...o) {
    let u = t(a);
    if (typeof u > "u") {
      if (n)
        u = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? J(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(u, ...o);
  }
  return i.unwrapped = e, i;
}
var Re = /* @__PURE__ */ rw();
function iw() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function aw({
  type: e,
  reducerName: t,
  createNotation: r
}, n, i) {
  let a, o;
  if ("reducer" in n) {
    if (r && !uw(n))
      throw new Error(process.env.NODE_ENV === "production" ? J(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    a = n.reducer, o = n.prepare;
  } else
    a = n;
  i.addCase(e, a).exposeCaseReducer(t, a).exposeAction(t, o ? tt(e, o) : tt(e));
}
function ow(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function uw(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function lw({
  type: e,
  reducerName: t
}, r, n, i) {
  if (!i)
    throw new Error(process.env.NODE_ENV === "production" ? J(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: a,
    fulfilled: o,
    pending: u,
    rejected: l,
    settled: c,
    options: s
  } = r, f = i(e, a, s);
  n.exposeAction(t, f), o && n.addCase(f.fulfilled, o), u && n.addCase(f.pending, u), l && n.addCase(f.rejected, l), c && n.addMatcher(f.settled, c), n.exposeCaseReducer(t, {
    fulfilled: o || Mi,
    pending: u || Mi,
    rejected: l || Mi,
    settled: c || Mi
  });
}
function Mi() {
}
var cw = "task", Zv = "listener", Qv = "completed", ll = "cancelled", sw = `task-${ll}`, fw = `task-${Qv}`, bu = `${Zv}-${ll}`, dw = `${Zv}-${Qv}`, Ga = class {
  constructor(e) {
    Oi(this, "code");
    Oi(this, "name", "TaskAbortError");
    Oi(this, "message");
    this.code = e, this.message = `${cw} ${ll} (reason: ${e})`;
  }
}, cl = (e, t) => {
  if (typeof e != "function")
    throw new TypeError(process.env.NODE_ENV === "production" ? J(32) : `${t} is not a function`);
}, aa = () => {
}, Jv = (e, t = aa) => (e.catch(t), e), ep = (e, t) => (e.addEventListener("abort", t, {
  once: !0
}), () => e.removeEventListener("abort", t)), Pr = (e) => {
  if (e.aborted)
    throw new Ga(e.reason);
};
function tp(e, t) {
  let r = aa;
  return new Promise((n, i) => {
    const a = () => i(new Ga(e.reason));
    if (e.aborted) {
      a();
      return;
    }
    r = ep(e, a), t.finally(() => r()).then(n, i);
  }).finally(() => {
    r = aa;
  });
}
var hw = async (e, t) => {
  try {
    return await Promise.resolve(), {
      status: "ok",
      value: await e()
    };
  } catch (r) {
    return {
      status: r instanceof Ga ? "cancelled" : "rejected",
      error: r
    };
  } finally {
    t == null || t();
  }
}, oa = (e) => (t) => Jv(tp(e, t).then((r) => (Pr(e), r))), rp = (e) => {
  const t = oa(e);
  return (r) => t(new Promise((n) => setTimeout(n, r)));
}, {
  assign: Zr
} = Object, as = {}, ai = "listenerMiddleware", vw = (e, t) => {
  const r = (n) => ep(e, () => n.abort(e.reason));
  return (n, i) => {
    cl(n, "taskExecutor");
    const a = new AbortController();
    r(a);
    const o = hw(async () => {
      Pr(e), Pr(a.signal);
      const u = await n({
        pause: oa(a.signal),
        delay: rp(a.signal),
        signal: a.signal
      });
      return Pr(a.signal), u;
    }, () => a.abort(fw));
    return i != null && i.autoJoin && t.push(o.catch(aa)), {
      result: oa(e)(o),
      cancel() {
        a.abort(sw);
      }
    };
  };
}, pw = (e, t) => {
  const r = async (n, i) => {
    Pr(t);
    let a = () => {
    };
    const u = [new Promise((l, c) => {
      let s = e({
        predicate: n,
        effect: (f, d) => {
          d.unsubscribe(), l([f, d.getState(), d.getOriginalState()]);
        }
      });
      a = () => {
        s(), c();
      };
    })];
    i != null && u.push(new Promise((l) => setTimeout(l, i, null)));
    try {
      const l = await tp(t, Promise.race(u));
      return Pr(t), l;
    } finally {
      a();
    }
  };
  return (n, i) => Jv(r(n, i));
}, np = (e) => {
  let {
    type: t,
    actionCreator: r,
    matcher: n,
    predicate: i,
    effect: a
  } = e;
  if (t)
    i = tt(t).match;
  else if (r)
    t = r.type, i = r.match;
  else if (n)
    i = n;
  else if (!i) throw new Error(process.env.NODE_ENV === "production" ? J(21) : "Creating or removing a listener requires one of the known fields for matching an action");
  return cl(a, "options.listener"), {
    predicate: i,
    type: t,
    effect: a
  };
}, ip = /* @__PURE__ */ Zr((e) => {
  const {
    type: t,
    predicate: r,
    effect: n
  } = np(e);
  return {
    id: Jx(),
    effect: n,
    type: t,
    predicate: r,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(process.env.NODE_ENV === "production" ? J(22) : "Unsubscribe not initialized");
    }
  };
}, {
  withTypes: () => ip
}), os = (e, t) => {
  const {
    type: r,
    effect: n,
    predicate: i
  } = np(t);
  return Array.from(e.values()).find((a) => (typeof r == "string" ? a.type === r : a.predicate === i) && a.effect === n);
}, xu = (e) => {
  e.pending.forEach((t) => {
    t.abort(bu);
  });
}, mw = (e, t) => () => {
  for (const r of t.keys())
    xu(r);
  e.clear();
}, us = (e, t, r) => {
  try {
    e(t, r);
  } catch (n) {
    setTimeout(() => {
      throw n;
    }, 0);
  }
}, ap = /* @__PURE__ */ Zr(/* @__PURE__ */ tt(`${ai}/add`), {
  withTypes: () => ap
}), yw = /* @__PURE__ */ tt(`${ai}/removeAll`), op = /* @__PURE__ */ Zr(/* @__PURE__ */ tt(`${ai}/remove`), {
  withTypes: () => op
}), gw = (...e) => {
  console.error(`${ai}/error`, ...e);
}, oi = (e = {}) => {
  const t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), n = (h) => {
    const v = r.get(h) ?? 0;
    r.set(h, v + 1);
  }, i = (h) => {
    const v = r.get(h) ?? 1;
    v === 1 ? r.delete(h) : r.set(h, v - 1);
  }, {
    extra: a,
    onError: o = gw
  } = e;
  cl(o, "onError");
  const u = (h) => (h.unsubscribe = () => t.delete(h.id), t.set(h.id, h), (v) => {
    h.unsubscribe(), v != null && v.cancelActive && xu(h);
  }), l = (h) => {
    const v = os(t, h) ?? ip(h);
    return u(v);
  };
  Zr(l, {
    withTypes: () => l
  });
  const c = (h) => {
    const v = os(t, h);
    return v && (v.unsubscribe(), h.cancelActive && xu(v)), !!v;
  };
  Zr(c, {
    withTypes: () => c
  });
  const s = async (h, v, p, m) => {
    const y = new AbortController(), b = pw(l, y.signal), w = [];
    try {
      h.pending.add(y), n(h), await Promise.resolve(h.effect(
        v,
        // Use assign() rather than ... to avoid extra helper functions added to bundle
        Zr({}, p, {
          getOriginalState: m,
          condition: (x, O) => b(x, O).then(Boolean),
          take: b,
          delay: rp(y.signal),
          pause: oa(y.signal),
          extra: a,
          signal: y.signal,
          fork: vw(y.signal, w),
          unsubscribe: h.unsubscribe,
          subscribe: () => {
            t.set(h.id, h);
          },
          cancelActiveListeners: () => {
            h.pending.forEach((x, O, g) => {
              x !== y && (x.abort(bu), g.delete(x));
            });
          },
          cancel: () => {
            y.abort(bu), h.pending.delete(y);
          },
          throwIfCancelled: () => {
            Pr(y.signal);
          }
        })
      ));
    } catch (x) {
      x instanceof Ga || us(o, x, {
        raisedBy: "effect"
      });
    } finally {
      await Promise.all(w), y.abort(dw), i(h), h.pending.delete(y);
    }
  }, f = mw(t, r);
  return {
    middleware: (h) => (v) => (p) => {
      if (!il(p))
        return v(p);
      if (ap.match(p))
        return l(p.payload);
      if (yw.match(p)) {
        f();
        return;
      }
      if (op.match(p))
        return c(p.payload);
      let m = h.getState();
      const y = () => {
        if (m === as)
          throw new Error(process.env.NODE_ENV === "production" ? J(23) : `${ai}: getOriginalState can only be called synchronously`);
        return m;
      };
      let b;
      try {
        if (b = v(p), t.size > 0) {
          const w = h.getState(), x = Array.from(t.values());
          for (const O of x) {
            let g = !1;
            try {
              g = O.predicate(p, w, m);
            } catch (S) {
              g = !1, us(o, S, {
                raisedBy: "predicate"
              });
            }
            g && s(O, p, h, y);
          }
        }
      } finally {
        m = as;
      }
      return b;
    },
    startListening: l,
    stopListening: c,
    clearListeners: f
  };
};
function J(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var bw = {
  layoutType: "horizontal",
  width: 0,
  height: 0,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  },
  scale: 1
}, up = Re({
  name: "chartLayout",
  initialState: bw,
  reducers: {
    setLayout(e, t) {
      e.layoutType = t.payload;
    },
    setChartSize(e, t) {
      e.width = t.payload.width, e.height = t.payload.height;
    },
    setMargin(e, t) {
      var r, n, i, a;
      e.margin.top = (r = t.payload.top) !== null && r !== void 0 ? r : 0, e.margin.right = (n = t.payload.right) !== null && n !== void 0 ? n : 0, e.margin.bottom = (i = t.payload.bottom) !== null && i !== void 0 ? i : 0, e.margin.left = (a = t.payload.left) !== null && a !== void 0 ? a : 0;
    },
    setScale(e, t) {
      e.scale = t.payload;
    }
  }
}), Ya = up.actions, xw = Ya.setMargin, ww = Ya.setLayout, Aw = Ya.setChartSize, Ow = Ya.setScale, Sw = up.reducer;
function lp(e, t, r) {
  return Array.isArray(e) && e && t + r !== 0 ? e.slice(t, r + 1) : e;
}
function H(e) {
  return Number.isFinite(e);
}
function lr(e) {
  return typeof e == "number" && e > 0 && Number.isFinite(e);
}
function ls(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ls(Object(r), !0).forEach(function(n) {
      Ew(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ls(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ew(e, t, r) {
  return (t = _w(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _w(e) {
  var t = Pw(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Pw(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Se(e, t, r) {
  return xe(e) || xe(t) ? r : ut(t) ? Kt(e, t, r) : typeof t == "function" ? t(e) : r;
}
var Iw = (e, t, r) => {
  if (t && r) {
    var n = r.width, i = r.height, a = t.align, o = t.verticalAlign, u = t.layout, l = t.position, c = t.offset, s = c === void 0 ? 0 : c;
    if (l != null) {
      if (C0(l)) {
        if (l === "top" && $(e.top))
          return Ke(Ke({}, e), {}, {
            top: e.top + (i || 0) + s
          });
        if (l === "bottom" && $(e.bottom))
          return Ke(Ke({}, e), {}, {
            bottom: e.bottom + (i || 0) + s
          });
        if (l === "left" && $(e.left))
          return Ke(Ke({}, e), {}, {
            left: e.left + (n || 0) + s
          });
        if (l === "right" && $(e.right))
          return Ke(Ke({}, e), {}, {
            right: e.right + (n || 0) + s
          });
      }
      return e;
    }
    if ((u === "vertical" || u === "horizontal" && o === "middle") && a !== "center" && $(e[a]))
      return Ke(Ke({}, e), {}, {
        [a]: e[a] + (n || 0)
      });
    if ((u === "horizontal" || u === "vertical" && a === "center") && o !== "middle" && $(e[o]))
      return Ke(Ke({}, e), {}, {
        [o]: e[o] + (i || 0)
      });
  }
  return e;
}, sr = (e, t) => e === "horizontal" && t === "xAxis" || e === "vertical" && t === "yAxis" || e === "centric" && t === "angleAxis" || e === "radial" && t === "radiusAxis", kw = (e, t) => {
  if (!t || t.length !== 2 || !$(t[0]) || !$(t[1]))
    return e;
  var r = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]), i = [e[0], e[1]];
  return (!$(e[0]) || e[0] < r) && (i[0] = r), (!$(e[1]) || e[1] > n) && (i[1] = n), i[0] > n && (i[0] = n), i[1] < r && (i[1] = r), i;
}, Cw = (e) => {
  var t, r = e.length;
  if (!(r <= 0)) {
    var n = (t = e[0]) === null || t === void 0 ? void 0 : t.length;
    if (!(n == null || n <= 0))
      for (var i = 0; i < n; ++i)
        for (var a = 0, o = 0, u = 0; u < r; ++u) {
          var l = e[u], c = l == null ? void 0 : l[i];
          if (c != null) {
            var s = c[1], f = c[0], d = Mt(s) ? f : s;
            d >= 0 ? (c[0] = a, a += d, c[1] = a) : (c[0] = o, o += d, c[1] = o);
          }
        }
  }
}, Tw = (e) => {
  var t, r = e.length;
  if (!(r <= 0)) {
    var n = (t = e[0]) === null || t === void 0 ? void 0 : t.length;
    if (!(n == null || n <= 0))
      for (var i = 0; i < n; ++i)
        for (var a = 0, o = 0; o < r; ++o) {
          var u = e[o], l = u == null ? void 0 : u[i];
          if (l != null) {
            var c = Mt(l[1]) ? l[0] : l[1];
            c >= 0 ? (l[0] = a, a += c, l[1] = a) : (l[0] = 0, l[1] = 0);
          }
        }
  }
}, Mw = {
  sign: Cw,
  // @ts-expect-error definitelytyped types are incorrect
  expand: X0,
  // @ts-expect-error definitelytyped types are incorrect
  none: Mr,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Z0,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: Q0,
  positive: Tw
}, jw = (e, t, r) => {
  var n, i = (n = Mw[r]) !== null && n !== void 0 ? n : Mr, a = q0().keys(t).value((u, l) => Number(Se(u, l, 0))).order(iu).offset(i), o = a(e);
  return o.forEach((u, l) => {
    u.forEach((c, s) => {
      var f = Se(e[s], t[l], 0);
      Array.isArray(f) && f.length === 2 && $(f[0]) && $(f[1]) && (c[0] = f[0], c[1] = f[1]);
    });
  }), o;
};
function Dw(e) {
  return e == null ? void 0 : String(e);
}
var cs = (e) => {
  var t = e.axis, r = e.ticks, n = e.offset, i = e.bandSize, a = e.entry, o = e.index;
  if (t.type === "category")
    return r[o] ? r[o].coordinate + n : null;
  var u = Se(a, t.dataKey, t.scale.domain()[o]);
  if (xe(u))
    return null;
  var l = t.scale.map(u);
  return $(l) ? l - i / 2 + n : null;
}, Nw = (e) => {
  var t = e.numericAxis, r = t.scale.domain();
  if (t.type === "number") {
    var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]);
    return n <= 0 && i >= 0 ? 0 : i < 0 ? i : n;
  }
  return r[0];
}, $w = (e) => {
  var t = e.flat(2).filter($);
  return [Math.min(...t), Math.max(...t)];
}, Lw = (e) => [e[0] === 1 / 0 ? 0 : e[0], e[1] === -1 / 0 ? 0 : e[1]], Rw = (e, t, r) => {
  if (!(e == null || Object.keys(e).length === 0))
    return Lw(Object.keys(e).reduce((n, i) => {
      var a = e[i];
      if (!a)
        return n;
      var o = a.stackedData, u = o.reduce((l, c) => {
        var s = lp(c, t, r), f = $w(s);
        return !H(f[0]) || !H(f[1]) ? l : [Math.min(l[0], f[0]), Math.max(l[1], f[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(u[0], n[0]), Math.max(u[1], n[1])];
    }, [1 / 0, -1 / 0]));
}, ss = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, fs = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ua = (e, t, r) => {
  if (e && e.scale && e.scale.bandwidth) {
    var n = e.scale.bandwidth();
    if (!r || n > 0)
      return n;
  }
  if (e && t && t.length >= 2) {
    for (var i = Ba(t, (p) => p.coordinate), a = [], o = 0, u = 1, l = i.length; u < l; u++) {
      var c, s, f = (((c = i[u]) === null || c === void 0 ? void 0 : c.coordinate) || 0) - (((s = i[u - 1]) === null || s === void 0 ? void 0 : s.coordinate) || 0);
      a.push(f), o = Math.max(f, o);
    }
    var d = o * 1e-4, h = 1 / 0;
    for (var v of a)
      v > d && (h = Math.min(v, h));
    return h === 1 / 0 ? 0 : h;
  }
  return r ? void 0 : 0;
};
function ds(e) {
  var t = e.tooltipEntrySettings, r = e.dataKey, n = e.payload, i = e.value, a = e.name;
  return Ke(Ke({}, t), {}, {
    dataKey: r,
    payload: n,
    value: i,
    name: a
  });
}
function cp(e, t) {
  if (e != null)
    return String(e);
  if (typeof t == "string")
    return t;
}
var Bw = (e, t) => {
  if (t === "horizontal")
    return e.relativeX;
  if (t === "vertical")
    return e.relativeY;
}, zw = (e, t) => t === "centric" ? e.angle : e.radius, qt = (e) => e.layout.width, Xt = (e) => e.layout.height, Fw = (e) => e.layout.scale, sp = (e) => e.layout.margin, qa = E((e) => e.cartesianAxis.xAxis, (e) => Object.values(e)), Xa = E((e) => e.cartesianAxis.yAxis, (e) => Object.values(e)), Ww = "data-recharts-item-index", Uw = "data-recharts-item-id", ui = 60, sl = 30;
function hs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ji(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hs(Object(r), !0).forEach(function(n) {
      Kw(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Kw(e, t, r) {
  return (t = Vw(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Vw(e) {
  var t = Hw(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Hw(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Gw = (e) => e.brush.height;
function Yw(e) {
  var t = Xa(e);
  return t.reduce((r, n) => {
    if (n.orientation === "left" && !n.mirror && !n.hide) {
      var i = typeof n.width == "number" ? n.width : ui;
      return r + i;
    }
    return r;
  }, 0);
}
function qw(e) {
  var t = Xa(e);
  return t.reduce((r, n) => {
    if (n.orientation === "right" && !n.mirror && !n.hide) {
      var i = typeof n.width == "number" ? n.width : ui;
      return r + i;
    }
    return r;
  }, 0);
}
function Xw(e) {
  var t = qa(e);
  return t.reduce((r, n) => {
    if (n.orientation === "top" && !n.mirror && !n.hide) {
      var i = typeof n.height == "number" ? n.height : sl;
      return r + i;
    }
    return r;
  }, 0);
}
function Zw(e) {
  var t = qa(e);
  return t.reduce((r, n) => {
    if (n.orientation === "bottom" && !n.mirror && !n.hide) {
      var i = typeof n.height == "number" ? n.height : sl;
      return r + i;
    }
    return r;
  }, 0);
}
var Ee = E([qt, Xt, sp, Gw, Yw, qw, Xw, Zw, Iv, rx], (e, t, r, n, i, a, o, u, l, c) => {
  var s = {
    left: (r.left || 0) + i,
    right: (r.right || 0) + a
  }, f = {
    top: (r.top || 0) + o,
    bottom: (r.bottom || 0) + u
  }, d = ji(ji({}, f), s), h = d.bottom;
  d.bottom += n, d = Iw(d, l, c);
  var v = e - d.left - d.right, p = t - d.top - d.bottom;
  return ji(ji({
    brushBottom: h
  }, d), {}, {
    // never return negative values for height and width
    width: Math.max(v, 0),
    height: Math.max(p, 0)
  });
}), Qw = E(Ee, (e) => ({
  x: e.left,
  y: e.top,
  width: e.width,
  height: e.height
})), fl = E(qt, Xt, (e, t) => ({
  x: 0,
  y: 0,
  width: e,
  height: t
})), Jw = /* @__PURE__ */ Ge(null), Ye = () => rt(Jw) != null, Za = (e) => e.brush, Qa = E([Za, Ee, sp], (e, t, r) => ({
  height: e.height,
  x: $(e.x) ? e.x : t.left,
  y: $(e.y) ? e.y : t.top + t.height + t.brushBottom - ((r == null ? void 0 : r.bottom) || 0),
  width: $(e.width) ? e.width : t.width
}));
function eA(e, t, { signal: r, edges: n } = {}) {
  let i, a = null;
  const o = n != null && n.includes("leading"), u = n == null || n.includes("trailing"), l = () => {
    a !== null && (e.apply(i, a), i = void 0, a = null);
  }, c = () => {
    u && l(), h();
  };
  let s = null;
  const f = () => {
    s != null && clearTimeout(s), s = setTimeout(() => {
      s = null, c();
    }, t);
  }, d = () => {
    s !== null && (clearTimeout(s), s = null);
  }, h = () => {
    d(), i = void 0, a = null;
  }, v = () => {
    l();
  }, p = function(...m) {
    if (r != null && r.aborted) return;
    i = this, a = m;
    const y = s == null;
    f(), o && y && l();
  };
  return p.schedule = f, p.cancel = h, p.flush = v, r == null || r.addEventListener("abort", h, { once: !0 }), p;
}
function tA(e, t = 0, r = {}) {
  typeof r != "object" && (r = {});
  const { leading: n = !1, trailing: i = !0, maxWait: a } = r, o = Array(2);
  n && (o[0] = "leading"), i && (o[1] = "trailing");
  let u, l = null;
  const c = eA(function(...d) {
    u = e.apply(this, d), l = null;
  }, t, { edges: o }), s = function(...d) {
    return a != null && (l === null && (l = Date.now()), Date.now() - l >= a) ? (u = e.apply(this, d), l = Date.now(), c.cancel(), c.schedule(), u) : (c.apply(this, d), u);
  }, f = () => (c.flush(), u);
  return s.cancel = c.cancel, s.flush = f, s;
}
function rA(e, t = 0, r = {}) {
  const { leading: n = !0, trailing: i = !0 } = r;
  return tA(e, t, {
    leading: n,
    maxWait: t,
    trailing: i
  });
}
var vs = function(t, r) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    i[a - 2] = arguments[a];
  if (typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, () => i[o++]));
    }
}, Pt = {
  width: "100%",
  height: "100%",
  debounce: 0,
  minWidth: 0,
  initialDimension: {
    width: -1,
    height: -1
  }
}, fp = (e, t, r) => {
  var n = r.width, i = n === void 0 ? Pt.width : n, a = r.height, o = a === void 0 ? Pt.height : a, u = r.aspect, l = r.maxHeight, c = Tr(i) ? e : Number(i), s = Tr(o) ? t : Number(o);
  return u && u > 0 && (c ? s = c / u : s && (c = s * u), l && s != null && s > l && (s = l)), {
    calculatedWidth: c,
    calculatedHeight: s
  };
}, nA = {
  width: 0,
  height: 0,
  overflow: "visible"
}, iA = {
  width: 0,
  overflowX: "visible"
}, aA = {
  height: 0,
  overflowY: "visible"
}, oA = {}, uA = (e) => {
  var t = e.width, r = e.height, n = Tr(t), i = Tr(r);
  return n && i ? nA : n ? iA : i ? aA : oA;
};
function lA(e) {
  var t = e.width, r = e.height, n = e.aspect, i = t, a = r;
  return i === void 0 && a === void 0 ? (i = Pt.width, a = Pt.height) : i === void 0 ? i = n && n > 0 ? void 0 : Pt.width : a === void 0 && (a = n && n > 0 ? void 0 : Pt.height), {
    width: i,
    height: a
  };
}
var cA = ["aspect", "initialDimension", "width", "height", "minWidth", "minHeight", "maxHeight", "children", "debounce", "id", "className", "onResize", "style"];
function la() {
  return la = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, la.apply(null, arguments);
}
function ps(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ms(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ps(Object(r), !0).forEach(function(n) {
      sA(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ps(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sA(e, t, r) {
  return (t = fA(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function fA(e) {
  var t = dA(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function dA(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hA(e, t) {
  return yA(e) || mA(e, t) || pA(e, t) || vA();
}
function vA() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pA(e, t) {
  if (e) {
    if (typeof e == "string") return ys(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ys(e, t) : void 0;
  }
}
function ys(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function mA(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function yA(e) {
  if (Array.isArray(e)) return e;
}
function gA(e, t) {
  if (e == null) return {};
  var r, n, i = bA(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function bA(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var dp = /* @__PURE__ */ Ge(Pt.initialDimension);
function xA(e) {
  return lr(e.width) && lr(e.height);
}
function hp(e) {
  var t = e.children, r = e.width, n = e.height, i = Ve(() => ({
    width: r,
    height: n
  }), [r, n]);
  return xA(i) ? /* @__PURE__ */ A.createElement(dp.Provider, {
    value: i
  }, t) : null;
}
var dl = () => rt(dp), wA = /* @__PURE__ */ Le((e, t) => {
  var r = e.aspect, n = e.initialDimension, i = n === void 0 ? Pt.initialDimension : n, a = e.width, o = e.height, u = e.minWidth, l = u === void 0 ? Pt.minWidth : u, c = e.minHeight, s = e.maxHeight, f = e.children, d = e.debounce, h = d === void 0 ? Pt.debounce : d, v = e.id, p = e.className, m = e.onResize, y = e.style, b = y === void 0 ? {} : y, w = gA(e, cA), x = X(null), O = X();
  O.current = m, kh(t, () => x.current);
  var g = be({
    containerWidth: i.width,
    containerHeight: i.height
  }), S = hA(g, 2), P = S[0], k = S[1], T = ne((K, V) => {
    k((R) => {
      var q = Math.round(K), W = Math.round(V);
      return R.containerWidth === q && R.containerHeight === W ? R : {
        containerWidth: q,
        containerHeight: W
      };
    });
  }, []);
  se(() => {
    if (x.current == null || typeof ResizeObserver > "u")
      return hn;
    var K = (he) => {
      var ve, ce = he[0];
      if (ce != null) {
        var ze = ce.contentRect, qe = ze.width, ht = ze.height;
        T(qe, ht), (ve = O.current) === null || ve === void 0 || ve.call(O, qe, ht);
      }
    };
    h > 0 && (K = rA(K, h, {
      trailing: !0,
      leading: !1
    }));
    var V = new ResizeObserver(K), R = x.current.getBoundingClientRect(), q = R.width, W = R.height;
    return T(q, W), V.observe(x.current), () => {
      V.disconnect();
    };
  }, [T, h]);
  var I = P.containerWidth, _ = P.containerHeight;
  vs(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
  var L = fp(I, _, {
    width: a,
    height: o,
    aspect: r,
    maxHeight: s
  }), D = L.calculatedWidth, F = L.calculatedHeight;
  return vs(I < 0 || _ < 0 || D != null && D > 0 || F != null && F > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, D, F, a, o, l, c, r), /* @__PURE__ */ A.createElement("div", la({
    id: v ? "".concat(v) : void 0,
    className: le("recharts-responsive-container", p),
    style: ms(ms({}, b), {}, {
      width: a,
      height: o,
      minWidth: l,
      minHeight: c,
      maxHeight: s
    }),
    ref: x
  }, w), /* @__PURE__ */ A.createElement("div", {
    style: uA({
      width: a,
      height: o
    })
  }, /* @__PURE__ */ A.createElement(hp, {
    width: D,
    height: F
  }, f)));
}), vp = /* @__PURE__ */ Le((e, t) => {
  var r = dl();
  if (lr(r.width) && lr(r.height))
    return e.children;
  var n = lA({
    width: e.width,
    height: e.height,
    aspect: e.aspect
  }), i = n.width, a = n.height, o = fp(void 0, void 0, {
    width: i,
    height: a,
    aspect: e.aspect,
    maxHeight: e.maxHeight
  }), u = o.calculatedWidth, l = o.calculatedHeight;
  return $(u) && $(l) ? /* @__PURE__ */ A.createElement(hp, {
    width: u,
    height: l
  }, e.children) : /* @__PURE__ */ A.createElement(wA, la({}, e, {
    width: i,
    height: a,
    ref: t
  }));
}), li = () => {
  var e, t = Ye(), r = N(Qw), n = N(Qa), i = (e = N(Za)) === null || e === void 0 ? void 0 : e.padding;
  return !t || !n || !i ? r : {
    width: n.width - i.left - i.right,
    height: n.height - i.top - i.bottom,
    x: i.left,
    y: i.top
  };
}, AA = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: 0,
  height: 0,
  brushBottom: 0
}, OA = () => {
  var e;
  return (e = N(Ee)) !== null && e !== void 0 ? e : AA;
}, SA = () => N(qt), EA = () => N(Xt), re = (e) => e.layout.layoutType, vn = () => N(re), pp = () => {
  var e = vn();
  if (e === "horizontal" || e === "vertical")
    return e;
}, mp = (e) => {
  var t = e.layout.layoutType;
  if (t === "centric" || t === "radial")
    return t;
}, _A = () => {
  var e = vn();
  return e !== void 0;
}, ci = (e) => {
  var t = oe(), r = Ye(), n = e.width, i = e.height, a = dl(), o = n, u = i;
  return a && (o = a.width > 0 ? a.width : n, u = a.height > 0 ? a.height : i), se(() => {
    !r && lr(o) && lr(u) && t(Aw({
      width: o,
      height: u
    }));
  }, [t, r, o, u]), null;
}, PA = {
  settings: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
    itemSorter: "value",
    position: void 0,
    offset: 0
  },
  size: {
    width: 0,
    height: 0
  },
  payload: []
}, yp = Re({
  name: "legend",
  initialState: PA,
  reducers: {
    setLegendSize(e, t) {
      e.size.width = t.payload.width, e.size.height = t.payload.height;
    },
    setLegendSettings(e, t) {
      e.settings.align = t.payload.align, e.settings.layout = t.payload.layout, e.settings.verticalAlign = t.payload.verticalAlign, e.settings.itemSorter = t.payload.itemSorter, e.settings.position = t.payload.position, e.settings.offset = t.payload.offset;
    },
    addLegendPayload: {
      reducer(e, t) {
        e.payload.push(Z(t.payload));
      },
      prepare: ie()
    },
    replaceLegendPayload: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next, a = at(e).payload.indexOf(Z(n));
        a > -1 && (e.payload[a] = Z(i));
      },
      prepare: ie()
    },
    removeLegendPayload: {
      reducer(e, t) {
        var r = at(e).payload.indexOf(Z(t.payload));
        r > -1 && e.payload.splice(r, 1);
      },
      prepare: ie()
    }
  }
}), si = yp.actions;
si.setLegendSize;
si.setLegendSettings;
var IA = si.addLegendPayload, kA = si.replaceLegendPayload, CA = si.removeLegendPayload, TA = yp.reducer, To = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gs;
function MA() {
  if (gs) return To;
  gs = 1;
  var e = dn;
  function t(l, c) {
    return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, i = e.useRef, a = e.useEffect, o = e.useMemo, u = e.useDebugValue;
  return To.useSyncExternalStoreWithSelector = function(l, c, s, f, d) {
    var h = i(null);
    if (h.current === null) {
      var v = { hasValue: !1, value: null };
      h.current = v;
    } else v = h.current;
    h = o(
      function() {
        function m(O) {
          if (!y) {
            if (y = !0, b = O, O = f(O), d !== void 0 && v.hasValue) {
              var g = v.value;
              if (d(g, O))
                return w = g;
            }
            return w = O;
          }
          if (g = w, r(b, O)) return g;
          var S = f(O);
          return d !== void 0 && d(g, S) ? (b = O, g) : (b = O, w = S);
        }
        var y = !1, b, w, x = s === void 0 ? null : s;
        return [
          function() {
            return m(c());
          },
          x === null ? void 0 : function() {
            return m(x());
          }
        ];
      },
      [c, s, f, d]
    );
    var p = n(l, h[0], h[1]);
    return a(
      function() {
        v.hasValue = !0, v.value = p;
      },
      [p]
    ), u(p), p;
  }, To;
}
var Mo = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bs;
function jA() {
  return bs || (bs = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, c) {
      return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = dn, r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, i = t.useRef, a = t.useEffect, o = t.useMemo, u = t.useDebugValue;
    Mo.useSyncExternalStoreWithSelector = function(l, c, s, f, d) {
      var h = i(null);
      if (h.current === null) {
        var v = { hasValue: !1, value: null };
        h.current = v;
      } else v = h.current;
      h = o(
        function() {
          function m(O) {
            if (!y) {
              if (y = !0, b = O, O = f(O), d !== void 0 && v.hasValue) {
                var g = v.value;
                if (d(g, O))
                  return w = g;
              }
              return w = O;
            }
            if (g = w, r(b, O))
              return g;
            var S = f(O);
            return d !== void 0 && d(g, S) ? (b = O, g) : (b = O, w = S);
          }
          var y = !1, b, w, x = s === void 0 ? null : s;
          return [
            function() {
              return m(c());
            },
            x === null ? void 0 : function() {
              return m(x());
            }
          ];
        },
        [c, s, f, d]
      );
      var p = n(l, h[0], h[1]);
      return a(
        function() {
          v.hasValue = !0, v.value = p;
        },
        [p]
      ), u(p), p;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Mo;
}
process.env.NODE_ENV === "production" ? MA() : jA();
function DA(e) {
  e();
}
function NA() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      DA(() => {
        let r = e;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      const r = [];
      let n = e;
      for (; n; )
        r.push(n), n = n.next;
      return r;
    },
    subscribe(r) {
      let n = !0;
      const i = t = {
        callback: r,
        next: null,
        prev: t
      };
      return i.prev ? i.prev.next = i : e = i, function() {
        !n || e === null || (n = !1, i.next ? i.next.prev = i.prev : t = i.prev, i.prev ? i.prev.next = i.next : e = i.next);
      };
    }
  };
}
var xs = {
  notify() {
  },
  get: () => []
};
function $A(e, t) {
  let r, n = xs, i = 0, a = !1;
  function o(p) {
    s();
    const m = n.subscribe(p);
    let y = !1;
    return () => {
      y || (y = !0, m(), f());
    };
  }
  function u() {
    n.notify();
  }
  function l() {
    v.onStateChange && v.onStateChange();
  }
  function c() {
    return a;
  }
  function s() {
    i++, r || (r = e.subscribe(l), n = NA());
  }
  function f() {
    i--, r && i === 0 && (r(), r = void 0, n.clear(), n = xs);
  }
  function d() {
    a || (a = !0, s());
  }
  function h() {
    a && (a = !1, f());
  }
  const v = {
    addNestedSub: o,
    notifyNestedSubs: u,
    handleChangeWrapper: l,
    isSubscribed: c,
    trySubscribe: d,
    tryUnsubscribe: h,
    getListeners: () => n
  };
  return v;
}
var LA = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", RA = /* @__PURE__ */ LA(), BA = () => typeof navigator < "u" && navigator.product === "ReactNative", zA = /* @__PURE__ */ BA(), FA = () => RA || zA ? A.useLayoutEffect : A.useEffect, WA = /* @__PURE__ */ FA();
function ws(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function UA(e, t) {
  if (ws(e, t)) return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length) return !1;
  for (let i = 0; i < r.length; i++)
    if (!Object.prototype.hasOwnProperty.call(t, r[i]) || !ws(e[r[i]], t[r[i]]))
      return !1;
  return !0;
}
var jo = /* @__PURE__ */ Symbol.for("react-redux-context"), Do = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function KA() {
  if (!A.createContext) return {};
  const e = Do[jo] ?? (Do[jo] = /* @__PURE__ */ new Map());
  let t = e.get(A.createContext);
  return t || (t = A.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(A.createContext, t)), t;
}
var VA = /* @__PURE__ */ KA();
function HA(e) {
  const { children: t, context: r, serverState: n, store: i } = e, a = A.useMemo(() => {
    const l = $A(i), c = {
      store: i,
      subscription: l,
      getServerState: n ? () => n : void 0
    };
    if (process.env.NODE_ENV === "production")
      return c;
    {
      const { identityFunctionCheck: s = "once", stabilityCheck: f = "once" } = e;
      return /* @__PURE__ */ Object.assign(c, {
        stabilityCheck: f,
        identityFunctionCheck: s
      });
    }
  }, [i, n]), o = A.useMemo(() => i.getState(), [i]);
  WA(() => {
    const { subscription: l } = a;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), o !== i.getState() && l.notifyNestedSubs(), () => {
      l.tryUnsubscribe(), l.onStateChange = void 0;
    };
  }, [a, o]);
  const u = r || VA;
  return /* @__PURE__ */ A.createElement(u.Provider, { value: a }, t);
}
var GA = HA, YA = /* @__PURE__ */ new Set([
  "axisLine",
  "tickLine",
  "activeBar",
  "activeDot",
  "activeLabel",
  "activeShape",
  "allowEscapeViewBox",
  "background",
  "cursor",
  "dot",
  "label",
  "line",
  "margin",
  "padding",
  "position",
  "shape",
  "style",
  "tick",
  "wrapperStyle",
  // radius can be an array of 4 numbers, easy to compare shallowly
  "radius",
  "throttledEvents"
]);
function qA(e, t) {
  return e == null && t == null ? !0 : typeof e == "number" && typeof t == "number" ? e === t || e !== e && t !== t : e === t;
}
function Ja(e, t) {
  var r = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]);
  for (var n of r)
    if (YA.has(n)) {
      if (e[n] == null && t[n] == null)
        continue;
      if (!UA(e[n], t[n]))
        return !1;
    } else if (!qA(e[n], t[n]))
      return !1;
  return !0;
}
function wu() {
  return wu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wu.apply(null, arguments);
}
function As(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function _n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? As(Object(r), !0).forEach(function(n) {
      XA(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : As(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function XA(e, t, r) {
  return (t = ZA(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ZA(e) {
  var t = QA(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function QA(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function JA(e, t) {
  return nO(e) || rO(e, t) || tO(e, t) || eO();
}
function eO() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tO(e, t) {
  if (e) {
    if (typeof e == "string") return Os(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Os(e, t) : void 0;
  }
}
function Os(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function rO(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function nO(e) {
  if (Array.isArray(e)) return e;
}
function iO(e) {
  return Array.isArray(e) && ut(e[0]) && ut(e[1]) ? e.join(" ~ ") : e;
}
var Wr = {
  separator: " : ",
  contentStyle: {
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  },
  itemStyle: {
    display: "block",
    paddingTop: 4,
    paddingBottom: 4,
    color: "#000"
  },
  labelStyle: {},
  accessibilityLayer: !1
};
function aO(e, t) {
  return t == null ? e : Ba(e, t);
}
var oO = (e) => {
  var t = e.separator, r = t === void 0 ? Wr.separator : t, n = e.contentStyle, i = e.itemStyle, a = e.labelStyle, o = a === void 0 ? Wr.labelStyle : a, u = e.payload, l = e.formatter, c = e.itemSorter, s = e.wrapperClassName, f = e.labelClassName, d = e.label, h = e.labelFormatter, v = e.accessibilityLayer, p = v === void 0 ? Wr.accessibilityLayer : v, m = () => {
    if (u && u.length) {
      var P = {
        padding: 0,
        margin: 0
      }, k = aO(u, c), T = k.map((I, _) => {
        if (!I || I.type === "none")
          return null;
        var L = I.formatter || l || iO, D = I.value, F = I.name, K = D, V = F;
        if (L) {
          var R = L(D, F, I, _, u);
          if (Array.isArray(R)) {
            var q = JA(R, 2);
            K = q[0], V = q[1];
          } else if (R != null)
            K = R;
          else
            return null;
        }
        var W = _n(_n({}, Wr.itemStyle), {}, {
          color: I.color || Wr.itemStyle.color
        }, i);
        return /* @__PURE__ */ A.createElement("li", {
          className: "recharts-tooltip-item",
          key: "tooltip-item-".concat(_),
          style: W
        }, ut(V) ? /* @__PURE__ */ A.createElement("span", {
          className: "recharts-tooltip-item-name"
        }, V) : null, ut(V) ? /* @__PURE__ */ A.createElement("span", {
          className: "recharts-tooltip-item-separator"
        }, r) : null, /* @__PURE__ */ A.createElement("span", {
          className: "recharts-tooltip-item-value"
        }, K), /* @__PURE__ */ A.createElement("span", {
          className: "recharts-tooltip-item-unit"
        }, I.unit || ""));
      });
      return /* @__PURE__ */ A.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: P
      }, T);
    }
    return null;
  }, y = _n(_n({}, Wr.contentStyle), n), b = _n({
    margin: 0
  }, o), w = !xe(d), x = w ? d : "", O = le("recharts-default-tooltip", s), g = le("recharts-tooltip-label", f);
  w && h && u !== void 0 && u !== null && (x = h(d, u));
  var S = p ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ A.createElement("div", wu({
    className: O,
    style: y
  }, S), /* @__PURE__ */ A.createElement("p", {
    className: g,
    style: b
  }, /* @__PURE__ */ A.isValidElement(x) ? x : "".concat(x)), m());
}, Pn = "recharts-tooltip-wrapper", uO = {
  visibility: "hidden"
};
function lO(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return le(Pn, {
    ["".concat(Pn, "-right")]: $(r) && t && $(t.x) && r >= t.x,
    ["".concat(Pn, "-left")]: $(r) && t && $(t.x) && r < t.x,
    ["".concat(Pn, "-bottom")]: $(n) && t && $(t.y) && n >= t.y,
    ["".concat(Pn, "-top")]: $(n) && t && $(t.y) && n < t.y
  });
}
function Ss(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offset, a = e.position, o = e.reverseDirection, u = e.tooltipDimension, l = e.viewBox, c = e.viewBoxDimension;
  if (a && $(a[n]))
    return a[n];
  var s = r[n] - u - (i > 0 ? i : 0), f = r[n] + i;
  if (t[n])
    return o[n] ? s : f;
  var d = l[n];
  if (d == null)
    return 0;
  if (o[n]) {
    var h = s, v = d;
    return h < v ? Math.max(f, d) : Math.max(s, d);
  }
  if (c == null)
    return 0;
  var p = f + u, m = d + c;
  return p > m ? Math.max(s, d) : Math.max(f, d);
}
function cO(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function sO(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTop, i = e.offsetLeft, a = e.position, o = e.reverseDirection, u = e.tooltipBox, l = e.useTranslate3d, c = e.viewBox, s, f, d;
  return u && u.height > 0 && u.width > 0 && r ? (f = Ss({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offset: i,
    position: a,
    reverseDirection: o,
    tooltipDimension: u.width,
    viewBox: c,
    viewBoxDimension: c.width
  }), d = Ss({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offset: n,
    position: a,
    reverseDirection: o,
    tooltipDimension: u.height,
    viewBox: c,
    viewBoxDimension: c.height
  }), s = cO({
    translateX: f,
    translateY: d,
    useTranslate3d: l
  })) : s = uO, {
    cssProperties: s,
    cssClasses: lO({
      translateX: f,
      translateY: d,
      coordinate: r
    })
  };
}
var fO = () => !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout), fi = {
  isSsr: fO()
};
function dO(e, t) {
  return mO(e) || pO(e, t) || vO(e, t) || hO();
}
function hO() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vO(e, t) {
  if (e) {
    if (typeof e == "string") return Es(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Es(e, t) : void 0;
  }
}
function Es(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function pO(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function mO(e) {
  if (Array.isArray(e)) return e;
}
function gp() {
  var e = be(() => fi.isSsr || !window.matchMedia ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches), t = dO(e, 2), r = t[0], n = t[1];
  return se(() => {
    if (window.matchMedia) {
      var i = window.matchMedia("(prefers-reduced-motion: reduce)"), a = () => {
        n(i.matches);
      };
      return i.addEventListener("change", a), () => {
        i.removeEventListener("change", a);
      };
    }
  }, []), r;
}
function _s(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ur(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _s(Object(r), !0).forEach(function(n) {
      yO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _s(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yO(e, t, r) {
  return (t = gO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function gO(e) {
  var t = bO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function bO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xO(e, t) {
  return SO(e) || OO(e, t) || AO(e, t) || wO();
}
function wO() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AO(e, t) {
  if (e) {
    if (typeof e == "string") return Ps(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Ps(e, t) : void 0;
  }
}
function Ps(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function OO(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function SO(e) {
  if (Array.isArray(e)) return e;
}
function EO(e) {
  if (!(e.prefersReducedMotion && e.isAnimationActive === "auto") && e.isAnimationActive && e.active) {
    var t = typeof e.animationEasing == "string" ? e.animationEasing : "ease";
    return "transform ".concat(e.animationDuration, "ms ").concat(t);
  }
}
function _O(e) {
  var t, r, n, i, a, o, u = gp(), l = A.useState(() => ({
    dismissed: !1,
    dismissedAtCoordinate: {
      x: 0,
      y: 0
    }
  })), c = xO(l, 2), s = c[0], f = c[1];
  A.useEffect(() => {
    var y = (b) => {
      if (b.key === "Escape") {
        var w, x, O, g;
        f({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (w = (x = e.coordinate) === null || x === void 0 ? void 0 : x.x) !== null && w !== void 0 ? w : 0,
            y: (O = (g = e.coordinate) === null || g === void 0 ? void 0 : g.y) !== null && O !== void 0 ? O : 0
          }
        });
      }
    };
    return document.addEventListener("keydown", y), () => {
      document.removeEventListener("keydown", y);
    };
  }, [(t = e.coordinate) === null || t === void 0 ? void 0 : t.x, (r = e.coordinate) === null || r === void 0 ? void 0 : r.y]), s.dismissed && (((n = (i = e.coordinate) === null || i === void 0 ? void 0 : i.x) !== null && n !== void 0 ? n : 0) !== s.dismissedAtCoordinate.x || ((a = (o = e.coordinate) === null || o === void 0 ? void 0 : o.y) !== null && a !== void 0 ? a : 0) !== s.dismissedAtCoordinate.y) && f(Ur(Ur({}, s), {}, {
    dismissed: !1
  }));
  var d = sO({
    allowEscapeViewBox: e.allowEscapeViewBox,
    coordinate: e.coordinate,
    offsetLeft: typeof e.offset == "number" ? e.offset : e.offset.x,
    offsetTop: typeof e.offset == "number" ? e.offset : e.offset.y,
    position: e.position,
    reverseDirection: e.reverseDirection,
    tooltipBox: e.lastBoundingBox,
    useTranslate3d: e.useTranslate3d,
    viewBox: e.viewBox
  }), h = d.cssClasses, v = d.cssProperties, p = e.hasPortalFromProps ? {} : Ur(Ur({
    transition: EO({
      prefersReducedMotion: u,
      isAnimationActive: e.isAnimationActive,
      active: e.active,
      animationDuration: e.animationDuration,
      animationEasing: e.animationEasing
    })
  }, v), {}, {
    pointerEvents: "none",
    position: "absolute",
    top: 0,
    left: 0
  }), m = Ur(Ur({}, p), {}, {
    visibility: !s.dismissed && e.active && e.hasPayload ? "visible" : "hidden"
  }, e.wrapperStyle);
  return /* @__PURE__ */ A.createElement("div", {
    // @ts-expect-error TypeScript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
    xmlns: "http://www.w3.org/1999/xhtml",
    tabIndex: -1,
    className: h,
    style: m,
    ref: e.innerRef
  }, e.children);
}
var PO = /* @__PURE__ */ A.memo(_O), bp = () => {
  var e;
  return (e = N((t) => t.rootProps.accessibilityLayer)) !== null && e !== void 0 ? e : !0;
};
function Au() {
  return Au = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Au.apply(null, arguments);
}
function Is(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ks(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Is(Object(r), !0).forEach(function(n) {
      IO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Is(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function IO(e, t, r) {
  return (t = kO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function kO(e) {
  var t = CO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function CO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Cs = {
  curveBasisClosed: R0,
  curveBasisOpen: B0,
  curveBasis: L0,
  curveBumpX: N0,
  curveBumpY: $0,
  curveLinearClosed: z0,
  curveLinear: La,
  curveMonotoneX: F0,
  curveMonotoneY: W0,
  curveNatural: U0,
  curveStep: K0,
  curveStepAfter: H0,
  curveStepBefore: V0
}, ca = (e) => H(e.x) && H(e.y), Ts = (e) => e.base != null && ca(e.base) && ca(e), In = (e) => e.x, kn = (e) => e.y, TO = (e, t) => {
  if (typeof e == "function")
    return e;
  var r = "curve".concat(qu(e));
  if ((r === "curveMonotone" || r === "curveBump") && t) {
    var n = Cs["".concat(r).concat(t === "vertical" ? "Y" : "X")];
    if (n)
      return n;
  }
  return Cs[r] || La;
}, Ms = {
  connectNulls: !1,
  type: "linear"
}, MO = (e) => {
  var t = e.type, r = t === void 0 ? Ms.type : t, n = e.points, i = n === void 0 ? [] : n, a = e.baseLine, o = e.layout, u = e.connectNulls, l = u === void 0 ? Ms.connectNulls : u, c = TO(r, o), s = l ? i.filter(ca) : i;
  if (Array.isArray(a)) {
    var f, d = i.map((y, b) => ks(ks({}, y), {}, {
      base: a[b]
    }));
    o === "vertical" ? f = Ei().y(kn).x1(In).x0((y) => y.base.x) : f = Ei().x(In).y1(kn).y0((y) => y.base.y);
    var h = f.defined(Ts).curve(c), v = l ? d.filter(Ts) : d;
    return h(v);
  }
  var p;
  o === "vertical" && $(a) ? p = Ei().y(kn).x1(In).x0(a) : $(a) ? p = Ei().x(In).y1(kn).y0(a) : p = Uh().x(In).y(kn);
  var m = p.defined(ca).curve(c);
  return m(s);
}, jO = (e) => {
  var t = e.className, r = e.points, n = e.path, i = e.pathRef, a = vn();
  if ((!r || !r.length) && !n)
    return null;
  var o = {
    type: e.type,
    points: e.points,
    baseLine: e.baseLine,
    layout: e.layout || a,
    connectNulls: e.connectNulls
  }, u = r && r.length ? MO(o) : n;
  return /* @__PURE__ */ A.createElement("path", Au({}, ur(e), J0(e), {
    className: le("recharts-curve", t),
    d: u === null ? void 0 : u,
    ref: i
  }));
}, DO = ["x", "y", "top", "left", "width", "height", "className"];
function Ou() {
  return Ou = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ou.apply(null, arguments);
}
function js(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function NO(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? js(Object(r), !0).forEach(function(n) {
      $O(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : js(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $O(e, t, r) {
  return (t = LO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function LO(e) {
  var t = RO(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function RO(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function BO(e, t) {
  if (e == null) return {};
  var r, n, i = zO(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function zO(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var FO = (e, t, r, n, i, a) => "M".concat(e, ",").concat(i, "v").concat(n, "M").concat(a, ",").concat(t, "h").concat(r), WO = (e) => {
  var t = e.x, r = t === void 0 ? 0 : t, n = e.y, i = n === void 0 ? 0 : n, a = e.top, o = a === void 0 ? 0 : a, u = e.left, l = u === void 0 ? 0 : u, c = e.width, s = c === void 0 ? 0 : c, f = e.height, d = f === void 0 ? 0 : f, h = e.className, v = BO(e, DO), p = NO({
    x: r,
    y: i,
    top: o,
    left: l,
    width: s,
    height: d
  }, v);
  return !$(r) || !$(i) || !$(s) || !$(d) || !$(o) || !$(l) ? null : /* @__PURE__ */ A.createElement("path", Ou({}, Tt(p), {
    className: le("recharts-cross", h),
    d: FO(r, i, s, d, o, l)
  }));
};
function UO(e, t, r, n) {
  var i = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - i,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
var sa = 1e-4, xp = (e, t) => [0, 3 * e, 3 * t - 6 * e, 3 * e - 3 * t + 1], wp = (e, t) => e.map((r, n) => r * t ** n).reduce((r, n) => r + n), Ds = (e, t) => (r) => {
  var n = xp(e, t);
  return wp(n, r);
}, KO = (e, t) => (r) => {
  var n = xp(e, t), i = [...n.map((a, o) => a * o).slice(1), 0];
  return wp(i, r);
}, VO = (e) => {
  var t, r = e.split("(");
  if (r.length !== 2 || r[0] !== "cubic-bezier")
    return null;
  var n = (t = r[1]) === null || t === void 0 || (t = t.split(")")[0]) === null || t === void 0 ? void 0 : t.split(",");
  if (n == null || n.length !== 4)
    return null;
  var i = n.map((a) => parseFloat(a));
  return [i[0], i[1], i[2], i[3]];
}, HO = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        return [0, 0, 1, 1];
      case "ease":
        return [0.25, 0.1, 0.25, 1];
      case "ease-in":
        return [0.42, 0, 1, 1];
      case "ease-out":
        return [0.42, 0, 0.58, 1];
      case "ease-in-out":
        return [0, 0, 0.58, 1];
      default: {
        var i = VO(r[0]);
        if (i)
          return i;
      }
    }
  return r.length === 4 ? r : [0, 0, 1, 1];
}, GO = (e, t, r, n) => {
  var i = Ds(e, r), a = Ds(t, n), o = KO(e, r), u = (c) => c > 1 ? 1 : c < 0 ? 0 : c, l = (c) => {
    for (var s = c > 1 ? 1 : c, f = s, d = 0; d < 8; ++d) {
      var h = i(f) - s, v = o(f);
      if (Math.abs(h - s) < sa || v < sa)
        return a(f);
      f = u(f - h / v);
    }
    return a(f);
  };
  return l.isStepper = !1, l;
}, Ns = function() {
  return GO(...HO(...arguments));
}, YO = function() {
  for (var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, a = i === void 0 ? 8 : i, o = t.dt, u = o === void 0 ? 16.67 : o, l = 1, c = [0], s = 0, f = 0, d = 1e4, h = 0; h < d; ) {
    var v = -(s - l) * n, p = f * a;
    if (f += (v - p) * u / 1e3, s += f * u / 1e3, c.push(s), Math.abs(s - l) < sa && Math.abs(f) < sa)
      break;
    h++;
  }
  c[c.length - 1] = l;
  var m = c.length - 1;
  return (y) => {
    var b, w, x;
    if (y <= 0) return 0;
    if (y >= 1) return l;
    var O = y * m, g = Math.floor(O), S = O - g;
    return ((b = c[g]) !== null && b !== void 0 ? b : 0) + (((w = c[g + 1]) !== null && w !== void 0 ? w : 0) - ((x = c[g]) !== null && x !== void 0 ? x : 0)) * S;
  };
}, qO = (e) => {
  if (typeof e == "string")
    switch (e) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return Ns(e);
      case "spring":
        return YO();
      default:
        if (e.split("(")[0] === "cubic-bezier")
          return Ns(e);
    }
  return typeof e == "function" ? e : null;
}, XO = (e, t, r) => {
  var n, i = (a) => {
    var o = t.tick(a);
    if (t.getState() === "active") {
      if (r(t.getInterpolated()), t.getProgress() === 1) {
        t.complete(), n = void 0;
        return;
      }
      n = e.setTimeout(i, o);
      return;
    }
    n = e.setTimeout(i, o);
  };
  return n = e.setTimeout(i, 0), () => {
    var a;
    return (a = n) === null || a === void 0 ? void 0 : a();
  };
}, Ap = /* @__PURE__ */ Ge(XO);
Ap.Provider;
function ZO(e) {
  var t = rt(Ap);
  return Ve(() => e ?? t, [e, t]);
}
function QO(e, t, r) {
  return (t = JO(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JO(e) {
  var t = e1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function e1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $s = "init", Ls = "pending", Rs = "active", t1 = "completed";
function No(e) {
  return Math.max(0, e);
}
class r1 {
  /**
   * Returns the absolute time after the animationBegin delay has been completed,
   * and when the animationDuration started ticking.
   */
  getAnimationStartedTime() {
    return this.animationStartedTime;
  }
  /**
   * Returns the absolute time of when the animation began - now it will wait for {animationBegin} ms before the transition starts
   */
  getBeginStartedTime() {
    return this.beginStartedTime;
  }
  constructor(t) {
    var r;
    QO(this, "state", $s), this.animationId = t.animationId, this.onAnimationEnd = t.onAnimationEnd, this.animationDuration = No(t.animationDuration), this.animationBegin = No(t.animationBegin), this.progress = 0, this.from = t.from, this.to = t.to, this.easing = t.easing, (r = t.onAnimationStart) === null || r === void 0 || r.call(t);
  }
  /**
   * Returns the state machine current state
   * - `init`:       animation had just been created. It immediately calls `onAnimationStart`
   * - `pending`:    animation is now paused for `animationBegin` milliseconds until the transition begins
   * - `active`:     animation is transitioning items on screen
   * - `completed`:  animation has completed its transition and executed `onAnimationEnd`.
   *                 This state is final and the animation is no longer allowed to transition to other states.
   */
  getState() {
    return this.state;
  }
  /**
   * Returns the easing input or function
   */
  getEasing() {
    return this.easing;
  }
  /**
   * Returns the configuration - the duration of the transition.
   * Does not change in time, does not change when state changes, this is a static value.
   */
  getAnimationDuration() {
    return this.animationDuration;
  }
  /**
   * Sets the current time of the animation. The animation sets its internal state and progress accordingly.
   * This is current, absolute time; not additive!
   * This allows you to essentially "travel back in time" based on the value you pass in here.
   *
   * Returns the (relative) time remaining until the current activity is over.
   * Meaning: if the state is in a middle of a delay, returns the time left until the delay is finished.
   * If the state is in the middle of a transition, returns time left until that transition is complete.
   * This is useful because it's the same number you can take and put into setTimeout(fn, X)
   * as that's how much time we need to wait until the next state transition happens.
   */
  tick(t) {
    if (this.getState() === $s)
      return this.state = Ls, this.beginStartedTime = t, this.animationBegin;
    if (this.getState() === Ls) {
      if (this.beginStartedTime == null)
        throw new Error();
      var r = t - this.beginStartedTime;
      return r >= this.animationBegin ? (this.state = Rs, this.animationStartedTime = t, this.nextAnimationUpdate(0)) : No(this.animationBegin - r);
    }
    if (this.getState() === Rs) {
      if (this.animationStartedTime == null)
        throw new Error();
      var n = t - this.animationStartedTime;
      return this.setProgress(n / this.animationDuration), this.nextAnimationUpdate(n);
    }
    return 0;
  }
  setProgress(t) {
    this.progress = Math.min(1, Math.max(0, t));
  }
  /**
   * Returns an abstract "progress" which is number between 0 and 1 which shows the distance of transition.
   * This progress depends on the animation state:
   * - `init`: 0
   * - `pending`: 0
   * - `active`: transitioning between [0, 1] based on the time elapsed
   * - `completed`: 1
   *
   * The progress is hard-capped to be between 0 and 1 (inclusive) to avoid overshooting caused by coarse timers.
   * For this reason, the easing function must be applied _after_ this animation state,
   * so that one has a chance to construct dynamic "overshoot" animations.
   *
   * The progress is linear with time.
   * If you wish for easing, use `getInterpolated()` instead.
   */
  getProgress() {
    return this.progress;
  }
  /**
   * Completes the animation. Completed animation:
   * - cannot be manipulated anymore
   * - its progress is set to 1
   * - tick function doesn't do anything
   * - getState() always returns 'completed'
   */
  complete() {
    if (this.progress = 1, this.state === "active") {
      var t;
      (t = this.onAnimationEnd) === null || t === void 0 || t.call(this);
    }
    this.state = t1;
  }
  /**
   * Returns the starting value of the animation.
   * Does not include progress, easing, interpolation, none of that - just the static starting value
   */
  getFrom() {
    return this.from;
  }
  /**
   * Returns the end value of the animation.
   * Does not include progress, easing, interpolation, none of that - just the static end value
   */
  getTo() {
    return this.to;
  }
  /**
   * Unique identifier of an animation
   */
  getAnimationId() {
    return this.animationId;
  }
  /**
   * Returns the configuration - the duration of delay in between animation initialization, and transition.
   * Does not change in time, does not change when state changes, this is a static value.
   */
  getAnimationBegin() {
    return this.animationBegin;
  }
  /**
   * Returns value of the transition at the current time.
   * The exact details differ based on the animation type
   */
  /**
   * Returns the duration of time of when the controller should ask for the next update
   */
}
class n1 extends r1 {
  // eslint-disable-next-line class-methods-use-this
  nextAnimationUpdate() {
    return 0;
  }
  /**
   * Returns value of the animation after its easing function had been applied.
   * This value, unlike getProgress(), can escape the [0..1] range
   * because this is entirely within the easing function control. Spring typically does this.
   */
  getInterpolated() {
    return this.easing(De(this.getFrom(), this.getTo(), this.getProgress()));
  }
}
class i1 {
  setTimeout(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = performance.now(), i = null, a = (o) => {
      o - n >= r ? t(o) : i = requestAnimationFrame(a);
    };
    return i = requestAnimationFrame(a), () => {
      i != null && cancelAnimationFrame(i);
    };
  }
}
function a1(e, t) {
  return c1(e) || l1(e, t) || u1(e, t) || o1();
}
function o1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u1(e, t) {
  if (e) {
    if (typeof e == "string") return Bs(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Bs(e, t) : void 0;
  }
}
function Bs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function l1(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function c1(e) {
  if (Array.isArray(e)) return e;
}
var s1 = {
  begin: 0,
  duration: 1e3,
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  onAnimationEnd: () => {
  },
  onAnimationStart: () => {
  }
}, zs = 0, $o = 1;
function Op(e) {
  var t = st(e, s1), r = t.animationId, n = t.isActive, i = t.canBegin, a = t.duration, o = t.easing, u = t.begin, l = t.onAnimationEnd, c = t.onAnimationStart, s = t.children, f = gp(), d = n === "auto" ? !fi.isSsr && !f : n, h = ZO(t.animationController), v = be(d ? zs : $o), p = a1(v, 2), m = p[0], y = p[1];
  return se(() => {
    d || y($o);
  }, [d]), se(() => {
    var b = qO(o);
    if (!d || !i || b == null)
      return hn;
    var w = new i1(), x = new n1({
      animationId: r,
      easing: b,
      animationDuration: a,
      animationBegin: u,
      onAnimationStart: c,
      onAnimationEnd: l,
      from: zs,
      to: $o
    });
    return h(w, x, y);
  }, [h, r, d, i, a, o, u, c, l]), s(Number(m));
}
function Sp(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "animation-", r = X(Un(t)), n = X(e);
  return n.current !== e && (r.current = Un(t), n.current = e), r.current;
}
var f1 = (e) => e.replace(/([A-Z])/g, (t) => "-".concat(t.toLowerCase())), d1 = (e, t, r) => e.map((n) => "".concat(f1(n), " ").concat(t, "ms ").concat(r)).join(","), h1 = ["radius"], v1 = ["radius"], Fs, Ws, Us, Ks, Vs, Hs, Gs, Ys, qs, Xs;
function Zs(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zs(Object(r), !0).forEach(function(n) {
      p1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zs(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function p1(e, t, r) {
  return (t = m1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function m1(e) {
  var t = y1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function y1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fa() {
  return fa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, fa.apply(null, arguments);
}
function Js(e, t) {
  if (e == null) return {};
  var r, n, i = g1(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function g1(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function b1(e, t) {
  return O1(e) || A1(e, t) || w1(e, t) || x1();
}
function x1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w1(e, t) {
  if (e) {
    if (typeof e == "string") return ef(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ef(e, t) : void 0;
  }
}
function ef(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function A1(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function O1(e) {
  if (Array.isArray(e)) return e;
}
function St(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var tf = (e, t, r, n, i) => {
  var a = ir(r), o = ir(n), u = Math.min(Math.abs(a) / 2, Math.abs(o) / 2), l = o >= 0 ? 1 : -1, c = a >= 0 ? 1 : -1, s = o >= 0 && a >= 0 || o < 0 && a < 0 ? 1 : 0, f;
  if (u > 0 && Array.isArray(i)) {
    for (var d = [0, 0, 0, 0], h = 0, v = 4; h < v; h++) {
      var p, m = (p = i[h]) !== null && p !== void 0 ? p : 0;
      d[h] = m > u ? u : m;
    }
    f = Ce(Fs || (Fs = St(["M", ",", ""])), e, t + l * d[0]), d[0] > 0 && (f += Ce(Ws || (Ws = St(["A ", ",", ",0,0,", ",", ",", ""])), d[0], d[0], s, e + c * d[0], t)), f += Ce(Us || (Us = St(["L ", ",", ""])), e + r - c * d[1], t), d[1] > 0 && (f += Ce(Ks || (Ks = St(["A ", ",", ",0,0,", `,
        `, ",", ""])), d[1], d[1], s, e + r, t + l * d[1])), f += Ce(Vs || (Vs = St(["L ", ",", ""])), e + r, t + n - l * d[2]), d[2] > 0 && (f += Ce(Hs || (Hs = St(["A ", ",", ",0,0,", `,
        `, ",", ""])), d[2], d[2], s, e + r - c * d[2], t + n)), f += Ce(Gs || (Gs = St(["L ", ",", ""])), e + c * d[3], t + n), d[3] > 0 && (f += Ce(Ys || (Ys = St(["A ", ",", ",0,0,", `,
        `, ",", ""])), d[3], d[3], s, e, t + n - l * d[3])), f += "Z";
  } else if (u > 0 && i === +i && i > 0) {
    var y = Math.min(u, i);
    f = Ce(qs || (qs = St(["M ", ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", " Z"])), e, t + l * y, y, y, s, e + c * y, t, e + r - c * y, t, y, y, s, e + r, t + l * y, e + r, t + n - l * y, y, y, s, e + r - c * y, t + n, e + c * y, t + n, y, y, s, e, t + n - l * y);
  } else
    f = Ce(Xs || (Xs = St(["M ", ",", " h ", " v ", " h ", " Z"])), e, t, r, n, -r);
  return f;
}, rf = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Ep = (e) => {
  var t = st(e, rf), r = X(null), n = be(-1), i = b1(n, 2), a = i[0], o = i[1];
  se(() => {
    if (r.current && r.current.getTotalLength)
      try {
        var R = r.current.getTotalLength();
        R && o(R);
      } catch {
      }
  }, []);
  var u = t.x, l = t.y, c = t.width, s = t.height, f = t.radius, d = t.className, h = t.animationEasing, v = t.animationDuration, p = t.animationBegin, m = t.isAnimationActive, y = t.isUpdateAnimationActive, b = X(c), w = X(s), x = X(u), O = X(l), g = Ve(() => ({
    x: u,
    y: l,
    width: c,
    height: s,
    radius: f
  }), [u, l, c, s, f]), S = Sp(g, "rectangle-");
  if (u !== +u || l !== +l || c !== +c || s !== +s || c === 0 || s === 0)
    return null;
  var P = le("recharts-rectangle", d);
  if (!y) {
    var k = Tt(t);
    k.radius;
    var T = Js(k, h1);
    return /* @__PURE__ */ A.createElement("path", fa({}, T, {
      x: ir(u),
      y: ir(l),
      width: ir(c),
      height: ir(s),
      radius: typeof f == "number" ? f : void 0,
      className: P,
      d: tf(u, l, c, s, f)
    }));
  }
  var I = b.current, _ = w.current, L = x.current, D = O.current, F = "0px ".concat(a === -1 ? 1 : a, "px"), K = "".concat(a, "px ").concat(a, "px"), V = d1(["strokeDasharray"], v, typeof h == "string" ? h : rf.animationEasing);
  return /* @__PURE__ */ A.createElement(Op, {
    animationId: S,
    key: S,
    canBegin: a > 0,
    duration: v,
    easing: h,
    isActive: y,
    begin: p
  }, (R) => {
    var q = De(I, c, R), W = De(_, s, R), he = De(L, u, R), ve = De(D, l, R);
    r.current && (b.current = q, w.current = W, x.current = he, O.current = ve);
    var ce;
    m ? R > 0 ? ce = {
      transition: V,
      strokeDasharray: K
    } : ce = {
      strokeDasharray: F
    } : ce = {
      strokeDasharray: K
    };
    var ze = Tt(t);
    ze.radius;
    var qe = Js(ze, v1);
    return /* @__PURE__ */ A.createElement("path", fa({}, qe, {
      radius: typeof f == "number" ? f : void 0,
      className: P,
      d: tf(he, ve, q, W, f),
      ref: r,
      style: Qs(Qs({}, ce), t.style)
    }));
  });
};
function nf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function af(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nf(Object(r), !0).forEach(function(n) {
      S1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nf(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function S1(e, t, r) {
  return (t = E1(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function E1(e) {
  var t = _1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function _1(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var da = Math.PI / 180, P1 = (e) => e * 180 / Math.PI, Me = (e, t, r, n) => ({
  x: e + Math.cos(-da * n) * r,
  y: t + Math.sin(-da * n) * r
}), I1 = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, k1 = (e, t) => {
  var r = e.x, n = e.y, i = t.x, a = t.y;
  return Math.sqrt((r - i) ** 2 + (n - a) ** 2);
}, C1 = (e, t) => {
  var r = e.x, n = e.y, i = t.cx, a = t.cy, o = k1({
    x: r,
    y: n
  }, {
    x: i,
    y: a
  });
  if (o <= 0)
    return {
      radius: o,
      angle: 0
    };
  var u = (r - i) / o, l = Math.acos(u);
  return n > a && (l = 2 * Math.PI - l), {
    radius: o,
    angle: P1(l),
    angleInRadian: l
  };
}, T1 = (e) => {
  var t = e.startAngle, r = e.endAngle, n = Math.floor(t / 360), i = Math.floor(r / 360), a = Math.min(n, i);
  return {
    startAngle: t - a * 360,
    endAngle: r - a * 360
  };
}, M1 = (e, t) => {
  var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), a = Math.floor(n / 360), o = Math.min(i, a);
  return e + o * 360;
}, j1 = (e, t) => {
  var r = e.relativeX, n = e.relativeY, i = C1({
    x: r,
    y: n
  }, t), a = i.radius, o = i.angle, u = t.innerRadius, l = t.outerRadius;
  if (a < u || a > l || a === 0)
    return null;
  var c = T1(t), s = c.startAngle, f = c.endAngle, d = o, h;
  if (s <= f) {
    for (; d > f; )
      d -= 360;
    for (; d < s; )
      d += 360;
    h = d >= s && d <= f;
  } else {
    for (; d > s; )
      d -= 360;
    for (; d < f; )
      d += 360;
    h = d >= f && d <= s;
  }
  return h ? af(af({}, t), {}, {
    radius: a,
    angle: M1(d, t)
  }) : null;
};
function _p(e) {
  var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, a = e.endAngle, o = Me(t, r, n, i), u = Me(t, r, n, a);
  return {
    points: [o, u],
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  };
}
var of, uf, lf, cf, sf, ff, df;
function Su() {
  return Su = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Su.apply(null, arguments);
}
function Or(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
var D1 = (e, t) => {
  var r = Je(t - e), n = Math.min(Math.abs(t - e), 359.999);
  return r * n;
}, Di = (e) => {
  var t = e.cx, r = e.cy, n = e.radius, i = e.angle, a = e.sign, o = e.isExternal, u = e.cornerRadius, l = e.cornerIsExternal, c = u * (o ? 1 : -1) + n, s = Math.asin(u / c) / da, f = l ? i : i + a * s, d = Me(t, r, c, f), h = Me(t, r, n, f), v = l ? i - a * s : i, p = Me(t, r, c * Math.cos(s * da), v);
  return {
    center: d,
    circleTangency: h,
    lineTangency: p,
    theta: s
  };
}, Pp = (e) => {
  var t = e.cx, r = e.cy, n = e.innerRadius, i = e.outerRadius, a = e.startAngle, o = e.endAngle, u = D1(a, o), l = a + u, c = Me(t, r, i, a), s = Me(t, r, i, l), f = Ce(of || (of = Or(["M ", ",", `
    A `, ",", `,0,
    `, ",", `,
    `, ",", `
  `])), c.x, c.y, i, i, +(Math.abs(u) > 180), +(a > l), s.x, s.y);
  if (n > 0) {
    var d = Me(t, r, n, a), h = Me(t, r, n, l);
    f += Ce(uf || (uf = Or(["L ", ",", `
            A `, ",", `,0,
            `, ",", `,
            `, ",", " Z"])), h.x, h.y, n, n, +(Math.abs(u) > 180), +(a <= l), d.x, d.y);
  } else
    f += Ce(lf || (lf = Or(["L ", ",", " Z"])), t, r);
  return f;
}, N1 = (e) => {
  var t = e.cx, r = e.cy, n = e.innerRadius, i = e.outerRadius, a = e.cornerRadius, o = e.forceCornerRadius, u = e.cornerIsExternal, l = e.startAngle, c = e.endAngle, s = Je(c - l), f = Di({
    cx: t,
    cy: r,
    radius: i,
    angle: l,
    sign: s,
    cornerRadius: a,
    cornerIsExternal: u
  }), d = f.circleTangency, h = f.lineTangency, v = f.theta, p = Di({
    cx: t,
    cy: r,
    radius: i,
    angle: c,
    sign: -s,
    cornerRadius: a,
    cornerIsExternal: u
  }), m = p.circleTangency, y = p.lineTangency, b = p.theta, w = u ? Math.abs(l - c) : Math.abs(l - c) - v - b;
  if (w < 0)
    return o ? Ce(cf || (cf = Or(["M ", ",", `
        a`, ",", ",0,0,1,", `,0
        a`, ",", ",0,0,1,", `,0
      `])), h.x, h.y, a, a, a * 2, a, a, -a * 2) : Pp({
      cx: t,
      cy: r,
      innerRadius: n,
      outerRadius: i,
      startAngle: l,
      endAngle: c
    });
  var x = Ce(sf || (sf = Or(["M ", ",", `
    A`, ",", ",0,0,", ",", ",", `
    A`, ",", ",0,", ",", ",", ",", `
    A`, ",", ",0,0,", ",", ",", `
  `])), h.x, h.y, a, a, +(s < 0), d.x, d.y, i, i, +(w > 180), +(s < 0), m.x, m.y, a, a, +(s < 0), y.x, y.y);
  if (n > 0) {
    var O = Di({
      cx: t,
      cy: r,
      radius: n,
      angle: l,
      sign: s,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: u
    }), g = O.circleTangency, S = O.lineTangency, P = O.theta, k = Di({
      cx: t,
      cy: r,
      radius: n,
      angle: c,
      sign: -s,
      isExternal: !0,
      cornerRadius: a,
      cornerIsExternal: u
    }), T = k.circleTangency, I = k.lineTangency, _ = k.theta, L = u ? Math.abs(l - c) : Math.abs(l - c) - P - _;
    if (L < 0 && a === 0)
      return "".concat(x, "L").concat(t, ",").concat(r, "Z");
    x += Ce(ff || (ff = Or(["L", ",", `
      A`, ",", ",0,0,", ",", ",", `
      A`, ",", ",0,", ",", ",", ",", `
      A`, ",", ",0,0,", ",", ",", "Z"])), I.x, I.y, a, a, +(s < 0), T.x, T.y, n, n, +(L > 180), +(s > 0), g.x, g.y, a, a, +(s < 0), S.x, S.y);
  } else
    x += Ce(df || (df = Or(["L", ",", "Z"])), t, r);
  return x;
}, $1 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, L1 = (e) => {
  var t = st(e, $1), r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.cornerRadius, u = t.forceCornerRadius, l = t.cornerIsExternal, c = t.startAngle, s = t.endAngle, f = t.className;
  if (a < i || c === s)
    return null;
  var d = le("recharts-sector", f), h = a - i, v = bt(o, h, 0, !0), p;
  return v > 0 && Math.abs(c - s) < 360 ? p = N1({
    cx: r,
    cy: n,
    innerRadius: i,
    outerRadius: a,
    cornerRadius: Math.min(v, h / 2),
    forceCornerRadius: u,
    cornerIsExternal: l,
    startAngle: c,
    endAngle: s
  }) : p = Pp({
    cx: r,
    cy: n,
    innerRadius: i,
    outerRadius: a,
    startAngle: c,
    endAngle: s
  }), /* @__PURE__ */ A.createElement("path", Su({}, Tt(t), {
    className: d,
    d: p
  }));
};
function R1(e, t, r) {
  if (e === "horizontal")
    return [{
      x: t.x,
      y: r.top
    }, {
      x: t.x,
      y: r.top + r.height
    }];
  if (e === "vertical")
    return [{
      x: r.left,
      y: t.y
    }, {
      x: r.left + r.width,
      y: t.y
    }];
  if (Qh(t)) {
    if (e === "centric") {
      var n = t.cx, i = t.cy, a = t.innerRadius, o = t.outerRadius, u = t.angle, l = Me(n, i, a, u), c = Me(n, i, o, u);
      return [{
        x: l.x,
        y: l.y
      }, {
        x: c.x,
        y: c.y
      }];
    }
    return _p(t);
  }
}
function B1(e) {
  return Pv(e) ? NaN : Number(e);
}
function Lo(e) {
  return e ? (e = B1(e), e === 1 / 0 || e === -1 / 0 ? (e < 0 ? -1 : 1) * Number.MAX_VALUE : e === e ? e : 0) : e === 0 ? e : 0;
}
function Ip(e, t, r) {
  r && typeof r != "number" && cu(e, t, r) && (t = r = void 0), e = Lo(e), t === void 0 ? (t = e, e = 0) : t = Lo(t), r = r === void 0 ? e < t ? 1 : -1 : Lo(r);
  const n = Math.max(Math.ceil((t - e) / (r || 1)), 0), i = new Array(n);
  for (let a = 0; a < n; a++)
    i[a] = e, e += r;
  return i;
}
var wt = (e) => e.chartData, hl = E([wt], (e) => {
  var t = e.chartData != null ? e.chartData.length - 1 : 0;
  return {
    chartData: e.chartData,
    computedData: e.computedData,
    dataEndIndex: t,
    dataStartIndex: 0
  };
}), eo = (e, t, r, n) => n ? hl(e) : wt(e), z1 = (e, t, r) => r ? hl(e) : wt(e), F1 = E([eo], (e) => {
  var t = e.chartData, r = e.dataStartIndex, n = e.dataEndIndex;
  return t != null ? t.slice(r, n + 1) : [];
});
E([hl], (e) => {
  var t = e.chartData, r = e.dataStartIndex, n = e.dataEndIndex;
  return t != null ? t.slice(r, n + 1) : [];
});
var W1 = E([wt], (e) => {
  var t = e.chartData, r = e.dataStartIndex, n = e.dataEndIndex;
  return t != null ? t.slice(r, n + 1) : [];
});
function vl(e, t) {
  return H1(e) || V1(e, t) || K1(e, t) || U1();
}
function U1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function K1(e, t) {
  if (e) {
    if (typeof e == "string") return hf(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? hf(e, t) : void 0;
  }
}
function hf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function V1(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function H1(e) {
  if (Array.isArray(e)) return e;
}
function kt(e) {
  if (Array.isArray(e) && e.length === 2) {
    var t = vl(e, 2), r = t[0], n = t[1];
    if (H(r) && H(n))
      return !0;
  }
  return !1;
}
function vf(e, t, r) {
  return r ? e : [Math.min(e[0], t[0]), Math.max(e[1], t[1])];
}
function kp(e, t) {
  if (t && typeof e != "function" && Array.isArray(e) && e.length === 2) {
    var r = vl(e, 2), n = r[0], i = r[1], a, o;
    if (H(n))
      a = n;
    else if (typeof n == "function")
      return;
    if (H(i))
      o = i;
    else if (typeof i == "function")
      return;
    var u = [a, o];
    if (kt(u))
      return u;
  }
}
function G1(e, t, r) {
  if (!(!r && t == null)) {
    if (typeof e == "function" && t != null)
      try {
        var n = e(t, r);
        if (kt(n))
          return vf(n, t, r);
      } catch {
      }
    if (Array.isArray(e) && e.length === 2) {
      var i = vl(e, 2), a = i[0], o = i[1], u, l;
      if (a === "auto")
        t != null && (u = Math.min(...t));
      else if ($(a))
        u = a;
      else if (typeof a == "function")
        try {
          t != null && (u = a(t == null ? void 0 : t[0]));
        } catch {
        }
      else if (typeof a == "string" && ss.test(a)) {
        var c = ss.exec(a);
        if (c == null || c[1] == null || t == null)
          u = void 0;
        else {
          var s = +c[1];
          u = t[0] - s;
        }
      } else
        u = t == null ? void 0 : t[0];
      if (o === "auto")
        t != null && (l = Math.max(...t));
      else if ($(o))
        l = o;
      else if (typeof o == "function")
        try {
          t != null && (l = o(t == null ? void 0 : t[1]));
        } catch {
        }
      else if (typeof o == "string" && fs.test(o)) {
        var f = fs.exec(o);
        if (f == null || f[1] == null || t == null)
          l = void 0;
        else {
          var d = +f[1];
          l = t[1] + d;
        }
      } else
        l = t == null ? void 0 : t[1];
      var h = [u, l];
      if (kt(h))
        return t == null ? h : vf(h, t, r);
    }
  }
}
var pn = 1e9, Y1 = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, ml, ue = !0, ct = "[DecimalError] ", Ir = ct + "Invalid argument: ", pl = ct + "Exponent out of range: ", mn = Math.floor, br = Math.pow, q1 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Qe, Oe = 1e7, ae = 7, Cp = 9007199254740991, ha = mn(Cp / ae), j = {};
j.absoluteValue = j.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
j.comparedTo = j.cmp = function(e) {
  var t, r, n, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ a.s < 0 ? 1 : -1;
};
j.decimalPlaces = j.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * ae;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
j.dividedBy = j.div = function(e) {
  return Ut(this, new this.constructor(e));
};
j.dividedToIntegerBy = j.idiv = function(e) {
  var t = this, r = t.constructor;
  return te(Ut(t, new r(e), 0, 1), r.precision);
};
j.equals = j.eq = function(e) {
  return !this.cmp(e);
};
j.exponent = function() {
  return pe(this);
};
j.greaterThan = j.gt = function(e) {
  return this.cmp(e) > 0;
};
j.greaterThanOrEqualTo = j.gte = function(e) {
  return this.cmp(e) >= 0;
};
j.isInteger = j.isint = function() {
  return this.e > this.d.length - 2;
};
j.isNegative = j.isneg = function() {
  return this.s < 0;
};
j.isPositive = j.ispos = function() {
  return this.s > 0;
};
j.isZero = function() {
  return this.s === 0;
};
j.lessThan = j.lt = function(e) {
  return this.cmp(e) < 0;
};
j.lessThanOrEqualTo = j.lte = function(e) {
  return this.cmp(e) < 1;
};
j.logarithm = j.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, a = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Qe)) throw Error(ct + "NaN");
  if (r.s < 1) throw Error(ct + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Qe) ? new n(0) : (ue = !1, t = Ut(Gn(r, a), Gn(e, a), a), ue = !0, te(t, i));
};
j.minus = j.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? jp(t, e) : Tp(t, (e.s = -e.s, e));
};
j.modulo = j.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(ct + "NaN");
  return r.s ? (ue = !1, t = Ut(r, e, 0, 1).times(e), ue = !0, r.minus(t)) : te(new n(r), i);
};
j.naturalExponential = j.exp = function() {
  return Mp(this);
};
j.naturalLogarithm = j.ln = function() {
  return Gn(this);
};
j.negated = j.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
j.plus = j.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? Tp(t, e) : jp(t, (e.s = -e.s, e));
};
j.precision = j.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Ir + e);
  if (t = pe(i) + 1, n = i.d.length - 1, r = n * ae + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
j.squareRoot = j.sqrt = function() {
  var e, t, r, n, i, a, o, u = this, l = u.constructor;
  if (u.s < 1) {
    if (!u.s) return new l(0);
    throw Error(ct + "NaN");
  }
  for (e = pe(u), ue = !1, i = Math.sqrt(+u), i == 0 || i == 1 / 0 ? (t = It(u.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = mn((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new l(t)) : n = new l(i.toString()), r = l.precision, i = o = r + 3; ; )
    if (a = n, n = a.plus(Ut(u, a, o + 2)).times(0.5), It(a.d).slice(0, o) === (t = It(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (te(a, r + 1, 0), a.times(a).eq(u)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return ue = !0, te(n, r);
};
j.times = j.mul = function(e) {
  var t, r, n, i, a, o, u, l, c, s = this, f = s.constructor, d = s.d, h = (e = new f(e)).d;
  if (!s.s || !e.s) return new f(0);
  for (e.s *= s.s, r = s.e + e.e, l = d.length, c = h.length, l < c && (a = d, d = h, h = a, o = l, l = c, c = o), a = [], o = l + c, n = o; n--; ) a.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, i = l + n; i > n; )
      u = a[i] + h[n] * d[i - n - 1] + t, a[i--] = u % Oe | 0, t = u / Oe | 0;
    a[i] = (a[i] + t) % Oe | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, ue ? te(e, f.precision) : e;
};
j.toDecimalPlaces = j.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (jt(e, 0, pn), t === void 0 ? t = n.rounding : jt(t, 0, 8), te(r, e + pe(r) + 1, t));
};
j.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = Dr(n, !0) : (jt(e, 0, pn), t === void 0 ? t = i.rounding : jt(t, 0, 8), n = te(new i(n), e + 1, t), r = Dr(n, !0, e + 1)), r;
};
j.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? Dr(i) : (jt(e, 0, pn), t === void 0 ? t = a.rounding : jt(t, 0, 8), n = te(new a(i), e + pe(i) + 1, t), r = Dr(n.abs(), !1, e + pe(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
j.toInteger = j.toint = function() {
  var e = this, t = e.constructor;
  return te(new t(e), pe(e) + 1, t.rounding);
};
j.toNumber = function() {
  return +this;
};
j.toPower = j.pow = function(e) {
  var t, r, n, i, a, o, u = this, l = u.constructor, c = 12, s = +(e = new l(e));
  if (!e.s) return new l(Qe);
  if (u = new l(u), !u.s) {
    if (e.s < 1) throw Error(ct + "Infinity");
    return u;
  }
  if (u.eq(Qe)) return u;
  if (n = l.precision, e.eq(Qe)) return te(u, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, a = u.s, o) {
    if ((r = s < 0 ? -s : s) <= Cp) {
      for (i = new l(Qe), t = Math.ceil(n / ae + 4), ue = !1; r % 2 && (i = i.times(u), mf(i.d, t)), r = mn(r / 2), r !== 0; )
        u = u.times(u), mf(u.d, t);
      return ue = !0, e.s < 0 ? new l(Qe).div(i) : te(i, n);
    }
  } else if (a < 0) throw Error(ct + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, u.s = 1, ue = !1, i = e.times(Gn(u, n + c)), ue = !0, i = Mp(i), i.s = a, i;
};
j.toPrecision = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? (r = pe(i), n = Dr(i, r <= a.toExpNeg || r >= a.toExpPos)) : (jt(e, 1, pn), t === void 0 ? t = a.rounding : jt(t, 0, 8), i = te(new a(i), e, t), r = pe(i), n = Dr(i, e <= r || r <= a.toExpNeg, e)), n;
};
j.toSignificantDigits = j.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (jt(e, 1, pn), t === void 0 ? t = n.rounding : jt(t, 0, 8)), te(new n(r), e, t);
};
j.toString = j.valueOf = j.val = j.toJSON = j[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = pe(e), r = e.constructor;
  return Dr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function Tp(e, t) {
  var r, n, i, a, o, u, l, c, s = e.constructor, f = s.precision;
  if (!e.s || !t.s)
    return t.s || (t = new s(e)), ue ? te(t, f) : t;
  if (l = e.d, c = t.d, o = e.e, i = t.e, l = l.slice(), a = o - i, a) {
    for (a < 0 ? (n = l, a = -a, u = c.length) : (n = c, i = o, u = l.length), o = Math.ceil(f / ae), u = o > u ? o + 1 : u + 1, a > u && (a = u, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (u = l.length, a = c.length, u - a < 0 && (a = u, n = c, c = l, l = n), r = 0; a; )
    r = (l[--a] = l[a] + c[a] + r) / Oe | 0, l[a] %= Oe;
  for (r && (l.unshift(r), ++i), u = l.length; l[--u] == 0; ) l.pop();
  return t.d = l, t.e = i, ue ? te(t, f) : t;
}
function jt(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Ir + e);
}
function It(e) {
  var t, r, n, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      n = e[t] + "", r = ae - n.length, r && (a += rr(r)), a += n;
    o = e[t], n = o + "", r = ae - n.length, r && (a += rr(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Ut = /* @__PURE__ */ function() {
  function e(n, i) {
    var a, o = 0, u = n.length;
    for (n = n.slice(); u--; )
      a = n[u] * i + o, n[u] = a % Oe | 0, o = a / Oe | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, a, o) {
    var u, l;
    if (a != o)
      l = a > o ? 1 : -1;
    else
      for (u = l = 0; u < a; u++)
        if (n[u] != i[u]) {
          l = n[u] > i[u] ? 1 : -1;
          break;
        }
    return l;
  }
  function r(n, i, a) {
    for (var o = 0; a--; )
      n[a] -= o, o = n[a] < i[a] ? 1 : 0, n[a] = o * Oe + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, o) {
    var u, l, c, s, f, d, h, v, p, m, y, b, w, x, O, g, S, P, k = n.constructor, T = n.s == i.s ? 1 : -1, I = n.d, _ = i.d;
    if (!n.s) return new k(n);
    if (!i.s) throw Error(ct + "Division by zero");
    for (l = n.e - i.e, S = _.length, O = I.length, h = new k(T), v = h.d = [], c = 0; _[c] == (I[c] || 0); ) ++c;
    if (_[c] > (I[c] || 0) && --l, a == null ? b = a = k.precision : o ? b = a + (pe(n) - pe(i)) + 1 : b = a, b < 0) return new k(0);
    if (b = b / ae + 2 | 0, c = 0, S == 1)
      for (s = 0, _ = _[0], b++; (c < O || s) && b--; c++)
        w = s * Oe + (I[c] || 0), v[c] = w / _ | 0, s = w % _ | 0;
    else {
      for (s = Oe / (_[0] + 1) | 0, s > 1 && (_ = e(_, s), I = e(I, s), S = _.length, O = I.length), x = S, p = I.slice(0, S), m = p.length; m < S; ) p[m++] = 0;
      P = _.slice(), P.unshift(0), g = _[0], _[1] >= Oe / 2 && ++g;
      do
        s = 0, u = t(_, p, S, m), u < 0 ? (y = p[0], S != m && (y = y * Oe + (p[1] || 0)), s = y / g | 0, s > 1 ? (s >= Oe && (s = Oe - 1), f = e(_, s), d = f.length, m = p.length, u = t(f, p, d, m), u == 1 && (s--, r(f, S < d ? P : _, d))) : (s == 0 && (u = s = 1), f = _.slice()), d = f.length, d < m && f.unshift(0), r(p, f, m), u == -1 && (m = p.length, u = t(_, p, S, m), u < 1 && (s++, r(p, S < m ? P : _, m))), m = p.length) : u === 0 && (s++, p = [0]), v[c++] = s, u && p[0] ? p[m++] = I[x] || 0 : (p = [I[x]], m = 1);
      while ((x++ < O || p[0] !== void 0) && b--);
    }
    return v[0] || v.shift(), h.e = l, te(h, o ? a + pe(h) + 1 : a);
  };
}();
function Mp(e, t) {
  var r, n, i, a, o, u, l = 0, c = 0, s = e.constructor, f = s.precision;
  if (pe(e) > 16) throw Error(pl + pe(e));
  if (!e.s) return new s(Qe);
  for (ue = !1, u = f, o = new s(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(br(2, c)) / Math.LN10 * 2 + 5 | 0, u += n, r = i = a = new s(Qe), s.precision = u; ; ) {
    if (i = te(i.times(e), u), r = r.times(++l), o = a.plus(Ut(i, r, u)), It(o.d).slice(0, u) === It(a.d).slice(0, u)) {
      for (; c--; ) a = te(a.times(a), u);
      return s.precision = f, t == null ? (ue = !0, te(a, f)) : a;
    }
    a = o;
  }
}
function pe(e) {
  for (var t = e.e * ae, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Ro(e, t, r) {
  if (t > e.LN10.sd())
    throw ue = !0, r && (e.precision = r), Error(ct + "LN10 precision limit exceeded");
  return te(new e(e.LN10), t);
}
function rr(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function Gn(e, t) {
  var r, n, i, a, o, u, l, c, s, f = 1, d = 10, h = e, v = h.d, p = h.constructor, m = p.precision;
  if (h.s < 1) throw Error(ct + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(Qe)) return new p(0);
  if (t == null ? (ue = !1, c = m) : c = t, h.eq(10))
    return t == null && (ue = !0), Ro(p, c);
  if (c += d, p.precision = c, r = It(v), n = r.charAt(0), a = pe(h), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      h = h.times(e), r = It(h.d), n = r.charAt(0), f++;
    a = pe(h), n > 1 ? (h = new p("0." + r), a++) : h = new p(n + "." + r.slice(1));
  } else
    return l = Ro(p, c + 2, m).times(a + ""), h = Gn(new p(n + "." + r.slice(1)), c - d).plus(l), p.precision = m, t == null ? (ue = !0, te(h, m)) : h;
  for (u = o = h = Ut(h.minus(Qe), h.plus(Qe), c), s = te(h.times(h), c), i = 3; ; ) {
    if (o = te(o.times(s), c), l = u.plus(Ut(o, new p(i), c)), It(l.d).slice(0, c) === It(u.d).slice(0, c))
      return u = u.times(2), a !== 0 && (u = u.plus(Ro(p, c + 2, m).times(a + ""))), u = Ut(u, new p(f), c), p.precision = m, t == null ? (ue = !0, te(u, m)) : u;
    u = l, i += 2;
  }
}
function pf(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = mn(r / ae), e.d = [], n = (r + 1) % ae, r < 0 && (n += ae), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= ae; n < i; ) e.d.push(+t.slice(n, n += ae));
      t = t.slice(n), n = ae - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), ue && (e.e > ha || e.e < -ha)) throw Error(pl + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function te(e, t, r) {
  var n, i, a, o, u, l, c, s, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (n = t - o, n < 0)
    n += ae, i = t, c = f[s = 0];
  else {
    if (s = Math.ceil((n + 1) / ae), a = f.length, s >= a) return e;
    for (c = a = f[s], o = 1; a >= 10; a /= 10) o++;
    n %= ae, i = n - ae + o;
  }
  if (r !== void 0 && (a = br(10, o - i - 1), u = c / a % 10 | 0, l = t < 0 || f[s + 1] !== void 0 || c % a, l = r < 4 ? (u || l) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : u > 5 || u == 5 && (r == 4 || l || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? c / br(10, o - i) : 0 : f[s - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return l ? (a = pe(e), f.length = 1, t = t - a - 1, f[0] = br(10, (ae - t % ae) % ae), e.e = mn(-t / ae) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = s, a = 1, s--) : (f.length = s + 1, a = br(10, ae - n), f[s] = i > 0 ? (c / br(10, o - i) % br(10, i) | 0) * a : 0), l)
    for (; ; )
      if (s == 0) {
        (f[0] += a) == Oe && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[s] += a, f[s] != Oe) break;
        f[s--] = 0, a = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (ue && (e.e > ha || e.e < -ha))
    throw Error(pl + pe(e));
  return e;
}
function jp(e, t) {
  var r, n, i, a, o, u, l, c, s, f, d = e.constructor, h = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), ue ? te(t, h) : t;
  if (l = e.d, f = t.d, n = t.e, c = e.e, l = l.slice(), o = c - n, o) {
    for (s = o < 0, s ? (r = l, o = -o, u = f.length) : (r = f, n = c, u = l.length), i = Math.max(Math.ceil(h / ae), u) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = l.length, u = f.length, s = i < u, s && (u = i), i = 0; i < u; i++)
      if (l[i] != f[i]) {
        s = l[i] < f[i];
        break;
      }
    o = 0;
  }
  for (s && (r = l, l = f, f = r, t.s = -t.s), u = l.length, i = f.length - u; i > 0; --i) l[u++] = 0;
  for (i = f.length; i > o; ) {
    if (l[--i] < f[i]) {
      for (a = i; a && l[--a] === 0; ) l[a] = Oe - 1;
      --l[a], l[i] += Oe;
    }
    l[i] -= f[i];
  }
  for (; l[--u] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --n;
  return l[0] ? (t.d = l, t.e = n, ue ? te(t, h) : t) : new d(0);
}
function Dr(e, t, r) {
  var n, i = pe(e), a = It(e.d), o = a.length;
  return t ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + rr(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + rr(-i - 1) + a, r && (n = r - o) > 0 && (a += rr(n))) : i >= o ? (a += rr(i + 1 - o), r && (n = r - i - 1) > 0 && (a = a + "." + rr(n))) : ((n = i + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (a += "."), a += rr(n))), e.s < 0 ? "-" + a : a;
}
function mf(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function Dp(e) {
  var t, r, n;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(Ir + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return pf(o, a.toString());
    } else if (typeof a != "string")
      throw Error(Ir + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, q1.test(a)) pf(o, a);
    else throw Error(Ir + a);
  }
  if (i.prototype = j, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = Dp, i.config = i.set = X1, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function X1(e) {
  if (!e || typeof e != "object")
    throw Error(ct + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    pn,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (mn(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Ir + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Ir + r + ": " + n);
  return this;
}
var ml = Dp(Y1);
Qe = new ml(1);
const Y = ml;
function Np(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new Y(e).abs().log(10).toNumber()) + 1, t;
}
function $p(e, t, r) {
  for (var n = new Y(e), i = 0, a = []; n.lt(t) && i < 1e5; )
    a.push(n.toNumber()), n = n.add(r), i++;
  return a;
}
function Yn(e, t) {
  return eS(e) || J1(e, t) || Q1(e, t) || Z1();
}
function Z1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q1(e, t) {
  if (e) {
    if (typeof e == "string") return yf(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? yf(e, t) : void 0;
  }
}
function yf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function J1(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function eS(e) {
  if (Array.isArray(e)) return e;
}
var Lp = (e) => {
  var t = Yn(e, 2), r = t[0], n = t[1], i = r, a = n;
  return r > n && (i = n, a = r), [i, a];
}, yl = (e, t, r) => {
  if (e.lte(0))
    return new Y(0);
  var n = Np(e.toNumber()), i = new Y(10).pow(n), a = e.div(i), o = n !== 1 ? 0.05 : 0.1, u = new Y(Math.ceil(a.div(o).toNumber())).add(r).mul(o), l = u.mul(i);
  return t ? new Y(l.toNumber()) : new Y(Math.ceil(l.toNumber()));
}, Rp = (e, t, r) => {
  var n;
  if (e.lte(0))
    return new Y(0);
  var i = [1, 2, 2.5, 5], a = e.toNumber(), o = Math.floor(new Y(a).abs().log(10).toNumber()), u = new Y(10).pow(o), l = e.div(u).toNumber(), c = i.findIndex((h) => h >= l - 1e-10);
  if (c === -1 && (u = u.mul(10), c = 0), c += r, c >= i.length) {
    var s = Math.floor(c / i.length);
    c %= i.length, u = u.mul(new Y(10).pow(s));
  }
  var f = (n = i[c]) !== null && n !== void 0 ? n : 1, d = new Y(f).mul(u);
  return t ? d : new Y(Math.ceil(d.toNumber()));
}, tS = (e, t, r) => {
  var n = new Y(1), i = new Y(e);
  if (!i.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new Y(10).pow(Np(e) - 1), i = new Y(Math.floor(i.div(n).toNumber())).mul(n)) : a > 1 && (i = new Y(Math.floor(e)));
  } else e === 0 ? i = new Y(Math.floor((t - 1) / 2)) : r || (i = new Y(Math.floor(e)));
  for (var o = Math.floor((t - 1) / 2), u = [], l = 0; l < t; l++)
    u.push(i.add(new Y(l - o).mul(n)).toNumber());
  return u;
}, Bp = function(t, r, n, i) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : yl;
  if (!Number.isFinite((r - t) / (n - 1)))
    return {
      step: new Y(0),
      tickMin: new Y(0),
      tickMax: new Y(0)
    };
  var u = o(new Y(r).sub(t).div(n - 1), i, a), l;
  t <= 0 && r >= 0 ? l = new Y(0) : (l = new Y(t).add(r).div(2), l = l.sub(new Y(l).mod(u)));
  var c = Math.ceil(l.sub(t).div(u).toNumber()), s = Math.ceil(new Y(r).sub(l).div(u).toNumber()), f = c + s + 1;
  return f > n ? Bp(t, r, n, i, a + 1, o) : (f < n && (s = r > 0 ? s + (n - f) : s, c = r > 0 ? c : c + (n - f)), {
    step: u,
    tickMin: l.sub(new Y(c).mul(u)),
    tickMax: l.add(new Y(s).mul(u))
  });
}, gf = function(t) {
  var r = Yn(t, 2), n = r[0], i = r[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "auto", l = Math.max(a, 2), c = Lp([n, i]), s = Yn(c, 2), f = s[0], d = s[1];
  if (f === -1 / 0 || d === 1 / 0) {
    var h = d === 1 / 0 ? [f, ...Array(a - 1).fill(1 / 0)] : [...Array(a - 1).fill(-1 / 0), d];
    return n > i ? h.reverse() : h;
  }
  if (f === d)
    return tS(f, a, o);
  var v = u === "snap125" ? Rp : yl, p = Bp(f, d, l, o, 0, v), m = p.step, y = p.tickMin, b = p.tickMax, w = $p(y, b.add(new Y(0.1).mul(m)), m);
  return n > i ? w.reverse() : w;
}, bf = function(t, r) {
  var n = Yn(t, 2), i = n[0], a = n[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "auto", l = Lp([i, a]), c = Yn(l, 2), s = c[0], f = c[1];
  if (s === -1 / 0 || f === 1 / 0)
    return [i, a];
  if (s === f)
    return [s];
  var d = u === "snap125" ? Rp : yl, h = Math.max(r, 2), v = d(new Y(f).sub(s).div(h - 1), o, 0), p = [...$p(new Y(s), new Y(f), v), f];
  if (o === !1) {
    p = p.map((y) => Math.round(y));
    var m = p.length - 1;
    m > 0 && p[m] === p[m - 1] && (p = p.slice(0, m));
  }
  return i > a ? p.reverse() : p;
}, zp = (e) => e.rootProps.maxBarSize, rS = (e) => e.rootProps.barGap, Fp = (e) => e.rootProps.barCategoryGap, nS = (e) => e.rootProps.barSize, to = (e) => e.rootProps.stackOffset, Wp = (e) => e.rootProps.reverseStackOrder, gl = (e) => e.options.chartName, bl = (e) => e.rootProps.syncId, Up = (e) => e.rootProps.syncMethod, xl = (e) => e.options.eventEmitter, Fe = {
  /**
   * CartesianGrid and PolarGrid
   */
  grid: -100,
  /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */
  barBackground: -50,
  /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */
  /**
   * Area, Pie, Radar, and ReferenceArea
   */
  area: 100,
  /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */
  cursorRectangle: 200,
  /**
   * Bar and RadialBar
   */
  bar: 300,
  /**
   * Line and ReferenceLine, and ErrorBor
   */
  line: 400,
  /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */
  axis: 500,
  /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */
  scatter: 600,
  /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */
  activeBar: 1e3,
  /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */
  cursorLine: 1100,
  /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */
  activeDot: 1200,
  /**
   * LabelList and Label, including Axis labels
   */
  label: 2e3
}, vr = {
  allowDecimals: !1,
  // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
  allowDataOverflow: !1,
  angleAxisId: 0,
  reversed: !1,
  scale: "auto",
  tick: !0,
  type: "auto"
}, Et = {
  allowDataOverflow: !1,
  allowDecimals: !1,
  allowDuplicatedCategory: !0,
  includeHidden: !1,
  radiusAxisId: 0,
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  type: "auto"
}, ro = (e, t) => {
  if (!(!e || !t))
    return e != null && e.reversed ? [t[1], t[0]] : t;
};
function no(e, t, r) {
  if (r !== "auto")
    return r;
  if (e != null)
    return sr(e, t) ? "category" : "number";
}
function xf(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function va(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xf(Object(r), !0).forEach(function(n) {
      iS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xf(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function iS(e, t, r) {
  return (t = aS(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aS(e) {
  var t = oS(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function oS(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var wf = {
  allowDataOverflow: vr.allowDataOverflow,
  allowDecimals: vr.allowDecimals,
  allowDuplicatedCategory: !1,
  // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
  dataKey: void 0,
  domain: void 0,
  id: vr.angleAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: vr.reversed,
  scale: vr.scale,
  tick: vr.tick,
  tickCount: void 0,
  ticks: void 0,
  type: vr.type,
  unit: void 0,
  niceTicks: "auto"
}, Af = {
  allowDataOverflow: Et.allowDataOverflow,
  allowDecimals: Et.allowDecimals,
  allowDuplicatedCategory: Et.allowDuplicatedCategory,
  dataKey: void 0,
  domain: void 0,
  id: Et.radiusAxisId,
  includeHidden: Et.includeHidden,
  name: void 0,
  reversed: Et.reversed,
  scale: Et.scale,
  tick: Et.tick,
  tickCount: Et.tickCount,
  ticks: void 0,
  type: Et.type,
  unit: void 0,
  niceTicks: "auto"
}, uS = (e, t) => {
  if (t != null)
    return e.polarAxis.angleAxis[t];
}, wl = E([uS, mp], (e, t) => {
  var r;
  if (e != null)
    return e;
  var n = (r = no(t, "angleAxis", wf.type)) !== null && r !== void 0 ? r : "category";
  return va(va({}, wf), {}, {
    type: n
  });
}), lS = (e, t) => e.polarAxis.radiusAxis[t], Al = E([lS, mp], (e, t) => {
  var r;
  if (e != null)
    return e;
  var n = (r = no(t, "radiusAxis", Af.type)) !== null && r !== void 0 ? r : "category";
  return va(va({}, Af), {}, {
    type: n
  });
}), io = (e) => e.polarOptions, Ol = E([qt, Xt, Ee], I1), Kp = E([io, Ol], (e, t) => {
  if (e != null)
    return bt(e.innerRadius, t, 0);
}), Vp = E([io, Ol], (e, t) => {
  if (e != null)
    return bt(e.outerRadius, t, t * 0.8);
}), cS = (e) => {
  if (e == null)
    return [0, 0];
  var t = e.startAngle, r = e.endAngle;
  return [t, r];
}, Hp = E([io], cS);
E([wl, Hp], ro);
var Gp = E([Ol, Kp, Vp], (e, t, r) => {
  if (!(e == null || t == null || r == null))
    return [t, r];
});
E([Al, Gp], ro);
var Yp = E([re, io, Kp, Vp, qt, Xt], (e, t, r, n, i, a) => {
  if (!(e !== "centric" && e !== "radial" || t == null || r == null || n == null)) {
    var o = t.cx, u = t.cy, l = t.startAngle, c = t.endAngle;
    return {
      cx: bt(o, i, i / 2),
      cy: bt(u, a, a / 2),
      innerRadius: r,
      outerRadius: n,
      startAngle: l,
      endAngle: c,
      clockWise: !1
      // this property look useful, why not use it?
    };
  }
}), _e = (e, t) => t, ao = (e, t, r) => r;
function Sl(e) {
  return e == null ? void 0 : e.id;
}
function qp(e, t, r) {
  var n = t.chartData, i = n === void 0 ? [] : n, a = r.allowDuplicatedCategory, o = r.dataKey, u = /* @__PURE__ */ new Map();
  return e.forEach((l) => {
    var c, s = (c = l.data) !== null && c !== void 0 ? c : i;
    if (!(s == null || s.length === 0)) {
      var f = Sl(l);
      s.forEach((d, h) => {
        var v = o == null || a ? h : String(Se(d, o, null)), p = Se(d, l.dataKey, 0), m;
        u.has(v) ? m = u.get(v) : m = {}, Object.assign(m, {
          [f]: p
        }), u.set(v, m);
      });
    }
  }), Array.from(u.values());
}
function oo(e) {
  return "stackId" in e && e.stackId != null && e.dataKey != null;
}
var di = (e, t) => e === t ? !0 : e == null || t == null ? !1 : e[0] === t[0] && e[1] === t[1];
function uo(e, t) {
  return Array.isArray(e) && Array.isArray(t) && e.length === 0 && t.length === 0 ? !0 : e === t;
}
function sS(e, t) {
  if (e.length === t.length) {
    for (var r = 0; r < e.length; r++)
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
  return !1;
}
var Pe = (e) => {
  var t = re(e);
  return t === "horizontal" ? "xAxis" : t === "vertical" ? "yAxis" : t === "centric" ? "angleAxis" : "radiusAxis";
}, yn = (e) => e.tooltip.settings.axisId;
function El(e) {
  if (e != null) {
    var t = e.ticks, r = e.bandwidth, n = e.range(), i = [Math.min(...n), Math.max(...n)];
    return {
      domain: () => e.domain(),
      range: function(a) {
        function o() {
          return a.apply(this, arguments);
        }
        return o.toString = function() {
          return a.toString();
        }, o;
      }(() => i),
      rangeMin: () => i[0],
      rangeMax: () => i[1],
      isInRange(a) {
        var o = i[0], u = i[1];
        return o <= u ? a >= o && a <= u : a >= u && a <= o;
      },
      bandwidth: r ? () => r.call(e) : void 0,
      ticks: t ? (a) => t.call(e, a) : void 0,
      map: (a, o) => {
        var u = e(a);
        if (u != null) {
          if (e.bandwidth && o !== null && o !== void 0 && o.position) {
            var l = e.bandwidth();
            switch (o.position) {
              case "middle":
                u += l / 2;
                break;
              case "end":
                u += l;
                break;
            }
          }
          return u;
        }
      }
    };
  }
}
var fS = (e, t) => {
  if (t != null)
    switch (e) {
      case "linear": {
        if (!kt(t)) {
          for (var r, n, i = 0; i < t.length; i++) {
            var a = t[i];
            H(a) && ((r === void 0 || a < r) && (r = a), (n === void 0 || a > n) && (n = a));
          }
          return r !== void 0 && n !== void 0 ? [r, n] : void 0;
        }
        return t;
      }
      default:
        return t;
    }
};
function ar(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function dS(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function _l(e) {
  let t, r, n;
  e.length !== 2 ? (t = ar, r = (u, l) => ar(e(u), l), n = (u, l) => e(u) - l) : (t = e === ar || e === dS ? e : hS, r = e, n = e);
  function i(u, l, c = 0, s = u.length) {
    if (c < s) {
      if (t(l, l) !== 0) return s;
      do {
        const f = c + s >>> 1;
        r(u[f], l) < 0 ? c = f + 1 : s = f;
      } while (c < s);
    }
    return c;
  }
  function a(u, l, c = 0, s = u.length) {
    if (c < s) {
      if (t(l, l) !== 0) return s;
      do {
        const f = c + s >>> 1;
        r(u[f], l) <= 0 ? c = f + 1 : s = f;
      } while (c < s);
    }
    return c;
  }
  function o(u, l, c = 0, s = u.length) {
    const f = i(u, l, c, s - 1);
    return f > c && n(u[f - 1], l) > -n(u[f], l) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function hS() {
  return 0;
}
function Xp(e) {
  return e === null ? NaN : +e;
}
function* vS(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const pS = _l(ar), hi = pS.right;
_l(Xp).center;
class Of extends Map {
  constructor(t, r = gS) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
  }
  get(t) {
    return super.get(Sf(this, t));
  }
  has(t) {
    return super.has(Sf(this, t));
  }
  set(t, r) {
    return super.set(mS(this, t), r);
  }
  delete(t) {
    return super.delete(yS(this, t));
  }
}
function Sf({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function mS({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function yS({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function gS(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function bS(e = ar) {
  if (e === ar) return Zp;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function Zp(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const xS = Math.sqrt(50), wS = Math.sqrt(10), AS = Math.sqrt(2);
function pa(e, t, r) {
  const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), o = a >= xS ? 10 : a >= wS ? 5 : a >= AS ? 2 : 1;
  let u, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, u = Math.round(e * c), l = Math.round(t * c), u / c < e && ++u, l / c > t && --l, c = -c) : (c = Math.pow(10, i) * o, u = Math.round(e / c), l = Math.round(t / c), u * c < e && ++u, l * c > t && --l), l < u && 0.5 <= r && r < 2 ? pa(e, t, r * 2) : [u, l, c];
}
function Eu(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [i, a, o] = n ? pa(t, e, r) : pa(e, t, r);
  if (!(a >= i)) return [];
  const u = a - i + 1, l = new Array(u);
  if (n)
    if (o < 0) for (let c = 0; c < u; ++c) l[c] = (a - c) / -o;
    else for (let c = 0; c < u; ++c) l[c] = (a - c) * o;
  else if (o < 0) for (let c = 0; c < u; ++c) l[c] = (i + c) / -o;
  else for (let c = 0; c < u; ++c) l[c] = (i + c) * o;
  return l;
}
function _u(e, t, r) {
  return t = +t, e = +e, r = +r, pa(e, t, r)[2];
}
function Pu(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, i = n ? _u(t, e, r) : _u(e, t, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Ef(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function _f(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Qp(e, t, r = 0, n = 1 / 0, i) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (i = i === void 0 ? Zp : bS(i); n > r; ) {
    if (n - r > 600) {
      const l = n - r + 1, c = t - r + 1, s = Math.log(l), f = 0.5 * Math.exp(2 * s / 3), d = 0.5 * Math.sqrt(s * f * (l - f) / l) * (c - l / 2 < 0 ? -1 : 1), h = Math.max(r, Math.floor(t - c * f / l + d)), v = Math.min(n, Math.floor(t + (l - c) * f / l + d));
      Qp(e, t, h, v, i);
    }
    const a = e[t];
    let o = r, u = n;
    for (Cn(e, r, t), i(e[n], a) > 0 && Cn(e, r, n); o < u; ) {
      for (Cn(e, o, u), ++o, --u; i(e[o], a) < 0; ) ++o;
      for (; i(e[u], a) > 0; ) --u;
    }
    i(e[r], a) === 0 ? Cn(e, r, u) : (++u, Cn(e, u, n)), u <= t && (r = u + 1), t <= u && (n = u - 1);
  }
  return e;
}
function Cn(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function OS(e, t, r) {
  if (e = Float64Array.from(vS(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return _f(e);
    if (t >= 1) return Ef(e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = Ef(Qp(e, a).subarray(0, a + 1)), u = _f(e.subarray(a + 1));
    return o + (u - o) * (i - a);
  }
}
function SS(e, t, r = Xp) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = +r(e[a], a, e), u = +r(e[a + 1], a + 1, e);
    return o + (u - o) * (i - a);
  }
}
function ES(e, t, r) {
  e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
  for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(i); ++n < i; )
    a[n] = e + n * r;
  return a;
}
function ft(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Zt(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Iu = Symbol("implicit");
function Pl() {
  var e = new Of(), t = [], r = [], n = Iu;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (n !== Iu) return n;
      e.set(a, o = t.push(a) - 1);
    }
    return r[o % r.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new Of();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (r = Array.from(a), i) : r.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Pl(t, r).unknown(n);
  }, ft.apply(i, arguments), i;
}
function Il() {
  var e = Pl().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, a, o, u = !1, l = 0, c = 0, s = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, h = i < n, v = h ? i : n, p = h ? n : i;
    a = (p - v) / Math.max(1, d - l + c * 2), u && (a = Math.floor(a)), v += (p - v - a * (d - l)) * s, o = a * (1 - l), u && (v = Math.round(v), o = Math.round(o));
    var m = ES(d).map(function(y) {
      return v + a * y;
    });
    return r(h ? m.reverse() : m);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, i] = d, n = +n, i = +i, f()) : [n, i];
  }, e.rangeRound = function(d) {
    return [n, i] = d, n = +n, i = +i, u = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (u = !!d, f()) : u;
  }, e.padding = function(d) {
    return arguments.length ? (l = Math.min(1, c = +d), f()) : l;
  }, e.paddingInner = function(d) {
    return arguments.length ? (l = Math.min(1, d), f()) : l;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = +d, f()) : c;
  }, e.align = function(d) {
    return arguments.length ? (s = Math.max(0, Math.min(1, d)), f()) : s;
  }, e.copy = function() {
    return Il(t(), [n, i]).round(u).paddingInner(l).paddingOuter(c).align(s);
  }, ft.apply(f(), arguments);
}
function Jp(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Jp(t());
  }, e;
}
function _S() {
  return Jp(Il.apply(null, arguments).paddingInner(1));
}
function kl(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function em(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function vi() {
}
var qn = 0.7, ma = 1 / qn, Qr = "\\s*([+-]?\\d+)\\s*", Xn = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ct = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", PS = /^#([0-9a-f]{3,8})$/, IS = new RegExp(`^rgb\\(${Qr},${Qr},${Qr}\\)$`), kS = new RegExp(`^rgb\\(${Ct},${Ct},${Ct}\\)$`), CS = new RegExp(`^rgba\\(${Qr},${Qr},${Qr},${Xn}\\)$`), TS = new RegExp(`^rgba\\(${Ct},${Ct},${Ct},${Xn}\\)$`), MS = new RegExp(`^hsl\\(${Xn},${Ct},${Ct}\\)$`), jS = new RegExp(`^hsla\\(${Xn},${Ct},${Ct},${Xn}\\)$`), Pf = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
kl(vi, Zn, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: If,
  // Deprecated! Use color.formatHex.
  formatHex: If,
  formatHex8: DS,
  formatHsl: NS,
  formatRgb: kf,
  toString: kf
});
function If() {
  return this.rgb().formatHex();
}
function DS() {
  return this.rgb().formatHex8();
}
function NS() {
  return tm(this).formatHsl();
}
function kf() {
  return this.rgb().formatRgb();
}
function Zn(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = PS.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Cf(t) : r === 3 ? new He(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Ni(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Ni(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = IS.exec(e)) ? new He(t[1], t[2], t[3], 1) : (t = kS.exec(e)) ? new He(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = CS.exec(e)) ? Ni(t[1], t[2], t[3], t[4]) : (t = TS.exec(e)) ? Ni(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = MS.exec(e)) ? jf(t[1], t[2] / 100, t[3] / 100, 1) : (t = jS.exec(e)) ? jf(t[1], t[2] / 100, t[3] / 100, t[4]) : Pf.hasOwnProperty(e) ? Cf(Pf[e]) : e === "transparent" ? new He(NaN, NaN, NaN, 0) : null;
}
function Cf(e) {
  return new He(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ni(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new He(e, t, r, n);
}
function $S(e) {
  return e instanceof vi || (e = Zn(e)), e ? (e = e.rgb(), new He(e.r, e.g, e.b, e.opacity)) : new He();
}
function ku(e, t, r, n) {
  return arguments.length === 1 ? $S(e) : new He(e, t, r, n ?? 1);
}
function He(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
kl(He, ku, em(vi, {
  brighter(e) {
    return e = e == null ? ma : Math.pow(ma, e), new He(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? qn : Math.pow(qn, e), new He(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new He(kr(this.r), kr(this.g), kr(this.b), ya(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Tf,
  // Deprecated! Use color.formatHex.
  formatHex: Tf,
  formatHex8: LS,
  formatRgb: Mf,
  toString: Mf
}));
function Tf() {
  return `#${Sr(this.r)}${Sr(this.g)}${Sr(this.b)}`;
}
function LS() {
  return `#${Sr(this.r)}${Sr(this.g)}${Sr(this.b)}${Sr((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Mf() {
  const e = ya(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${kr(this.r)}, ${kr(this.g)}, ${kr(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function ya(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function kr(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Sr(e) {
  return e = kr(e), (e < 16 ? "0" : "") + e.toString(16);
}
function jf(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new mt(e, t, r, n);
}
function tm(e) {
  if (e instanceof mt) return new mt(e.h, e.s, e.l, e.opacity);
  if (e instanceof vi || (e = Zn(e)), !e) return new mt();
  if (e instanceof mt) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, u = a - i, l = (a + i) / 2;
  return u ? (t === a ? o = (r - n) / u + (r < n) * 6 : r === a ? o = (n - t) / u + 2 : o = (t - r) / u + 4, u /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : u = l > 0 && l < 1 ? 0 : o, new mt(o, u, l, e.opacity);
}
function RS(e, t, r, n) {
  return arguments.length === 1 ? tm(e) : new mt(e, t, r, n ?? 1);
}
function mt(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
kl(mt, RS, em(vi, {
  brighter(e) {
    return e = e == null ? ma : Math.pow(ma, e), new mt(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? qn : Math.pow(qn, e), new mt(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
    return new He(
      Bo(e >= 240 ? e - 240 : e + 120, i, n),
      Bo(e, i, n),
      Bo(e < 120 ? e + 240 : e - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new mt(Df(this.h), $i(this.s), $i(this.l), ya(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = ya(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Df(this.h)}, ${$i(this.s) * 100}%, ${$i(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Df(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function $i(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Bo(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const Cl = (e) => () => e;
function BS(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function zS(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function FS(e) {
  return (e = +e) == 1 ? rm : function(t, r) {
    return r - t ? zS(t, r, e) : Cl(isNaN(t) ? r : t);
  };
}
function rm(e, t) {
  var r = t - e;
  return r ? BS(e, r) : Cl(isNaN(e) ? t : e);
}
const Nf = function e(t) {
  var r = FS(t);
  function n(i, a) {
    var o = r((i = ku(i)).r, (a = ku(a)).r), u = r(i.g, a.g), l = r(i.b, a.b), c = rm(i.opacity, a.opacity);
    return function(s) {
      return i.r = o(s), i.g = u(s), i.b = l(s), i.opacity = c(s), i + "";
    };
  }
  return n.gamma = e, n;
}(1);
function WS(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i) n[i] = e[i] * (1 - a) + t[i] * a;
    return n;
  };
}
function US(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function KS(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
  for (o = 0; o < n; ++o) i[o] = gn(e[o], t[o]);
  for (; o < r; ++o) a[o] = t[o];
  return function(u) {
    for (o = 0; o < n; ++o) a[o] = i[o](u);
    return a;
  };
}
function VS(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function ga(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function HS(e, t) {
  var r = {}, n = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? r[i] = gn(e[i], t[i]) : n[i] = t[i];
  return function(a) {
    for (i in r) n[i] = r[i](a);
    return n;
  };
}
var Cu = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, zo = new RegExp(Cu.source, "g");
function GS(e) {
  return function() {
    return e;
  };
}
function YS(e) {
  return function(t) {
    return e(t) + "";
  };
}
function qS(e, t) {
  var r = Cu.lastIndex = zo.lastIndex = 0, n, i, a, o = -1, u = [], l = [];
  for (e = e + "", t = t + ""; (n = Cu.exec(e)) && (i = zo.exec(t)); )
    (a = i.index) > r && (a = t.slice(r, a), u[o] ? u[o] += a : u[++o] = a), (n = n[0]) === (i = i[0]) ? u[o] ? u[o] += i : u[++o] = i : (u[++o] = null, l.push({ i: o, x: ga(n, i) })), r = zo.lastIndex;
  return r < t.length && (a = t.slice(r), u[o] ? u[o] += a : u[++o] = a), u.length < 2 ? l[0] ? YS(l[0].x) : GS(t) : (t = l.length, function(c) {
    for (var s = 0, f; s < t; ++s) u[(f = l[s]).i] = f.x(c);
    return u.join("");
  });
}
function gn(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? Cl(t) : (r === "number" ? ga : r === "string" ? (n = Zn(t)) ? (t = n, Nf) : qS : t instanceof Zn ? Nf : t instanceof Date ? VS : US(t) ? WS : Array.isArray(t) ? KS : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? HS : ga)(e, t);
}
function Tl(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function XS(e, t) {
  t === void 0 && (t = e, e = gn);
  for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(i, i = t[++r]);
  return function(o) {
    var u = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return a[u](o - u);
  };
}
function ZS(e) {
  return function() {
    return e;
  };
}
function ba(e) {
  return +e;
}
var $f = [0, 1];
function We(e) {
  return e;
}
function Tu(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : ZS(isNaN(t) ? NaN : 0.5);
}
function QS(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function JS(e, t, r) {
  var n = e[0], i = e[1], a = t[0], o = t[1];
  return i < n ? (n = Tu(i, n), a = r(o, a)) : (n = Tu(n, i), a = r(a, o)), function(u) {
    return a(n(u));
  };
}
function eE(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, i = new Array(n), a = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    i[o] = Tu(e[o], e[o + 1]), a[o] = r(t[o], t[o + 1]);
  return function(u) {
    var l = hi(e, u, 1, n) - 1;
    return a[l](i[l](u));
  };
}
function pi(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function lo() {
  var e = $f, t = $f, r = gn, n, i, a, o = We, u, l, c;
  function s() {
    var d = Math.min(e.length, t.length);
    return o !== We && (o = QS(e[0], e[d - 1])), u = d > 2 ? eE : JS, l = c = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? a : (l || (l = u(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(i((c || (c = u(t, e.map(n), ga)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, ba), s()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), s()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = Tl, s();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : We, s()) : o !== We;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, s()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (a = d, f) : a;
  }, function(d, h) {
    return n = d, i = h, s();
  };
}
function Ml() {
  return lo()(We, We);
}
function tE(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function xa(e, t) {
  if (!isFinite(e) || e === 0) return null;
  var r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e"), n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function rn(e) {
  return e = xa(Math.abs(e)), e ? e[1] : NaN;
}
function rE(e, t) {
  return function(r, n) {
    for (var i = r.length, a = [], o = 0, u = e[0], l = 0; i > 0 && u > 0 && (l + u + 1 > n && (u = Math.max(1, n - l)), a.push(r.substring(i -= u, i + u)), !((l += u + 1) > n)); )
      u = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function nE(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var iE = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Qn(e) {
  if (!(t = iE.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new jl({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Qn.prototype = jl.prototype;
function jl(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
jl.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function aE(e) {
  e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = i = r;
        break;
      case "0":
        n === 0 && (n = r), i = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
}
var wa;
function oE(e, t) {
  var r = xa(e, t);
  if (!r) return wa = void 0, e.toPrecision(t);
  var n = r[0], i = r[1], a = i - (wa = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = n.length;
  return a === o ? n : a > o ? n + new Array(a - o + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + xa(e, Math.max(0, t + a - 1))[0];
}
function Lf(e, t) {
  var r = xa(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const Rf = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: tE,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Lf(e * 100, t),
  r: Lf,
  s: oE,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Bf(e) {
  return e;
}
var zf = Array.prototype.map, Ff = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function uE(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Bf : rE(zf.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Bf : nE(zf.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f, d) {
    f = Qn(f);
    var h = f.fill, v = f.align, p = f.sign, m = f.symbol, y = f.zero, b = f.width, w = f.comma, x = f.precision, O = f.trim, g = f.type;
    g === "n" ? (w = !0, g = "g") : Rf[g] || (x === void 0 && (x = 12), O = !0, g = "g"), (y || h === "0" && v === "=") && (y = !0, h = "0", v = "=");
    var S = (d && d.prefix !== void 0 ? d.prefix : "") + (m === "$" ? r : m === "#" && /[boxX]/.test(g) ? "0" + g.toLowerCase() : ""), P = (m === "$" ? n : /[%p]/.test(g) ? o : "") + (d && d.suffix !== void 0 ? d.suffix : ""), k = Rf[g], T = /[defgprs%]/.test(g);
    x = x === void 0 ? 6 : /[gprs]/.test(g) ? Math.max(1, Math.min(21, x)) : Math.max(0, Math.min(20, x));
    function I(_) {
      var L = S, D = P, F, K, V;
      if (g === "c")
        D = k(_) + D, _ = "";
      else {
        _ = +_;
        var R = _ < 0 || 1 / _ < 0;
        if (_ = isNaN(_) ? l : k(Math.abs(_), x), O && (_ = aE(_)), R && +_ == 0 && p !== "+" && (R = !1), L = (R ? p === "(" ? p : u : p === "-" || p === "(" ? "" : p) + L, D = (g === "s" && !isNaN(_) && wa !== void 0 ? Ff[8 + wa / 3] : "") + D + (R && p === "(" ? ")" : ""), T) {
          for (F = -1, K = _.length; ++F < K; )
            if (V = _.charCodeAt(F), 48 > V || V > 57) {
              D = (V === 46 ? i + _.slice(F + 1) : _.slice(F)) + D, _ = _.slice(0, F);
              break;
            }
        }
      }
      w && !y && (_ = t(_, 1 / 0));
      var q = L.length + _.length + D.length, W = q < b ? new Array(b - q + 1).join(h) : "";
      switch (w && y && (_ = t(W + _, W.length ? b - D.length : 1 / 0), W = ""), v) {
        case "<":
          _ = L + _ + D + W;
          break;
        case "=":
          _ = L + W + _ + D;
          break;
        case "^":
          _ = W.slice(0, q = W.length >> 1) + L + _ + D + W.slice(q);
          break;
        default:
          _ = W + L + _ + D;
          break;
      }
      return a(_);
    }
    return I.toString = function() {
      return f + "";
    }, I;
  }
  function s(f, d) {
    var h = Math.max(-8, Math.min(8, Math.floor(rn(d) / 3))) * 3, v = Math.pow(10, -h), p = c((f = Qn(f), f.type = "f", f), { suffix: Ff[8 + h / 3] });
    return function(m) {
      return p(v * m);
    };
  }
  return {
    format: c,
    formatPrefix: s
  };
}
var Li, Dl, nm;
lE({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function lE(e) {
  return Li = uE(e), Dl = Li.format, nm = Li.formatPrefix, Li;
}
function cE(e) {
  return Math.max(0, -rn(Math.abs(e)));
}
function sE(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(rn(t) / 3))) * 3 - rn(Math.abs(e)));
}
function fE(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, rn(t) - rn(e)) + 1;
}
function im(e, t, r, n) {
  var i = Pu(e, t, r), a;
  switch (n = Qn(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = sE(i, o)) && (n.precision = a), nm(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = fE(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = cE(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return Dl(n);
}
function fr(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return Eu(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var i = t();
    return im(i[0], i[i.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), i = 0, a = n.length - 1, o = n[i], u = n[a], l, c, s = 10;
    for (u < o && (c = o, o = u, u = c, c = i, i = a, a = c); s-- > 0; ) {
      if (c = _u(o, u, r), c === l)
        return n[i] = o, n[a] = u, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, u = Math.ceil(u / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, u = Math.floor(u * c) / c;
      else
        break;
      l = c;
    }
    return e;
  }, e;
}
function am() {
  var e = Ml();
  return e.copy = function() {
    return pi(e, am());
  }, ft.apply(e, arguments), fr(e);
}
function om(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, ba), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return om(e).unknown(t);
  }, e = arguments.length ? Array.from(e, ba) : [0, 1], fr(r);
}
function um(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, i = e[r], a = e[n], o;
  return a < i && (o = r, r = n, n = o, o = i, i = a, a = o), e[r] = t.floor(i), e[n] = t.ceil(a), e;
}
function Wf(e) {
  return Math.log(e);
}
function Uf(e) {
  return Math.exp(e);
}
function dE(e) {
  return -Math.log(-e);
}
function hE(e) {
  return -Math.exp(-e);
}
function vE(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function pE(e) {
  return e === 10 ? vE : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function mE(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function Kf(e) {
  return (t, r) => -e(-t, r);
}
function Nl(e) {
  const t = e(Wf, Uf), r = t.domain;
  let n = 10, i, a;
  function o() {
    return i = mE(n), a = pE(n), r()[0] < 0 ? (i = Kf(i), a = Kf(a), e(dE, hE)) : e(Wf, Uf), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (r(u), o()) : r();
  }, t.ticks = (u) => {
    const l = r();
    let c = l[0], s = l[l.length - 1];
    const f = s < c;
    f && ([c, s] = [s, c]);
    let d = i(c), h = i(s), v, p;
    const m = u == null ? 10 : +u;
    let y = [];
    if (!(n % 1) && h - d < m) {
      if (d = Math.floor(d), h = Math.ceil(h), c > 0) {
        for (; d <= h; ++d)
          for (v = 1; v < n; ++v)
            if (p = d < 0 ? v / a(-d) : v * a(d), !(p < c)) {
              if (p > s) break;
              y.push(p);
            }
      } else for (; d <= h; ++d)
        for (v = n - 1; v >= 1; --v)
          if (p = d > 0 ? v / a(-d) : v * a(d), !(p < c)) {
            if (p > s) break;
            y.push(p);
          }
      y.length * 2 < m && (y = Eu(c, s, m));
    } else
      y = Eu(d, h, Math.min(h - d, m)).map(a);
    return f ? y.reverse() : y;
  }, t.tickFormat = (u, l) => {
    if (u == null && (u = 10), l == null && (l = n === 10 ? "s" : ","), typeof l != "function" && (!(n % 1) && (l = Qn(l)).precision == null && (l.trim = !0), l = Dl(l)), u === 1 / 0) return l;
    const c = Math.max(1, n * u / t.ticks().length);
    return (s) => {
      let f = s / a(Math.round(i(s)));
      return f * n < n - 0.5 && (f *= n), f <= c ? l(s) : "";
    };
  }, t.nice = () => r(um(r(), {
    floor: (u) => a(Math.floor(i(u))),
    ceil: (u) => a(Math.ceil(i(u)))
  })), t;
}
function lm() {
  const e = Nl(lo()).domain([1, 10]);
  return e.copy = () => pi(e, lm()).base(e.base()), ft.apply(e, arguments), e;
}
function Vf(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function Hf(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function $l(e) {
  var t = 1, r = e(Vf(t), Hf(t));
  return r.constant = function(n) {
    return arguments.length ? e(Vf(t = +n), Hf(t)) : t;
  }, fr(r);
}
function cm() {
  var e = $l(lo());
  return e.copy = function() {
    return pi(e, cm()).constant(e.constant());
  }, ft.apply(e, arguments);
}
function Gf(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function yE(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function gE(e) {
  return e < 0 ? -e * e : e * e;
}
function Ll(e) {
  var t = e(We, We), r = 1;
  function n() {
    return r === 1 ? e(We, We) : r === 0.5 ? e(yE, gE) : e(Gf(r), Gf(1 / r));
  }
  return t.exponent = function(i) {
    return arguments.length ? (r = +i, n()) : r;
  }, fr(t);
}
function Rl() {
  var e = Ll(lo());
  return e.copy = function() {
    return pi(e, Rl()).exponent(e.exponent());
  }, ft.apply(e, arguments), e;
}
function bE() {
  return Rl.apply(null, arguments).exponent(0.5);
}
function Yf(e) {
  return Math.sign(e) * e * e;
}
function xE(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function sm() {
  var e = Ml(), t = [0, 1], r = !1, n;
  function i(a) {
    var o = xE(e(a));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(Yf(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, ba)).map(Yf)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return sm(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, ft.apply(i, arguments), fr(i);
}
function fm() {
  var e = [], t = [], r = [], n;
  function i() {
    var o = 0, u = Math.max(1, t.length);
    for (r = new Array(u - 1); ++o < u; ) r[o - 1] = SS(e, o / u);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? n : t[hi(r, o)];
  }
  return a.invertExtent = function(o) {
    var u = t.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? r[u - 1] : e[0],
      u < r.length ? r[u] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let u of o) u != null && !isNaN(u = +u) && e.push(u);
    return e.sort(ar), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return fm().domain(e).range(t).unknown(n);
  }, ft.apply(a, arguments);
}
function dm() {
  var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], a;
  function o(l) {
    return l != null && l <= l ? i[hi(n, l, 0, r)] : a;
  }
  function u() {
    var l = -1;
    for (n = new Array(r); ++l < r; ) n[l] = ((l + 1) * t - (l - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([e, t] = l, e = +e, t = +t, u()) : [e, t];
  }, o.range = function(l) {
    return arguments.length ? (r = (i = Array.from(l)).length - 1, u()) : i.slice();
  }, o.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(l) {
    return arguments.length && (a = l), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return dm().domain([e, t]).range(i).unknown(a);
  }, ft.apply(fr(o), arguments);
}
function hm() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function i(a) {
    return a != null && a <= a ? t[hi(e, a, 0, n)] : r;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return hm().domain(e).range(t).unknown(r);
  }, ft.apply(i, arguments);
}
const Fo = /* @__PURE__ */ new Date(), Wo = /* @__PURE__ */ new Date();
function we(e, t, r, n) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), u = i.ceil(a);
    return a - o < u - a ? o : u;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, u) => {
    const l = [];
    if (a = i.ceil(a), u = u == null ? 1 : Math.floor(u), !(a < o) || !(u > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+a)), t(a, u), e(a);
    while (c < a && a < o);
    return l;
  }, i.filter = (a) => we((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, u) => {
    if (o >= o)
      if (u < 0) for (; ++u <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --u >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), r && (i.count = (a, o) => (Fo.setTime(+a), Wo.setTime(+o), e(Fo), e(Wo), Math.floor(r(Fo, Wo))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(n ? (o) => n(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const Aa = we(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Aa.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? we((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Aa);
Aa.range;
const zt = 1e3, ot = zt * 60, Ft = ot * 60, Ht = Ft * 24, Bl = Ht * 7, qf = Ht * 30, Uo = Ht * 365, Er = we((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * zt);
}, (e, t) => (t - e) / zt, (e) => e.getUTCSeconds());
Er.range;
const zl = we((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * zt);
}, (e, t) => {
  e.setTime(+e + t * ot);
}, (e, t) => (t - e) / ot, (e) => e.getMinutes());
zl.range;
const Fl = we((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * ot);
}, (e, t) => (t - e) / ot, (e) => e.getUTCMinutes());
Fl.range;
const Wl = we((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * zt - e.getMinutes() * ot);
}, (e, t) => {
  e.setTime(+e + t * Ft);
}, (e, t) => (t - e) / Ft, (e) => e.getHours());
Wl.range;
const Ul = we((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ft);
}, (e, t) => (t - e) / Ft, (e) => e.getUTCHours());
Ul.range;
const mi = we(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ot) / Ht,
  (e) => e.getDate() - 1
);
mi.range;
const co = we((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ht, (e) => e.getUTCDate() - 1);
co.range;
const vm = we((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Ht, (e) => Math.floor(e / Ht));
vm.range;
function Lr(e) {
  return we((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * ot) / Bl);
}
const so = Lr(0), Oa = Lr(1), wE = Lr(2), AE = Lr(3), nn = Lr(4), OE = Lr(5), SE = Lr(6);
so.range;
Oa.range;
wE.range;
AE.range;
nn.range;
OE.range;
SE.range;
function Rr(e) {
  return we((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / Bl);
}
const fo = Rr(0), Sa = Rr(1), EE = Rr(2), _E = Rr(3), an = Rr(4), PE = Rr(5), IE = Rr(6);
fo.range;
Sa.range;
EE.range;
_E.range;
an.range;
PE.range;
IE.range;
const Kl = we((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Kl.range;
const Vl = we((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Vl.range;
const Gt = we((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Gt.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : we((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Gt.range;
const Yt = we((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Yt.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : we((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Yt.range;
function pm(e, t, r, n, i, a) {
  const o = [
    [Er, 1, zt],
    [Er, 5, 5 * zt],
    [Er, 15, 15 * zt],
    [Er, 30, 30 * zt],
    [a, 1, ot],
    [a, 5, 5 * ot],
    [a, 15, 15 * ot],
    [a, 30, 30 * ot],
    [i, 1, Ft],
    [i, 3, 3 * Ft],
    [i, 6, 6 * Ft],
    [i, 12, 12 * Ft],
    [n, 1, Ht],
    [n, 2, 2 * Ht],
    [r, 1, Bl],
    [t, 1, qf],
    [t, 3, 3 * qf],
    [e, 1, Uo]
  ];
  function u(c, s, f) {
    const d = s < c;
    d && ([c, s] = [s, c]);
    const h = f && typeof f.range == "function" ? f : l(c, s, f), v = h ? h.range(c, +s + 1) : [];
    return d ? v.reverse() : v;
  }
  function l(c, s, f) {
    const d = Math.abs(s - c) / f, h = _l(([, , m]) => m).right(o, d);
    if (h === o.length) return e.every(Pu(c / Uo, s / Uo, f));
    if (h === 0) return Aa.every(Math.max(Pu(c, s, f), 1));
    const [v, p] = o[d / o[h - 1][2] < o[h][2] / d ? h - 1 : h];
    return v.every(p);
  }
  return [u, l];
}
const [kE, CE] = pm(Yt, Vl, fo, vm, Ul, Fl), [TE, ME] = pm(Gt, Kl, so, mi, Wl, zl);
function Ko(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Vo(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Tn(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function jE(e) {
  var t = e.dateTime, r = e.date, n = e.time, i = e.periods, a = e.days, o = e.shortDays, u = e.months, l = e.shortMonths, c = Mn(i), s = jn(i), f = Mn(a), d = jn(a), h = Mn(o), v = jn(o), p = Mn(u), m = jn(u), y = Mn(l), b = jn(l), w = {
    a: V,
    A: R,
    b: q,
    B: W,
    c: null,
    d: td,
    e: td,
    f: r_,
    g: d_,
    G: v_,
    H: JE,
    I: e_,
    j: t_,
    L: mm,
    m: n_,
    M: i_,
    p: he,
    q: ve,
    Q: id,
    s: ad,
    S: a_,
    u: o_,
    U: u_,
    V: l_,
    w: c_,
    W: s_,
    x: null,
    X: null,
    y: f_,
    Y: h_,
    Z: p_,
    "%": nd
  }, x = {
    a: ce,
    A: ze,
    b: qe,
    B: ht,
    c: null,
    d: rd,
    e: rd,
    f: b_,
    g: k_,
    G: T_,
    H: m_,
    I: y_,
    j: g_,
    L: gm,
    m: x_,
    M: w_,
    p: vt,
    q: En,
    Q: id,
    s: ad,
    S: A_,
    u: O_,
    U: S_,
    V: E_,
    w: __,
    W: P_,
    x: null,
    X: null,
    y: I_,
    Y: C_,
    Z: M_,
    "%": nd
  }, O = {
    a: T,
    A: I,
    b: _,
    B: L,
    c: D,
    d: Jf,
    e: Jf,
    f: qE,
    g: Qf,
    G: Zf,
    H: ed,
    I: ed,
    j: VE,
    L: YE,
    m: KE,
    M: HE,
    p: k,
    q: UE,
    Q: ZE,
    s: QE,
    S: GE,
    u: RE,
    U: BE,
    V: zE,
    w: LE,
    W: FE,
    x: F,
    X: K,
    y: Qf,
    Y: Zf,
    Z: WE,
    "%": XE
  };
  w.x = g(r, w), w.X = g(n, w), w.c = g(t, w), x.x = g(r, x), x.X = g(n, x), x.c = g(t, x);
  function g(M, U) {
    return function(z) {
      var C = [], je = -1, ee = 0, B = M.length, Xe, hr, _c;
      for (z instanceof Date || (z = /* @__PURE__ */ new Date(+z)); ++je < B; )
        M.charCodeAt(je) === 37 && (C.push(M.slice(ee, je)), (hr = Xf[Xe = M.charAt(++je)]) != null ? Xe = M.charAt(++je) : hr = Xe === "e" ? " " : "0", (_c = U[Xe]) && (Xe = _c(z, hr)), C.push(Xe), ee = je + 1);
      return C.push(M.slice(ee, je)), C.join("");
    };
  }
  function S(M, U) {
    return function(z) {
      var C = Tn(1900, void 0, 1), je = P(C, M, z += "", 0), ee, B;
      if (je != z.length) return null;
      if ("Q" in C) return new Date(C.Q);
      if ("s" in C) return new Date(C.s * 1e3 + ("L" in C ? C.L : 0));
      if (U && !("Z" in C) && (C.Z = 0), "p" in C && (C.H = C.H % 12 + C.p * 12), C.m === void 0 && (C.m = "q" in C ? C.q : 0), "V" in C) {
        if (C.V < 1 || C.V > 53) return null;
        "w" in C || (C.w = 1), "Z" in C ? (ee = Vo(Tn(C.y, 0, 1)), B = ee.getUTCDay(), ee = B > 4 || B === 0 ? Sa.ceil(ee) : Sa(ee), ee = co.offset(ee, (C.V - 1) * 7), C.y = ee.getUTCFullYear(), C.m = ee.getUTCMonth(), C.d = ee.getUTCDate() + (C.w + 6) % 7) : (ee = Ko(Tn(C.y, 0, 1)), B = ee.getDay(), ee = B > 4 || B === 0 ? Oa.ceil(ee) : Oa(ee), ee = mi.offset(ee, (C.V - 1) * 7), C.y = ee.getFullYear(), C.m = ee.getMonth(), C.d = ee.getDate() + (C.w + 6) % 7);
      } else ("W" in C || "U" in C) && ("w" in C || (C.w = "u" in C ? C.u % 7 : "W" in C ? 1 : 0), B = "Z" in C ? Vo(Tn(C.y, 0, 1)).getUTCDay() : Ko(Tn(C.y, 0, 1)).getDay(), C.m = 0, C.d = "W" in C ? (C.w + 6) % 7 + C.W * 7 - (B + 5) % 7 : C.w + C.U * 7 - (B + 6) % 7);
      return "Z" in C ? (C.H += C.Z / 100 | 0, C.M += C.Z % 100, Vo(C)) : Ko(C);
    };
  }
  function P(M, U, z, C) {
    for (var je = 0, ee = U.length, B = z.length, Xe, hr; je < ee; ) {
      if (C >= B) return -1;
      if (Xe = U.charCodeAt(je++), Xe === 37) {
        if (Xe = U.charAt(je++), hr = O[Xe in Xf ? U.charAt(je++) : Xe], !hr || (C = hr(M, z, C)) < 0) return -1;
      } else if (Xe != z.charCodeAt(C++))
        return -1;
    }
    return C;
  }
  function k(M, U, z) {
    var C = c.exec(U.slice(z));
    return C ? (M.p = s.get(C[0].toLowerCase()), z + C[0].length) : -1;
  }
  function T(M, U, z) {
    var C = h.exec(U.slice(z));
    return C ? (M.w = v.get(C[0].toLowerCase()), z + C[0].length) : -1;
  }
  function I(M, U, z) {
    var C = f.exec(U.slice(z));
    return C ? (M.w = d.get(C[0].toLowerCase()), z + C[0].length) : -1;
  }
  function _(M, U, z) {
    var C = y.exec(U.slice(z));
    return C ? (M.m = b.get(C[0].toLowerCase()), z + C[0].length) : -1;
  }
  function L(M, U, z) {
    var C = p.exec(U.slice(z));
    return C ? (M.m = m.get(C[0].toLowerCase()), z + C[0].length) : -1;
  }
  function D(M, U, z) {
    return P(M, t, U, z);
  }
  function F(M, U, z) {
    return P(M, r, U, z);
  }
  function K(M, U, z) {
    return P(M, n, U, z);
  }
  function V(M) {
    return o[M.getDay()];
  }
  function R(M) {
    return a[M.getDay()];
  }
  function q(M) {
    return l[M.getMonth()];
  }
  function W(M) {
    return u[M.getMonth()];
  }
  function he(M) {
    return i[+(M.getHours() >= 12)];
  }
  function ve(M) {
    return 1 + ~~(M.getMonth() / 3);
  }
  function ce(M) {
    return o[M.getUTCDay()];
  }
  function ze(M) {
    return a[M.getUTCDay()];
  }
  function qe(M) {
    return l[M.getUTCMonth()];
  }
  function ht(M) {
    return u[M.getUTCMonth()];
  }
  function vt(M) {
    return i[+(M.getUTCHours() >= 12)];
  }
  function En(M) {
    return 1 + ~~(M.getUTCMonth() / 3);
  }
  return {
    format: function(M) {
      var U = g(M += "", w);
      return U.toString = function() {
        return M;
      }, U;
    },
    parse: function(M) {
      var U = S(M += "", !1);
      return U.toString = function() {
        return M;
      }, U;
    },
    utcFormat: function(M) {
      var U = g(M += "", x);
      return U.toString = function() {
        return M;
      }, U;
    },
    utcParse: function(M) {
      var U = S(M += "", !0);
      return U.toString = function() {
        return M;
      }, U;
    }
  };
}
var Xf = { "-": "", _: " ", 0: "0" }, Ie = /^\s*\d+/, DE = /^%/, NE = /[\\^$*+?|[\]().{}]/g;
function Q(e, t, r) {
  var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", a = i.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + i : i);
}
function $E(e) {
  return e.replace(NE, "\\$&");
}
function Mn(e) {
  return new RegExp("^(?:" + e.map($E).join("|") + ")", "i");
}
function jn(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function LE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function RE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function BE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function zE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function FE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function Zf(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function Qf(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function WE(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function UE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function KE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function Jf(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function VE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function ed(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function HE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function GE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function YE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function qE(e, t, r) {
  var n = Ie.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function XE(e, t, r) {
  var n = DE.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function ZE(e, t, r) {
  var n = Ie.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function QE(e, t, r) {
  var n = Ie.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function td(e, t) {
  return Q(e.getDate(), t, 2);
}
function JE(e, t) {
  return Q(e.getHours(), t, 2);
}
function e_(e, t) {
  return Q(e.getHours() % 12 || 12, t, 2);
}
function t_(e, t) {
  return Q(1 + mi.count(Gt(e), e), t, 3);
}
function mm(e, t) {
  return Q(e.getMilliseconds(), t, 3);
}
function r_(e, t) {
  return mm(e, t) + "000";
}
function n_(e, t) {
  return Q(e.getMonth() + 1, t, 2);
}
function i_(e, t) {
  return Q(e.getMinutes(), t, 2);
}
function a_(e, t) {
  return Q(e.getSeconds(), t, 2);
}
function o_(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function u_(e, t) {
  return Q(so.count(Gt(e) - 1, e), t, 2);
}
function ym(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? nn(e) : nn.ceil(e);
}
function l_(e, t) {
  return e = ym(e), Q(nn.count(Gt(e), e) + (Gt(e).getDay() === 4), t, 2);
}
function c_(e) {
  return e.getDay();
}
function s_(e, t) {
  return Q(Oa.count(Gt(e) - 1, e), t, 2);
}
function f_(e, t) {
  return Q(e.getFullYear() % 100, t, 2);
}
function d_(e, t) {
  return e = ym(e), Q(e.getFullYear() % 100, t, 2);
}
function h_(e, t) {
  return Q(e.getFullYear() % 1e4, t, 4);
}
function v_(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? nn(e) : nn.ceil(e), Q(e.getFullYear() % 1e4, t, 4);
}
function p_(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Q(t / 60 | 0, "0", 2) + Q(t % 60, "0", 2);
}
function rd(e, t) {
  return Q(e.getUTCDate(), t, 2);
}
function m_(e, t) {
  return Q(e.getUTCHours(), t, 2);
}
function y_(e, t) {
  return Q(e.getUTCHours() % 12 || 12, t, 2);
}
function g_(e, t) {
  return Q(1 + co.count(Yt(e), e), t, 3);
}
function gm(e, t) {
  return Q(e.getUTCMilliseconds(), t, 3);
}
function b_(e, t) {
  return gm(e, t) + "000";
}
function x_(e, t) {
  return Q(e.getUTCMonth() + 1, t, 2);
}
function w_(e, t) {
  return Q(e.getUTCMinutes(), t, 2);
}
function A_(e, t) {
  return Q(e.getUTCSeconds(), t, 2);
}
function O_(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function S_(e, t) {
  return Q(fo.count(Yt(e) - 1, e), t, 2);
}
function bm(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? an(e) : an.ceil(e);
}
function E_(e, t) {
  return e = bm(e), Q(an.count(Yt(e), e) + (Yt(e).getUTCDay() === 4), t, 2);
}
function __(e) {
  return e.getUTCDay();
}
function P_(e, t) {
  return Q(Sa.count(Yt(e) - 1, e), t, 2);
}
function I_(e, t) {
  return Q(e.getUTCFullYear() % 100, t, 2);
}
function k_(e, t) {
  return e = bm(e), Q(e.getUTCFullYear() % 100, t, 2);
}
function C_(e, t) {
  return Q(e.getUTCFullYear() % 1e4, t, 4);
}
function T_(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? an(e) : an.ceil(e), Q(e.getUTCFullYear() % 1e4, t, 4);
}
function M_() {
  return "+0000";
}
function nd() {
  return "%";
}
function id(e) {
  return +e;
}
function ad(e) {
  return Math.floor(+e / 1e3);
}
var Kr, xm, wm;
j_({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function j_(e) {
  return Kr = jE(e), xm = Kr.format, Kr.parse, wm = Kr.utcFormat, Kr.utcParse, Kr;
}
function D_(e) {
  return new Date(e);
}
function N_(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Hl(e, t, r, n, i, a, o, u, l, c) {
  var s = Ml(), f = s.invert, d = s.domain, h = c(".%L"), v = c(":%S"), p = c("%I:%M"), m = c("%I %p"), y = c("%a %d"), b = c("%b %d"), w = c("%B"), x = c("%Y");
  function O(g) {
    return (l(g) < g ? h : u(g) < g ? v : o(g) < g ? p : a(g) < g ? m : n(g) < g ? i(g) < g ? y : b : r(g) < g ? w : x)(g);
  }
  return s.invert = function(g) {
    return new Date(f(g));
  }, s.domain = function(g) {
    return arguments.length ? d(Array.from(g, N_)) : d().map(D_);
  }, s.ticks = function(g) {
    var S = d();
    return e(S[0], S[S.length - 1], g ?? 10);
  }, s.tickFormat = function(g, S) {
    return S == null ? O : c(S);
  }, s.nice = function(g) {
    var S = d();
    return (!g || typeof g.range != "function") && (g = t(S[0], S[S.length - 1], g ?? 10)), g ? d(um(S, g)) : s;
  }, s.copy = function() {
    return pi(s, Hl(e, t, r, n, i, a, o, u, l, c));
  }, s;
}
function $_() {
  return ft.apply(Hl(TE, ME, Gt, Kl, so, mi, Wl, zl, Er, xm).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function L_() {
  return ft.apply(Hl(kE, CE, Yt, Vl, fo, co, Ul, Fl, Er, wm).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function ho() {
  var e = 0, t = 1, r, n, i, a, o = We, u = !1, l;
  function c(f) {
    return f == null || isNaN(f = +f) ? l : o(i === 0 ? 0.5 : (f = (a(f) - r) * i, u ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = a(e = +e), n = a(t = +t), i = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (u = !!f, c) : u;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function s(f) {
    return function(d) {
      var h, v;
      return arguments.length ? ([h, v] = d, o = f(h, v), c) : [o(0), o(1)];
    };
  }
  return c.range = s(gn), c.rangeRound = s(Tl), c.unknown = function(f) {
    return arguments.length ? (l = f, c) : l;
  }, function(f) {
    return a = f, r = f(e), n = f(t), i = r === n ? 0 : 1 / (n - r), c;
  };
}
function dr(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Am() {
  var e = fr(ho()(We));
  return e.copy = function() {
    return dr(e, Am());
  }, Zt.apply(e, arguments);
}
function Om() {
  var e = Nl(ho()).domain([1, 10]);
  return e.copy = function() {
    return dr(e, Om()).base(e.base());
  }, Zt.apply(e, arguments);
}
function Sm() {
  var e = $l(ho());
  return e.copy = function() {
    return dr(e, Sm()).constant(e.constant());
  }, Zt.apply(e, arguments);
}
function Gl() {
  var e = Ll(ho());
  return e.copy = function() {
    return dr(e, Gl()).exponent(e.exponent());
  }, Zt.apply(e, arguments);
}
function R_() {
  return Gl.apply(null, arguments).exponent(0.5);
}
function Em() {
  var e = [], t = We;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((hi(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(ar), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, i) => t(i / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (i, a) => OS(e, a / n));
  }, r.copy = function() {
    return Em(t).domain(e);
  }, Zt.apply(r, arguments);
}
function vo() {
  var e = 0, t = 0.5, r = 1, n = 1, i, a, o, u, l, c = We, s, f = !1, d;
  function h(p) {
    return isNaN(p = +p) ? d : (p = 0.5 + ((p = +s(p)) - a) * (n * p < n * a ? u : l), c(f ? Math.max(0, Math.min(1, p)) : p));
  }
  h.domain = function(p) {
    return arguments.length ? ([e, t, r] = p, i = s(e = +e), a = s(t = +t), o = s(r = +r), u = i === a ? 0 : 0.5 / (a - i), l = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, h) : [e, t, r];
  }, h.clamp = function(p) {
    return arguments.length ? (f = !!p, h) : f;
  }, h.interpolator = function(p) {
    return arguments.length ? (c = p, h) : c;
  };
  function v(p) {
    return function(m) {
      var y, b, w;
      return arguments.length ? ([y, b, w] = m, c = XS(p, [y, b, w]), h) : [c(0), c(0.5), c(1)];
    };
  }
  return h.range = v(gn), h.rangeRound = v(Tl), h.unknown = function(p) {
    return arguments.length ? (d = p, h) : d;
  }, function(p) {
    return s = p, i = p(e), a = p(t), o = p(r), u = i === a ? 0 : 0.5 / (a - i), l = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, h;
  };
}
function _m() {
  var e = fr(vo()(We));
  return e.copy = function() {
    return dr(e, _m());
  }, Zt.apply(e, arguments);
}
function Pm() {
  var e = Nl(vo()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return dr(e, Pm()).base(e.base());
  }, Zt.apply(e, arguments);
}
function Im() {
  var e = $l(vo());
  return e.copy = function() {
    return dr(e, Im()).constant(e.constant());
  }, Zt.apply(e, arguments);
}
function Yl() {
  var e = Ll(vo());
  return e.copy = function() {
    return dr(e, Yl()).exponent(e.exponent());
  }, Zt.apply(e, arguments);
}
function B_() {
  return Yl.apply(null, arguments).exponent(0.5);
}
const km = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Il,
  scaleDiverging: _m,
  scaleDivergingLog: Pm,
  scaleDivergingPow: Yl,
  scaleDivergingSqrt: B_,
  scaleDivergingSymlog: Im,
  scaleIdentity: om,
  scaleImplicit: Iu,
  scaleLinear: am,
  scaleLog: lm,
  scaleOrdinal: Pl,
  scalePoint: _S,
  scalePow: Rl,
  scaleQuantile: fm,
  scaleQuantize: dm,
  scaleRadial: sm,
  scaleSequential: Am,
  scaleSequentialLog: Om,
  scaleSequentialPow: Gl,
  scaleSequentialQuantile: Em,
  scaleSequentialSqrt: R_,
  scaleSequentialSymlog: Sm,
  scaleSqrt: bE,
  scaleSymlog: cm,
  scaleThreshold: hm,
  scaleTime: $_,
  scaleUtc: L_,
  tickFormat: im
}, Symbol.toStringTag, { value: "Module" }));
function z_(e) {
  var t = km;
  if (e in t && typeof t[e] == "function")
    return t[e]();
  var r = "scale".concat(qu(e));
  if (r in t && typeof t[r] == "function")
    return t[r]();
}
function od(e, t, r) {
  if (typeof e == "function")
    return e.copy().domain(t).range(r);
  if (e != null) {
    var n = z_(e);
    if (n != null)
      return n.domain(t).range(r), n;
  }
}
function ql(e, t, r, n) {
  if (!(r == null || n == null))
    return typeof e.scale == "function" ? od(e.scale, r, n) : od(t, r, n);
}
function F_(e) {
  return "scale".concat(qu(e));
}
function W_(e) {
  return F_(e) in km;
}
var Cm = (e, t, r) => {
  if (e != null) {
    var n = e.scale, i = e.type;
    if (n === "auto")
      return i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !t) ? "point" : i === "category" ? "band" : "linear";
    if (typeof n == "string")
      return W_(n) ? n : "point";
  }
};
function U_(e, t) {
  for (var r = 0, n = e.length, i = e[0] < e[e.length - 1]; r < n; ) {
    var a = Math.floor((r + n) / 2);
    (i ? e[a] < t : e[a] > t) ? r = a + 1 : n = a;
  }
  return r;
}
function Tm(e, t) {
  if (e) {
    var r = t ?? e.domain(), n = r.map((a) => {
      var o;
      return (o = e(a)) !== null && o !== void 0 ? o : 0;
    }), i = e.range();
    if (!(r.length === 0 || i.length < 2))
      return (a) => {
        var o, u, l = U_(n, a);
        if (l <= 0)
          return r[0];
        if (l >= r.length)
          return r[r.length - 1];
        var c = (o = n[l - 1]) !== null && o !== void 0 ? o : 0, s = (u = n[l]) !== null && u !== void 0 ? u : 0;
        return Math.abs(a - c) <= Math.abs(a - s) ? r[l - 1] : r[l];
      };
  }
}
function K_(e) {
  if (e != null)
    return "invert" in e && typeof e.invert == "function" ? e.invert.bind(e) : Tm(e, void 0);
}
function ud(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ea(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ud(Object(r), !0).forEach(function(n) {
      V_(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ud(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function V_(e, t, r) {
  return (t = H_(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function H_(e) {
  var t = G_(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function G_(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Mm(e, t) {
  return Z_(e) || X_(e, t) || q_(e, t) || Y_();
}
function Y_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q_(e, t) {
  if (e) {
    if (typeof e == "string") return ld(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ld(e, t) : void 0;
  }
}
function ld(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function X_(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function Z_(e) {
  if (Array.isArray(e)) return e;
}
var Mu = [0, "auto"], me = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: void 0,
  height: 30,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "bottom",
  padding: {
    left: 0,
    right: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "category",
  unit: void 0,
  niceTicks: "auto"
}, jm = (e, t) => e.cartesianAxis.xAxis[t], Dt = (e, t) => {
  var r = jm(e, t);
  return r ?? me;
}, ye = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: Mu,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "left",
  padding: {
    top: 0,
    bottom: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "number",
  unit: void 0,
  niceTicks: "auto",
  width: ui
}, Dm = (e, t) => e.cartesianAxis.yAxis[t], Nt = (e, t) => {
  var r = Dm(e, t);
  return r ?? ye;
}, Q_ = {
  domain: [0, "auto"],
  includeHidden: !1,
  reversed: !1,
  allowDataOverflow: !1,
  allowDuplicatedCategory: !1,
  dataKey: void 0,
  id: 0,
  name: "",
  range: [64, 64],
  scale: "auto",
  type: "number",
  unit: ""
}, Xl = (e, t) => {
  var r = e.cartesianAxis.zAxis[t];
  return r ?? Q_;
}, Be = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Dt(e, r);
    case "yAxis":
      return Nt(e, r);
    case "zAxis":
      return Xl(e, r);
    case "angleAxis":
      return wl(e, r);
    case "radiusAxis":
      return Al(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, J_ = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Dt(e, r);
    case "yAxis":
      return Nt(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, yi = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return Dt(e, r);
    case "yAxis":
      return Nt(e, r);
    case "angleAxis":
      return wl(e, r);
    case "radiusAxis":
      return Al(e, r);
    default:
      throw new Error("Unexpected axis type: ".concat(t));
  }
}, Nm = (e) => e.graphicalItems.cartesianItems.some((t) => t.type === "bar") || e.graphicalItems.polarItems.some((t) => t.type === "radialBar");
function $m(e, t) {
  return (r) => {
    switch (e) {
      case "xAxis":
        return "xAxisId" in r && r.xAxisId === t;
      case "yAxis":
        return "yAxisId" in r && r.yAxisId === t;
      case "zAxis":
        return "zAxisId" in r && r.zAxisId === t;
      case "angleAxis":
        return "angleAxisId" in r && r.angleAxisId === t;
      case "radiusAxis":
        return "radiusAxisId" in r && r.radiusAxisId === t;
      default:
        return !1;
    }
  };
}
var Zl = (e) => e.graphicalItems.cartesianItems, eP = E([_e, ao], $m), Lm = (e, t, r) => e.filter(r).filter((n) => (t == null ? void 0 : t.includeHidden) === !0 ? !0 : !n.hide), bn = E([Zl, Be, eP], Lm, {
  memoizeOptions: {
    resultEqualityCheck: uo
  }
}), Rm = E([bn], (e) => e.filter((t) => t.type === "area" || t.type === "bar").filter(oo)), Bm = (e) => e.filter((t) => !("stackId" in t) || t.stackId === void 0), tP = E([bn], Bm), zm = (e) => e.map((t) => t.data).filter(Boolean).flat(1), rP = E([bn], (e) => e.some((t) => !t.data)), Fm = E([bn], zm, {
  memoizeOptions: {
    resultEqualityCheck: uo
  }
}), Wm = (e, t) => {
  var r = t.chartData, n = r === void 0 ? [] : r, i = t.dataStartIndex, a = t.dataEndIndex;
  return e.length > 0 ? e : n.slice(i, a + 1);
}, Ql = E([Fm, eo], Wm), nP = (e, t, r) => (t == null ? void 0 : t.dataKey) != null ? e.map((n) => ({
  value: Se(n, t.dataKey)
})) : r.length > 0 ? r.map((n) => n.dataKey).flatMap((n) => e.map((i) => ({
  value: Se(i, n)
}))) : e.map((n) => ({
  value: n
})), Um = (e, t, r, n, i, a) => {
  var o = n.chartData, u = o === void 0 ? [] : o, l = n.dataStartIndex, c = n.dataEndIndex, s = nP(e, t, r);
  if (i && (t == null ? void 0 : t.dataKey) != null && a.length > 0) {
    var f = u.slice(l, c + 1), d = f.map((h) => ({
      value: Se(h, t.dataKey)
    })).filter((h) => h.value != null);
    return [...d, ...s];
  }
  return s;
}, gi = E([Ql, Be, bn, eo, rP, Fm], Um);
function Jr(e) {
  if (ut(e) || e instanceof Date) {
    var t = Number(e);
    if (H(t))
      return t;
  }
}
function cd(e) {
  if (Array.isArray(e)) {
    var t = [Jr(e[0]), Jr(e[1])];
    return kt(t) ? t : void 0;
  }
  var r = Jr(e);
  if (r != null)
    return [r, r];
}
function xt(e) {
  return e.map(Jr).filter(_t);
}
function iP(e, t) {
  var r = Jr(e), n = Jr(t);
  return r == null && n == null ? 0 : r == null ? -1 : n == null ? 1 : r - n;
}
var aP = E([gi], (e) => e == null ? void 0 : e.map((t) => t.value).sort(iP));
function Km(e, t) {
  switch (e) {
    case "xAxis":
      return t.direction === "x";
    case "yAxis":
      return t.direction === "y";
    default:
      return !1;
  }
}
function oP(e, t, r) {
  if (!r)
    return [];
  if (!r.length)
    return [];
  var n;
  if (typeof t == "number" && !Mt(t))
    n = t;
  else if (Array.isArray(t)) {
    var i = xt(t);
    i.length > 0 && (n = Math.max(...i));
  }
  return n == null ? [] : xt(r.flatMap((a) => {
    var o = Se(e, a.dataKey), u, l;
    if (Array.isArray(o)) {
      var c = Mm(o, 2);
      u = c[0], l = c[1];
    } else
      u = l = o;
    if (!(!H(u) || !H(l)))
      return [n - u, n + l];
  }));
}
var Ae = (e) => {
  var t = Pe(e), r = yn(e);
  return yi(e, t, r);
}, on = E([Ae], (e) => e == null ? void 0 : e.dataKey), uP = E([Rm, eo, Ae], qp), Vm = (e, t, r, n) => {
  var i = {}, a = t.reduce((o, u) => {
    if (u.stackId == null)
      return o;
    var l = o[u.stackId];
    return l == null && (l = []), l.push(u), o[u.stackId] = l, o;
  }, i);
  return Object.fromEntries(Object.entries(a).map((o) => {
    var u = Mm(o, 2), l = u[0], c = u[1], s = n ? [...c].reverse() : c, f = s.map(Sl);
    return [l, {
      // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
      stackedData: jw(e, f, r),
      graphicalItems: s
    }];
  }));
}, ju = E([uP, Rm, to, Wp], Vm), Hm = (e, t, r, n) => {
  var i = t.dataStartIndex, a = t.dataEndIndex;
  if (n == null && r !== "zAxis")
    return Rw(e, i, a);
}, lP = E([Be], (e) => e.allowDataOverflow), Jl = (e) => {
  var t;
  if (e == null || !("domain" in e))
    return Mu;
  if (e.domain != null)
    return e.domain;
  if ("ticks" in e && e.ticks != null) {
    if (e.type === "number") {
      var r = xt(e.ticks);
      return [Math.min(...r), Math.max(...r)];
    }
    if (e.type === "category")
      return e.ticks.map(String);
  }
  return (t = e == null ? void 0 : e.domain) !== null && t !== void 0 ? t : Mu;
}, Gm = E([Be], Jl), Ym = E([Gm, lP], kp), cP = E([ju, wt, _e, Ym], Hm, {
  memoizeOptions: {
    resultEqualityCheck: di
  }
}), ec = (e) => e.errorBars, sP = (e, t, r) => e.flatMap((n) => t[n.id]).filter(Boolean).filter((n) => Km(r, n)), _a = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r.filter(Boolean);
  if (i.length !== 0) {
    var a = i.flat(), o = Math.min(...a), u = Math.max(...a);
    return [o, u];
  }
}, qm = function(t, r, n, i, a) {
  var o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], u, l;
  if (n.length > 0 && n.forEach((c) => {
    var s, f = c.data != null ? [...c.data] : o, d = (s = i[c.id]) === null || s === void 0 ? void 0 : s.filter((h) => Km(a, h));
    f.forEach((h) => {
      var v, p = Se(h, (v = r.dataKey) !== null && v !== void 0 ? v : c.dataKey), m = oP(h, p, d);
      if (m.length >= 2) {
        var y = Math.min(...m), b = Math.max(...m);
        (u == null || y < u) && (u = y), (l == null || b > l) && (l = b);
      }
      var w = cd(p);
      w != null && (u = u == null ? w[0] : Math.min(u, w[0]), l = l == null ? w[1] : Math.max(l, w[1]));
    });
  }), (r == null ? void 0 : r.dataKey) != null && n.length === 0 && t.forEach((c) => {
    var s = cd(Se(c, r.dataKey));
    s != null && (u = u == null ? s[0] : Math.min(u, s[0]), l = l == null ? s[1] : Math.max(l, s[1]));
  }), H(u) && H(l))
    return [u, l];
}, fP = E([Ql, Be, tP, ec, _e, F1], qm, {
  memoizeOptions: {
    resultEqualityCheck: di
  }
});
function dP(e) {
  var t = e.value;
  if (ut(t) || t instanceof Date)
    return t;
}
var hP = (e, t, r) => {
  var n = e.map(dP).filter((i) => i != null);
  return r && (t.dataKey == null || t.allowDuplicatedCategory && Lh(n)) ? Ip(0, e.length) : t.allowDuplicatedCategory ? n : Array.from(new Set(n));
}, Xm = (e) => e.referenceElements.dots, xn = (e, t, r) => e.filter((n) => n.ifOverflow === "extendDomain").filter((n) => t === "xAxis" ? n.xAxisId === r : n.yAxisId === r), vP = E([Xm, _e, ao], xn), Zm = (e) => e.referenceElements.areas, pP = E([Zm, _e, ao], xn), Qm = (e) => e.referenceElements.lines, mP = E([Qm, _e, ao], xn), Jm = (e, t) => {
  if (e != null) {
    var r = xt(e.map((n) => t === "xAxis" ? n.x : n.y));
    if (r.length !== 0)
      return [Math.min(...r), Math.max(...r)];
  }
}, yP = E(vP, _e, Jm), ey = (e, t) => {
  if (e != null) {
    var r = xt(e.flatMap((n) => [t === "xAxis" ? n.x1 : n.y1, t === "xAxis" ? n.x2 : n.y2]));
    if (r.length !== 0)
      return [Math.min(...r), Math.max(...r)];
  }
}, gP = E([pP, _e], ey);
function bP(e) {
  var t;
  if (e.x != null)
    return xt([e.x]);
  var r = (t = e.segment) === null || t === void 0 ? void 0 : t.map((n) => n.x);
  return r == null || r.length === 0 ? [] : xt(r);
}
function xP(e) {
  var t;
  if (e.y != null)
    return xt([e.y]);
  var r = (t = e.segment) === null || t === void 0 ? void 0 : t.map((n) => n.y);
  return r == null || r.length === 0 ? [] : xt(r);
}
var ty = (e, t) => {
  if (e != null) {
    var r = e.flatMap((n) => t === "xAxis" ? bP(n) : xP(n));
    if (r.length !== 0)
      return [Math.min(...r), Math.max(...r)];
  }
}, wP = E([mP, _e], ty), AP = E(yP, wP, gP, (e, t, r) => _a(e, r, t)), ry = (e, t, r, n, i, a, o, u, l) => {
  if (r != null)
    return r;
  var c = o === "vertical" && u === "xAxis" || o === "horizontal" && u === "yAxis", s = c ? _a(n, a, i) : _a(a, i), f = G1(t, s, e.allowDataOverflow);
  return f ?? (e.allowDataOverflow && s == null && l != null ? l : f);
}, OP = (e) => {
  if (!(e == null || e.type !== "number" || !("ticks" in e) || e.ticks == null)) {
    var t = xt(e.ticks);
    if (t.length !== 0)
      return [Math.min(...t), Math.max(...t)];
  }
}, SP = E([Be], OP, {
  memoizeOptions: {
    resultEqualityCheck: di
  }
}), EP = E([Be, Gm, Ym, cP, fP, AP, re, _e, SP], ry, {
  memoizeOptions: {
    resultEqualityCheck: di
  }
}), _P = [0, 1], ny = (e, t, r, n, i, a, o) => {
  if (!((e == null || r == null || r.length === 0) && o === void 0)) {
    var u = e.dataKey, l = e.type, c = sr(t, a);
    if (c && u == null) {
      var s;
      return Ip(0, (s = r == null ? void 0 : r.length) !== null && s !== void 0 ? s : 0);
    }
    return l === "category" ? hP(n, e, c) : i === "expand" && !c ? _P : o;
  }
}, tc = E([Be, re, Ql, gi, to, _e, EP], ny), wn = E([Be, Nm, gl], Cm), iy = (e, t, r) => {
  var n = t.niceTicks;
  if (n !== "none") {
    var i = Jl(t), a = Array.isArray(i) && (i[0] === "auto" || i[1] === "auto");
    if ((n === "snap125" || n === "adaptive") && t != null && t.tickCount && kt(e)) {
      if (a)
        return gf(e, t.tickCount, t.allowDecimals, n);
      if (t.type === "number")
        return bf(e, t.tickCount, t.allowDecimals, n);
    }
    if (n === "auto" && r === "linear" && t != null && t.tickCount) {
      if (a && kt(e))
        return gf(e, t.tickCount, t.allowDecimals, "adaptive");
      if (t.type === "number" && kt(e))
        return bf(e, t.tickCount, t.allowDecimals, "adaptive");
    }
  }
}, rc = E([tc, yi, wn], iy), ay = (e, t, r, n) => {
  if (
    /*
     * Angle axis for some reason uses nice ticks when rendering axis tick labels,
     * but doesn't use nice ticks for extending domain like all the other axes do.
     * Not really sure why? Is there a good reason,
     * or is it just because someone added support for nice ticks to the other axes and forgot this one?
     */
    n !== "angleAxis" && (e == null ? void 0 : e.type) === "number" && kt(t) && Array.isArray(r) && r.length > 0
  ) {
    var i, a, o = t[0], u = (i = r[0]) !== null && i !== void 0 ? i : 0, l = t[1], c = (a = r[r.length - 1]) !== null && a !== void 0 ? a : 0;
    return [Math.min(o, u), Math.max(l, c)];
  }
  return t;
}, PP = E([Be, tc, rc, _e], ay), IP = E(gi, Be, (e, t) => {
  if (!(!t || t.type !== "number")) {
    var r = 1 / 0, n = Array.from(xt(e.map((f) => f.value))).sort((f, d) => f - d), i = n[0], a = n[n.length - 1];
    if (i == null || a == null)
      return 1 / 0;
    var o = a - i;
    if (o === 0)
      return 1 / 0;
    for (var u = 0; u < n.length - 1; u++) {
      var l = n[u], c = n[u + 1];
      if (!(l == null || c == null)) {
        var s = c - l;
        r = Math.min(r, s);
      }
    }
    return r / o;
  }
}), oy = E(IP, re, Fp, Ee, (e, t, r, n, i) => i, (e, t, r, n, i) => {
  if (!H(e))
    return 0;
  var a = t === "vertical" ? n.height : n.width;
  if (i === "gap")
    return e * a / 2;
  if (i === "no-gap") {
    var o = bt(r, e * a), u = e * a / 2;
    return u - o - (u - o) / a * o;
  }
  return 0;
}), kP = (e, t, r) => {
  var n = Dt(e, t);
  return n == null || typeof n.padding != "string" ? 0 : oy(e, "xAxis", t, r, n.padding);
}, CP = (e, t, r) => {
  var n = Nt(e, t);
  return n == null || typeof n.padding != "string" ? 0 : oy(e, "yAxis", t, r, n.padding);
}, TP = E(Dt, kP, (e, t) => {
  var r, n;
  if (e == null)
    return {
      left: 0,
      right: 0
    };
  var i = e.padding;
  return typeof i == "string" ? {
    left: t,
    right: t
  } : {
    left: ((r = i.left) !== null && r !== void 0 ? r : 0) + t,
    right: ((n = i.right) !== null && n !== void 0 ? n : 0) + t
  };
}), MP = E(Nt, CP, (e, t) => {
  var r, n;
  if (e == null)
    return {
      top: 0,
      bottom: 0
    };
  var i = e.padding;
  return typeof i == "string" ? {
    top: t,
    bottom: t
  } : {
    top: ((r = i.top) !== null && r !== void 0 ? r : 0) + t,
    bottom: ((n = i.bottom) !== null && n !== void 0 ? n : 0) + t
  };
}), uy = E([Ee, TP, Qa, Za, (e, t, r) => r], (e, t, r, n, i) => {
  var a = n.padding;
  return i ? [a.left, r.width - a.right] : [e.left + t.left, e.left + e.width - t.right];
}), ly = E([Ee, re, MP, Qa, Za, (e, t, r) => r], (e, t, r, n, i, a) => {
  var o = i.padding;
  return a ? [n.height - o.bottom, o.top] : t === "horizontal" ? [e.top + e.height - r.bottom, e.top + r.top] : [e.top + r.top, e.top + e.height - r.bottom];
}), bi = (e, t, r, n) => {
  var i;
  switch (t) {
    case "xAxis":
      return uy(e, r, n);
    case "yAxis":
      return ly(e, r, n);
    case "zAxis":
      return (i = Xl(e, r)) === null || i === void 0 ? void 0 : i.range;
    case "angleAxis":
      return Hp(e);
    case "radiusAxis":
      return Gp(e, r);
    default:
      return;
  }
}, cy = E([Be, bi], ro), jP = E([wn, PP], fS), nc = E([Be, wn, jP, cy], ql), sy = (e, t, r, n) => {
  if (!(r == null || r.dataKey == null)) {
    var i = r.type, a = r.scale, o = sr(e, n);
    if (o && (i === "number" || a !== "auto"))
      return t.map((u) => u.value);
  }
}, ic = E([re, gi, yi, _e], sy), un = E([nc], El);
E([nc], K_);
E([nc, aP], Tm);
E([bn, ec, _e], sP);
function fy(e, t) {
  return e.id < t.id ? -1 : e.id > t.id ? 1 : 0;
}
var po = (e, t) => t, mo = (e, t, r) => r, DP = E(qa, po, mo, (e, t, r) => e.filter((n) => n.orientation === t).filter((n) => n.mirror === r).sort(fy)), NP = E(Xa, po, mo, (e, t, r) => e.filter((n) => n.orientation === t).filter((n) => n.mirror === r).sort(fy)), dy = (e, t) => {
  var r = typeof t.height == "number" ? t.height : sl;
  return {
    width: e.width,
    height: r
  };
}, $P = (e, t) => {
  var r = typeof t.width == "number" ? t.width : ui;
  return {
    width: r,
    height: e.height
  };
}, hy = E(Ee, Dt, dy), LP = (e, t, r) => {
  switch (t) {
    case "top":
      return e.top;
    case "bottom":
      return r - e.bottom;
    default:
      return 0;
  }
}, RP = (e, t, r) => {
  switch (t) {
    case "left":
      return e.left;
    case "right":
      return r - e.right;
    default:
      return 0;
  }
}, BP = E(Xt, Ee, DP, po, mo, (e, t, r, n, i) => {
  var a = {}, o;
  return r.forEach((u) => {
    var l = dy(t, u);
    o == null && (o = LP(t, n, e));
    var c = n === "top" && !i || n === "bottom" && i;
    a[u.id] = o - Number(c) * l.height, o += (c ? -1 : 1) * l.height;
  }), a;
}), zP = E(qt, Ee, NP, po, mo, (e, t, r, n, i) => {
  var a = {}, o;
  return r.forEach((u) => {
    var l = $P(t, u);
    o == null && (o = RP(t, n, e));
    var c = n === "left" && !i || n === "right" && i;
    a[u.id] = o - Number(c) * l.width, o += (c ? -1 : 1) * l.width;
  }), a;
}), FP = (e, t) => {
  var r = Dt(e, t);
  if (r != null)
    return BP(e, r.orientation, r.mirror);
}, WP = E([Ee, Dt, FP, (e, t) => t], (e, t, r, n) => {
  if (t != null) {
    var i = r == null ? void 0 : r[n];
    return i == null ? {
      x: e.left,
      y: 0
    } : {
      x: e.left,
      y: i
    };
  }
}), UP = (e, t) => {
  var r = Nt(e, t);
  if (r != null)
    return zP(e, r.orientation, r.mirror);
}, KP = E([Ee, Nt, UP, (e, t) => t], (e, t, r, n) => {
  if (t != null) {
    var i = r == null ? void 0 : r[n];
    return i == null ? {
      x: 0,
      y: e.top
    } : {
      x: i,
      y: e.top
    };
  }
}), vy = E(Ee, Nt, (e, t) => {
  var r = typeof t.width == "number" ? t.width : ui;
  return {
    width: r,
    height: e.height
  };
}), sd = (e, t, r) => {
  switch (t) {
    case "xAxis":
      return hy(e, r).width;
    case "yAxis":
      return vy(e, r).height;
    default:
      return;
  }
}, py = (e, t, r, n) => {
  if (r != null) {
    var i = r.allowDuplicatedCategory, a = r.type, o = r.dataKey, u = sr(e, n), l = t.map((s) => s.value), c = l.filter((s) => s != null);
    if (o && u && a === "category" && i && Lh(c))
      return l;
  }
}, ac = E([re, gi, Be, _e], py);
E([re, J_, wn, un, ac, ic, bi, rc, _e], (e, t, r, n, i, a, o, u, l) => {
  if (t != null) {
    var c = sr(e, l);
    return {
      angle: t.angle,
      interval: t.interval,
      minTickGap: t.minTickGap,
      orientation: t.orientation,
      tick: t.tick,
      tickCount: t.tickCount,
      tickFormatter: t.tickFormatter,
      ticks: t.ticks,
      type: t.type,
      unit: t.unit,
      axisType: l,
      categoricalDomain: a,
      duplicateDomain: i,
      isCategorical: c,
      niceTicks: u,
      range: o,
      realScaleType: r,
      scale: n
    };
  }
});
var VP = (e, t, r, n, i, a, o, u, l) => {
  if (!(t == null || n == null)) {
    var c = sr(e, l), s = t.type, f = t.ticks, d = t.tickCount, h = (
      // @ts-expect-error This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
      r === "scaleBand" && typeof n.bandwidth == "function" ? n.bandwidth() / 2 : 2
    ), v = s === "category" && n.bandwidth ? n.bandwidth() / h : 0;
    v = l === "angleAxis" && a != null && a.length >= 2 ? Je(a[0] - a[1]) * 2 * v : v;
    var p = f || i;
    return p ? p.map((m, y) => {
      var b = o ? o.indexOf(m) : m, w = n.map(b);
      return H(w) ? {
        index: y,
        coordinate: w + v,
        value: m,
        offset: v
      } : null;
    }).filter(_t) : c && u ? u.map((m, y) => {
      var b = n.map(m);
      return H(b) ? {
        coordinate: b + v,
        value: m,
        index: y,
        offset: v
      } : null;
    }).filter(_t) : n.ticks ? n.ticks(d).map((m, y) => {
      var b = n.map(m);
      return H(b) ? {
        coordinate: b + v,
        value: m,
        index: y,
        offset: v
      } : null;
    }).filter(_t) : n.domain().map((m, y) => {
      var b = n.map(m);
      return H(b) ? {
        coordinate: b + v,
        // @ts-expect-error can't use Date as index
        value: o ? o[m] : m,
        index: y,
        offset: v
      } : null;
    }).filter(_t);
  }
}, my = E([re, yi, wn, un, rc, bi, ac, ic, _e], VP), HP = (e, t, r, n, i, a, o) => {
  if (!(t == null || r == null || n == null || n[0] === n[1])) {
    var u = sr(e, o), l = t.tickCount, c = 0;
    return c = o === "angleAxis" && (n == null ? void 0 : n.length) >= 2 ? Je(n[0] - n[1]) * 2 * c : c, u && a ? a.map((s, f) => {
      var d = r.map(s);
      return H(d) ? {
        coordinate: d + c,
        value: s,
        index: f,
        offset: c
      } : null;
    }).filter(_t) : r.ticks ? r.ticks(l).map((s, f) => {
      var d = r.map(s);
      return H(d) ? {
        coordinate: d + c,
        value: s,
        index: f,
        offset: c
      } : null;
    }).filter(_t) : r.domain().map((s, f) => {
      var d = r.map(s);
      return H(d) ? {
        coordinate: d + c,
        // @ts-expect-error can't use unknown as index
        value: i ? i[s] : s,
        index: f,
        offset: c
      } : null;
    }).filter(_t);
  }
}, ln = E([re, yi, un, bi, ac, ic, _e], HP), cn = E(Be, un, (e, t) => {
  if (!(e == null || t == null))
    return Ea(Ea({}, e), {}, {
      scale: t
    });
}), GP = E([Be, wn, tc, cy], ql), YP = E([GP], El);
E((e, t, r) => Xl(e, r), YP, (e, t) => {
  if (!(e == null || t == null))
    return Ea(Ea({}, e), {}, {
      scale: t
    });
});
var qP = E([re, qa, Xa], (e, t, r) => {
  switch (e) {
    case "horizontal":
      return t.some((n) => n.reversed) ? "right-to-left" : "left-to-right";
    case "vertical":
      return r.some((n) => n.reversed) ? "bottom-to-top" : "top-to-bottom";
    case "centric":
    case "radial":
      return "left-to-right";
    default:
      return;
  }
}), XP = (e, t, r) => {
  var n;
  return (n = e.renderedTicks[t]) === null || n === void 0 ? void 0 : n[r];
};
E([XP], (e) => {
  if (!(!e || e.length === 0))
    return (t) => {
      var r, n = 1 / 0, i = e[0];
      for (var a of e) {
        var o = Math.abs(a.coordinate - t);
        o < n && (n = o, i = a);
      }
      return (r = i) === null || r === void 0 ? void 0 : r.value;
    };
});
var yy = (e) => e.options.defaultTooltipEventType, gy = (e) => e.options.validateTooltipEventTypes;
function by(e, t, r) {
  if (e == null)
    return t;
  var n = e ? "axis" : "item";
  return r == null ? t : r.includes(n) ? n : t;
}
function xi(e, t) {
  var r = yy(e), n = gy(e);
  return by(t, r, n);
}
function ZP(e) {
  return N((t) => xi(t, e));
}
var xy = (e, t) => {
  var r, n = Number(t);
  if (!(Mt(n) || t == null))
    return n >= 0 ? e == null || (r = e[n]) === null || r === void 0 ? void 0 : r.value : void 0;
}, QP = (e) => e.tooltip.settings, nr = {
  active: !1,
  index: null,
  dataKey: void 0,
  graphicalItemId: void 0,
  coordinate: void 0
}, JP = {
  itemInteraction: {
    click: nr,
    hover: nr
  },
  axisInteraction: {
    click: nr,
    hover: nr
  },
  keyboardInteraction: nr,
  syncInteraction: {
    active: !1,
    index: null,
    dataKey: void 0,
    label: void 0,
    coordinate: void 0,
    sourceViewBox: void 0,
    graphicalItemId: void 0
  },
  tooltipItemPayloads: [],
  settings: {
    shared: void 0,
    trigger: "hover",
    axisId: 0,
    active: !1,
    defaultIndex: void 0
  }
}, wy = Re({
  name: "tooltip",
  initialState: JP,
  reducers: {
    addTooltipEntrySettings: {
      reducer(e, t) {
        e.tooltipItemPayloads.push(Z(t.payload));
      },
      prepare: ie()
    },
    replaceTooltipEntrySettings: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next, a = at(e).tooltipItemPayloads.indexOf(Z(n));
        a > -1 && (e.tooltipItemPayloads[a] = Z(i));
      },
      prepare: ie()
    },
    removeTooltipEntrySettings: {
      reducer(e, t) {
        var r = at(e).tooltipItemPayloads.indexOf(Z(t.payload));
        r > -1 && e.tooltipItemPayloads.splice(r, 1);
      },
      prepare: ie()
    },
    setTooltipSettingsState(e, t) {
      e.settings = t.payload;
    },
    setActiveMouseOverItemIndex(e, t) {
      e.syncInteraction.active = !1, e.syncInteraction.sourceViewBox = void 0, e.keyboardInteraction.active = !1, e.itemInteraction.hover.active = !0, e.itemInteraction.hover.index = t.payload.activeIndex, e.itemInteraction.hover.dataKey = t.payload.activeDataKey, e.itemInteraction.hover.graphicalItemId = t.payload.activeGraphicalItemId, e.itemInteraction.hover.coordinate = t.payload.activeCoordinate;
    },
    mouseLeaveChart(e) {
      e.itemInteraction.hover.active = !1, e.axisInteraction.hover.active = !1;
    },
    mouseLeaveItem(e) {
      e.itemInteraction.hover.active = !1;
    },
    setActiveClickItemIndex(e, t) {
      e.syncInteraction.active = !1, e.syncInteraction.sourceViewBox = void 0, e.itemInteraction.click.active = !0, e.keyboardInteraction.active = !1, e.itemInteraction.click.index = t.payload.activeIndex, e.itemInteraction.click.dataKey = t.payload.activeDataKey, e.itemInteraction.click.graphicalItemId = t.payload.activeGraphicalItemId, e.itemInteraction.click.coordinate = t.payload.activeCoordinate;
    },
    setMouseOverAxisIndex(e, t) {
      e.syncInteraction.active = !1, e.syncInteraction.sourceViewBox = void 0, e.axisInteraction.hover.active = !0, e.keyboardInteraction.active = !1, e.axisInteraction.hover.index = t.payload.activeIndex, e.axisInteraction.hover.dataKey = t.payload.activeDataKey, e.axisInteraction.hover.coordinate = t.payload.activeCoordinate;
    },
    setMouseClickAxisIndex(e, t) {
      e.syncInteraction.active = !1, e.syncInteraction.sourceViewBox = void 0, e.keyboardInteraction.active = !1, e.axisInteraction.click.active = !0, e.axisInteraction.click.index = t.payload.activeIndex, e.axisInteraction.click.dataKey = t.payload.activeDataKey, e.axisInteraction.click.coordinate = t.payload.activeCoordinate;
    },
    setSyncInteraction(e, t) {
      e.syncInteraction = t.payload;
    },
    setKeyboardInteraction(e, t) {
      e.keyboardInteraction.active = t.payload.active, e.keyboardInteraction.index = t.payload.activeIndex, e.keyboardInteraction.coordinate = t.payload.activeCoordinate;
    }
  }
}), dt = wy.actions, eI = dt.addTooltipEntrySettings, tI = dt.replaceTooltipEntrySettings, rI = dt.removeTooltipEntrySettings, nI = dt.setTooltipSettingsState, Ay = dt.setActiveMouseOverItemIndex, iI = dt.mouseLeaveItem, Oy = dt.mouseLeaveChart, aI = dt.setActiveClickItemIndex, Sy = dt.setMouseOverAxisIndex, oI = dt.setMouseClickAxisIndex, Ln = dt.setSyncInteraction, Pa = dt.setKeyboardInteraction, uI = wy.reducer;
function fd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ri(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fd(Object(r), !0).forEach(function(n) {
      lI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function lI(e, t, r) {
  return (t = cI(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function cI(e) {
  var t = sI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function sI(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function fI(e, t, r) {
  return t === "axis" ? r === "click" ? e.axisInteraction.click : e.axisInteraction.hover : r === "click" ? e.itemInteraction.click : e.itemInteraction.hover;
}
function dI(e) {
  return e.index != null;
}
var Ey = (e, t, r, n) => {
  if (t == null)
    return nr;
  var i = fI(e, t, r);
  if (i == null)
    return nr;
  if (i.active)
    return i;
  if (e.keyboardInteraction.active)
    return e.keyboardInteraction;
  if (e.syncInteraction.active && e.syncInteraction.index != null)
    return e.syncInteraction;
  var a = e.settings.active === !0;
  if (dI(i)) {
    if (a)
      return Ri(Ri({}, i), {}, {
        active: !0
      });
  } else if (n != null)
    return {
      active: !0,
      coordinate: void 0,
      dataKey: void 0,
      index: n,
      graphicalItemId: void 0
    };
  return Ri(Ri({}, nr), {}, {
    coordinate: i.coordinate
  });
};
function hI(e) {
  if (typeof e == "number")
    return Number.isFinite(e) ? e : void 0;
  if (e instanceof Date) {
    var t = e.valueOf();
    return Number.isFinite(t) ? t : void 0;
  }
  var r = Number(e);
  return Number.isFinite(r) ? r : void 0;
}
function vI(e, t) {
  var r = hI(e), n = t[0], i = t[1];
  if (r === void 0)
    return !1;
  var a = Math.min(n, i), o = Math.max(n, i);
  return r >= a && r <= o;
}
function pI(e, t, r) {
  if (r == null || t == null)
    return !0;
  var n = Se(e, t);
  return n == null || !kt(r) ? !0 : vI(n, r);
}
var zn = (e, t, r, n) => {
  var i = e == null ? void 0 : e.index;
  if (i == null)
    return null;
  var a = Number(i);
  if (!H(a))
    return i;
  var o = 0, u = 1 / 0;
  t.length > 0 && (u = t.length - 1);
  var l = Math.max(o, Math.min(a, u)), c = t[l];
  return c == null || pI(c, r, n) ? String(l) : null;
}, _y = (e, t, r, n, i, a, o) => {
  if (a != null) {
    var u = o[0], l = u == null ? void 0 : u.getPosition(a);
    if (l != null)
      return l;
    var c = i == null ? void 0 : i[Number(a)];
    if (c)
      switch (r) {
        case "horizontal":
          return {
            x: c.coordinate,
            y: (n.top + t) / 2
          };
        default:
          return {
            x: (n.left + e) / 2,
            y: c.coordinate
          };
      }
  }
}, Py = (e, t, r, n) => {
  if (t === "axis")
    return e.tooltipItemPayloads;
  if (e.tooltipItemPayloads.length === 0)
    return [];
  var i;
  if (r === "hover" ? i = e.itemInteraction.hover.graphicalItemId : i = e.itemInteraction.click.graphicalItemId, e.syncInteraction.active && i == null)
    return e.tooltipItemPayloads;
  if (i == null && (n != null || e.keyboardInteraction.active)) {
    var a = e.tooltipItemPayloads[0];
    return a != null ? [a] : [];
  }
  return e.tooltipItemPayloads.filter((o) => {
    var u;
    return ((u = o.settings) === null || u === void 0 ? void 0 : u.graphicalItemId) === i;
  });
}, Iy = (e) => e.options.tooltipPayloadSearcher, An = (e) => e.tooltip;
function dd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dd(Object(r), !0).forEach(function(n) {
      mI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function mI(e, t, r) {
  return (t = yI(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function yI(e) {
  var t = gI(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function gI(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function bI(e) {
  if (typeof e == "string" || typeof e == "number")
    return e;
}
function xI(e) {
  if (typeof e == "string" || typeof e == "number" || typeof e == "boolean")
    return e;
}
function wI(e) {
  if (typeof e == "string" || typeof e == "number")
    return e;
  if (typeof e == "function")
    return (t) => e(t);
}
function vd(e) {
  if (typeof e == "string")
    return e;
}
function AI(e) {
  if (!(e == null || typeof e != "object")) {
    var t = "name" in e ? bI(e.name) : void 0, r = "unit" in e ? xI(e.unit) : void 0, n = "dataKey" in e ? wI(e.dataKey) : void 0, i = "payload" in e ? e.payload : void 0, a = "color" in e ? vd(e.color) : void 0, o = "fill" in e ? vd(e.fill) : void 0;
    return {
      name: t,
      unit: r,
      dataKey: n,
      payload: i,
      color: a,
      fill: o
    };
  }
}
function OI(e, t) {
  return e ?? t;
}
var ky = (e, t, r, n, i, a, o) => {
  if (!(t == null || a == null)) {
    var u = r.chartData, l = r.computedData, c = r.dataStartIndex, s = r.dataEndIndex, f = [];
    return e.reduce((d, h) => {
      var v, p = h.dataDefinedOnItem, m = h.settings, y = OI(p, u), b = Array.isArray(y) ? lp(y, c, s) : y, w = (v = m == null ? void 0 : m.dataKey) !== null && v !== void 0 ? v : n, x = m == null ? void 0 : m.nameKey, O;
      if (n && Array.isArray(b) && /*
       * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
       * as tooltip payloads and findEntryInArray is not prepared to handle that.
       * Sad but also ScatterChart only allows 'item' tooltipEventType
       * and also this is only a problem if there are multiple Scatters and each has its own data array
       * so let's fix that some other time.
       */
      !Array.isArray(b[0]) && /*
       * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
       * because thanks to allowDuplicatedCategory=false, the order of elements in the array
       * no longer matches the order of elements in the original data
       * and so we need to search by the active dataKey + label rather than by index.
       *
       * The same happens if multiple graphical items are present in the chart
       * and each of them has its own data array. Those arrays get concatenated
       * and again the tooltip index no longer matches the original data.
       *
       * On the other hand the tooltipEventType 'item' should always search by index
       * because we get the index from interacting over the individual elements
       * which is always accurate, irrespective of the allowDuplicatedCategory setting.
       */
      o === "axis" ? (O = S0(b, n, i), O == null && (O = a(b, t, l, x))) : O = a(b, t, l, x), Array.isArray(O))
        O.forEach((S) => {
          var P, k, T = AI(S), I = T == null ? void 0 : T.name, _ = T == null ? void 0 : T.dataKey, L = T == null ? void 0 : T.payload, D = hd(hd({}, m), {}, {
            name: I,
            unit: T == null ? void 0 : T.unit,
            // Preserve item-level color/fill from graphical items.
            color: (P = T == null ? void 0 : T.color) !== null && P !== void 0 ? P : m == null ? void 0 : m.color,
            fill: (k = T == null ? void 0 : T.fill) !== null && k !== void 0 ? k : m == null ? void 0 : m.fill
          });
          d.push(ds({
            tooltipEntrySettings: D,
            dataKey: _,
            payload: L,
            value: Se(L, _),
            name: I == null ? void 0 : String(I)
          }));
        });
      else {
        var g;
        d.push(ds({
          tooltipEntrySettings: m,
          dataKey: w,
          payload: O,
          // getValueByDataKey does not validate the output type
          value: Se(O, w),
          // getValueByDataKey does not validate the output type
          name: (g = Se(O, x)) !== null && g !== void 0 ? g : m == null ? void 0 : m.name
        }));
      }
      return d;
    }, f);
  }
}, oc = E([Ae, Nm, gl], Cm), SI = E([(e) => e.graphicalItems.cartesianItems, (e) => e.graphicalItems.polarItems], (e, t) => [...e, ...t]), EI = E([Pe, yn], $m), Br = E([SI, Ae, EI], Lm, {
  memoizeOptions: {
    resultEqualityCheck: uo
  }
}), _I = E([Br], (e) => e.filter(oo)), Cy = E([Br], zm, {
  memoizeOptions: {
    resultEqualityCheck: uo
  }
}), PI = E([Br], (e) => e.some((t) => !t.data)), Nr = E([Cy, wt], Wm), II = E([_I, wt, Ae], qp), uc = E([Nr, Ae, Br, wt, PI, Cy], Um), Ty = E([Ae], Jl), kI = E([Ae], (e) => e.allowDataOverflow), My = E([Ty, kI], kp), CI = E([Br], (e) => e.filter(oo)), TI = E([II, CI, to, Wp], Vm), MI = E([TI, wt, Pe, My], Hm), jI = E([Br], Bm), DI = E([Nr, Ae, jI, ec, Pe, W1], qm, {
  memoizeOptions: {
    resultEqualityCheck: di
  }
}), NI = E([Xm, Pe, yn], xn), $I = E([NI, Pe], Jm), LI = E([Zm, Pe, yn], xn), RI = E([LI, Pe], ey), BI = E([Qm, Pe, yn], xn), zI = E([BI, Pe], ty), FI = E([$I, zI, RI], _a), WI = E([Ae, Ty, My, MI, DI, FI, re, Pe], ry), sn = E([Ae, re, Nr, uc, to, Pe, WI], ny), UI = E([sn, Ae, oc], iy), KI = E([Ae, sn, UI, Pe], ay), jy = (e) => {
  var t = Pe(e), r = yn(e), n = !1;
  return bi(e, t, r, n);
}, Dy = E([Ae, jy], ro), VI = E([Ae, oc, KI, Dy], ql), Ny = E([VI], El), HI = E([re, uc, Ae, Pe], py), GI = E([re, uc, Ae, Pe], sy), YI = (e, t, r, n, i, a, o, u) => {
  if (t) {
    var l = t.type, c = sr(e, u);
    if (n) {
      var s = r === "scaleBand" && n.bandwidth ? n.bandwidth() / 2 : 2, f = l === "category" && n.bandwidth ? n.bandwidth() / s : 0;
      return f = u === "angleAxis" && i != null && (i == null ? void 0 : i.length) >= 2 ? Je(i[0] - i[1]) * 2 * f : f, c && o ? o.map((d, h) => {
        var v = n.map(d);
        return H(v) ? {
          coordinate: v + f,
          value: d,
          index: h,
          offset: f
        } : null;
      }).filter(_t) : n.domain().map((d, h) => {
        var v = n.map(d);
        return H(v) ? {
          coordinate: v + f,
          // @ts-expect-error can't use Date as an index
          value: a ? a[d] : d,
          index: h,
          offset: f
        } : null;
      }).filter(_t);
    }
  }
}, Qt = E([re, Ae, oc, Ny, jy, HI, GI, Pe], YI), lc = E([yy, gy, QP], (e, t, r) => by(r.shared, e, t)), $y = (e) => e.tooltip.settings.trigger, cc = (e) => e.tooltip.settings.defaultIndex, wi = E([An, lc, $y, cc], Ey), fn = E([wi, Nr, on, sn], zn), Ly = E([Qt, fn], xy), Ry = E([wi], (e) => {
  if (e)
    return e.dataKey;
}), qI = E([wi], (e) => {
  if (e)
    return e.graphicalItemId;
}), By = E([An, lc, $y, cc], Py), XI = E([qt, Xt, re, Ee, Qt, cc, By], _y), ZI = E([wi, XI], (e, t) => e != null && e.coordinate ? e.coordinate : t), QI = E([wi], (e) => {
  var t;
  return (t = e == null ? void 0 : e.active) !== null && t !== void 0 ? t : !1;
}), JI = E([By, fn, wt, on, Ly, Iy, lc], ky);
E([JI], (e) => {
  if (e != null) {
    var t = e.map((r) => r.payload).filter((r) => r != null);
    return Array.from(new Set(t));
  }
});
function pd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function md(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pd(Object(r), !0).forEach(function(n) {
      ek(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ek(e, t, r) {
  return (t = tk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function tk(e) {
  var t = rk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function rk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nk = () => N(Ae), ik = () => {
  var e = nk(), t = N(Qt), r = N(Ny);
  return ua(!e || !r ? void 0 : md(md({}, e), {}, {
    scale: r
  }), t);
};
function yd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yd(Object(r), !0).forEach(function(n) {
      ak(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ak(e, t, r) {
  return (t = ok(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ok(e) {
  var t = uk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function uk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var lk = (e, t, r, n) => {
  var i = t.find((a) => a && a.index === r);
  if (i) {
    if (e === "horizontal")
      return {
        x: i.coordinate,
        y: n.relativeY
      };
    if (e === "vertical")
      return {
        x: n.relativeX,
        y: i.coordinate
      };
  }
  return {
    x: 0,
    y: 0
  };
}, ck = (e, t, r, n) => {
  var i = t.find((c) => c && c.index === r);
  if (i) {
    if (e === "centric") {
      var a = i.coordinate, o = n.radius;
      return Vr(Vr(Vr({}, n), Me(n.cx, n.cy, o, a)), {}, {
        angle: a,
        radius: o
      });
    }
    var u = i.coordinate, l = n.angle;
    return Vr(Vr(Vr({}, n), Me(n.cx, n.cy, u, l)), {}, {
      angle: l,
      radius: u
    });
  }
  return {
    angle: 0,
    clockWise: !1,
    cx: 0,
    cy: 0,
    endAngle: 0,
    innerRadius: 0,
    outerRadius: 0,
    radius: 0,
    startAngle: 0,
    x: 0,
    y: 0
  };
};
function sk(e, t) {
  var r = e.relativeX, n = e.relativeY;
  return r >= t.left && r <= t.left + t.width && n >= t.top && n <= t.top + t.height;
}
var zy = (e, t, r, n, i) => {
  var a, o = (a = t == null ? void 0 : t.length) !== null && a !== void 0 ? a : 0;
  if (o <= 1 || e == null)
    return 0;
  if (n === "angleAxis" && i != null && Math.abs(Math.abs(i[1] - i[0]) - 360) <= 1e-6)
    for (var u = i[1] - i[0], l = (F, K, V) => [e, e + u, e - u].some((R) => (V ? R >= F : R > F) && R <= K), c = 0; c < o; c++) {
      var s, f, d, h, v, p = c > 0 ? (s = r[c - 1]) === null || s === void 0 ? void 0 : s.coordinate : (f = r[o - 1]) === null || f === void 0 ? void 0 : f.coordinate, m = (d = r[c]) === null || d === void 0 ? void 0 : d.coordinate, y = c >= o - 1 ? (h = r[0]) === null || h === void 0 ? void 0 : h.coordinate : (v = r[c + 1]) === null || v === void 0 ? void 0 : v.coordinate, b = void 0;
      if (!(p == null || m == null || y == null))
        if (Je(m - p) !== Je(y - m)) {
          var w = [];
          if (Je(y - m) === Je(i[1] - i[0])) {
            b = y;
            var x = m + i[1] - i[0];
            w[0] = Math.min(x, (x + p) / 2), w[1] = Math.max(x, (x + p) / 2);
          } else {
            b = p;
            var O = y + i[1] - i[0];
            w[0] = Math.min(m, (O + m) / 2), w[1] = Math.max(m, (O + m) / 2);
          }
          var g = [Math.min(m, (b + m) / 2), Math.max(m, (b + m) / 2)];
          if (l(g[0], g[1], !1) || l(w[0], w[1], !0)) {
            var S;
            return (S = r[c]) === null || S === void 0 ? void 0 : S.index;
          }
        } else {
          var P = Math.min(p, y), k = Math.max(p, y);
          if (l((P + m) / 2, (k + m) / 2, !1)) {
            var T;
            return (T = r[c]) === null || T === void 0 ? void 0 : T.index;
          }
        }
    }
  else if (t)
    for (var I = 0; I < o; I++) {
      var _ = t[I];
      if (_ != null) {
        var L = t[I + 1], D = t[I - 1];
        if (I === 0 && L != null && e <= (_.coordinate + L.coordinate) / 2 || I === o - 1 && D != null && e > (_.coordinate + D.coordinate) / 2 || I > 0 && I < o - 1 && D != null && L != null && e > (_.coordinate + D.coordinate) / 2 && e <= (_.coordinate + L.coordinate) / 2)
          return _.index;
      }
    }
  return -1;
}, fk = () => N(gl), sc = (e, t) => t, Fy = (e, t, r) => r, fc = (e, t, r, n) => n, dk = E(Qt, (e) => Ba(e, (t) => t.coordinate)), dc = E([An, sc, Fy, fc], Ey), hc = E([dc, Nr, on, sn], zn), hk = (e, t, r) => {
  if (t != null) {
    var n = An(e);
    return t === "axis" ? r === "hover" ? n.axisInteraction.hover.dataKey : n.axisInteraction.click.dataKey : r === "hover" ? n.itemInteraction.hover.dataKey : n.itemInteraction.click.dataKey;
  }
}, Wy = E([An, sc, Fy, fc], Py), Ia = E([qt, Xt, re, Ee, Qt, fc, Wy], _y), vk = E([dc, Ia], (e, t) => {
  var r;
  return (r = e.coordinate) !== null && r !== void 0 ? r : t;
}), Uy = E([Qt, hc], xy), pk = E([Wy, hc, wt, on, Uy, Iy, sc], ky), mk = E([dc, hc], (e, t) => ({
  isActive: e.active && t != null,
  activeIndex: t
})), yk = (e, t, r, n, i, a, o) => {
  if (!(!e || !r || !n || !i) && sk(e, o)) {
    var u = Bw(e, t), l = zy(u, a, i, r, n), c = lk(t, i, l, e);
    return {
      activeIndex: String(l),
      activeCoordinate: c
    };
  }
}, gk = (e, t, r, n, i, a, o) => {
  if (!(!e || !n || !i || !a || !r)) {
    var u = j1(e, r);
    if (u) {
      var l = zw(u, t), c = zy(l, o, a, n, i), s = ck(t, a, c, u);
      return {
        activeIndex: String(c),
        activeCoordinate: s
      };
    }
  }
}, bk = (e, t, r, n, i, a, o, u) => {
  if (!(!e || !t || !n || !i || !a))
    return t === "horizontal" || t === "vertical" ? yk(e, t, n, i, a, o, u) : gk(e, t, r, n, i, a, o);
}, xk = E((e) => e.zIndex.zIndexMap, (e, t) => t, (e, t, r) => r, (e, t, r) => {
  if (t != null) {
    var n = e[t];
    if (n != null)
      return r ? n.panoramaElement : n.element;
  }
}), wk = E((e) => e.zIndex.zIndexMap, (e) => {
  var t = Object.keys(e).map((n) => parseInt(n, 10)).concat(Object.values(Fe)), r = Array.from(new Set(t));
  return r.sort((n, i) => n - i);
}, {
  memoizeOptions: {
    resultEqualityCheck: sS
  }
});
function gd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gd(Object(r), !0).forEach(function(n) {
      Ak(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ak(e, t, r) {
  return (t = Ok(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ok(e) {
  var t = Sk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Sk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Ek = {}, _k = {
  zIndexMap: Object.values(Fe).reduce((e, t) => bd(bd({}, e), {}, {
    [t]: {
      element: void 0,
      panoramaElement: void 0,
      consumers: 0
    }
  }), Ek)
}, Pk = new Set(Object.values(Fe));
function Ik(e) {
  return Pk.has(e);
}
var Ky = Re({
  name: "zIndex",
  initialState: _k,
  reducers: {
    registerZIndexPortal: {
      reducer: (e, t) => {
        var r = t.payload.zIndex;
        e.zIndexMap[r] ? e.zIndexMap[r].consumers += 1 : e.zIndexMap[r] = {
          consumers: 1,
          element: void 0,
          panoramaElement: void 0
        };
      },
      prepare: ie()
    },
    unregisterZIndexPortal: {
      reducer: (e, t) => {
        var r = t.payload.zIndex;
        e.zIndexMap[r] && (e.zIndexMap[r].consumers -= 1, e.zIndexMap[r].consumers <= 0 && !Ik(r) && delete e.zIndexMap[r]);
      },
      prepare: ie()
    },
    registerZIndexPortalElement: {
      reducer: (e, t) => {
        var r = t.payload, n = r.zIndex, i = r.element, a = r.isPanorama;
        e.zIndexMap[n] ? a ? e.zIndexMap[n].panoramaElement = Z(i) : e.zIndexMap[n].element = Z(i) : e.zIndexMap[n] = {
          consumers: 0,
          element: a ? void 0 : Z(i),
          panoramaElement: a ? Z(i) : void 0
        };
      },
      prepare: ie()
    },
    unregisterZIndexPortalElement: {
      reducer: (e, t) => {
        var r = t.payload.zIndex;
        e.zIndexMap[r] && (t.payload.isPanorama ? e.zIndexMap[r].panoramaElement = void 0 : e.zIndexMap[r].element = void 0);
      },
      prepare: ie()
    }
  }
}), yo = Ky.actions, kk = yo.registerZIndexPortal, Ho = yo.unregisterZIndexPortal, Ck = yo.registerZIndexPortalElement, Tk = yo.unregisterZIndexPortalElement, Mk = Ky.reducer;
function Jt(e) {
  var t = e.zIndex, r = e.children, n = _A(), i = n && t !== void 0 && t !== 0, a = Ye(), o = X(void 0), u = X(/* @__PURE__ */ new Set()), l = oe(), c = N((f) => xk(f, t, a));
  if (Ue(() => {
    if (!i) {
      var f = u.current;
      f.forEach((h) => {
        l(Ho({
          zIndex: h
        }));
      }), f.clear(), o.current = void 0;
      return;
    }
    if (u.current.has(t) || (l(kk({
      zIndex: t
    })), u.current.add(t)), c) {
      o.current = c;
      var d = u.current;
      d.forEach((h) => {
        h !== t && (l(Ho({
          zIndex: h
        })), d.delete(h));
      });
    }
  }, [l, t, i, c]), Ue(() => {
    var f = u.current;
    return () => {
      f.forEach((d) => {
        l(Ho({
          zIndex: d
        }));
      }), f.clear();
    };
  }, [l]), !i)
    return r;
  var s = c ?? o.current;
  return s ? /* @__PURE__ */ Th(r, s) : null;
}
function Du() {
  return Du = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Du.apply(null, arguments);
}
function xd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Bi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xd(Object(r), !0).forEach(function(n) {
      jk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jk(e, t, r) {
  return (t = Dk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dk(e) {
  var t = Nk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Nk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $k(e) {
  var t = e.cursor, r = e.cursorComp, n = e.cursorProps;
  return /* @__PURE__ */ yt(t) ? /* @__PURE__ */ $a(t, n) : /* @__PURE__ */ Ch(r, n);
}
function Lk(e) {
  var t, r = e.coordinate, n = e.payload, i = e.index, a = e.offset, o = e.tooltipAxisBandSize, u = e.layout, l = e.cursor, c = e.tooltipEventType, s = e.chartName, f = r, d = n, h = i;
  if (!l || !f || s !== "ScatterChart" && c !== "axis")
    return null;
  var v, p, m;
  if (s === "ScatterChart")
    v = f, p = WO, m = Fe.cursorLine;
  else if (s === "BarChart")
    v = UO(u, f, a, o), p = Ep, m = Fe.cursorRectangle;
  else if (u === "radial" && Qh(f)) {
    var y = _p(f), b = y.cx, w = y.cy, x = y.radius, O = y.startAngle, g = y.endAngle;
    v = {
      cx: b,
      cy: w,
      startAngle: O,
      endAngle: g,
      innerRadius: x,
      outerRadius: x
    }, p = L1, m = Fe.cursorLine;
  } else
    v = {
      points: R1(u, f, a)
    }, p = jO, m = Fe.cursorLine;
  var S = typeof l == "object" && "className" in l ? l.className : void 0, P = Bi(Bi(Bi(Bi({
    stroke: "#ccc",
    pointerEvents: "none"
  }, a), v), Hu(l)), {}, {
    payload: d,
    payloadIndex: h,
    className: le("recharts-tooltip-cursor", S)
  });
  return /* @__PURE__ */ A.createElement(Jt, {
    zIndex: (t = e.zIndex) !== null && t !== void 0 ? t : m
  }, /* @__PURE__ */ A.createElement($k, {
    cursor: l,
    cursorComp: p,
    cursorProps: P
  }));
}
function Rk(e) {
  var t = ik(), r = OA(), n = vn(), i = fk();
  return t == null || r == null || n == null || i == null ? null : /* @__PURE__ */ A.createElement(Lk, Du({}, e, {
    offset: r,
    layout: n,
    tooltipAxisBandSize: t,
    chartName: i
  }));
}
var Vy = /* @__PURE__ */ Ge(null), Bk = () => rt(Vy), Hy = { exports: {} };
(function(e) {
  var t = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function i(l, c, s) {
    this.fn = l, this.context = c, this.once = s || !1;
  }
  function a(l, c, s, f, d) {
    if (typeof s != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(s, f || l, d), v = r ? r + c : c;
    return l._events[v] ? l._events[v].fn ? l._events[v] = [l._events[v], h] : l._events[v].push(h) : (l._events[v] = h, l._eventsCount++), l;
  }
  function o(l, c) {
    --l._eventsCount === 0 ? l._events = new n() : delete l._events[c];
  }
  function u() {
    this._events = new n(), this._eventsCount = 0;
  }
  u.prototype.eventNames = function() {
    var c = [], s, f;
    if (this._eventsCount === 0) return c;
    for (f in s = this._events)
      t.call(s, f) && c.push(r ? f.slice(1) : f);
    return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(s)) : c;
  }, u.prototype.listeners = function(c) {
    var s = r ? r + c : c, f = this._events[s];
    if (!f) return [];
    if (f.fn) return [f.fn];
    for (var d = 0, h = f.length, v = new Array(h); d < h; d++)
      v[d] = f[d].fn;
    return v;
  }, u.prototype.listenerCount = function(c) {
    var s = r ? r + c : c, f = this._events[s];
    return f ? f.fn ? 1 : f.length : 0;
  }, u.prototype.emit = function(c, s, f, d, h, v) {
    var p = r ? r + c : c;
    if (!this._events[p]) return !1;
    var m = this._events[p], y = arguments.length, b, w;
    if (m.fn) {
      switch (m.once && this.removeListener(c, m.fn, void 0, !0), y) {
        case 1:
          return m.fn.call(m.context), !0;
        case 2:
          return m.fn.call(m.context, s), !0;
        case 3:
          return m.fn.call(m.context, s, f), !0;
        case 4:
          return m.fn.call(m.context, s, f, d), !0;
        case 5:
          return m.fn.call(m.context, s, f, d, h), !0;
        case 6:
          return m.fn.call(m.context, s, f, d, h, v), !0;
      }
      for (w = 1, b = new Array(y - 1); w < y; w++)
        b[w - 1] = arguments[w];
      m.fn.apply(m.context, b);
    } else {
      var x = m.length, O;
      for (w = 0; w < x; w++)
        switch (m[w].once && this.removeListener(c, m[w].fn, void 0, !0), y) {
          case 1:
            m[w].fn.call(m[w].context);
            break;
          case 2:
            m[w].fn.call(m[w].context, s);
            break;
          case 3:
            m[w].fn.call(m[w].context, s, f);
            break;
          case 4:
            m[w].fn.call(m[w].context, s, f, d);
            break;
          default:
            if (!b) for (O = 1, b = new Array(y - 1); O < y; O++)
              b[O - 1] = arguments[O];
            m[w].fn.apply(m[w].context, b);
        }
    }
    return !0;
  }, u.prototype.on = function(c, s, f) {
    return a(this, c, s, f, !1);
  }, u.prototype.once = function(c, s, f) {
    return a(this, c, s, f, !0);
  }, u.prototype.removeListener = function(c, s, f, d) {
    var h = r ? r + c : c;
    if (!this._events[h]) return this;
    if (!s)
      return o(this, h), this;
    var v = this._events[h];
    if (v.fn)
      v.fn === s && (!d || v.once) && (!f || v.context === f) && o(this, h);
    else {
      for (var p = 0, m = [], y = v.length; p < y; p++)
        (v[p].fn !== s || d && !v[p].once || f && v[p].context !== f) && m.push(v[p]);
      m.length ? this._events[h] = m.length === 1 ? m[0] : m : o(this, h);
    }
    return this;
  }, u.prototype.removeAllListeners = function(c) {
    var s;
    return c ? (s = r ? r + c : c, this._events[s] && o(this, s)) : (this._events = new n(), this._eventsCount = 0), this;
  }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = r, u.EventEmitter = u, e.exports = u;
})(Hy);
var zk = Hy.exports;
const Fk = /* @__PURE__ */ l0(zk);
var Jn = new Fk(), Nu = "recharts.syncEvent.tooltip", wd = "recharts.syncEvent.brush", Wk = (e, t) => {
  if (t && Array.isArray(e)) {
    var r = Number.parseInt(t, 10);
    if (!Mt(r))
      return e[r];
  }
}, Uk = {
  chartName: "",
  tooltipPayloadSearcher: () => {
  },
  eventEmitter: void 0,
  defaultTooltipEventType: "axis"
}, Gy = Re({
  name: "options",
  initialState: Uk,
  reducers: {
    createEventEmitter: (e) => {
      e.eventEmitter == null && (e.eventEmitter = Symbol("rechartsEventEmitter"));
    }
  }
}), Kk = Gy.reducer, Vk = Gy.actions.createEventEmitter;
function Hk(e) {
  return e.tooltip.syncInteraction;
}
var Gk = {
  chartData: void 0,
  computedData: void 0,
  dataStartIndex: 0,
  dataEndIndex: 0
}, Yy = Re({
  name: "chartData",
  initialState: Gk,
  reducers: {
    setChartData(e, t) {
      if (e.chartData = Z(t.payload), t.payload == null) {
        e.dataStartIndex = 0, e.dataEndIndex = 0;
        return;
      }
      t.payload.length > 0 && e.dataEndIndex !== t.payload.length - 1 && (e.dataEndIndex = t.payload.length - 1);
    },
    setComputedData(e, t) {
      e.computedData = t.payload;
    },
    setDataStartEndIndexes(e, t) {
      var r = t.payload, n = r.startIndex, i = r.endIndex;
      n != null && (e.dataStartIndex = n), i != null && (e.dataEndIndex = i);
    }
  }
}), vc = Yy.actions, Ad = vc.setChartData, Yk = vc.setDataStartEndIndexes;
vc.setComputedData;
var qk = Yy.reducer, Xk = ["x", "y"];
function Od(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Od(Object(r), !0).forEach(function(n) {
      Zk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Od(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Zk(e, t, r) {
  return (t = Qk(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Qk(e) {
  var t = Jk(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Jk(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function eC(e, t) {
  if (e == null) return {};
  var r, n, i = tC(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function tC(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function rC() {
  var e = N(bl), t = N(xl), r = oe(), n = N(Up), i = N(Qt), a = vn(), o = li(), u = N((l) => l.rootProps.className);
  se(() => {
    if (e == null)
      return hn;
    var l = (c, s, f) => {
      if (t !== f && e === c) {
        if (s.payload.active === !1) {
          r(Ln({
            active: !1,
            coordinate: void 0,
            dataKey: void 0,
            index: null,
            label: void 0,
            sourceViewBox: void 0,
            graphicalItemId: void 0
          }));
          return;
        }
        if (n === "index") {
          var d;
          if (o && s !== null && s !== void 0 && (d = s.payload) !== null && d !== void 0 && d.coordinate && s.payload.sourceViewBox) {
            var h = s.payload.coordinate, v = h.x, p = h.y, m = eC(h, Xk), y = s.payload.sourceViewBox, b = y.x, w = y.y, x = y.width, O = y.height, g = Hr(Hr({}, m), {}, {
              x: o.x + (x ? (v - b) / x : 0) * o.width,
              y: o.y + (O ? (p - w) / O : 0) * o.height
            });
            r(Hr(Hr({}, s), {}, {
              payload: Hr(Hr({}, s.payload), {}, {
                coordinate: g
              })
            }));
          } else
            r(s);
          return;
        }
        if (i != null) {
          var S;
          if (typeof n == "function") {
            var P = {
              activeTooltipIndex: s.payload.index == null ? void 0 : Number(s.payload.index),
              isTooltipActive: s.payload.active,
              activeIndex: s.payload.index == null ? void 0 : Number(s.payload.index),
              activeLabel: s.payload.label,
              activeDataKey: s.payload.dataKey,
              activeCoordinate: s.payload.coordinate
            }, k = n(i, P);
            S = i[k];
          } else n === "value" && (S = i.find((V) => String(V.value) === s.payload.label));
          var T = s.payload.coordinate;
          if (T == null || o == null) {
            r(Ln({
              active: !1,
              coordinate: void 0,
              dataKey: void 0,
              index: null,
              label: void 0,
              sourceViewBox: void 0,
              graphicalItemId: void 0
            }));
            return;
          }
          if (S == null) {
            r(Ln({
              active: !1,
              coordinate: void 0,
              dataKey: void 0,
              index: null,
              label: void 0,
              sourceViewBox: s.payload.sourceViewBox,
              graphicalItemId: void 0
            }));
            return;
          }
          var I = T.x, _ = T.y, L = Math.min(I, o.x + o.width), D = Math.min(_, o.y + o.height), F = {
            x: a === "horizontal" ? S.coordinate : L,
            y: a === "horizontal" ? D : S.coordinate
          }, K = Ln({
            active: s.payload.active,
            coordinate: F,
            dataKey: s.payload.dataKey,
            index: String(S.index),
            label: s.payload.label,
            sourceViewBox: s.payload.sourceViewBox,
            graphicalItemId: s.payload.graphicalItemId
          });
          r(K);
        }
      }
    };
    return Jn.on(Nu, l), () => {
      Jn.off(Nu, l);
    };
  }, [u, r, t, e, n, i, a, o]);
}
function nC() {
  var e = N(bl), t = N(xl), r = oe();
  se(() => {
    if (e == null)
      return hn;
    var n = (i, a, o) => {
      t !== o && e === i && r(Yk(a));
    };
    return Jn.on(wd, n), () => {
      Jn.off(wd, n);
    };
  }, [r, t, e]);
}
function iC() {
  var e = oe();
  se(() => {
    e(Vk());
  }, [e]), rC(), nC();
}
function aC(e, t, r, n, i, a) {
  var o = N((v) => hk(v, e, t)), u = N(qI), l = N(xl), c = N(bl), s = N(Up), f = N(Hk), d = (f == null ? void 0 : f.sourceViewBox) != null, h = li();
  se(() => {
    if (!d && c != null && l != null) {
      var v = Ln({
        active: a,
        coordinate: r,
        dataKey: o,
        index: i,
        label: typeof n == "number" ? String(n) : n,
        sourceViewBox: h,
        graphicalItemId: u
      });
      Jn.emit(Nu, c, v, l);
    }
  }, [d, r, o, u, i, n, l, c, s, a, h]);
}
function Sd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ed(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sd(Object(r), !0).forEach(function(n) {
      oC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oC(e, t, r) {
  return (t = uC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uC(e) {
  var t = lC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function lC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function cC(e, t) {
  return hC(e) || dC(e, t) || fC(e, t) || sC();
}
function sC() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fC(e, t) {
  if (e) {
    if (typeof e == "string") return _d(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _d(e, t) : void 0;
  }
}
function _d(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function dC(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function hC(e) {
  if (Array.isArray(e)) return e;
}
function vC(e) {
  return e.dataKey;
}
function pC(e, t) {
  return /* @__PURE__ */ A.isValidElement(e) ? /* @__PURE__ */ A.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ A.createElement(e, t) : /* @__PURE__ */ A.createElement(oO, t);
}
var Pd = [], mC = {
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  axisId: 0,
  contentStyle: {},
  cursor: !0,
  filterNull: !0,
  includeHidden: !1,
  isAnimationActive: "auto",
  itemSorter: "name",
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  wrapperStyle: {}
};
function yC(e) {
  var t, r, n = st(e, mC), i = n.active, a = n.allowEscapeViewBox, o = n.animationDuration, u = n.animationEasing, l = n.content, c = n.filterNull, s = n.isAnimationActive, f = n.offset, d = n.payloadUniqBy, h = n.position, v = n.reverseDirection, p = n.useTranslate3d, m = n.wrapperStyle, y = n.cursor, b = n.shared, w = n.trigger, x = n.defaultIndex, O = n.portal, g = n.axisId, S = oe(), P = typeof x == "number" ? String(x) : x;
  se(() => {
    S(nI({
      shared: b,
      trigger: w,
      axisId: g,
      active: i,
      defaultIndex: P
    }));
  }, [S, b, w, g, i, P]);
  var k = li(), T = bp(), I = ZP(b), _ = (t = N((z) => mk(z, I, w, P))) !== null && t !== void 0 ? t : {}, L = _.activeIndex, D = _.isActive, F = N((z) => pk(z, I, w, P)), K = N((z) => Uy(z, I, w, P)), V = N((z) => vk(z, I, w, P)), R = F, q = Bk(), W = (r = i ?? D) !== null && r !== void 0 ? r : !1, he = cx([R, W]), ve = cC(he, 2), ce = ve[0], ze = ve[1], qe = I === "axis" ? K : void 0;
  aC(I, w, V, qe, L, W);
  var ht = O ?? q;
  if (ht == null || k == null || I == null)
    return null;
  var vt = R ?? Pd;
  W || (vt = Pd), c && vt.length && (vt = kb(vt.filter((z) => z.value != null && (z.hide !== !0 || n.includeHidden)), d, vC));
  var En = vt.length > 0, M = Ed(Ed({}, n), {}, {
    payload: vt,
    label: qe,
    active: W,
    activeIndex: L,
    coordinate: V,
    accessibilityLayer: T
  }), U = /* @__PURE__ */ A.createElement(PO, {
    allowEscapeViewBox: a,
    animationDuration: o,
    animationEasing: u,
    isAnimationActive: s,
    active: W,
    coordinate: V,
    hasPayload: En,
    offset: f,
    position: h,
    reverseDirection: v,
    useTranslate3d: p,
    viewBox: k,
    wrapperStyle: m,
    lastBoundingBox: ce,
    innerRef: ze,
    hasPortalFromProps: !!O
  }, pC(l, M));
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ Th(U, ht), W && /* @__PURE__ */ A.createElement(Rk, {
    cursor: y,
    tooltipEventType: I,
    coordinate: V,
    payload: vt,
    index: L
  }));
}
var go = (e) => null;
go.displayName = "Cell";
function gC(e, t, r) {
  return (t = bC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function bC(e) {
  var t = xC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function xC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
class wC {
  constructor(t) {
    gC(this, "cache", /* @__PURE__ */ new Map()), this.maxSize = t;
  }
  get(t) {
    var r = this.cache.get(t);
    return r !== void 0 && (this.cache.delete(t), this.cache.set(t, r)), r;
  }
  set(t, r) {
    if (this.cache.has(t))
      this.cache.delete(t);
    else if (this.cache.size >= this.maxSize) {
      var n = this.cache.keys().next().value;
      n != null && this.cache.delete(n);
    }
    this.cache.set(t, r);
  }
  clear() {
    this.cache.clear();
  }
  size() {
    return this.cache.size;
  }
}
function Id(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function AC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Id(Object(r), !0).forEach(function(n) {
      OC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Id(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function OC(e, t, r) {
  return (t = SC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function SC(e) {
  var t = EC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function EC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var _C = {
  cacheSize: 2e3,
  enableCache: !0
}, qy = AC({}, _C), kd = new wC(qy.cacheSize), PC = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, Cd = "recharts_measurement_span";
function IC(e, t) {
  var r = t.fontSize || "", n = t.fontFamily || "", i = t.fontWeight || "", a = t.fontStyle || "", o = t.letterSpacing || "", u = t.textTransform || "";
  return "".concat(e, "|").concat(r, "|").concat(n, "|").concat(i, "|").concat(a, "|").concat(o, "|").concat(u);
}
var Td = (e, t) => {
  try {
    var r = document.getElementById(Cd);
    r || (r = document.createElement("span"), r.setAttribute("id", Cd), r.setAttribute("aria-hidden", "true"), document.body.appendChild(r)), Object.assign(r.style, PC, t), r.textContent = "".concat(e);
    var n = r.getBoundingClientRect();
    return {
      width: n.width,
      height: n.height
    };
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, Fn = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || fi.isSsr)
    return {
      width: 0,
      height: 0
    };
  if (!qy.enableCache)
    return Td(t, r);
  var n = IC(t, r), i = kd.get(n);
  if (i)
    return i;
  var a = Td(t, r);
  return kd.set(n, a), a;
}, Xy;
function ka(e, t) {
  return MC(e) || TC(e, t) || CC(e, t) || kC();
}
function kC() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function CC(e, t) {
  if (e) {
    if (typeof e == "string") return Md(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Md(e, t) : void 0;
  }
}
function Md(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function TC(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function MC(e) {
  if (Array.isArray(e)) return e;
}
function jC(e, t, r) {
  return (t = DC(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function DC(e) {
  var t = NC(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function NC(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var jd = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Dd = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, $C = /^(px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q)$/, LC = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, RC = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, BC = ["cm", "mm", "pt", "pc", "in", "Q", "px"];
function zC(e) {
  return BC.includes(e);
}
var Xr = "NaN";
function FC(e, t) {
  return e * RC[t];
}
class Te {
  static parse(t) {
    var r, n = (r = LC.exec(t)) !== null && r !== void 0 ? r : [], i = ka(n, 3), a = i[1], o = i[2];
    return a == null ? Te.NaN : new Te(parseFloat(a), o ?? "");
  }
  constructor(t, r) {
    this.num = t, this.unit = r, this.num = t, this.unit = r, Mt(t) && (this.unit = ""), r !== "" && !$C.test(r) && (this.num = NaN, this.unit = ""), zC(r) && (this.num = FC(t, r), this.unit = "px");
  }
  add(t) {
    return this.unit !== t.unit ? new Te(NaN, "") : new Te(this.num + t.num, this.unit);
  }
  subtract(t) {
    return this.unit !== t.unit ? new Te(NaN, "") : new Te(this.num - t.num, this.unit);
  }
  multiply(t) {
    return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new Te(NaN, "") : new Te(this.num * t.num, this.unit || t.unit);
  }
  divide(t) {
    return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new Te(NaN, "") : new Te(this.num / t.num, this.unit || t.unit);
  }
  toString() {
    return "".concat(this.num).concat(this.unit);
  }
  isNaN() {
    return Mt(this.num);
  }
}
Xy = Te;
jC(Te, "NaN", new Xy(NaN, ""));
function Zy(e) {
  if (e == null || e.includes(Xr))
    return Xr;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = jd.exec(t)) !== null && r !== void 0 ? r : [], i = ka(n, 4), a = i[1], o = i[2], u = i[3], l = Te.parse(a ?? ""), c = Te.parse(u ?? ""), s = o === "*" ? l.multiply(c) : l.divide(c);
    if (s.isNaN())
      return Xr;
    t = t.replace(jd, s.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = Dd.exec(t)) !== null && f !== void 0 ? f : [], h = ka(d, 4), v = h[1], p = h[2], m = h[3], y = Te.parse(v ?? ""), b = Te.parse(m ?? ""), w = p === "+" ? y.add(b) : y.subtract(b);
    if (w.isNaN())
      return Xr;
    t = t.replace(Dd, w.toString());
  }
  return t;
}
var Nd = /\(([^()]*)\)/;
function WC(e) {
  for (var t = e, r; (r = Nd.exec(t)) != null; ) {
    var n = r, i = ka(n, 2), a = i[1];
    t = t.replace(Nd, Zy(a));
  }
  return t;
}
function UC(e) {
  var t = e.replace(/\s+/g, "");
  return t = WC(t), t = Zy(t), t;
}
function KC(e) {
  try {
    return UC(e);
  } catch {
    return Xr;
  }
}
function Go(e) {
  var t = KC(e.slice(5, -1));
  return t === Xr ? "" : t;
}
var VC = ["x", "y", "lineHeight", "capHeight", "fill", "scaleToFit", "textAnchor", "verticalAnchor"], HC = ["dx", "dy", "angle", "className", "breakAll"];
function $u() {
  return $u = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $u.apply(null, arguments);
}
function $d(e, t) {
  if (e == null) return {};
  var r, n, i = GC(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function GC(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Ld(e, t) {
  return ZC(e) || XC(e, t) || qC(e, t) || YC();
}
function YC() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qC(e, t) {
  if (e) {
    if (typeof e == "string") return Rd(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Rd(e, t) : void 0;
  }
}
function Rd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function XC(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function ZC(e) {
  if (Array.isArray(e)) return e;
}
var Qy = /[ \f\n\r\t\v\u2028\u2029]+/, Jy = (e) => {
  var t = e.children, r = e.breakAll, n = e.style;
  try {
    var i = [];
    xe(t) || (r ? i = t.toString().split("") : i = t.toString().split(Qy));
    var a = i.map((u) => ({
      word: u,
      width: Fn(u, n).width
    })), o = r ? 0 : Fn(" ", n).width;
    return {
      wordsWithComputedWidth: a,
      spaceWidth: o
    };
  } catch {
    return null;
  }
};
function eg(e) {
  return e === "start" || e === "middle" || e === "end" || e === "inherit";
}
function QC(e) {
  return xe(e) || typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
var tg = (e, t, r, n) => e.reduce((i, a) => {
  var o = a.word, u = a.width, l = i[i.length - 1];
  if (l && u != null && (t == null || n || l.width + u + r < Number(t)))
    l.words.push(o), l.width += u + r;
  else {
    var c = {
      words: [o],
      width: u
    };
    i.push(c);
  }
  return i;
}, []), rg = (e) => e.reduce((t, r) => t.width > r.width ? t : r), JC = "…", Bd = (e, t, r, n, i, a, o, u) => {
  var l = e.slice(0, t), c = Jy({
    breakAll: r,
    style: n,
    children: l + JC
  });
  if (!c)
    return [!1, []];
  var s = tg(c.wordsWithComputedWidth, a, o, u), f = s.length > i || rg(s).width > Number(a);
  return [f, s];
}, eT = (e, t, r, n, i) => {
  var a = e.maxLines, o = e.children, u = e.style, l = e.breakAll, c = $(a), s = String(o), f = tg(t, n, r, i);
  if (!c || i)
    return f;
  var d = f.length > a || rg(f).width > Number(n);
  if (!d)
    return f;
  for (var h = 0, v = s.length - 1, p = 0, m; h <= v && p <= s.length - 1; ) {
    var y = Math.floor((h + v) / 2), b = y - 1, w = Bd(s, b, l, u, a, n, r, i), x = Ld(w, 2), O = x[0], g = x[1], S = Bd(s, y, l, u, a, n, r, i), P = Ld(S, 1), k = P[0];
    if (!O && !k && (h = y + 1), O && k && (v = y - 1), !O && k) {
      m = g;
      break;
    }
    p++;
  }
  return m || f;
}, zd = (e) => {
  var t = xe(e) ? [] : e.toString().split(Qy);
  return [{
    words: t,
    width: void 0
  }];
}, tT = (e) => {
  var t = e.width, r = e.scaleToFit, n = e.children, i = e.style, a = e.breakAll, o = e.maxLines;
  if ((t || r) && !fi.isSsr) {
    var u, l, c = Jy({
      breakAll: a,
      children: n,
      style: i
    });
    if (c) {
      var s = c.wordsWithComputedWidth, f = c.spaceWidth;
      u = s, l = f;
    } else
      return zd(n);
    return eT({
      breakAll: a,
      children: n,
      maxLines: o,
      style: i
    }, u, l, t, !!r);
  }
  return zd(n);
}, ng = "#808080", rT = {
  angle: 0,
  breakAll: !1,
  // Magic number from d3
  capHeight: "0.71em",
  fill: ng,
  lineHeight: "1em",
  scaleToFit: !1,
  textAnchor: "start",
  // Maintain compat with existing charts / default SVG behavior
  verticalAnchor: "end",
  x: 0,
  y: 0
}, pc = /* @__PURE__ */ Le((e, t) => {
  var r = st(e, rT), n = r.x, i = r.y, a = r.lineHeight, o = r.capHeight, u = r.fill, l = r.scaleToFit, c = r.textAnchor, s = r.verticalAnchor, f = $d(r, VC), d = Ve(() => tT({
    breakAll: f.breakAll,
    children: f.children,
    maxLines: f.maxLines,
    scaleToFit: l,
    style: f.style,
    width: f.width
  }), [f.breakAll, f.children, f.maxLines, l, f.style, f.width]), h = f.dx, v = f.dy, p = f.angle, m = f.className, y = f.breakAll, b = $d(f, HC);
  if (!ut(n) || !ut(i) || d.length === 0)
    return null;
  var w = Number(n) + ($(h) ? h : 0), x = Number(i) + ($(v) ? v : 0);
  if (!H(w) || !H(x))
    return null;
  var O;
  switch (s) {
    case "start":
      O = Go("calc(".concat(o, ")"));
      break;
    case "middle":
      O = Go("calc(".concat((d.length - 1) / 2, " * -").concat(a, " + (").concat(o, " / 2))"));
      break;
    default:
      O = Go("calc(".concat(d.length - 1, " * -").concat(a, ")"));
      break;
  }
  var g = [], S = d[0];
  if (l && S != null) {
    var P = S.width, k = f.width;
    g.push("scale(".concat($(k) && $(P) ? k / P : 1, ")"));
  }
  return p && g.push("rotate(".concat(p, ", ").concat(w, ", ").concat(x, ")")), g.length && (b.transform = g.join(" ")), /* @__PURE__ */ A.createElement("text", $u({}, Tt(b), {
    ref: t,
    x: w,
    y: x,
    className: le("recharts-text", m),
    textAnchor: c,
    fill: u.includes("url") ? ng : u
  }), d.map((T, I) => {
    var _ = T.words.join(y ? "" : " ");
    return (
      // duplicate words will cause duplicate keys which is why we add the array index here
      /* @__PURE__ */ A.createElement("tspan", {
        x: w,
        dy: I === 0 ? O : a,
        key: "".concat(_, "-").concat(I)
      }, _)
    );
  }));
});
pc.displayName = "Text";
var nT = ["labelRef"], iT = ["content"];
function Fd(e, t) {
  if (e == null) return {};
  var r, n, i = aT(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function aT(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Wd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wd(Object(r), !0).forEach(function(n) {
      oT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oT(e, t, r) {
  return (t = uT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function uT(e) {
  var t = lT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function lT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bt() {
  return Bt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Bt.apply(null, arguments);
}
var ig = /* @__PURE__ */ Ge(null), ag = (e) => {
  var t = e.x, r = e.y, n = e.upperWidth, i = e.lowerWidth, a = e.width, o = e.height, u = e.children, l = Ve(() => ({
    x: t,
    y: r,
    upperWidth: n,
    lowerWidth: i,
    width: a,
    height: o
  }), [t, r, n, i, a, o]);
  return /* @__PURE__ */ A.createElement(ig.Provider, {
    value: l
  }, u);
}, og = () => {
  var e = rt(ig), t = li();
  return e || (t ? Xu(t) : void 0);
}, cT = /* @__PURE__ */ Ge(null), sT = () => {
  var e = rt(cT), t = N(Yp);
  return e || t;
}, fT = (e) => {
  var t = e.value, r = e.formatter, n = xe(e.children) ? t : e.children;
  return typeof r == "function" ? r(n) : n;
}, bo = (e) => e != null && typeof e == "function", dT = (e, t) => {
  var r = Je(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
}, hT = (e, t, r, n, i) => {
  var a = e.offset, o = e.className, u = i.cx, l = i.cy, c = i.innerRadius, s = i.outerRadius, f = i.startAngle, d = i.endAngle, h = i.clockWise, v = (c + s) / 2, p = dT(f, d), m = p >= 0 ? 1 : -1, y, b;
  switch (t) {
    case "insideStart":
      y = f + m * a, b = h;
      break;
    case "insideEnd":
      y = d - m * a, b = !h;
      break;
    case "end":
      y = d + m * a, b = h;
      break;
    default:
      throw new Error("Unsupported position ".concat(t));
  }
  b = p <= 0 ? b : !b;
  var w = Me(u, l, v, y), x = Me(u, l, v, y + (b ? 1 : -1) * 359), O = "M".concat(w.x, ",").concat(w.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(b ? 0 : 1, `,
    `).concat(x.x, ",").concat(x.y), g = xe(e.id) ? Un("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ A.createElement("text", Bt({}, n, {
    dominantBaseline: "central",
    className: le("recharts-radial-bar-label", o)
  }), /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("path", {
    id: g,
    d: O
  })), /* @__PURE__ */ A.createElement("textPath", {
    xlinkHref: "#".concat(g)
  }, r));
}, vT = (e, t, r) => {
  var n = e.cx, i = e.cy, a = e.innerRadius, o = e.outerRadius, u = e.startAngle, l = e.endAngle, c = (u + l) / 2;
  if (r === "outside") {
    var s = Me(n, i, o + t, c), f = s.x, d = s.y;
    return {
      x: f,
      y: d,
      textAnchor: f >= n ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (r === "center")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (r === "centerTop")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (r === "centerBottom")
    return {
      x: n,
      y: i,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var h = (a + o) / 2, v = Me(n, i, h, c), p = v.x, m = v.y;
  return {
    x: p,
    y: m,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, qr = (e) => e != null && "cx" in e && $(e.cx), pT = {
  angle: 0,
  offset: 5,
  zIndex: Fe.label,
  position: "middle",
  textBreakAll: !1
};
function mT(e) {
  if (!qr(e))
    return e;
  var t = e.cx, r = e.cy, n = e.outerRadius, i = n * 2;
  return {
    x: t - n,
    y: r - n,
    width: i,
    upperWidth: i,
    lowerWidth: i,
    height: i
  };
}
function Rt(e) {
  var t, r, n = st(e, pT), i = n.viewBox, a = n.parentViewBox, o = n.position, u = n.value, l = n.children, c = n.content, s = n.className, f = s === void 0 ? "" : s, d = n.textBreakAll, h = n.labelRef, v = sT(), p = og(), m = o === "center" ? p : v ?? p, y, b, w;
  i == null ? y = m : qr(i) ? y = i : y = Xu(i);
  var x = mT(y);
  if (!y || xe(u) && xe(l) && !/* @__PURE__ */ yt(c) && typeof c != "function")
    return null;
  var O = qr(y) && (o === "insideStart" || o === "insideEnd" || o === "end");
  if (qr(y))
    O || (w = vT(y, n.offset, n.position));
  else if (x) {
    var g = I0({
      viewBox: x,
      position: o,
      offset: n.offset,
      parentViewBox: qr(a) ? void 0 : a
    });
    w = xr(xr({
      x: g.x,
      y: g.y,
      textAnchor: g.horizontalAnchor,
      verticalAnchor: g.verticalAnchor
    }, g.width !== void 0 ? {
      width: g.width
    } : {}), g.height !== void 0 ? {
      height: g.height
    } : {});
  }
  var S = xr(xr(xr(xr({}, ((t = w) === null || t === void 0 ? void 0 : t.x) !== void 0 ? {
    x: w.x
  } : {}), ((r = w) === null || r === void 0 ? void 0 : r.y) !== void 0 ? {
    y: w.y
  } : {}), n), {}, {
    viewBox: y
  });
  if (/* @__PURE__ */ yt(c)) {
    S.labelRef;
    var P = Fd(S, nT);
    return /* @__PURE__ */ $a(c, P);
  }
  if (typeof c == "function") {
    S.content;
    var k = Fd(S, iT);
    if (b = /* @__PURE__ */ Ch(c, k), /* @__PURE__ */ yt(b))
      return b;
  } else
    b = fT(n);
  var T = Tt(n);
  return O && qr(y) ? hT(n, o, b, T, y) : w == null ? null : /* @__PURE__ */ A.createElement(Jt, {
    zIndex: n.zIndex
  }, /* @__PURE__ */ A.createElement(pc, Bt({
    ref: h,
    className: le("recharts-label", f)
  }, T, w, {
    /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */
    textAnchor: eg(T.textAnchor) ? T.textAnchor : w.textAnchor,
    breakAll: d
  }), b));
}
Rt.displayName = "Label";
var yT = (e, t, r) => {
  if (!e)
    return null;
  var n = {
    viewBox: t,
    labelRef: r
  };
  return e === !0 ? /* @__PURE__ */ A.createElement(Rt, Bt({
    key: "label-implicit"
  }, n)) : ut(e) ? /* @__PURE__ */ A.createElement(Rt, Bt({
    key: "label-implicit",
    value: e
  }, n)) : /* @__PURE__ */ yt(e) ? e.type === Rt ? /* @__PURE__ */ $a(e, xr({
    key: "label-implicit"
  }, n)) : /* @__PURE__ */ A.createElement(Rt, Bt({
    key: "label-implicit",
    content: e
  }, n)) : bo(e) ? /* @__PURE__ */ A.createElement(Rt, Bt({
    key: "label-implicit",
    content: e
  }, n)) : e && typeof e == "object" ? /* @__PURE__ */ A.createElement(Rt, Bt({}, e, {
    key: "label-implicit"
  }, n)) : null;
};
function ug(e) {
  var t = e.label, r = e.labelRef, n = og();
  return yT(t, n, r) || null;
}
var gT = ["valueAccessor"], bT = ["dataKey", "clockWise", "id", "textBreakAll", "zIndex"];
function Ca() {
  return Ca = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ca.apply(null, arguments);
}
function Ud(e, t) {
  if (e == null) return {};
  var r, n, i = xT(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function xT(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var wT = (e) => {
  var t = Array.isArray(e.value) ? e.value[e.value.length - 1] : e.value;
  if (QC(t))
    return t;
}, lg = /* @__PURE__ */ Ge(void 0), AT = lg.Provider, cg = /* @__PURE__ */ Ge(void 0);
cg.Provider;
function OT() {
  return rt(lg);
}
function ST() {
  return rt(cg);
}
function Yi(e) {
  var t = e.valueAccessor, r = t === void 0 ? wT : t, n = Ud(e, gT), i = n.dataKey;
  n.clockWise;
  var a = n.id, o = n.textBreakAll, u = n.zIndex, l = Ud(n, bT), c = OT(), s = ST(), f = c || s;
  return !f || !f.length ? null : /* @__PURE__ */ A.createElement(Jt, {
    zIndex: u ?? Fe.label
  }, /* @__PURE__ */ A.createElement(gt, {
    className: "recharts-label-list"
  }, f.map((d, h) => {
    var v, p = xe(i) ? r(d, h) : Se(d.payload, i), m = xe(a) ? {} : {
      id: "".concat(a, "-").concat(h)
    };
    return /* @__PURE__ */ A.createElement(Rt, Ca({
      key: "label-".concat(h)
    }, Tt(d), l, m, {
      /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */
      fill: (v = n.fill) !== null && v !== void 0 ? v : d.fill,
      parentViewBox: d.parentViewBox,
      value: p,
      textBreakAll: o,
      viewBox: d.viewBox,
      index: h,
      zIndex: 0
    }));
  })));
}
Yi.displayName = "LabelList";
function ET(e) {
  var t = e.label;
  return t ? t === !0 ? /* @__PURE__ */ A.createElement(Yi, {
    key: "labelList-implicit"
  }) : /* @__PURE__ */ A.isValidElement(t) || bo(t) ? /* @__PURE__ */ A.createElement(Yi, {
    key: "labelList-implicit",
    content: t
  }) : typeof t == "object" ? /* @__PURE__ */ A.createElement(Yi, Ca({
    key: "labelList-implicit"
  }, t, {
    type: String(t.type)
  })) : null : null;
}
var _T = {
  radiusAxis: {},
  angleAxis: {}
}, sg = Re({
  name: "polarAxis",
  initialState: _T,
  reducers: {
    addRadiusAxis(e, t) {
      e.radiusAxis[t.payload.id] = Z(t.payload);
    },
    removeRadiusAxis(e, t) {
      delete e.radiusAxis[t.payload.id];
    },
    addAngleAxis(e, t) {
      e.angleAxis[t.payload.id] = Z(t.payload);
    },
    removeAngleAxis(e, t) {
      delete e.angleAxis[t.payload.id];
    }
  }
}), xo = sg.actions;
xo.addRadiusAxis;
xo.removeRadiusAxis;
xo.addAngleAxis;
xo.removeAngleAxis;
var PT = sg.reducer;
function IT(e) {
  return e && typeof e == "object" && "className" in e && typeof e.className == "string" ? e.className : "";
}
var Kd = (e) => typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "", Vd = null, Yo = null, fg = (e) => {
  if (e === Vd && Array.isArray(Yo))
    return Yo;
  var t = [];
  return n0.forEach(e, (r) => {
    xe(r) || (c0.isFragment(r) ? t = t.concat(fg(r.props.children)) : t.push(r));
  }), Yo = t, Vd = e, t;
};
function kT(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map((i) => Kd(i)) : n = [Kd(t)], fg(e).forEach((i) => {
    var a = Kt(i, "type.displayName") || Kt(i, "type.name");
    a && n.indexOf(a) !== -1 && r.push(i);
  }), r;
}
function Hd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hd(Object(r), !0).forEach(function(n) {
      CT(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function CT(e, t, r) {
  return (t = TT(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function TT(e) {
  var t = MT(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function MT(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function dg(e, t) {
  return Gd(Gd({}, t), e);
}
function jT(e) {
  return /* @__PURE__ */ yt(e) ? e.props : e;
}
function DT(e, t) {
  return /* @__PURE__ */ $a(e, dg(jT(e), t));
}
function NT(e) {
  if ("index" in e) {
    var t = e.index;
    return typeof t == "number" || typeof t == "string" ? t : void 0;
  }
}
function $T(e) {
  return "isActive" in e && e.isActive === !0;
}
function LT(e) {
  var t = e.option, r = e.DefaultShape, n = e.shapeProps, i = e.activeClassName, a = i === void 0 ? "recharts-active-shape" : i, o = e.inActiveClassName, u = o === void 0 ? "recharts-shape" : o, l = NT(n), c;
  return /* @__PURE__ */ yt(t) ? c = DT(t, n) : t === r ? c = /* @__PURE__ */ A.createElement(r, n) : typeof t == "function" ? c = t(n, l) : typeof t == "object" ? c = /* @__PURE__ */ A.createElement(r, dg(t, n)) : c = /* @__PURE__ */ A.createElement(r, n), $T(n) ? /* @__PURE__ */ A.createElement(gt, {
    className: a
  }, c) : /* @__PURE__ */ A.createElement(gt, {
    className: u
  }, c);
}
var hg = (e, t, r) => {
  var n = oe();
  return (i, a) => (o) => {
    e == null || e(i, a, o), n(Ay({
      activeIndex: String(a),
      activeDataKey: t,
      activeCoordinate: i.tooltipPosition,
      activeGraphicalItemId: r
    }));
  };
}, vg = (e) => {
  var t = oe();
  return (r, n) => (i) => {
    e == null || e(r, n, i), t(iI());
  };
}, pg = (e, t, r) => {
  var n = oe();
  return (i, a) => (o) => {
    e == null || e(i, a, o), n(aI({
      activeIndex: String(a),
      activeDataKey: t,
      activeCoordinate: i.tooltipPosition,
      activeGraphicalItemId: r
    }));
  };
};
function RT(e) {
  var t = e.tooltipEntrySettings, r = oe(), n = Ye(), i = X(null);
  return Ue(() => {
    n || (i.current === null ? r(eI(t)) : i.current !== t && r(tI({
      prev: i.current,
      next: t
    })), i.current = t);
  }, [t, r, n]), Ue(() => () => {
    i.current && (r(rI(i.current)), i.current = null);
  }, [r]), null;
}
function BT(e) {
  var t = e.legendPayload, r = oe(), n = Ye(), i = X(null);
  return Ue(() => {
    n || (i.current === null ? r(IA(t)) : i.current !== t && r(kA({
      prev: i.current,
      next: t
    })), i.current = t);
  }, [r, n, t]), Ue(() => () => {
    i.current && (r(CA(i.current)), i.current = null);
  }, [r]), null;
}
function zT(e, t) {
  return KT(e) || UT(e, t) || WT(e, t) || FT();
}
function FT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WT(e, t) {
  if (e) {
    if (typeof e == "string") return Yd(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Yd(e, t) : void 0;
  }
}
function Yd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function UT(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function KT(e) {
  if (Array.isArray(e)) return e;
}
var mg = "index", yg = "append";
function mc(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], n = [];
  for (var i of r)
    n.push({
      status: "removed",
      prev: i
    });
  for (var a = 0; a < t.length; a++) {
    var o = e[a], u = t[a];
    o != null ? n.push({
      status: "matched",
      prev: o,
      next: u
    }) : n.push({
      status: "added",
      next: u
    });
  }
  return n;
}
function VT(e, t) {
  var r = e.length / t.length, n = t.map((i, a) => e[Math.floor(a * r)]);
  return mc(n, t);
}
function HT(e, t) {
  var r = t.map((n, i) => e[i]);
  return mc(r, t);
}
function GT(e, t) {
  for (var r = /* @__PURE__ */ new Map(), n = 0; n < e.length; n++) {
    var i = e[n];
    if (i != null) {
      var a = t(i, n);
      a != null && !r.has(a) && r.set(a, i);
    }
  }
  return r;
}
function YT(e, t, r) {
  var n = GT(e, r), i = /* @__PURE__ */ new Set(), a = t.map((f, d) => {
    var h = r(f, d);
    if (h != null) {
      var v = n.get(h);
      if (v !== void 0)
        return i.add(h), v;
    }
  }), o = [];
  for (var u of n) {
    var l = zT(u, 2), c = l[0], s = l[1];
    i.has(c) || o.push(s);
  }
  return mc(a, t, o);
}
function qT(e, t, r) {
  return t == null ? null : e == null ? t.map((n) => ({
    status: "added",
    next: n
  })) : r === mg ? VT(e, t) : r === yg ? HT(e, t) : YT(e, t, r);
}
function XT(e, t) {
  var r = X(e), n = X(t.current), i = X(!0);
  r.current !== e && (r.current = e, n.current = t.current, i.current = !1);
  var a = ne(function(o, u) {
    var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (u === 0) {
      i.current = !0;
      return;
    }
    u === 1 && (n.current = o), u > 0 && i.current && l && (t.current = o);
  }, [t]);
  return {
    startValue: n.current,
    syncStepValue: a
  };
}
function ZT(e, t) {
  return tM(e) || eM(e, t) || JT(e, t) || QT();
}
function QT() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JT(e, t) {
  if (e) {
    if (typeof e == "string") return qd(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? qd(e, t) : void 0;
  }
}
function qd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function eM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function tM(e) {
  if (Array.isArray(e)) return e;
}
function rM(e, t) {
  var r = be(!1), n = ZT(r, 2), i = n[0], a = n[1], o = ne(() => {
    typeof e == "function" && e(), a(!0);
  }, [e]), u = ne(() => {
    typeof t == "function" && t(), a(!1);
  }, [t]);
  return {
    isAnimating: i,
    handleAnimationStart: o,
    handleAnimationEnd: u
  };
}
function nM(e) {
  var t, r = e.animationInput, n = e.animationIdPrefix, i = e.items, a = e.previousItemsRef, o = e.isAnimationActive, u = e.animationBegin, l = e.animationDuration, c = e.animationEasing, s = e.onAnimationStart, f = e.onAnimationEnd, d = e.animationInterpolateFn, h = e.animationMatchBy, v = e.shouldUpdatePreviousRef, p = e.children, m = e.layout, y = Sp(r, n), b = XT(y, a), w = (t = b.startValue) !== null && t !== void 0 ? t : null, x = qT(w, i, h ?? mg);
  return /* @__PURE__ */ A.createElement(Op, {
    animationId: y,
    begin: u,
    duration: l,
    isActive: o,
    easing: c,
    onAnimationEnd: f,
    onAnimationStart: s,
    key: y
  }, (O) => {
    var g = w == null, S = i == null ? i : d(x, O, m), P = v ? v(O) : O > 0;
    return b.syncStepValue(S, O, P), S == null ? null : p(S, O, g);
  });
}
var qo;
function iM(e, t) {
  return lM(e) || uM(e, t) || oM(e, t) || aM();
}
function aM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oM(e, t) {
  if (e) {
    if (typeof e == "string") return Xd(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Xd(e, t) : void 0;
  }
}
function Xd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function uM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function lM(e) {
  if (Array.isArray(e)) return e;
}
var cM = () => {
  var e = A.useState(() => Un("uid-")), t = iM(e, 1), r = t[0];
  return r;
}, sM = (qo = A.useId) !== null && qo !== void 0 ? qo : cM;
function fM(e, t) {
  var r = sM();
  return t || (e ? "".concat(e, "-").concat(r) : r);
}
var dM = /* @__PURE__ */ Ge(void 0), hM = (e) => {
  var t = e.id, r = e.type, n = e.children, i = fM("recharts-".concat(r), t);
  return /* @__PURE__ */ A.createElement(dM.Provider, {
    value: i
  }, n(i));
}, vM = {
  cartesianItems: [],
  polarItems: []
}, gg = Re({
  name: "graphicalItems",
  initialState: vM,
  reducers: {
    addCartesianGraphicalItem: {
      reducer(e, t) {
        e.cartesianItems.push(Z(t.payload));
      },
      prepare: ie()
    },
    replaceCartesianGraphicalItem: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next, a = at(e).cartesianItems.indexOf(Z(n));
        a > -1 && (e.cartesianItems[a] = Z(i));
      },
      prepare: ie()
    },
    removeCartesianGraphicalItem: {
      reducer(e, t) {
        var r = at(e).cartesianItems.indexOf(Z(t.payload));
        r > -1 && e.cartesianItems.splice(r, 1);
      },
      prepare: ie()
    },
    addPolarGraphicalItem: {
      reducer(e, t) {
        e.polarItems.push(Z(t.payload));
      },
      prepare: ie()
    },
    removePolarGraphicalItem: {
      reducer(e, t) {
        var r = at(e).polarItems.indexOf(Z(t.payload));
        r > -1 && e.polarItems.splice(r, 1);
      },
      prepare: ie()
    },
    replacePolarGraphicalItem: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next, a = at(e).polarItems.indexOf(Z(n));
        a > -1 && (e.polarItems[a] = Z(i));
      },
      prepare: ie()
    }
  }
}), On = gg.actions, pM = On.addCartesianGraphicalItem, mM = On.replaceCartesianGraphicalItem, yM = On.removeCartesianGraphicalItem;
On.addPolarGraphicalItem;
On.removePolarGraphicalItem;
On.replacePolarGraphicalItem;
var gM = gg.reducer, bM = (e) => {
  var t = oe(), r = X(null);
  return Ue(() => {
    r.current === null ? t(pM(e)) : r.current !== e && t(mM({
      prev: r.current,
      next: e
    })), r.current = e;
  }, [t, e]), Ue(() => () => {
    r.current && (t(yM(r.current)), r.current = null);
  }, [t]), null;
}, xM = /* @__PURE__ */ Ku(bM);
function Zd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zd(Object(r), !0).forEach(function(n) {
      wM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wM(e, t, r) {
  return (t = AM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function AM(e) {
  var t = OM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function OM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var bg = 0, SM = {
  xAxis: {},
  yAxis: {},
  zAxis: {}
}, xg = Re({
  name: "cartesianAxis",
  initialState: SM,
  reducers: {
    addXAxis: {
      reducer(e, t) {
        e.xAxis[t.payload.id] = Z(t.payload);
      },
      prepare: ie()
    },
    replaceXAxis: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next;
        e.xAxis[n.id] !== void 0 && (n.id !== i.id && delete e.xAxis[n.id], e.xAxis[i.id] = Z(i));
      },
      prepare: ie()
    },
    removeXAxis: {
      reducer(e, t) {
        delete e.xAxis[t.payload.id];
      },
      prepare: ie()
    },
    addYAxis: {
      reducer(e, t) {
        e.yAxis[t.payload.id] = Z(t.payload);
      },
      prepare: ie()
    },
    replaceYAxis: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next;
        e.yAxis[n.id] !== void 0 && (n.id !== i.id && delete e.yAxis[n.id], e.yAxis[i.id] = Z(i));
      },
      prepare: ie()
    },
    removeYAxis: {
      reducer(e, t) {
        delete e.yAxis[t.payload.id];
      },
      prepare: ie()
    },
    addZAxis: {
      reducer(e, t) {
        e.zAxis[t.payload.id] = Z(t.payload);
      },
      prepare: ie()
    },
    replaceZAxis: {
      reducer(e, t) {
        var r = t.payload, n = r.prev, i = r.next;
        e.zAxis[n.id] !== void 0 && (n.id !== i.id && delete e.zAxis[n.id], e.zAxis[i.id] = Z(i));
      },
      prepare: ie()
    },
    removeZAxis: {
      reducer(e, t) {
        delete e.zAxis[t.payload.id];
      },
      prepare: ie()
    },
    updateYAxisWidth(e, t) {
      var r = t.payload, n = r.id, i = r.width, a = e.yAxis[n];
      if (a) {
        var o, u = a.widthHistory || [];
        if (u.length === 3 && u[0] === u[2] && i === u[1] && i !== a.width && Math.abs(i - ((o = u[0]) !== null && o !== void 0 ? o : 0)) <= 1)
          return;
        var l = [...u, i].slice(-3);
        e.yAxis[n] = zi(zi({}, a), {}, {
          width: i,
          widthHistory: l
        });
      }
    },
    updateXAxisHeight(e, t) {
      var r = t.payload, n = r.id, i = r.height, a = e.xAxis[n];
      if (a) {
        var o, u = a.heightHistory || [];
        if (u.length === 3 && u[0] === u[2] && i === u[1] && i !== a.height && Math.abs(i - ((o = u[0]) !== null && o !== void 0 ? o : 0)) <= 1)
          return;
        var l = [...u, i].slice(-3);
        e.xAxis[n] = zi(zi({}, a), {}, {
          height: i,
          heightHistory: l
        });
      }
    }
  }
}), At = xg.actions, EM = At.addXAxis, _M = At.replaceXAxis, PM = At.removeXAxis, IM = At.addYAxis, kM = At.replaceYAxis, CM = At.removeYAxis;
At.addZAxis;
At.replaceZAxis;
At.removeZAxis;
var TM = At.updateYAxisWidth, MM = At.updateXAxisHeight, jM = xg.reducer, DM = E([Ee], (e) => ({
  top: e.top,
  bottom: e.bottom,
  left: e.left,
  right: e.right
})), NM = E([DM, qt, Xt], (e, t, r) => {
  if (!(!e || t == null || r == null))
    return {
      x: e.left,
      y: e.top,
      width: Math.max(0, t - e.left - e.right),
      height: Math.max(0, r - e.top - e.bottom)
    };
}), wg = () => N(NM);
function $M(e, t) {
  return zM(e) || BM(e, t) || RM(e, t) || LM();
}
function LM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function RM(e, t) {
  if (e) {
    if (typeof e == "string") return Qd(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Qd(e, t) : void 0;
  }
}
function Qd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function BM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function zM(e) {
  if (Array.isArray(e)) return e;
}
var Jd = (e, t, r) => {
  var n = r ?? e;
  if (!xe(n))
    return bt(n, t, 0);
}, FM = (e, t, r) => {
  var n = {}, i = e.filter(oo), a = e.filter((c) => c.stackId == null), o = i.reduce((c, s) => {
    var f = c[s.stackId];
    return f == null && (f = []), f.push(s), c[s.stackId] = f, c;
  }, n), u = Object.entries(o).map((c) => {
    var s, f = $M(c, 2), d = f[0], h = f[1], v = h.map((m) => m.dataKey), p = Jd(t, r, (s = h[0]) === null || s === void 0 ? void 0 : s.barSize);
    return {
      stackId: d,
      dataKeys: v,
      barSize: p
    };
  }), l = a.map((c) => {
    var s = [c.dataKey].filter((d) => d != null), f = Jd(t, r, c.barSize);
    return {
      stackId: void 0,
      dataKeys: s,
      barSize: f
    };
  });
  return [...u, ...l];
};
function eh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? eh(Object(r), !0).forEach(function(n) {
      WM(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function WM(e, t, r) {
  return (t = UM(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function UM(e) {
  var t = KM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function KM(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function VM(e, t, r, n, i) {
  var a, o = n.length;
  if (!(o < 1)) {
    var u = bt(e, r, 0, !0), l, c = [];
    if (H((a = n[0]) === null || a === void 0 ? void 0 : a.barSize)) {
      var s = !1, f = r / o, d = n.reduce((b, w) => b + (w.barSize || 0), 0);
      d += (o - 1) * u, d >= r && (d -= (o - 1) * u, u = 0), d >= r && f > 0 && (s = !0, f *= 0.9, d = o * f);
      var h = Math.round((r - d) / 2), v = {
        offset: h - u,
        size: 0
      };
      l = n.reduce((b, w) => {
        var x, O = {
          stackId: w.stackId,
          dataKeys: w.dataKeys,
          position: {
            offset: v.offset + v.size + u,
            size: s ? f : (x = w.barSize) !== null && x !== void 0 ? x : 0
          }
        }, g = [...b, O];
        return v = O.position, g;
      }, c);
    } else {
      var p = bt(t, r, 0, !0);
      r - 2 * p - (o - 1) * u <= 0 && (u = 0);
      var m = (r - 2 * p - (o - 1) * u) / o;
      m > 1 && (m = Math.round(m));
      var y = H(i) ? Math.min(m, i) : m;
      l = n.reduce((b, w, x) => [...b, {
        stackId: w.stackId,
        dataKeys: w.dataKeys,
        position: {
          offset: p + o * (m - y) / 2 + (y + u) * x,
          size: y
        }
      }], c);
    }
    return l;
  }
}
var HM = (e, t, r, n, i, a, o) => {
  var u = xe(o) ? t : o, l = VM(r, n, i !== a ? i : a, e, u);
  return i !== a && l != null && (l = l.map((c) => Fi(Fi({}, c), {}, {
    position: Fi(Fi({}, c.position), {}, {
      offset: c.position.offset - i / 2
    })
  }))), l;
}, GM = (e, t) => {
  var r = Sl(t);
  if (!(!e || r == null || t == null)) {
    var n = t.stackId;
    if (n != null) {
      var i = e[n];
      if (i) {
        var a = i.stackedData;
        if (a)
          return a.find((o) => o.key === r);
      }
    }
  }
}, YM = (e, t) => {
  if (!(e == null || t == null)) {
    var r = e.find((n) => n.stackId === t.stackId && t.dataKey != null && n.dataKeys.includes(t.dataKey));
    if (r != null)
      return r.position;
  }
};
function qM(e, t) {
  return e && typeof e == "object" && "zIndex" in e && typeof e.zIndex == "number" && H(e.zIndex) ? e.zIndex : t;
}
var XM = (e) => {
  var t = e.chartData, r = oe(), n = Ye();
  return se(() => n ? () => {
  } : (r(Ad(t)), () => {
    r(Ad(void 0));
  }), [t, r, n]), null;
}, th = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}, Ag = Re({
  name: "brush",
  initialState: th,
  reducers: {
    setBrushSettings(e, t) {
      return t.payload == null ? th : t.payload;
    }
  }
});
Ag.actions.setBrushSettings;
var ZM = Ag.reducer, QM = (e, t) => {
  var r = e.x, n = e.y, i = t.x, a = t.y;
  return {
    x: Math.min(r, i),
    y: Math.min(n, a),
    width: Math.abs(i - r),
    height: Math.abs(a - n)
  };
}, JM = (e) => {
  var t = e.x1, r = e.y1, n = e.x2, i = e.y2;
  return QM({
    x: t,
    y: r
  }, {
    x: n,
    y: i
  });
};
function ej(e) {
  return (e % 180 + 180) % 180;
}
var tj = function(t) {
  var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = ej(i), o = a * Math.PI / 180, u = Math.atan(n / r), l = o > u && o < Math.PI - u ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(l);
}, rj = {
  dots: [],
  areas: [],
  lines: []
}, Og = Re({
  name: "referenceElements",
  initialState: rj,
  reducers: {
    addDot: (e, t) => {
      e.dots.push(t.payload);
    },
    removeDot: (e, t) => {
      var r = at(e).dots.findIndex((n) => n === t.payload);
      r !== -1 && e.dots.splice(r, 1);
    },
    addArea: (e, t) => {
      e.areas.push(t.payload);
    },
    removeArea: (e, t) => {
      var r = at(e).areas.findIndex((n) => n === t.payload);
      r !== -1 && e.areas.splice(r, 1);
    },
    addLine: (e, t) => {
      e.lines.push(Z(t.payload));
    },
    removeLine: (e, t) => {
      var r = at(e).lines.findIndex((n) => n === t.payload);
      r !== -1 && e.lines.splice(r, 1);
    }
  }
}), Sn = Og.actions;
Sn.addDot;
Sn.removeDot;
Sn.addArea;
Sn.removeArea;
var nj = Sn.addLine, ij = Sn.removeLine, aj = Og.reducer;
function oj(e, t) {
  return sj(e) || cj(e, t) || lj(e, t) || uj();
}
function uj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lj(e, t) {
  if (e) {
    if (typeof e == "string") return rh(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? rh(e, t) : void 0;
  }
}
function rh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function cj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function sj(e) {
  if (Array.isArray(e)) return e;
}
var Sg = /* @__PURE__ */ Ge(void 0), fj = (e) => {
  var t = e.children, r = be("".concat(Un("recharts"), "-clip")), n = oj(r, 1), i = n[0], a = wg();
  if (a == null)
    return null;
  var o = a.x, u = a.y, l = a.width, c = a.height;
  return /* @__PURE__ */ A.createElement(Sg.Provider, {
    value: i
  }, /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement("clipPath", {
    id: i
  }, /* @__PURE__ */ A.createElement("rect", {
    x: o,
    y: u,
    height: c,
    width: l
  }))), t);
}, dj = () => rt(Sg);
class hj {
  constructor(t) {
    var r = t.x, n = t.y;
    this.xAxisScale = r, this.yAxisScale = n;
  }
  map(t, r) {
    var n, i, a = r.position;
    return {
      x: (n = this.xAxisScale.map(t.x, {
        position: a
      })) !== null && n !== void 0 ? n : 0,
      y: (i = this.yAxisScale.map(t.y, {
        position: a
      })) !== null && i !== void 0 ? i : 0
    };
  }
  mapWithFallback(t, r) {
    var n, i, a = r.position, o = r.fallback, u, l;
    return o === "rangeMin" ? u = this.yAxisScale.rangeMin() : o === "rangeMax" ? u = this.yAxisScale.rangeMax() : u = 0, o === "rangeMin" ? l = this.xAxisScale.rangeMin() : o === "rangeMax" ? l = this.xAxisScale.rangeMax() : l = 0, {
      x: (n = this.xAxisScale.map(t.x, {
        position: a
      })) !== null && n !== void 0 ? n : l,
      y: (i = this.yAxisScale.map(t.y, {
        position: a
      })) !== null && i !== void 0 ? i : u
    };
  }
  isInRange(t) {
    var r = t.x, n = t.y, i = r == null || this.xAxisScale.isInRange(r), a = n == null || this.yAxisScale.isInRange(n);
    return i && a;
  }
}
function nh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ih(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nh(Object(r), !0).forEach(function(n) {
      vj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function vj(e, t, r) {
  return (t = pj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function pj(e) {
  var t = mj(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function mj(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ta() {
  return Ta = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ta.apply(null, arguments);
}
var yj = (e, t) => {
  var r;
  if (/* @__PURE__ */ A.isValidElement(e))
    r = /* @__PURE__ */ A.cloneElement(e, t);
  else if (typeof e == "function")
    r = e(t);
  else {
    if (!H(t.x1) || !H(t.y1) || !H(t.x2) || !H(t.y2))
      return null;
    r = /* @__PURE__ */ A.createElement("line", Ta({}, t, {
      className: "recharts-reference-line-line"
    }));
  }
  return r;
}, gj = (e, t, r, n, i, a) => {
  var o = a.x, u = a.width, l = i.map(e, {
    position: r
  });
  if (!H(l) || t === "discard" && !i.isInRange(l))
    return null;
  var c = [{
    x: o + u,
    y: l
  }, {
    x: o,
    y: l
  }];
  return n === "left" ? c.reverse() : c;
}, bj = (e, t, r, n, i, a) => {
  var o = a.y, u = a.height, l = i.map(e, {
    position: r
  });
  if (!H(l) || t === "discard" && !i.isInRange(l))
    return null;
  var c = [{
    x: l,
    y: o + u
  }, {
    x: l,
    y: o
  }];
  return n === "top" ? c.reverse() : c;
}, xj = (e, t, r, n) => {
  var i = [n.mapWithFallback(e[0], {
    position: r,
    fallback: "rangeMin"
  }), n.mapWithFallback(e[1], {
    position: r,
    fallback: "rangeMax"
  })];
  return t === "discard" && i.some((a) => !n.isInRange(a)) ? null : i;
}, wj = (e, t, r, n, i, a, o) => {
  var u = o.x, l = o.y, c = o.segment, s = o.ifOverflow, f = ut(u), d = ut(l);
  return d ? gj(l, s, n, a, t, r) : f ? bj(u, s, n, i, e, r) : c != null && c.length === 2 ? xj(c, s, n, new hj({
    x: e,
    y: t
  })) : null;
};
function Aj(e) {
  var t = oe();
  return se(() => (t(nj(e)), () => {
    t(ij(e));
  })), null;
}
function Oj(e) {
  var t = e.xAxisId, r = e.yAxisId, n = e.shape, i = e.className, a = e.ifOverflow, o = Ye(), u = dj(), l = N((S) => Dt(S, t)), c = N((S) => Nt(S, r)), s = N((S) => un(S, "xAxis", t, o)), f = N((S) => un(S, "yAxis", r, o)), d = li();
  if (!u || !d || l == null || c == null || s == null || f == null)
    return null;
  var h = wj(s, f, d, e.position, l.orientation, c.orientation, e);
  if (!h)
    return null;
  var v = h[0], p = h[1];
  if (v == null || p == null)
    return null;
  var m = v.x, y = v.y, b = p.x, w = p.y, x = a === "hidden" ? "url(#".concat(u, ")") : void 0, O = ih(ih({
    clipPath: x
  }, Tt(e)), {}, {
    x1: m,
    y1: y,
    x2: b,
    y2: w
  }), g = JM({
    x1: m,
    y1: y,
    x2: b,
    y2: w
  });
  return /* @__PURE__ */ A.createElement(Jt, {
    zIndex: e.zIndex
  }, /* @__PURE__ */ A.createElement(gt, {
    className: le("recharts-reference-line", i)
  }, yj(n, O), /* @__PURE__ */ A.createElement(ag, Ta({}, g, {
    lowerWidth: g.width,
    upperWidth: g.width
  }), /* @__PURE__ */ A.createElement(ug, {
    label: e.label
  }), e.children)));
}
var Sj = {
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  label: !1,
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle",
  zIndex: Fe.line
};
function yc(e) {
  var t = st(e, Sj);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(Aj, {
    yAxisId: t.yAxisId,
    xAxisId: t.xAxisId,
    ifOverflow: t.ifOverflow,
    x: t.x,
    y: t.y,
    segment: t.segment
  }), /* @__PURE__ */ A.createElement(Oj, t));
}
yc.displayName = "ReferenceLine";
function Ej() {
}
function ah(e) {
  if (!e || typeof e != "object") return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype || Object.getPrototypeOf(t) === null ? Object.prototype.toString.call(e) === "[object Object]" : !1;
}
function _j(e, t, r) {
  return Rn(e, t, void 0, void 0, void 0, void 0, r);
}
function Rn(e, t, r, n, i, a, o) {
  const u = o(e, t, r, n, i, a);
  if (u !== void 0) return u;
  if (typeof e == typeof t) switch (typeof e) {
    case "bigint":
    case "string":
    case "boolean":
    case "symbol":
    case "undefined":
      return e === t;
    case "number":
      return e === t || Object.is(e, t);
    case "function":
      return e === t;
    case "object":
      return Wn(e, t, a, o);
  }
  return Wn(e, t, a, o);
}
function Wn(e, t, r, n) {
  if (Object.is(e, t)) return !0;
  let i = en(e), a = en(t);
  if (i === "[object Arguments]" && (i = Ki), a === "[object Arguments]" && (a = Ki), i !== a) return !1;
  switch (i) {
    case el:
      return e.toString() === t.toString();
    case tl:
      return Bn(e.valueOf(), t.valueOf());
    case rl:
    case iv:
    case nv:
      return Object.is(e.valueOf(), t.valueOf());
    case tv:
      return e.source === t.source && e.flags === t.flags;
    case sb:
      return e === t;
  }
  r = r ?? /* @__PURE__ */ new Map();
  const o = r.get(e), u = r.get(t);
  if (o != null && u != null) return o === t;
  r.set(e, t), r.set(t, e);
  try {
    switch (i) {
      case av:
        if (e.size !== t.size) return !1;
        for (const [l, c] of e.entries()) if (!t.has(l) || !Rn(c, t.get(l), l, e, t, r, n)) return !1;
        return !0;
      case ov: {
        if (e.size !== t.size) return !1;
        const l = Array.from(e.values()), c = Array.from(t.values());
        for (let s = 0; s < l.length; s++) {
          const f = l[s], d = c.findIndex((h) => Rn(f, h, void 0, e, t, r, n));
          if (d === -1) return !1;
          c.splice(d, 1);
        }
        return !0;
      }
      case uv:
      case sv:
      case fv:
      case dv:
      case hv:
      case db:
      case vv:
      case pv:
      case mv:
      case hb:
      case yv:
      case gv:
        if (ou(e) !== ou(t) || e.length !== t.length) return !1;
        for (let l = 0; l < e.length; l++) if (!Rn(e[l], t[l], l, e, t, r, n)) return !1;
        return !0;
      case lv:
        return e.byteLength !== t.byteLength ? !1 : Wn(new Uint8Array(e), new Uint8Array(t), r, n);
      case cv:
        return e.byteLength !== t.byteLength || e.byteOffset !== t.byteOffset ? !1 : Wn(new Uint8Array(e), new Uint8Array(t), r, n);
      case fb:
        return e.name === t.name && e.message === t.message;
      case Ki: {
        if (!(Wn(e.constructor, t.constructor, r, n) || ah(e) && ah(t))) return !1;
        const l = [...Object.keys(e), ...au(e)], c = [...Object.keys(t), ...au(t)];
        if (l.length !== c.length) return !1;
        for (let s = 0; s < l.length; s++) {
          const f = l[s], d = e[f];
          if (!Object.hasOwn(t, f)) return !1;
          const h = t[f];
          if (!Rn(d, h, f, e, t, r, n)) return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    r.delete(e), r.delete(t);
  }
}
function Pj(e, t) {
  return _j(e, t, Ej);
}
function Eg(e, t) {
  if (t < 1)
    return [];
  if (t === 1)
    return e;
  for (var r = [], n = 0; n < e.length; n += t) {
    var i = e[n];
    i !== void 0 && r.push(i);
  }
  return r;
}
function Ij(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return tj(n, r);
}
function kj(e, t, r) {
  var n = r === "width", i = e.x, a = e.y, o = e.width, u = e.height;
  return t === 1 ? {
    start: n ? i : a,
    end: n ? i + o : a + u
  } : {
    start: n ? i + o : a + u,
    end: n ? i : a
  };
}
function ei(e, t, r, n, i) {
  if (e * t < e * n || e * t > e * i)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function Cj(e, t) {
  return Eg(e, t + 1);
}
function Tj(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = t.start, u = t.end, l = 0, c = 1, s = o, f = function() {
    var v = n == null ? void 0 : n[l];
    if (v === void 0)
      return {
        v: Eg(n, c)
      };
    var p = l, m, y = () => (m === void 0 && (m = r(v, p)), m), b = v.coordinate, w = l === 0 || ei(e, b, y, s, u);
    w || (l = 0, s = o, c += 1), w && (s = b + e * (y() / 2 + i), l += c);
  }, d; c <= a.length; )
    if (d = f(), d) return d.v;
  return [];
}
function Mj(e, t, r, n, i) {
  var a = (n || []).slice(), o = a.length;
  if (o === 0)
    return [];
  for (var u = t.start, l = t.end, c = 1; c <= o; c++) {
    for (var s = (o - 1) % c, f = u, d = !0, h = function() {
      var x = n[p];
      if (x == null)
        return 0;
      var O = p, g, S = () => (g === void 0 && (g = r(x, O)), g), P = x.coordinate, k = p === s || ei(e, P, S, f, l);
      if (!k)
        return d = !1, 1;
      k && (f = P + e * (S() / 2 + i));
    }, v, p = s; p < o && (v = h(), !(v !== 0 && v === 1)); p += c)
      ;
    if (d) {
      for (var m = [], y = s; y < o; y += c) {
        var b = n[y];
        b != null && m.push(b);
      }
      return m;
    }
  }
  return [];
}
function oh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ne(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oh(Object(r), !0).forEach(function(n) {
      jj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function jj(e, t, r) {
  return (t = Dj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Dj(e) {
  var t = Nj(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Nj(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function $j(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = a.length, u = t.start, l = t.end, c = function(d) {
    var h = a[d];
    if (h == null)
      return 1;
    var v = h, p, m = () => (p === void 0 && (p = r(h, d)), p);
    if (d === o - 1) {
      var y = e * (v.coordinate + e * m() / 2 - l);
      a[d] = v = Ne(Ne({}, v), {}, {
        tickCoord: y > 0 ? v.coordinate - y * e : v.coordinate
      });
    } else
      a[d] = v = Ne(Ne({}, v), {}, {
        tickCoord: v.coordinate
      });
    if (v.tickCoord != null) {
      var b = ei(e, v.tickCoord, m, u, l);
      b && (l = v.tickCoord - e * (m() / 2 + i), a[d] = Ne(Ne({}, v), {}, {
        isShow: !0
      }));
    }
  }, s = o - 1; s >= 0; s--)
    c(s);
  return a;
}
function Lj(e, t, r, n, i, a) {
  var o = (n || []).slice(), u = o.length, l = t.start, c = t.end;
  if (a) {
    var s = n[u - 1];
    if (s != null) {
      var f = r(s, u - 1), d = e * (s.coordinate + e * f / 2 - c);
      if (o[u - 1] = s = Ne(Ne({}, s), {}, {
        tickCoord: d > 0 ? s.coordinate - d * e : s.coordinate
      }), s.tickCoord != null) {
        var h = ei(e, s.tickCoord, () => f, l, c);
        h && (c = s.tickCoord - e * (f / 2 + i), o[u - 1] = Ne(Ne({}, s), {}, {
          isShow: !0
        }));
      }
    }
  }
  for (var v = a ? u - 1 : u, p = function(b) {
    var w = o[b];
    if (w == null)
      return 1;
    var x = w, O, g = () => (O === void 0 && (O = r(w, b)), O);
    if (b === 0) {
      var S = e * (x.coordinate - e * g() / 2 - l);
      o[b] = x = Ne(Ne({}, x), {}, {
        tickCoord: S < 0 ? x.coordinate - S * e : x.coordinate
      });
    } else
      o[b] = x = Ne(Ne({}, x), {}, {
        tickCoord: x.coordinate
      });
    if (x.tickCoord != null) {
      var P = ei(e, x.tickCoord, g, l, c);
      P && (l = x.tickCoord + e * (g() / 2 + i), o[b] = Ne(Ne({}, x), {}, {
        isShow: !0
      }));
    }
  }, m = 0; m < v; m++)
    p(m);
  return o;
}
function Rj(e, t, r) {
  var n = e.tick, i = e.ticks, a = e.viewBox, o = e.minTickGap, u = e.orientation, l = e.interval, c = e.tickFormatter, s = e.unit, f = e.angle;
  if (!i || !i.length || !n)
    return [];
  if ($(l) || fi.isSsr) {
    var d;
    return (d = Cj(i, $(l) ? l : 0)) !== null && d !== void 0 ? d : [];
  }
  var h = [], v = u === "top" || u === "bottom" ? "width" : "height", p = s && v === "width" ? Fn(s, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, m = (O, g) => {
    var S = typeof c == "function" ? c(O.value, g) : O.value;
    return v === "width" ? Ij(Fn(S, {
      fontSize: t,
      letterSpacing: r
    }), p, f) : Fn(S, {
      fontSize: t,
      letterSpacing: r
    })[v];
  }, y = i[0], b = i[1], w = i.length >= 2 && y != null && b != null ? Je(b.coordinate - y.coordinate) : 1, x = kj(a, w, v);
  return l === "equidistantPreserveStart" ? Tj(w, x, m, i, o) : l === "equidistantPreserveEnd" ? Mj(w, x, m, i, o) : (l === "preserveStart" || l === "preserveStartEnd" ? h = Lj(w, x, m, i, o, l === "preserveStartEnd") : h = $j(w, x, m, i, o), h.filter((O) => O.isShow));
}
var Bj = (e) => {
  var t = e.ticks, r = e.label, n = e.labelGapWithTick, i = n, a = e.tickSize, o = a === void 0 ? 0 : a, u = e.tickMargin, l = u === void 0 ? 0 : u, c = 0;
  if (t) {
    Array.from(t).forEach((h) => {
      if (h) {
        var v = h.getBoundingClientRect();
        v.width > c && (c = v.width);
      }
    });
    var s = r ? r.getBoundingClientRect().width : 0, f = o + l, d = c + f + s + (r ? i : 0);
    return Math.round(d);
  }
  return 0;
}, zj = (e) => {
  var t = e.ticks, r = e.label, n = e.labelGapWithTick, i = n, a = e.tickSize, o = a === void 0 ? 0 : a, u = e.tickMargin, l = u === void 0 ? 0 : u, c = 0;
  if (t) {
    Array.from(t).forEach((h) => {
      if (h) {
        var v = h.getBoundingClientRect();
        v.height > c && (c = v.height);
      }
    });
    var s = r ? r.getBoundingClientRect().height : 0, f = o + l, d = c + f + s + (r ? i : 0);
    return Math.round(d);
  }
  return 0;
}, Fj = {
  xAxis: {},
  yAxis: {}
}, _g = Re({
  name: "renderedTicks",
  initialState: Fj,
  reducers: {
    setRenderedTicks: (e, t) => {
      var r = t.payload, n = r.axisType, i = r.axisId, a = r.ticks;
      e[n][i] = Z(a);
    },
    removeRenderedTicks: (e, t) => {
      var r = t.payload, n = r.axisType, i = r.axisId;
      delete e[n][i];
    }
  }
}), Pg = _g.actions, Wj = Pg.setRenderedTicks, Uj = Pg.removeRenderedTicks, Kj = _g.reducer, Vj = ["axisLine", "width", "height", "className", "hide", "ticks", "axisType", "axisId"];
function uh(e, t) {
  return qj(e) || Yj(e, t) || Gj(e, t) || Hj();
}
function Hj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gj(e, t) {
  if (e) {
    if (typeof e == "string") return lh(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? lh(e, t) : void 0;
  }
}
function lh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Yj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function qj(e) {
  if (Array.isArray(e)) return e;
}
function Xj(e, t) {
  if (e == null) return {};
  var r, n, i = Zj(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function Zj(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function $r() {
  return $r = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, $r.apply(null, arguments);
}
function ch(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ch(Object(r), !0).forEach(function(n) {
      Qj(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ch(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Qj(e, t, r) {
  return (t = Jj(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jj(e) {
  var t = eD(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function eD(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Cr = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd",
  zIndex: Fe.axis
};
function tD(e) {
  var t = e.x, r = e.y, n = e.width, i = e.height, a = e.orientation, o = e.mirror, u = e.axisLine, l = e.otherSvgProps;
  if (!u)
    return null;
  var c = de(de(de({}, l), ur(u)), {}, {
    fill: "none"
  });
  if (a === "top" || a === "bottom") {
    var s = +(a === "top" && !o || a === "bottom" && o);
    c = de(de({}, c), {}, {
      x1: t,
      y1: r + s * i,
      x2: t + n,
      y2: r + s * i
    });
  } else {
    var f = +(a === "left" && !o || a === "right" && o);
    c = de(de({}, c), {}, {
      x1: t + f * n,
      y1: r,
      x2: t + f * n,
      y2: r + i
    });
  }
  return /* @__PURE__ */ A.createElement("line", $r({}, c, {
    className: le("recharts-cartesian-axis-line", Kt(u, "className"))
  }));
}
function rD(e, t, r, n, i, a, o, u, l) {
  var c, s, f, d, h, v, p = u ? -1 : 1, m = e.tickSize || o, y = $(e.tickCoord) ? e.tickCoord : e.coordinate;
  switch (a) {
    case "top":
      c = s = e.coordinate, d = r + +!u * i, f = d - p * m, v = f - p * l, h = y;
      break;
    case "left":
      f = d = e.coordinate, s = t + +!u * n, c = s - p * m, h = c - p * l, v = y;
      break;
    case "right":
      f = d = e.coordinate, s = t + +u * n, c = s + p * m, h = c + p * l, v = y;
      break;
    default:
      c = s = e.coordinate, d = r + +u * i, f = d + p * m, v = f + p * l, h = y;
      break;
  }
  return {
    line: {
      x1: c,
      y1: f,
      x2: s,
      y2: d
    },
    tick: {
      x: h,
      y: v
    }
  };
}
function nD(e, t) {
  switch (e) {
    case "left":
      return t ? "start" : "end";
    case "right":
      return t ? "end" : "start";
    default:
      return "middle";
  }
}
function iD(e, t) {
  switch (e) {
    case "left":
    case "right":
      return "middle";
    case "top":
      return t ? "start" : "end";
    default:
      return t ? "end" : "start";
  }
}
function aD(e) {
  var t = e.option, r = e.tickProps, n = e.value, i, a = le(r.className, "recharts-cartesian-axis-tick-value");
  if (/* @__PURE__ */ A.isValidElement(t))
    i = /* @__PURE__ */ A.cloneElement(t, de(de({}, r), {}, {
      className: a
    }));
  else if (typeof t == "function")
    i = t(de(de({}, r), {}, {
      className: a
    }));
  else {
    var o = "recharts-cartesian-axis-tick-value";
    typeof t != "boolean" && (o = le(o, IT(t))), i = /* @__PURE__ */ A.createElement(pc, $r({}, r, {
      className: o
    }), n);
  }
  return i;
}
function oD(e) {
  var t = e.ticks, r = e.axisType, n = e.axisId, i = oe(), a = X(null);
  return se(() => {
    if (!(n == null || r == null)) {
      var o = t.map((l) => ({
        value: l.value,
        coordinate: l.coordinate,
        offset: l.offset,
        index: l.index
      })), u = a.current;
      u != null && u.axisId === n && u.axisType === r && Pj(u.ticks, o) || (a.current = {
        ticks: o,
        axisId: n,
        axisType: r
      }, i(Wj({
        ticks: o,
        axisId: n,
        axisType: r
      })));
    }
  }, [i, t, n, r]), se(() => n == null || r == null ? hn : () => {
    i(Uj({
      axisId: n,
      axisType: r
    }));
  }, [i, n, r]), null;
}
var uD = /* @__PURE__ */ Le((e, t) => {
  var r = e.ticks, n = r === void 0 ? [] : r, i = e.tick, a = e.tickLine, o = e.stroke, u = e.tickFormatter, l = e.unit, c = e.padding, s = e.tickTextProps, f = e.orientation, d = e.mirror, h = e.x, v = e.y, p = e.width, m = e.height, y = e.tickSize, b = e.tickMargin, w = e.fontSize, x = e.letterSpacing, O = e.getTicksConfig, g = e.events, S = e.axisType, P = e.axisId, k = Rj(de(de({}, O), {}, {
    ticks: n
  }), w, x), T = ur(O), I = Hu(i), _ = eg(T.textAnchor) ? T.textAnchor : nD(f, d), L = iD(f, d), D = {};
  typeof a == "object" && (D = a);
  var F = de(de({}, T), {}, {
    fill: "none"
  }, D), K = k.map((q) => de({
    entry: q
  }, rD(q, h, v, p, m, f, y, d, b))), V = K.map((q) => {
    var W = q.entry, he = q.line;
    return /* @__PURE__ */ A.createElement(gt, {
      className: "recharts-cartesian-axis-tick",
      key: "tick-".concat(W.value, "-").concat(W.coordinate, "-").concat(W.tickCoord)
    }, a && /* @__PURE__ */ A.createElement("line", $r({}, F, he, {
      className: le("recharts-cartesian-axis-tick-line", Kt(a, "className"))
    })));
  }), R = K.map((q, W) => {
    var he, ve, ce = q.entry, ze = q.tick, qe = de(de(de(de({
      verticalAnchor: L
    }, T), {}, {
      textAnchor: _,
      stroke: "none",
      fill: o
    }, ze), {}, {
      index: W,
      payload: ce,
      visibleTicksCount: k.length,
      tickFormatter: u,
      padding: c
    }, s), {}, {
      angle: (he = (ve = s == null ? void 0 : s.angle) !== null && ve !== void 0 ? ve : T.angle) !== null && he !== void 0 ? he : 0
    }), ht = de(de({}, qe), I);
    return /* @__PURE__ */ A.createElement(gt, $r({
      className: "recharts-cartesian-axis-tick-label",
      key: "tick-label-".concat(ce.value, "-").concat(ce.coordinate, "-").concat(ce.tickCoord)
    }, Qu(g, ce, W)), i && /* @__PURE__ */ A.createElement(aD, {
      option: i,
      tickProps: ht,
      value: "".concat(typeof u == "function" ? u(ce.value, W) : ce.value).concat(l || "")
    }));
  });
  return /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-axis-ticks recharts-".concat(S, "-ticks")
  }, /* @__PURE__ */ A.createElement(oD, {
    ticks: k,
    axisId: P,
    axisType: S
  }), R.length > 0 && /* @__PURE__ */ A.createElement(Jt, {
    zIndex: Fe.label
  }, /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-axis-tick-labels recharts-".concat(S, "-tick-labels"),
    ref: t
  }, R)), V.length > 0 && /* @__PURE__ */ A.createElement("g", {
    className: "recharts-cartesian-axis-tick-lines recharts-".concat(S, "-tick-lines")
  }, V));
}), lD = /* @__PURE__ */ Le((e, t) => {
  var r = e.axisLine, n = e.width, i = e.height, a = e.className, o = e.hide, u = e.ticks, l = e.axisType, c = e.axisId, s = Xj(e, Vj), f = be(""), d = uh(f, 2), h = d[0], v = d[1], p = be(""), m = uh(p, 2), y = m[0], b = m[1], w = X(null);
  kh(t, () => ({
    getCalculatedWidth: () => {
      var O;
      return Bj({
        ticks: w.current,
        label: (O = e.labelRef) === null || O === void 0 ? void 0 : O.current,
        labelGapWithTick: 5,
        tickSize: e.tickSize,
        tickMargin: e.tickMargin
      });
    },
    getCalculatedHeight: () => {
      var O;
      return zj({
        ticks: w.current,
        label: (O = e.labelRef) === null || O === void 0 ? void 0 : O.current,
        labelGapWithTick: 5,
        tickSize: e.tickSize,
        tickMargin: e.tickMargin
      });
    }
  }));
  var x = ne((O) => {
    if (O) {
      var g = O.getElementsByClassName("recharts-cartesian-axis-tick-value");
      w.current = g;
      var S = g[0];
      if (S) {
        var P = window.getComputedStyle(S), k = P.fontSize, T = P.letterSpacing;
        (k !== h || T !== y) && (v(k), b(T));
      }
    }
  }, [h, y]);
  return o || n != null && n <= 0 || i != null && i <= 0 ? null : /* @__PURE__ */ A.createElement(Jt, {
    zIndex: e.zIndex
  }, /* @__PURE__ */ A.createElement(gt, {
    className: le("recharts-cartesian-axis", a)
  }, /* @__PURE__ */ A.createElement(tD, {
    x: e.x,
    y: e.y,
    width: n,
    height: i,
    orientation: e.orientation,
    mirror: e.mirror,
    axisLine: r,
    otherSvgProps: ur(e)
  }), /* @__PURE__ */ A.createElement(uD, {
    ref: x,
    axisType: l,
    events: s,
    fontSize: h,
    getTicksConfig: e,
    height: e.height,
    letterSpacing: y,
    mirror: e.mirror,
    orientation: e.orientation,
    padding: e.padding,
    stroke: e.stroke,
    tick: e.tick,
    tickFormatter: e.tickFormatter,
    tickLine: e.tickLine,
    tickMargin: e.tickMargin,
    tickSize: e.tickSize,
    tickTextProps: e.tickTextProps,
    ticks: u,
    unit: e.unit,
    width: e.width,
    x: e.x,
    y: e.y,
    axisId: c
  }), /* @__PURE__ */ A.createElement(ag, {
    x: e.x,
    y: e.y,
    width: e.width,
    height: e.height,
    lowerWidth: e.width,
    upperWidth: e.width
  }, /* @__PURE__ */ A.createElement(ug, {
    label: e.label,
    labelRef: e.labelRef
  }), e.children)));
}), gc = /* @__PURE__ */ A.forwardRef((e, t) => {
  var r = st(e, Cr);
  return /* @__PURE__ */ A.createElement(lD, $r({}, r, {
    ref: t
  }));
});
gc.displayName = "CartesianAxis";
var cD = {}, Ig = Re({
  name: "errorBars",
  initialState: cD,
  reducers: {
    addErrorBar: (e, t) => {
      var r = t.payload, n = r.itemId, i = r.errorBar;
      e[n] || (e[n] = []), e[n].push(i);
    },
    replaceErrorBar: (e, t) => {
      var r = t.payload, n = r.itemId, i = r.prev, a = r.next;
      e[n] && (e[n] = e[n].map((o) => o.dataKey === i.dataKey && o.direction === i.direction ? a : o));
    },
    removeErrorBar: (e, t) => {
      var r = t.payload, n = r.itemId, i = r.errorBar;
      e[n] && (e[n] = e[n].filter((a) => a.dataKey !== i.dataKey || a.direction !== i.direction));
    }
  }
}), bc = Ig.actions;
bc.addErrorBar;
bc.replaceErrorBar;
bc.removeErrorBar;
var sD = Ig.reducer, fD = ["children"];
function dD(e, t) {
  if (e == null) return {};
  var r, n, i = hD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function hD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var vD = {
  data: [],
  xAxisId: "xAxis-0",
  yAxisId: "yAxis-0",
  dataPointFormatter: () => ({
    x: 0,
    y: 0,
    value: 0
  }),
  errorBarOffset: 0
}, pD = /* @__PURE__ */ Ge(vD);
function mD(e) {
  var t = e.children, r = dD(e, fD);
  return /* @__PURE__ */ A.createElement(pD.Provider, {
    value: r
  }, t);
}
function kg(e, t) {
  var r, n, i = N((c) => Dt(c, e)), a = N((c) => Nt(c, t)), o = (r = i == null ? void 0 : i.allowDataOverflow) !== null && r !== void 0 ? r : me.allowDataOverflow, u = (n = a == null ? void 0 : a.allowDataOverflow) !== null && n !== void 0 ? n : ye.allowDataOverflow, l = o || u;
  return {
    needClip: l,
    needClipX: o,
    needClipY: u
  };
}
function yD(e) {
  var t = e.xAxisId, r = e.yAxisId, n = e.clipPathId, i = wg(), a = kg(t, r), o = a.needClipX, u = a.needClipY, l = a.needClip, c = N((w) => uy(w, t, !1)), s = N((w) => ly(w, r, !1));
  if (!l || !i)
    return null;
  var f = i.x, d = i.y, h = i.width, v = i.height, p = o && c ? Math.min(c[0], c[1]) : f - h / 2, m = u && s ? Math.min(s[0], s[1]) : d - v / 2, y = o && c ? Math.abs(c[1] - c[0]) : h * 2, b = u && s ? Math.abs(s[1] - s[0]) : v * 2;
  return /* @__PURE__ */ A.createElement("clipPath", {
    id: "clipPath-".concat(n)
  }, /* @__PURE__ */ A.createElement("rect", {
    x: p,
    y: m,
    width: y,
    height: b
  }));
}
function zr(e, t) {
  var r, n;
  return (r = (n = e.graphicalItems.cartesianItems.find((i) => i.id === t)) === null || n === void 0 ? void 0 : n.xAxisId) !== null && r !== void 0 ? r : bg;
}
function Fr(e, t) {
  var r, n;
  return (r = (n = e.graphicalItems.cartesianItems.find((i) => i.id === t)) === null || n === void 0 ? void 0 : n.yAxisId) !== null && r !== void 0 ? r : bg;
}
var gD = process.env.NODE_ENV === "production", Xo = "Invariant failed";
function bD(e, t) {
  if (gD)
    throw new Error(Xo);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat(Xo, ": ").concat(r) : Xo;
  throw new Error(n);
}
var xD = ["option"];
function wD(e, t) {
  if (e == null) return {};
  var r, n, i = AD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function AD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var xc = Ep;
function wc(e) {
  var t = e.option, r = wD(e, xD);
  return /* @__PURE__ */ A.createElement(LT, {
    option: t,
    DefaultShape: xc,
    shapeProps: r,
    activeClassName: "recharts-active-bar",
    inActiveClassName: "recharts-inactive-bar"
  });
}
var OD = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return (n, i) => {
    if ($(t)) return t;
    var a = $(n) || xe(n);
    return a ? t(n, i) : (a || bD(!1, "minPointSize callback function received a value with type of ".concat(typeof n, ". Currently only numbers or null/undefined are supported.")), r);
  };
}, SD = (e, t, r) => r, ED = (e, t) => t, Ai = E([Zl, ED], (e, t) => e.filter((r) => r.type === "bar").find((r) => r.id === t)), _D = E([Ai], (e) => e == null ? void 0 : e.maxBarSize), PD = (e, t, r, n) => n, ID = E([re, Zl, zr, Fr, SD], (e, t, r, n, i) => t.filter((a) => e === "horizontal" ? a.xAxisId === r : a.yAxisId === n).filter((a) => a.isPanorama === i).filter((a) => a.hide === !1).filter((a) => a.type === "bar")), kD = (e, t, r) => {
  var n = re(e), i = zr(e, t), a = Fr(e, t);
  if (!(i == null || a == null))
    return n === "horizontal" ? ju(e, "yAxis", a, r) : ju(e, "xAxis", i, r);
}, CD = (e, t) => {
  var r = re(e), n = zr(e, t), i = Fr(e, t);
  if (!(n == null || i == null))
    return r === "horizontal" ? sd(e, "xAxis", n) : sd(e, "yAxis", i);
}, TD = E([ID, nS, CD], FM), MD = (e, t, r) => {
  var n, i, a = Ai(e, t);
  if (a == null)
    return 0;
  var o = zr(e, t), u = Fr(e, t);
  if (o == null || u == null)
    return 0;
  var l = re(e), c = zp(e), s = a.maxBarSize, f = xe(s) ? c : s, d, h;
  return l === "horizontal" ? (d = cn(e, "xAxis", o, r), h = ln(e, "xAxis", o, r)) : (d = cn(e, "yAxis", u, r), h = ln(e, "yAxis", u, r)), (n = (i = ua(d, h, !0)) !== null && i !== void 0 ? i : f) !== null && n !== void 0 ? n : 0;
}, Cg = (e, t, r) => {
  var n = re(e), i = zr(e, t), a = Fr(e, t);
  if (!(i == null || a == null)) {
    var o, u;
    return n === "horizontal" ? (o = cn(e, "xAxis", i, r), u = ln(e, "xAxis", i, r)) : (o = cn(e, "yAxis", a, r), u = ln(e, "yAxis", a, r)), ua(o, u);
  }
}, jD = E([TD, zp, rS, Fp, MD, Cg, _D], HM), DD = (e, t, r) => {
  var n = zr(e, t);
  if (n != null)
    return cn(e, "xAxis", n, r);
}, ND = (e, t, r) => {
  var n = Fr(e, t);
  if (n != null)
    return cn(e, "yAxis", n, r);
}, $D = (e, t, r) => {
  var n = zr(e, t);
  if (n != null)
    return ln(e, "xAxis", n, r);
}, LD = (e, t, r) => {
  var n = Fr(e, t);
  if (n != null)
    return ln(e, "yAxis", n, r);
}, RD = E([jD, Ai], YM), BD = E([kD, Ai], GM), zD = E([Ee, fl, DD, ND, $D, LD, RD, re, z1, Cg, BD, Ai, PD], (e, t, r, n, i, a, o, u, l, c, s, f, d) => {
  var h = l.chartData, v = l.dataStartIndex, p = l.dataEndIndex;
  if (!(f == null || o == null || t == null || u !== "horizontal" && u !== "vertical" || r == null || n == null || i == null || a == null || c == null)) {
    var m = f.data, y;
    if (m != null && m.length > 0 ? y = m : y = h == null ? void 0 : h.slice(v, p + 1), y != null)
      return bN({
        layout: u,
        barSettings: f,
        pos: o,
        parentViewBox: t,
        bandSize: c,
        xAxis: r,
        yAxis: n,
        xAxisTicks: i,
        yAxisTicks: a,
        stackedData: s,
        displayedData: y,
        offset: e,
        cells: d,
        dataStartIndex: v
      });
  }
}), FD = ["index"];
function Lu() {
  return Lu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Lu.apply(null, arguments);
}
function WD(e, t) {
  if (e == null) return {};
  var r, n, i = UD(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function UD(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var Tg = /* @__PURE__ */ Ge(void 0), KD = (e) => {
  var t = rt(Tg);
  if (t != null)
    return t.stackId;
  if (e != null)
    return Dw(e);
}, VD = (e, t) => "recharts-bar-stack-clip-path-".concat(e, "-").concat(t), HD = (e) => {
  var t = rt(Tg);
  if (t != null) {
    var r = t.stackId;
    return "url(#".concat(VD(r, e), ")");
  }
}, Mg = (e) => {
  var t = e.index, r = WD(e, FD), n = HD(t);
  return /* @__PURE__ */ A.createElement(gt, Lu({
    className: "recharts-bar-stack-layer",
    clipPath: n
  }, r));
}, GD = ["onMouseEnter", "onMouseLeave", "onClick"], YD = ["value", "background", "tooltipPosition"], qD = ["id"], XD = ["onMouseEnter", "onClick", "onMouseLeave"];
function sh(e, t) {
  return eN(e) || JD(e, t) || QD(e, t) || ZD();
}
function ZD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QD(e, t) {
  if (e) {
    if (typeof e == "string") return fh(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fh(e, t) : void 0;
  }
}
function fh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function JD(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function eN(e) {
  if (Array.isArray(e)) return e;
}
function cr() {
  return cr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cr.apply(null, arguments);
}
function dh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ge(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dh(Object(r), !0).forEach(function(n) {
      tN(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tN(e, t, r) {
  return (t = rN(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rN(e) {
  var t = nN(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function nN(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ma(e, t) {
  if (e == null) return {};
  var r, n, i = iN(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function iN(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var aN = (e) => {
  var t = e.dataKey, r = e.name, n = e.fill, i = e.legendType, a = e.hide;
  return [{
    inactive: a,
    dataKey: t,
    type: i,
    color: n,
    value: cp(r, t),
    payload: e
  }];
}, oN = /* @__PURE__ */ A.memo((e) => {
  var t = e.dataKey, r = e.stroke, n = e.strokeWidth, i = e.fill, a = e.name, o = e.hide, u = e.unit, l = e.formatter, c = e.tooltipType, s = e.id, f = {
    dataDefinedOnItem: void 0,
    getPosition: hn,
    settings: {
      stroke: r,
      strokeWidth: n,
      fill: i,
      dataKey: t,
      nameKey: void 0,
      name: cp(a, t),
      hide: o,
      type: c,
      color: i,
      unit: u,
      formatter: l,
      graphicalItemId: s
    }
  };
  return /* @__PURE__ */ A.createElement(RT, {
    tooltipEntrySettings: f
  });
});
function uN(e) {
  var t = N(fn), r = e.data, n = e.dataKey, i = e.background, a = e.allOtherBarProps, o = a.onMouseEnter, u = a.onMouseLeave, l = a.onClick, c = Ma(a, GD), s = hg(o, n, a.id), f = vg(u), d = pg(l, n, a.id);
  if (!i || r == null)
    return null;
  var h = Hu(i);
  return /* @__PURE__ */ A.createElement(Jt, {
    zIndex: qM(i, Fe.barBackground)
  }, r.map((v, p) => {
    v.value;
    var m = v.background;
    v.tooltipPosition;
    var y = Ma(v, YD);
    if (!m)
      return null;
    var b = s(v, v.originalDataIndex), w = f(v, v.originalDataIndex), x = d(v, v.originalDataIndex), O = ge(ge(ge(ge(ge({
      option: i,
      isActive: String(v.originalDataIndex) === t
    }, y), {}, {
      // @ts-expect-error backgroundProps is contributing unknown props
      fill: "#eee"
    }, m), h), Qu(c, v, p)), {}, {
      onMouseEnter: b,
      onMouseLeave: w,
      onClick: x,
      dataKey: n,
      index: p,
      className: "recharts-bar-background-rectangle"
    });
    return /* @__PURE__ */ A.createElement(wc, cr({
      key: "background-bar-".concat(p)
    }, O));
  }));
}
function lN(e) {
  var t = e.showLabels, r = e.children, n = e.rects, i = n == null ? void 0 : n.map((a) => {
    var o = {
      x: a.x,
      y: a.y,
      width: a.width,
      lowerWidth: a.width,
      upperWidth: a.width,
      height: a.height
    };
    return ge(ge({}, o), {}, {
      value: a.value,
      payload: a.payload,
      parentViewBox: a.parentViewBox,
      viewBox: o,
      fill: a.fill
    });
  });
  return /* @__PURE__ */ A.createElement(AT, {
    value: t ? i : void 0
  }, r);
}
function cN(e) {
  var t = e.shape, r = e.activeBar, n = e.baseProps, i = e.entry, a = e.index, o = e.dataKey, u = N(fn), l = N(Ry), c = r && String(i.originalDataIndex) === u && (l == null || o === l), s = u != null && (String(i.originalDataIndex) !== u || l != null && o !== l), f = be(!1), d = sh(f, 2), h = d[0], v = d[1], p = be(!1), m = sh(p, 2), y = m[0], b = m[1];
  se(() => {
    var P;
    return c ? (v(!0), P = requestAnimationFrame(() => {
      b(!0);
    })) : (b(!1), s && v(!1)), () => {
      cancelAnimationFrame(P);
    };
  }, [c, s]);
  var w = ne(() => {
    c || v(!1);
  }, [c]), x = c && y, O = c || h, g;
  c ? r === !0 ? g = t : g = r : g = t;
  var S = /* @__PURE__ */ A.createElement(wc, cr({}, n, {
    name: String(n.name)
  }, i, {
    isActive: x,
    option: g,
    index: a,
    dataKey: o,
    animationElapsedTime: e.animationElapsedTime,
    isAnimating: e.isAnimating,
    isEntrance: e.isEntrance,
    onTransitionEnd: w
  }));
  return O ? /* @__PURE__ */ A.createElement(Jt, {
    zIndex: Fe.activeBar
  }, /* @__PURE__ */ A.createElement(Mg, {
    index: i.originalDataIndex
  }, S)) : S;
}
function sN(e) {
  var t = e.shape, r = e.baseProps, n = e.entry, i = e.index, a = e.dataKey;
  return /* @__PURE__ */ A.createElement(wc, cr({}, r, {
    name: String(r.name)
  }, n, {
    isActive: !1,
    option: t,
    index: i,
    dataKey: a,
    animationElapsedTime: e.animationElapsedTime,
    isAnimating: e.isAnimating,
    isEntrance: e.isEntrance
  }));
}
function fN(e) {
  var t, r = e.data, n = e.props, i = e.animationElapsedTime, a = e.isAnimating, o = e.isEntrance, u = (t = ur(n)) !== null && t !== void 0 ? t : {}, l = u.id, c = Ma(u, qD), s = n.shape, f = n.dataKey, d = n.activeBar, h = n.onMouseEnter, v = n.onClick, p = n.onMouseLeave, m = Ma(n, XD), y = hg(h, f, l), b = vg(p), w = pg(v, f, l);
  return r ? /* @__PURE__ */ A.createElement(A.Fragment, null, r.map((x, O) => /* @__PURE__ */ A.createElement(Mg, cr({
    index: x.originalDataIndex,
    key: "rectangle-".concat(x == null ? void 0 : x.x, "-").concat(x == null ? void 0 : x.y, "-").concat(x == null ? void 0 : x.value, "-").concat(O),
    className: "recharts-bar-rectangle"
  }, Qu(m, x, O), {
    onMouseEnter: y(x, x.originalDataIndex),
    onMouseLeave: b(x, x.originalDataIndex),
    onClick: w(x, x.originalDataIndex)
  }), d ? /* @__PURE__ */ A.createElement(cN, {
    shape: s,
    activeBar: d,
    baseProps: c,
    entry: x,
    index: O,
    dataKey: f,
    animationElapsedTime: i,
    isAnimating: a,
    isEntrance: o
  }) : (
    /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */
    /* @__PURE__ */ A.createElement(sN, {
      shape: s,
      baseProps: c,
      entry: x,
      index: O,
      dataKey: f,
      animationElapsedTime: i,
      isAnimating: a,
      isEntrance: o
    })
  )))) : null;
}
var dN = (e, t, r) => e == null ? [] : t === 1 ? e.flatMap((n) => n.status === "removed" ? [] : [n.next]) : e.flatMap((n) => {
  if (n.status === "removed")
    return r === "horizontal" ? [ge(ge({}, n.prev), {}, {
      height: De(n.prev.height, 0, t),
      y: De(n.prev.y, n.prev.y + n.prev.height, t)
    })] : [ge(ge({}, n.prev), {}, {
      width: De(n.prev.width, 0, t)
    })];
  if (n.status === "matched")
    return [ge(ge({}, n.next), {}, {
      x: De(n.prev.x, n.next.x, t),
      y: De(n.prev.y, n.next.y, t),
      width: De(n.prev.width, n.next.width, t),
      height: De(n.prev.height, n.next.height, t)
    })];
  var i = n.next;
  return r === "horizontal" ? [ge(ge({}, i), {}, {
    height: De(0, i.height, t),
    y: De(i.stackedBarStart, i.y, t)
  })] : [ge(ge({}, i), {}, {
    width: De(0, i.width, t),
    x: De(i.stackedBarStart, i.x, t)
  })];
});
function hN(e) {
  var t = e.props, r = e.previousRectanglesRef, n = t.data, i = t.isAnimationActive, a = t.animationBegin, o = t.animationDuration, u = t.animationEasing, l = t.animationInterpolateFn, c = t.layout, s = rM(t.onAnimationStart, t.onAnimationEnd), f = s.isAnimating, d = s.handleAnimationStart, h = s.handleAnimationEnd;
  return /* @__PURE__ */ A.createElement(lN, {
    showLabels: !f,
    rects: n
  }, /* @__PURE__ */ A.createElement(nM, {
    animationInput: n,
    animationIdPrefix: "recharts-bar-",
    items: n,
    previousItemsRef: r,
    isAnimationActive: i,
    animationBegin: a,
    animationDuration: o,
    animationEasing: u,
    onAnimationStart: d,
    onAnimationEnd: h,
    animationInterpolateFn: l,
    animationMatchBy: t.animationMatchBy,
    layout: c
  }, (v, p, m) => /* @__PURE__ */ A.createElement(gt, null, /* @__PURE__ */ A.createElement(fN, {
    props: t,
    data: v,
    animationElapsedTime: p,
    isAnimating: f || p < 1,
    isEntrance: m
  }))), /* @__PURE__ */ A.createElement(ET, {
    label: t.label
  }), t.children);
}
function vN(e) {
  var t = X(null);
  return /* @__PURE__ */ A.createElement(hN, {
    previousRectanglesRef: t,
    props: e
  });
}
var jg = 0, pN = (e, t) => {
  var r = Array.isArray(e.value) ? e.value[1] : e.value;
  return {
    x: e.x,
    y: e.y,
    value: r,
    // getValueByDataKey does not validate the output type
    errorVal: Se(e, t)
  };
};
class mN extends i0 {
  render() {
    var t = this.props, r = t.hide, n = t.data, i = t.dataKey, a = t.className, o = t.xAxisId, u = t.yAxisId, l = t.needClip, c = t.background, s = t.id;
    if (r || n == null)
      return null;
    var f = le("recharts-bar", a), d = s;
    return /* @__PURE__ */ A.createElement(gt, {
      className: f,
      id: s
    }, l && /* @__PURE__ */ A.createElement("defs", null, /* @__PURE__ */ A.createElement(yD, {
      clipPathId: d,
      xAxisId: o,
      yAxisId: u
    })), /* @__PURE__ */ A.createElement(gt, {
      className: "recharts-bar-rectangles",
      clipPath: l ? "url(#clipPath-".concat(d, ")") : void 0
    }, /* @__PURE__ */ A.createElement(uN, {
      data: n,
      dataKey: i,
      background: c,
      allOtherBarProps: this.props
    }), /* @__PURE__ */ A.createElement(vN, this.props)));
  }
}
var yN = {
  activeBar: !1,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease",
  animationInterpolateFn: dN,
  animationMatchBy: yg,
  background: !1,
  hide: !1,
  isAnimationActive: "auto",
  label: !1,
  legendType: "rect",
  minPointSize: jg,
  shape: xc,
  xAxisId: 0,
  yAxisId: 0,
  zIndex: Fe.bar
};
function gN(e) {
  var t = e.xAxisId, r = e.yAxisId, n = e.hide, i = e.legendType, a = e.minPointSize, o = e.activeBar, u = e.animationBegin, l = e.animationDuration, c = e.animationEasing, s = e.isAnimationActive, f = kg(t, r), d = f.needClip, h = vn(), v = Ye(), p = kT(e.children, go), m = N((w) => zD(w, e.id, v, p));
  if (h !== "vertical" && h !== "horizontal")
    return null;
  var y, b = m == null ? void 0 : m[0];
  return b == null || b.height == null || b.width == null ? y = 0 : y = h === "vertical" ? b.height / 2 : b.width / 2, /* @__PURE__ */ A.createElement(mD, {
    xAxisId: t,
    yAxisId: r,
    data: m,
    dataPointFormatter: pN,
    errorBarOffset: y
  }, /* @__PURE__ */ A.createElement(mN, cr({}, e, {
    layout: h,
    needClip: d,
    data: m,
    xAxisId: t,
    yAxisId: r,
    hide: n,
    legendType: i,
    minPointSize: a,
    activeBar: o,
    animationBegin: u,
    animationDuration: l,
    animationEasing: c,
    isAnimationActive: s
  })));
}
function bN(e) {
  var t = e.layout, r = e.barSettings, n = r.dataKey, i = r.minPointSize, a = r.hasCustomShape, o = e.pos, u = e.bandSize, l = e.xAxis, c = e.yAxis, s = e.xAxisTicks, f = e.yAxisTicks, d = e.stackedData, h = e.displayedData, v = e.offset, p = e.cells, m = e.parentViewBox, y = e.dataStartIndex, b = t === "horizontal" ? c : l, w = d ? b.scale.domain() : null, x = Nw({
    numericAxis: b
  }), O = b.scale.map(x);
  return h.map((g, S) => {
    var P, k, T, I, _, L;
    if (d) {
      var D = d[S + y];
      if (D == null)
        return null;
      P = kw(D, w);
    } else
      P = Se(g, n), Array.isArray(P) || (P = [x, P]);
    var F = OD(i, jg)(P[1], S);
    if (t === "horizontal") {
      var K, V = c.scale.map(P[0]), R = c.scale.map(P[1]);
      if (V == null || R == null)
        return null;
      k = cs({
        axis: l,
        ticks: s,
        bandSize: u,
        offset: o.offset,
        entry: g,
        index: S
      }), T = (K = R ?? V) !== null && K !== void 0 ? K : void 0, I = o.size;
      var q = V - R;
      if (_ = Mt(q) ? 0 : q, L = {
        x: k,
        y: v.top,
        width: I,
        height: v.height
      }, Math.abs(F) > 0 && Math.abs(_) < Math.abs(F)) {
        var W = Je(_ || F) * (Math.abs(F) - Math.abs(_));
        T -= W, _ += W;
      }
    } else {
      var he = l.scale.map(P[0]), ve = l.scale.map(P[1]);
      if (he == null || ve == null)
        return null;
      if (k = he, T = cs({
        axis: c,
        ticks: f,
        bandSize: u,
        offset: o.offset,
        entry: g,
        index: S
      }), I = ve - he, _ = o.size, L = {
        x: v.left,
        y: T,
        width: v.width,
        height: _
      }, Math.abs(F) > 0 && Math.abs(I) < Math.abs(F)) {
        var ce = Je(I || F) * (Math.abs(F) - Math.abs(I));
        I += ce;
      }
    }
    if (k == null || T == null || I == null || _ == null || !a && (I === 0 || _ === 0))
      return null;
    var ze = ge(ge({}, g), {}, {
      stackedBarStart: O,
      x: k,
      y: T,
      width: I,
      height: _,
      value: d ? P : P[1],
      payload: g,
      background: L,
      tooltipPosition: {
        x: k + I / 2,
        y: T + _ / 2
      },
      parentViewBox: m,
      originalDataIndex: S
    }, p && p[S] && p[S].props);
    return ze;
  }).filter(Boolean);
}
function xN(e) {
  var t = st(e, yN), r = KD(t.stackId), n = Ye();
  return /* @__PURE__ */ A.createElement(hM, {
    id: t.id,
    type: "bar"
  }, (i) => /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(BT, {
    legendPayload: aN(t)
  }), /* @__PURE__ */ A.createElement(oN, {
    dataKey: t.dataKey,
    stroke: t.stroke,
    strokeWidth: t.strokeWidth,
    fill: t.fill,
    name: t.name,
    hide: t.hide,
    unit: t.unit,
    formatter: t.formatter,
    tooltipType: t.tooltipType,
    id: i
  }), /* @__PURE__ */ A.createElement(xM, {
    type: "bar",
    id: i,
    data: void 0,
    xAxisId: t.xAxisId,
    yAxisId: t.yAxisId,
    zAxisId: 0,
    dataKey: t.dataKey,
    stackId: r,
    hide: t.hide,
    barSize: t.barSize,
    minPointSize: t.minPointSize,
    maxBarSize: t.maxBarSize,
    isPanorama: n,
    hasCustomShape: t.shape != null && t.shape !== xc
  }), /* @__PURE__ */ A.createElement(Jt, {
    zIndex: t.zIndex
  }, /* @__PURE__ */ A.createElement(gN, cr({}, t, {
    id: i
  })))));
}
var Ac = /* @__PURE__ */ A.memo(xN, Ja);
Ac.displayName = "Bar";
var wN = ["domain", "range"], AN = ["domain", "range"];
function hh(e, t) {
  if (e == null) return {};
  var r, n, i = ON(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function ON(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function vh(e, t) {
  return e === t ? !0 : Array.isArray(e) && e.length === 2 && Array.isArray(t) && t.length === 2 ? e[0] === t[0] && e[1] === t[1] : !1;
}
function Dg(e, t) {
  if (e === t)
    return !0;
  var r = e.domain, n = e.range, i = hh(e, wN), a = t.domain, o = t.range, u = hh(t, AN);
  return !vh(r, a) || !vh(n, o) ? !1 : Ja(i, u);
}
var SN = ["type"], EN = ["dangerouslySetInnerHTML", "ticks", "scale"], _N = ["id", "scale"];
function Ru() {
  return Ru = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ru.apply(null, arguments);
}
function ph(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ph(Object(r), !0).forEach(function(n) {
      PN(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ph(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function PN(e, t, r) {
  return (t = IN(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function IN(e) {
  var t = kN(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function kN(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Bu(e, t) {
  if (e == null) return {};
  var r, n, i = CN(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function CN(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function TN(e) {
  var t = oe(), r = X(null), n = pp(), i = e.type, a = Bu(e, SN), o = no(n, "xAxis", i), u = Ve(() => {
    if (o != null)
      return mh(mh({}, a), {}, {
        type: o
      });
  }, [a, o]);
  return Ue(() => {
    u != null && (r.current === null ? t(EM(u)) : r.current !== u && t(_M({
      prev: r.current,
      next: u
    })), r.current = u);
  }, [u, t]), Ue(() => () => {
    r.current && (t(PM(r.current)), r.current = null);
  }, [t]), null;
}
var MN = (e) => {
  var t = e.xAxisId, r = e.className, n = e.height, i = e.label, a = X(null), o = X(null), u = N(fl), l = Ye(), c = oe(), s = "xAxis", f = N((y) => my(y, s, t, l)), d = N((y) => hy(y, t)), h = N((y) => WP(y, t)), v = N((y) => jm(y, t));
  if (Ue(() => {
    if (!(n !== "auto" || !d || bo(i) || /* @__PURE__ */ yt(i) || v == null)) {
      var y = a.current;
      if (y) {
        var b = y.getCalculatedHeight();
        Math.round(d.height) !== Math.round(b) && c(MM({
          id: t,
          height: b
        }));
      }
    }
  }, [
    // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
    // The ref will be populated by then.
    // To re-run this effect when ticks change, we can depend on the ticks array from the store.
    f,
    d,
    c,
    i,
    t,
    n,
    v
  ]), d == null || h == null || v == null)
    return null;
  e.dangerouslySetInnerHTML, e.ticks, e.scale;
  var p = Bu(e, EN);
  v.id, v.scale;
  var m = Bu(v, _N);
  return /* @__PURE__ */ A.createElement(gc, Ru({}, p, m, {
    ref: a,
    labelRef: o,
    x: h.x,
    y: h.y,
    width: d.width,
    height: d.height,
    className: le("recharts-".concat(s, " ").concat(s), r),
    viewBox: u,
    ticks: f,
    axisType: s,
    axisId: t
  }));
}, jN = {
  allowDataOverflow: me.allowDataOverflow,
  allowDecimals: me.allowDecimals,
  allowDuplicatedCategory: me.allowDuplicatedCategory,
  angle: me.angle,
  axisLine: Cr.axisLine,
  height: me.height,
  hide: !1,
  includeHidden: me.includeHidden,
  interval: me.interval,
  label: !1,
  minTickGap: me.minTickGap,
  mirror: me.mirror,
  orientation: me.orientation,
  padding: me.padding,
  reversed: me.reversed,
  scale: me.scale,
  tick: me.tick,
  tickCount: me.tickCount,
  tickLine: Cr.tickLine,
  tickSize: Cr.tickSize,
  type: me.type,
  niceTicks: me.niceTicks,
  xAxisId: 0
}, DN = (e) => {
  var t = st(e, jN);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(TN, {
    allowDataOverflow: t.allowDataOverflow,
    allowDecimals: t.allowDecimals,
    allowDuplicatedCategory: t.allowDuplicatedCategory,
    angle: t.angle,
    dataKey: t.dataKey,
    domain: t.domain,
    height: t.height,
    hide: t.hide,
    id: t.xAxisId,
    includeHidden: t.includeHidden,
    interval: t.interval,
    minTickGap: t.minTickGap,
    mirror: t.mirror,
    name: t.name,
    orientation: t.orientation,
    padding: t.padding,
    reversed: t.reversed,
    scale: t.scale,
    tick: t.tick,
    tickCount: t.tickCount,
    tickFormatter: t.tickFormatter,
    ticks: t.ticks,
    type: t.type,
    unit: t.unit,
    niceTicks: t.niceTicks
  }), /* @__PURE__ */ A.createElement(MN, t));
}, ti = /* @__PURE__ */ A.memo(DN, Dg);
ti.displayName = "XAxis";
var NN = ["type"], $N = ["dangerouslySetInnerHTML", "ticks", "scale"], LN = ["id", "scale"];
function zu() {
  return zu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, zu.apply(null, arguments);
}
function yh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function gh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yh(Object(r), !0).forEach(function(n) {
      RN(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function RN(e, t, r) {
  return (t = BN(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function BN(e) {
  var t = zN(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function zN(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fu(e, t) {
  if (e == null) return {};
  var r, n, i = FN(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function FN(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function WN(e) {
  var t = oe(), r = X(null), n = pp(), i = e.type, a = Fu(e, NN), o = no(n, "yAxis", i), u = Ve(() => {
    if (o != null)
      return gh(gh({}, a), {}, {
        type: o
      });
  }, [o, a]);
  return Ue(() => {
    u != null && (r.current === null ? t(IM(u)) : r.current !== u && t(kM({
      prev: r.current,
      next: u
    })), r.current = u);
  }, [u, t]), Ue(() => () => {
    r.current && (t(CM(r.current)), r.current = null);
  }, [t]), null;
}
function UN(e) {
  var t = e.yAxisId, r = e.className, n = e.width, i = e.label, a = X(null), o = X(null), u = N(fl), l = Ye(), c = oe(), s = "yAxis", f = N((y) => vy(y, t)), d = N((y) => KP(y, t)), h = N((y) => my(y, s, t, l)), v = N((y) => Dm(y, t));
  if (Ue(() => {
    if (!(n !== "auto" || !f || bo(i) || /* @__PURE__ */ yt(i) || v == null)) {
      var y = a.current;
      if (y) {
        var b = y.getCalculatedWidth();
        Math.round(f.width) !== Math.round(b) && c(TM({
          id: t,
          width: b
        }));
      }
    }
  }, [
    // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
    // The ref will be populated by then.
    // To re-run this effect when ticks change, we can depend on the ticks array from the store.
    h,
    f,
    c,
    i,
    t,
    n,
    v
  ]), f == null || d == null || v == null)
    return null;
  e.dangerouslySetInnerHTML, e.ticks, e.scale;
  var p = Fu(e, $N);
  v.id, v.scale;
  var m = Fu(v, LN);
  return /* @__PURE__ */ A.createElement(gc, zu({}, p, m, {
    ref: a,
    labelRef: o,
    x: d.x,
    y: d.y,
    tickTextProps: n === "auto" ? {
      width: void 0
    } : {
      width: n
    },
    width: f.width,
    height: f.height,
    className: le("recharts-".concat(s, " ").concat(s), r),
    viewBox: u,
    ticks: h,
    axisType: s,
    axisId: t
  }));
}
var KN = {
  allowDataOverflow: ye.allowDataOverflow,
  allowDecimals: ye.allowDecimals,
  allowDuplicatedCategory: ye.allowDuplicatedCategory,
  angle: ye.angle,
  axisLine: Cr.axisLine,
  hide: !1,
  includeHidden: ye.includeHidden,
  interval: ye.interval,
  label: !1,
  minTickGap: ye.minTickGap,
  mirror: ye.mirror,
  orientation: ye.orientation,
  padding: ye.padding,
  reversed: ye.reversed,
  scale: ye.scale,
  tick: ye.tick,
  tickCount: ye.tickCount,
  tickLine: Cr.tickLine,
  tickSize: Cr.tickSize,
  type: ye.type,
  niceTicks: ye.niceTicks,
  width: ye.width,
  yAxisId: 0
}, VN = (e) => {
  var t = st(e, KN);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(WN, {
    interval: t.interval,
    id: t.yAxisId,
    scale: t.scale,
    type: t.type,
    domain: t.domain,
    allowDataOverflow: t.allowDataOverflow,
    dataKey: t.dataKey,
    allowDuplicatedCategory: t.allowDuplicatedCategory,
    allowDecimals: t.allowDecimals,
    tickCount: t.tickCount,
    padding: t.padding,
    includeHidden: t.includeHidden,
    reversed: t.reversed,
    ticks: t.ticks,
    width: t.width,
    orientation: t.orientation,
    mirror: t.mirror,
    hide: t.hide,
    unit: t.unit,
    name: t.name,
    angle: t.angle,
    minTickGap: t.minTickGap,
    tick: t.tick,
    tickFormatter: t.tickFormatter,
    niceTicks: t.niceTicks
  }), /* @__PURE__ */ A.createElement(UN, t));
}, Oc = /* @__PURE__ */ A.memo(VN, Dg);
Oc.displayName = "YAxis";
var HN = (e, t) => t, Sc = E([HN, re, Yp, Pe, Dy, Qt, dk, Ee], bk);
function GN(e) {
  return "getBBox" in e.currentTarget && typeof e.currentTarget.getBBox == "function";
}
function Ec(e) {
  var t = e.currentTarget.getBoundingClientRect(), r, n;
  if (GN(e)) {
    var i = e.currentTarget.getBBox();
    r = i.width > 0 ? t.width / i.width : 1, n = i.height > 0 ? t.height / i.height : 1;
  } else {
    var a = e.currentTarget;
    r = a.offsetWidth > 0 ? t.width / a.offsetWidth : 1, n = a.offsetHeight > 0 ? t.height / a.offsetHeight : 1;
  }
  var o = (u, l) => ({
    /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */
    relativeX: Math.round((u - t.left) / r),
    relativeY: Math.round((l - t.top) / n)
  });
  return "touches" in e ? Array.from(e.touches).map((u) => o(u.clientX, u.clientY)) : o(e.clientX, e.clientY);
}
var Ng = tt("mouseClick"), $g = oi();
$g.startListening({
  actionCreator: Ng,
  effect: (e, t) => {
    var r = e.payload, n = Sc(t.getState(), Ec(r));
    (n == null ? void 0 : n.activeIndex) != null && t.dispatch(oI({
      activeIndex: n.activeIndex,
      activeDataKey: void 0,
      activeCoordinate: n.activeCoordinate
    }));
  }
});
var Wu = tt("mouseMove"), Lg = oi(), Gr = null, pr = null, Zo = null;
Lg.startListening({
  actionCreator: Wu,
  effect: (e, t) => {
    var r = e.payload, n = t.getState(), i = n.eventSettings, a = i.throttleDelay, o = i.throttledEvents, u = o === "all" || (o == null ? void 0 : o.includes("mousemove"));
    Gr !== null && (cancelAnimationFrame(Gr), Gr = null), pr !== null && (typeof a != "number" || !u) && (clearTimeout(pr), pr = null), Zo = Ec(r);
    var l = () => {
      var c = t.getState(), s = xi(c, c.tooltip.settings.shared);
      if (!Zo) {
        Gr = null, pr = null;
        return;
      }
      if (s === "axis") {
        var f = Sc(c, Zo);
        (f == null ? void 0 : f.activeIndex) != null ? t.dispatch(Sy({
          activeIndex: f.activeIndex,
          activeDataKey: void 0,
          activeCoordinate: f.activeCoordinate
        })) : t.dispatch(Oy());
      }
      Gr = null, pr = null;
    };
    if (!u) {
      l();
      return;
    }
    a === "raf" ? Gr = requestAnimationFrame(l) : typeof a == "number" && pr === null && (pr = setTimeout(l, a));
  }
});
function YN(e, t) {
  return t instanceof HTMLElement ? "HTMLElement <".concat(t.tagName, ' class="').concat(t.className, '">') : t === window ? "global.window" : e === "children" && typeof t == "object" && t !== null ? "<<CHILDREN>>" : t;
}
var bh = {
  accessibilityLayer: !0,
  barCategoryGap: "10%",
  barGap: 4,
  barSize: void 0,
  className: void 0,
  maxBarSize: void 0,
  stackOffset: "none",
  syncId: void 0,
  syncMethod: "index",
  baseValue: void 0,
  reverseStackOrder: !1
}, Rg = Re({
  name: "rootProps",
  initialState: bh,
  reducers: {
    updateOptions: (e, t) => {
      var r;
      e.accessibilityLayer = t.payload.accessibilityLayer, e.barCategoryGap = t.payload.barCategoryGap, e.barGap = (r = t.payload.barGap) !== null && r !== void 0 ? r : bh.barGap, e.barSize = t.payload.barSize, e.maxBarSize = t.payload.maxBarSize, e.stackOffset = t.payload.stackOffset, e.syncId = t.payload.syncId, e.syncMethod = t.payload.syncMethod, e.className = t.payload.className, e.baseValue = t.payload.baseValue, e.reverseStackOrder = t.payload.reverseStackOrder;
    }
  }
}), qN = Rg.reducer, XN = Rg.actions.updateOptions, ZN = null, QN = {
  updatePolarOptions: (e, t) => e === null ? t.payload : (e.startAngle = t.payload.startAngle, e.endAngle = t.payload.endAngle, e.cx = t.payload.cx, e.cy = t.payload.cy, e.innerRadius = t.payload.innerRadius, e.outerRadius = t.payload.outerRadius, e)
}, Bg = Re({
  name: "polarOptions",
  initialState: ZN,
  reducers: QN
});
Bg.actions.updatePolarOptions;
var JN = Bg.reducer, zg = tt("keyDown"), Fg = tt("focus"), Wg = tt("blur"), wo = oi(), Yr = null, mr = null, Wi = null;
wo.startListening({
  actionCreator: zg,
  effect: (e, t) => {
    Wi = e.payload, Yr !== null && (cancelAnimationFrame(Yr), Yr = null);
    var r = t.getState(), n = r.eventSettings, i = n.throttleDelay, a = n.throttledEvents, o = a === "all" || a.includes("keydown");
    mr !== null && (typeof i != "number" || !o) && (clearTimeout(mr), mr = null);
    var u = () => {
      try {
        var l = t.getState(), c = l.rootProps.accessibilityLayer !== !1;
        if (!c)
          return;
        var s = l.tooltip.keyboardInteraction, f = Wi;
        if (f !== "ArrowRight" && f !== "ArrowLeft" && f !== "Enter")
          return;
        var d = zn(s, Nr(l), on(l), sn(l)), h = d == null ? -1 : Number(d), v = !Number.isFinite(h) || h < 0, p = Qt(l), m = Nr(l), y = xi(l, l.tooltip.settings.shared);
        if (f === "Enter") {
          if (v)
            return;
          var b = Ia(l, y, "hover", String(s.index));
          t.dispatch(Pa({
            active: !s.active,
            activeIndex: s.index,
            activeCoordinate: b
          }));
          return;
        }
        var w = qP(l), x = w === "left-to-right" ? 1 : -1, O = f === "ArrowRight" ? 1 : -1, g;
        if (v) {
          var S = on(l), P = sn(l), k = O * x, T = (F) => ({
            active: !1,
            index: String(F),
            dataKey: void 0,
            graphicalItemId: void 0,
            coordinate: void 0
          });
          if (g = -1, k > 0) {
            for (var I = 0; I < m.length; I++)
              if (zn(T(I), m, S, P) != null) {
                g = I;
                break;
              }
          } else
            for (var _ = m.length - 1; _ >= 0; _--)
              if (zn(T(_), m, S, P) != null) {
                g = _;
                break;
              }
          if (g < 0)
            return;
        } else {
          g = h + O * x;
          var L = (p == null ? void 0 : p.length) || m.length;
          if (L === 0 || g >= L || g < 0)
            return;
        }
        var D = Ia(l, y, "hover", String(g));
        t.dispatch(Pa({
          active: !0,
          activeIndex: g.toString(),
          activeCoordinate: D
        }));
      } finally {
        Yr = null, mr = null;
      }
    };
    if (!o) {
      u();
      return;
    }
    i === "raf" ? Yr = requestAnimationFrame(u) : typeof i == "number" && mr === null && (u(), Wi = null, mr = setTimeout(() => {
      Wi ? u() : (mr = null, Yr = null);
    }, i));
  }
});
wo.startListening({
  actionCreator: Fg,
  effect: (e, t) => {
    var r = t.getState(), n = r.rootProps.accessibilityLayer !== !1;
    if (n) {
      var i = r.tooltip.keyboardInteraction;
      if (!i.active && i.index == null) {
        var a = "0", o = xi(r, r.tooltip.settings.shared), u = Ia(r, o, "hover", String(a));
        t.dispatch(Pa({
          active: !0,
          activeIndex: a,
          activeCoordinate: u
        }));
      }
    }
  }
});
wo.startListening({
  actionCreator: Wg,
  effect: (e, t) => {
    var r = t.getState(), n = r.rootProps.accessibilityLayer !== !1;
    if (n) {
      var i = r.tooltip.keyboardInteraction;
      i.active && t.dispatch(Pa({
        active: !1,
        activeIndex: i.index,
        activeCoordinate: i.coordinate
      }));
    }
  }
});
function Ug(e) {
  e.persist();
  var t = e.currentTarget;
  return new Proxy(e, {
    get: (r, n) => {
      if (n === "currentTarget")
        return t;
      var i = Reflect.get(r, n);
      return typeof i == "function" ? i.bind(r) : i;
    }
  });
}
var nt = tt("externalEvent"), Kg = oi(), Ui = /* @__PURE__ */ new Map(), Dn = /* @__PURE__ */ new Map(), Qo = /* @__PURE__ */ new Map();
Kg.startListening({
  actionCreator: nt,
  effect: (e, t) => {
    var r = e.payload, n = r.handler, i = r.reactEvent;
    if (n != null) {
      var a = i.type, o = Ug(i);
      Qo.set(a, {
        handler: n,
        reactEvent: o
      });
      var u = Ui.get(a);
      u !== void 0 && (cancelAnimationFrame(u), Ui.delete(a));
      var l = t.getState(), c = l.eventSettings, s = c.throttleDelay, f = c.throttledEvents, d = f, h = d === "all" || (d == null ? void 0 : d.includes(a)), v = Dn.get(a);
      v !== void 0 && (typeof s != "number" || !h) && (clearTimeout(v), Dn.delete(a));
      var p = () => {
        var b = Qo.get(a);
        try {
          if (!b)
            return;
          var w = b.handler, x = b.reactEvent, O = t.getState(), g = {
            activeCoordinate: ZI(O),
            activeDataKey: Ry(O),
            activeIndex: fn(O),
            activeLabel: Ly(O),
            activeTooltipIndex: fn(O),
            isTooltipActive: QI(O)
          };
          w && w(g, x);
        } finally {
          Ui.delete(a), Dn.delete(a), Qo.delete(a);
        }
      };
      if (!h) {
        p();
        return;
      }
      if (s === "raf") {
        var m = requestAnimationFrame(p);
        Ui.set(a, m);
      } else if (typeof s == "number") {
        if (!Dn.has(a)) {
          p();
          var y = setTimeout(p, s);
          Dn.set(a, y);
        }
      } else
        p();
    }
  }
});
var e$ = E([An], (e) => e.tooltipItemPayloads), t$ = E([e$, (e, t) => t, (e, t, r) => r], (e, t, r) => {
  if (t != null) {
    var n = e.find((a) => a.settings.graphicalItemId === r);
    if (n != null) {
      var i = n.getPosition;
      if (i != null)
        return i(t);
    }
  }
}), Vg = tt("touchMove"), Hg = oi(), yr = null, er = null, xh = null, Nn = null;
Hg.startListening({
  actionCreator: Vg,
  effect: (e, t) => {
    var r = e.payload;
    if (!(r.touches == null || r.touches.length === 0)) {
      Nn = Ug(r);
      var n = t.getState(), i = n.eventSettings, a = i.throttleDelay, o = i.throttledEvents, u = o === "all" || o.includes("touchmove");
      yr !== null && (cancelAnimationFrame(yr), yr = null), er !== null && (typeof a != "number" || !u) && (clearTimeout(er), er = null), xh = Array.from(r.touches).map((c) => Ec({
        clientX: c.clientX,
        clientY: c.clientY,
        currentTarget: r.currentTarget
      }));
      var l = () => {
        if (Nn != null) {
          var c = t.getState(), s = xi(c, c.tooltip.settings.shared);
          if (s === "axis") {
            var f, d = (f = xh) === null || f === void 0 ? void 0 : f[0];
            if (d == null) {
              yr = null, er = null;
              return;
            }
            var h = Sc(c, d);
            (h == null ? void 0 : h.activeIndex) != null && t.dispatch(Sy({
              activeIndex: h.activeIndex,
              activeDataKey: void 0,
              activeCoordinate: h.activeCoordinate
            }));
          } else if (s === "item") {
            var v, p = Nn.touches[0];
            if (document.elementFromPoint == null || p == null)
              return;
            var m = document.elementFromPoint(p.clientX, p.clientY);
            if (!m || !m.getAttribute)
              return;
            var y = m.getAttribute(Ww), b = (v = m.getAttribute(Uw)) !== null && v !== void 0 ? v : void 0, w = Br(c).find((g) => g.id === b);
            if (y == null || w == null || b == null)
              return;
            var x = w.dataKey, O = t$(c, y, b);
            t.dispatch(Ay({
              activeDataKey: x,
              activeIndex: y,
              activeCoordinate: O,
              activeGraphicalItemId: b
            }));
          }
          yr = null, er = null;
        }
      };
      if (!u) {
        l();
        return;
      }
      a === "raf" ? yr = requestAnimationFrame(l) : typeof a == "number" && er === null && (l(), Nn = null, er = setTimeout(() => {
        Nn ? l() : (er = null, yr = null);
      }, a));
    }
  }
});
var Gg = {
  throttleDelay: "raf",
  throttledEvents: ["mousemove", "touchmove", "pointermove", "scroll", "wheel"]
}, Yg = Re({
  name: "eventSettings",
  initialState: Gg,
  reducers: {
    setEventSettings: (e, t) => {
      t.payload.throttleDelay != null && (e.throttleDelay = t.payload.throttleDelay), t.payload.throttledEvents != null && (e.throttledEvents = Z(t.payload.throttledEvents));
    }
  }
}), r$ = Yg.actions.setEventSettings, n$ = Yg.reducer, i$ = Cv({
  brush: ZM,
  cartesianAxis: jM,
  chartData: qk,
  errorBars: sD,
  eventSettings: n$,
  graphicalItems: gM,
  layout: Sw,
  legend: TA,
  options: Kk,
  polarAxis: PT,
  polarOptions: JN,
  referenceElements: aj,
  renderedTicks: Kj,
  rootProps: qN,
  tooltip: uI,
  zIndex: Mk
}), a$ = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Chart";
  return qx({
    reducer: i$,
    // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
    preloadedState: t,
    // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
    middleware: (n) => {
      var i;
      return n({
        serializableCheck: !1,
        immutableCheck: !["commonjs", "es6", "production"].includes((i = "es6") !== null && i !== void 0 ? i : "")
      }).concat([$g.middleware, Lg.middleware, wo.middleware, Kg.middleware, Hg.middleware]);
    },
    /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */
    // @ts-expect-error mismatched generics
    enhancers: (n) => {
      var i = n;
      return typeof n == "function" && (i = n()), i.concat(qv({
        type: "raf"
      }));
    },
    devTools: {
      serialize: {
        replacer: YN
      },
      name: "recharts-".concat(r)
    }
  });
};
function o$(e) {
  var t = e.preloadedState, r = e.children, n = e.reduxStoreName, i = Ye(), a = X(null);
  if (i)
    return r;
  a.current == null && (a.current = a$(t, n));
  var o = nl;
  return /* @__PURE__ */ A.createElement(GA, {
    context: o,
    store: a.current
  }, r);
}
function u$(e) {
  var t = e.layout, r = e.margin, n = oe(), i = Ye();
  return se(() => {
    i || (n(ww(t)), n(xw(r)));
  }, [n, i, t, r]), null;
}
var l$ = /* @__PURE__ */ Ku(u$, Ja);
function c$(e) {
  var t = oe();
  return se(() => {
    t(XN(e));
  }, [t, e]), null;
}
var s$ = (e) => {
  var t = oe();
  return se(() => {
    t(r$(e));
  }, [t, e]), null;
}, f$ = /* @__PURE__ */ Ku(s$, Ja);
function wh(e) {
  var t = e.zIndex, r = e.isPanorama, n = X(null), i = oe();
  return Ue(() => (n.current && i(Ck({
    zIndex: t,
    element: n.current,
    isPanorama: r
  })), () => {
    i(Tk({
      zIndex: t,
      isPanorama: r
    }));
  }), [i, t, r]), /* @__PURE__ */ A.createElement("g", {
    tabIndex: -1,
    ref: n,
    className: "recharts-zIndex-layer_".concat(t)
  });
}
function Ah(e) {
  var t = e.children, r = e.isPanorama, n = N(wk);
  if (!n || n.length === 0)
    return t;
  var i = n.filter((o) => o < 0), a = n.filter((o) => o > 0);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, i.map((o) => /* @__PURE__ */ A.createElement(wh, {
    key: o,
    zIndex: o,
    isPanorama: r
  })), t, a.map((o) => /* @__PURE__ */ A.createElement(wh, {
    key: o,
    zIndex: o,
    isPanorama: r
  })));
}
var d$ = ["children"];
function h$(e, t) {
  if (e == null) return {};
  var r, n, i = v$(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function v$(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function ja() {
  return ja = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ja.apply(null, arguments);
}
var p$ = {
  width: "100%",
  height: "100%",
  /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */
  display: "block"
}, m$ = /* @__PURE__ */ Le((e, t) => {
  var r = SA(), n = EA(), i = bp();
  if (!lr(r) || !lr(n))
    return null;
  var a = e.children, o = e.otherAttributes, u = e.title, l = e.desc, c, s;
  return o != null && (typeof o.tabIndex == "number" ? c = o.tabIndex : c = i ? 0 : void 0, typeof o.role == "string" ? s = o.role : s = i ? "application" : void 0), /* @__PURE__ */ A.createElement(Dh, ja({}, o, {
    title: u,
    desc: l,
    role: s,
    tabIndex: c,
    width: r,
    height: n,
    style: p$,
    ref: t
  }), a);
}), y$ = (e) => {
  var t = e.children, r = N(Qa);
  if (!r)
    return null;
  var n = r.width, i = r.height, a = r.y, o = r.x;
  return /* @__PURE__ */ A.createElement(Dh, {
    width: n,
    height: i,
    x: o,
    y: a
  }, t);
}, Oh = /* @__PURE__ */ Le((e, t) => {
  var r = e.children, n = h$(e, d$), i = Ye();
  return i ? /* @__PURE__ */ A.createElement(y$, null, /* @__PURE__ */ A.createElement(Ah, {
    isPanorama: !0
  }, r)) : /* @__PURE__ */ A.createElement(m$, ja({
    ref: t
  }, n), /* @__PURE__ */ A.createElement(Ah, {
    isPanorama: !1
  }, r));
});
function g$(e, t) {
  return A$(e) || w$(e, t) || x$(e, t) || b$();
}
function b$() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x$(e, t) {
  if (e) {
    if (typeof e == "string") return Sh(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Sh(e, t) : void 0;
  }
}
function Sh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function w$(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function A$(e) {
  if (Array.isArray(e)) return e;
}
function O$() {
  var e = oe(), t = be(null), r = g$(t, 2), n = r[0], i = r[1], a = N(Fw);
  return se(() => {
    if (n != null) {
      var o = n.getBoundingClientRect(), u = o.width / n.offsetWidth;
      H(u) && u !== a && e(Ow(u));
    }
  }, [n, e, a]), i;
}
function Eh(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function S$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eh(Object(r), !0).forEach(function(n) {
      E$(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Eh(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function E$(e, t, r) {
  return (t = _$(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _$(e) {
  var t = P$(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function P$(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function or() {
  return or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, or.apply(null, arguments);
}
function Da(e, t) {
  return T$(e) || C$(e, t) || k$(e, t) || I$();
}
function I$() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k$(e, t) {
  if (e) {
    if (typeof e == "string") return _h(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _h(e, t) : void 0;
  }
}
function _h(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function C$(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], l = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(l = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); l = !0) ;
    } catch (s) {
      c = !0, i = s;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function T$(e) {
  if (Array.isArray(e)) return e;
}
var M$ = () => (iC(), null);
function Na(e) {
  if (typeof e == "number")
    return e;
  if (typeof e == "string") {
    var t = parseFloat(e);
    if (!Number.isNaN(t))
      return t;
  }
  return 0;
}
var j$ = /* @__PURE__ */ Le((e, t) => {
  var r, n, i = X(null), a = be({
    containerWidth: Na((r = e.style) === null || r === void 0 ? void 0 : r.width),
    containerHeight: Na((n = e.style) === null || n === void 0 ? void 0 : n.height)
  }), o = Da(a, 2), u = o[0], l = o[1], c = ne((f, d) => {
    l((h) => {
      var v = Math.round(f), p = Math.round(d);
      return h.containerWidth === v && h.containerHeight === p ? h : {
        containerWidth: v,
        containerHeight: p
      };
    });
  }, []), s = ne((f) => {
    if (typeof t == "function" && t(f), i.current != null && (i.current.disconnect(), i.current = null), f != null && typeof ResizeObserver < "u") {
      var d = f.getBoundingClientRect(), h = d.width, v = d.height;
      c(h, v);
      var p = (y) => {
        var b = y[0];
        if (b != null) {
          var w = b.contentRect, x = w.width, O = w.height;
          c(x, O);
        }
      }, m = new ResizeObserver(p);
      m.observe(f), i.current = m;
    }
  }, [t, c]);
  return se(() => () => {
    var f = i.current;
    f != null && f.disconnect();
  }, [c]), /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(ci, {
    width: u.containerWidth,
    height: u.containerHeight
  }), /* @__PURE__ */ A.createElement("div", or({
    ref: s
  }, e)));
}), D$ = /* @__PURE__ */ Le((e, t) => {
  var r = e.width, n = e.height, i = be({
    containerWidth: Na(r),
    containerHeight: Na(n)
  }), a = Da(i, 2), o = a[0], u = a[1], l = ne((s, f) => {
    u((d) => {
      var h = Math.round(s), v = Math.round(f);
      return d.containerWidth === h && d.containerHeight === v ? d : {
        containerWidth: h,
        containerHeight: v
      };
    });
  }, []), c = ne((s) => {
    if (typeof t == "function" && t(s), s != null) {
      var f = s.getBoundingClientRect(), d = f.width, h = f.height;
      l(d, h);
    }
  }, [t, l]);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(ci, {
    width: o.containerWidth,
    height: o.containerHeight
  }), /* @__PURE__ */ A.createElement("div", or({
    ref: c
  }, e)));
}), N$ = /* @__PURE__ */ Le((e, t) => {
  var r = e.width, n = e.height;
  return /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(ci, {
    width: r,
    height: n
  }), /* @__PURE__ */ A.createElement("div", or({
    ref: t
  }, e)));
}), $$ = /* @__PURE__ */ Le((e, t) => {
  var r = e.width, n = e.height;
  return typeof r == "string" || typeof n == "string" ? /* @__PURE__ */ A.createElement(D$, or({}, e, {
    ref: t
  })) : typeof r == "number" && typeof n == "number" ? /* @__PURE__ */ A.createElement(N$, or({}, e, {
    width: r,
    height: n,
    ref: t
  })) : /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(ci, {
    width: r,
    height: n
  }), /* @__PURE__ */ A.createElement("div", or({
    ref: t
  }, e)));
});
function L$(e) {
  return e ? j$ : $$;
}
var R$ = /* @__PURE__ */ Le((e, t) => {
  var r = e.children, n = e.className, i = e.height, a = e.onClick, o = e.onContextMenu, u = e.onDoubleClick, l = e.onMouseDown, c = e.onMouseEnter, s = e.onMouseLeave, f = e.onMouseMove, d = e.onMouseUp, h = e.onTouchEnd, v = e.onTouchMove, p = e.onTouchStart, m = e.style, y = e.width, b = e.responsive, w = e.dispatchTouchEvents, x = w === void 0 ? !0 : w, O = X(null), g = oe(), S = be(null), P = Da(S, 2), k = P[0], T = P[1], I = be(null), _ = Da(I, 2), L = _[0], D = _[1], F = O$(), K = dl(), V = (K == null ? void 0 : K.width) > 0 ? K.width : y, R = (K == null ? void 0 : K.height) > 0 ? K.height : i, q = ne((B) => {
    F(B), typeof t == "function" && t(B), T(B), D(B), B != null && (O.current = B);
  }, [F, t, T, D]), W = ne((B) => {
    g(Ng(B)), g(nt({
      handler: a,
      reactEvent: B
    }));
  }, [g, a]), he = ne((B) => {
    g(Wu(B)), g(nt({
      handler: c,
      reactEvent: B
    }));
  }, [g, c]), ve = ne((B) => {
    g(Oy()), g(nt({
      handler: s,
      reactEvent: B
    }));
  }, [g, s]), ce = ne((B) => {
    g(Wu(B)), g(nt({
      handler: f,
      reactEvent: B
    }));
  }, [g, f]), ze = ne(() => {
    g(Fg());
  }, [g]), qe = ne(() => {
    g(Wg());
  }, [g]), ht = ne((B) => {
    g(zg(B.key));
  }, [g]), vt = ne((B) => {
    g(nt({
      handler: o,
      reactEvent: B
    }));
  }, [g, o]), En = ne((B) => {
    g(nt({
      handler: u,
      reactEvent: B
    }));
  }, [g, u]), M = ne((B) => {
    g(nt({
      handler: l,
      reactEvent: B
    }));
  }, [g, l]), U = ne((B) => {
    g(nt({
      handler: d,
      reactEvent: B
    }));
  }, [g, d]), z = ne((B) => {
    g(nt({
      handler: p,
      reactEvent: B
    }));
  }, [g, p]), C = ne((B) => {
    x && g(Vg(B)), g(nt({
      handler: v,
      reactEvent: B
    }));
  }, [g, x, v]), je = ne((B) => {
    g(nt({
      handler: h,
      reactEvent: B
    }));
  }, [g, h]), ee = L$(b);
  return /* @__PURE__ */ A.createElement(Vy.Provider, {
    value: k
  }, /* @__PURE__ */ A.createElement(T0.Provider, {
    value: L
  }, /* @__PURE__ */ A.createElement(ee, {
    width: V ?? (m == null ? void 0 : m.width),
    height: R ?? (m == null ? void 0 : m.height),
    className: le("recharts-wrapper", n),
    style: S$({
      position: "relative",
      cursor: "default",
      width: V,
      height: R
    }, m),
    onClick: W,
    onContextMenu: vt,
    onDoubleClick: En,
    onFocus: ze,
    onBlur: qe,
    onKeyDown: ht,
    onMouseDown: M,
    onMouseEnter: he,
    onMouseLeave: ve,
    onMouseMove: ce,
    onMouseUp: U,
    onTouchEnd: je,
    onTouchMove: C,
    onTouchStart: z,
    ref: q
  }, /* @__PURE__ */ A.createElement(M$, null), r)));
}), B$ = ["width", "height", "responsive", "children", "className", "style", "compact", "title", "desc"];
function z$(e, t) {
  if (e == null) return {};
  var r, n, i = F$(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) r = a[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function F$(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var W$ = /* @__PURE__ */ Le((e, t) => {
  var r = e.width, n = e.height, i = e.responsive, a = e.children, o = e.className, u = e.style, l = e.compact, c = e.title, s = e.desc, f = z$(e, B$), d = ur(f);
  return l ? /* @__PURE__ */ A.createElement(A.Fragment, null, /* @__PURE__ */ A.createElement(ci, {
    width: r,
    height: n
  }), /* @__PURE__ */ A.createElement(Oh, {
    otherAttributes: d,
    title: c,
    desc: s
  }, a)) : /* @__PURE__ */ A.createElement(R$, {
    className: o,
    style: u,
    width: r,
    height: n,
    responsive: i ?? !1,
    onClick: e.onClick,
    onMouseLeave: e.onMouseLeave,
    onMouseEnter: e.onMouseEnter,
    onMouseMove: e.onMouseMove,
    onMouseDown: e.onMouseDown,
    onMouseUp: e.onMouseUp,
    onContextMenu: e.onContextMenu,
    onDoubleClick: e.onDoubleClick,
    onTouchStart: e.onTouchStart,
    onTouchMove: e.onTouchMove,
    onTouchEnd: e.onTouchEnd
  }, /* @__PURE__ */ A.createElement(Oh, {
    otherAttributes: d,
    title: c,
    desc: s,
    ref: t
  }, /* @__PURE__ */ A.createElement(fj, null, a)));
});
function Uu() {
  return Uu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Uu.apply(null, arguments);
}
function Ph(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function U$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ph(Object(r), !0).forEach(function(n) {
      K$(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ph(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function K$(e, t, r) {
  return (t = V$(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function V$(e) {
  var t = H$(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function H$(e, t) {
  if (typeof e != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var G$ = {
  top: 5,
  right: 5,
  bottom: 5,
  left: 5
}, Y$ = U$({
  accessibilityLayer: !0,
  barCategoryGap: "10%",
  barGap: 4,
  layout: "horizontal",
  margin: G$,
  responsive: !1,
  reverseStackOrder: !1,
  stackOffset: "none",
  syncMethod: "index"
}, Gg), q$ = /* @__PURE__ */ Le(function(t, r) {
  var n, i = st(t.categoricalChartProps, Y$), a = t.chartName, o = t.defaultTooltipEventType, u = t.validateTooltipEventTypes, l = t.tooltipPayloadSearcher, c = t.categoricalChartProps, s = {
    chartName: a,
    defaultTooltipEventType: o,
    validateTooltipEventTypes: u,
    tooltipPayloadSearcher: l,
    eventEmitter: void 0
  };
  return /* @__PURE__ */ A.createElement(o$, {
    preloadedState: {
      options: s
    },
    reduxStoreName: (n = c.id) !== null && n !== void 0 ? n : a
  }, /* @__PURE__ */ A.createElement(XM, {
    chartData: c.data
  }), /* @__PURE__ */ A.createElement(l$, {
    layout: i.layout,
    margin: i.margin
  }), /* @__PURE__ */ A.createElement(f$, {
    throttleDelay: i.throttleDelay,
    throttledEvents: i.throttledEvents
  }), /* @__PURE__ */ A.createElement(c$, {
    baseValue: i.baseValue,
    accessibilityLayer: i.accessibilityLayer,
    barCategoryGap: i.barCategoryGap,
    maxBarSize: i.maxBarSize,
    stackOffset: i.stackOffset,
    barGap: i.barGap,
    barSize: i.barSize,
    syncId: i.syncId,
    syncMethod: i.syncMethod,
    className: i.className,
    reverseStackOrder: i.reverseStackOrder
  }), /* @__PURE__ */ A.createElement(W$, Uu({}, i, {
    ref: r
  })));
}), X$ = ["axis", "item"], qg = /* @__PURE__ */ Le((e, t) => /* @__PURE__ */ A.createElement(q$, {
  chartName: "BarChart",
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: X$,
  tooltipPayloadSearcher: Wk,
  categoricalChartProps: e,
  ref: t
}));
const Z$ = "_wrapper_i9pgh_35", Q$ = "_tabs_i9pgh_44", J$ = "_barChartWrapper_i9pgh_50", eL = "_bidirectionalBarChartWrapper_i9pgh_51", tL = "_compactBarChartWrapper_i9pgh_54", rL = "_compactBidirectionalBarChartWrapper_i9pgh_55", nL = "_otherLines_i9pgh_160", iL = "_alternativeLines_i9pgh_167", aL = "_slider_i9pgh_174", oL = "_primaryAxis_i9pgh_183", uL = "_xAxisLabel_i9pgh_195", it = {
  wrapper: Z$,
  tabs: Q$,
  barChartWrapper: J$,
  bidirectionalBarChartWrapper: eL,
  compactBarChartWrapper: tL,
  compactBidirectionalBarChartWrapper: rL,
  otherLines: nL,
  alternativeLines: iL,
  slider: aL,
  primaryAxis: oL,
  xAxisLabel: uL
};
var ri = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.COMPACT = "compact", e))(ri || {});
const lL = (e, t, r, n) => {
  const i = [...e].sort((o, u) => new Date(u.startTime).getTime() - new Date(o.startTime).getTime()).slice(0, n);
  let a = i;
  return t === "Home" ? a = i.filter((o) => o.participant.side === "HOME") : t === "Away" ? a = i.filter((o) => o.participant.side === "AWAY") : t === "versus" && r && (a = i.filter(
    (o) => o.homeTeam.participantId === r.participantId || o.awayTeam.participantId === r.participantId
  )), a.reverse();
};
function Xg({ historyData: e, limit: t, oppositionTeam: r, trackEvent: n }) {
  const [i, a] = be("All"), o = Ve(
    () => lL(e, i, r, t),
    [e, i, r, t]
  ), u = Ve(
    () => e.length === 0 ? 0 : Math.max(...e.map((f) => f.participant.betStat)),
    [e]
  ), l = Ve(() => (u.toString().length + 1) * 8, [u]), c = Ve(() => o.some(
    (f) => f.homeTeam.participantId === (r == null ? void 0 : r.participantId) || f.awayTeam.participantId === (r == null ? void 0 : r.participantId)
  ), [o, r]);
  return {
    selectedFilterType: i,
    filteredData: o,
    maxBetStat: u,
    yAxisWidth: l,
    shouldShowVersusTab: c,
    changeFilterType: (f) => {
      n == null || n("match_venue_change", {
        eventLabel: "Match Venue Change",
        selection: f
      }), a(f);
    }
  };
}
function Zg(e, t) {
  const [r, n] = be(!1);
  return se(() => {
    const i = e.current;
    if (!i) return;
    const a = new ResizeObserver((u) => {
      for (const l of u) {
        const c = l.contentRect.width;
        n(c >= t);
      }
    });
    a.observe(i);
    const o = i.getBoundingClientRect().width;
    return n(o >= t), () => {
      a.disconnect();
    };
  }, [e, t]), r;
}
const cL = ({ payload: e, x: t, y: r }) => e ? /* @__PURE__ */ G("g", { transform: `translate(${t},${r})`, children: /* @__PURE__ */ G("text", { className: it.xAxisLabel, dy: 4, style: { fontSize: "12px" }, textAnchor: "end", x: 0, y: 0, children: e.value }) }) : null, sL = (e, t = !1) => t ? e.participant.side === "HOME" ? e.awayTeam.shortName : `@${e.homeTeam.shortName}` : e.participant.side === "HOME" ? `${e.awayTeam.shortName} (H)` : `${e.homeTeam.shortName} (A)`, fL = (e, t = !1) => {
  const r = new Date(e.startTime), n = r.getMonth() + 1, i = r.getDate();
  return t ? `${n}/${i}` : `${i}/${n}`;
}, Qg = ({
  americanFormat: e,
  isContainerWide: t
}) => ({
  axisLine: !1,
  className: it.primaryAxis,
  dataKey: (r) => sL(r, e),
  fontSize: 12,
  height: t ? 5 : 45,
  interval: 0,
  tick: /* @__PURE__ */ G(cL, {}),
  tickLine: !1
}), Jg = ({ americanFormat: e, className: t }) => ({
  allowDuplicatedCategory: !1,
  axisLine: !1,
  ...t === void 0 ? {} : { className: t },
  dataKey: (r) => fL(r, e),
  dy: 5,
  fontSize: 10,
  tick: { fill: "var(--cxy-color-content-default)", className: "dateAxis" },
  tickLine: !1,
  xAxisId: "1"
}), $t = {
  CHAR_WIDTH: 6,
  PADDING: 3,
  HEIGHT: 13,
  VERTICAL_OFFSET: 7.5,
  FONT_SIZE: 10,
  BACKGROUND_FILL: "var(--cxy-color-content-default)",
  TEXT_FILL: "var(--cxy-color-reference-line-label, var(--cxy-color-content-contrast))"
}, dL = ({ value: e, viewBox: t }) => {
  if (!t || !("x" in t) || !("y" in t) || !("width" in t)) return null;
  const { width: r, x: n, y: i } = t, a = e.toString().length * $t.CHAR_WIDTH + $t.PADDING, o = n + r, u = o + a / 2;
  return /* @__PURE__ */ Wt("g", { children: [
    /* @__PURE__ */ G(
      "rect",
      {
        fill: $t.BACKGROUND_FILL,
        height: $t.HEIGHT,
        rx: 2,
        width: a,
        x: o,
        y: i - $t.VERTICAL_OFFSET
      }
    ),
    /* @__PURE__ */ G(
      "text",
      {
        "data-testid": "reference-line-label",
        dominantBaseline: "middle",
        fill: $t.TEXT_FILL,
        fontSize: $t.FONT_SIZE,
        fontWeight: 600,
        textAnchor: "middle",
        x: u,
        y: i,
        children: e
      }
    )
  ] });
}, e0 = ({
  customLabels: e = { All: "All", Home: "Home", Away: "Away", versus: "vs" },
  fullTabsWidth: t = !1,
  oppositionTeam: r,
  selectedFilterType: n,
  setSelectedFilterType: i,
  shouldShowVersusTab: a
}) => /* @__PURE__ */ G(o0, { className: it.tabs, onValueChange: i, value: n, children: /* @__PURE__ */ Wt(u0, { fullWidth: t, children: [
  /* @__PURE__ */ G(Si, { value: "All", children: e.All }),
  /* @__PURE__ */ G(Si, { value: "Home", children: e.Home }),
  /* @__PURE__ */ G(Si, { value: "Away", children: e.Away }),
  a && r && /* @__PURE__ */ Wt(Si, { value: "versus", children: [
    e.versus,
    " ",
    r.shortName
  ] })
] }) });
function AL({
  alternativeLines: e = "Alternative Lines",
  americanFormat: t = !1,
  barRadius: r = 0,
  customLabels: n = { All: "All", Home: "Home", Away: "Away", versus: "vs" },
  flipBarSuccess: i = !1,
  fullTabsWidth: a = !1,
  historyData: o,
  limit: u,
  line: l,
  oppositionTeam: c,
  trackEvent: s,
  variant: f = ri.DEFAULT
}) {
  const d = X(null), [h, v] = be(Number.isFinite(l) ? Number(l) : null), { changeFilterType: p, filteredData: m, maxBetStat: y, selectedFilterType: b, shouldShowVersusTab: w, yAxisWidth: x } = Xg({
    historyData: o,
    limit: u,
    oppositionTeam: c,
    trackEvent: s
  }), O = f === ri.COMPACT, g = Zg(d, 769), S = Ve(() => Array.from({ length: y + 1 }, (I, _) => _), [y]), P = Ve(() => {
    const I = {
      top: 10,
      right: 0,
      left: 0,
      bottom: 0
    };
    if (h === null)
      return I;
    const L = (y.toString().length + 1) * $t.CHAR_WIDTH + $t.PADDING;
    return {
      ...I,
      right: L
    };
  }, [h, y]), k = (I, _, L = 0, D = !1) => Number.isFinite(_) ? I.participant.betStat > L ? D ? "bar-below" : "bar-above" : D ? "bar-above" : "bar-below" : I.participant.betResult === "WON" ? "bar-above" : "bar-below", T = (I) => {
    s == null || s("lines_selection", {
      eventLabel: "Lines Selection",
      selection: I[0]
    }), v(I[0]);
  };
  return /* @__PURE__ */ G("div", { className: it.wrapper, "data-cxy-name": "bar-chart", ref: d, children: /* @__PURE__ */ Wt("div", { children: [
    !O && /* @__PURE__ */ G(
      e0,
      {
        customLabels: n,
        fullTabsWidth: a,
        oppositionTeam: c,
        selectedFilterType: b,
        setSelectedFilterType: p,
        shouldShowVersusTab: w
      }
    ),
    /* @__PURE__ */ G("div", { className: O ? it.compactBarChartWrapper : it.barChartWrapper, children: /* @__PURE__ */ G(vp, { height: "100%", width: "100%", children: /* @__PURE__ */ Wt(qg, { data: m, margin: P, children: [
      !O && /* @__PURE__ */ Wt(Ih, { children: [
        /* @__PURE__ */ G(ti, { ...Qg({ americanFormat: t, isContainerWide: g }) }),
        /* @__PURE__ */ G(ti, { ...Jg({ americanFormat: t }) })
      ] }),
      /* @__PURE__ */ G(
        Oc,
        {
          axisLine: !1,
          domain: [0, y],
          fontSize: 12,
          tickLine: !1,
          ticks: S,
          width: x
        }
      ),
      /* @__PURE__ */ G(Ac, { dataKey: "participant.betStat", radius: r, children: m.map((I, _) => /* @__PURE__ */ G(
        go,
        {
          className: k(I, l, h ?? 0, i)
        },
        `cell-${_}`
      )) }),
      h !== null && /* @__PURE__ */ G(yc, { y: h, children: /* @__PURE__ */ G(Rt, { content: (I) => /* @__PURE__ */ G(dL, { ...I, value: h }) }) })
    ] }) }) }),
    !O && /* @__PURE__ */ G("div", { className: it.otherLines, children: /* @__PURE__ */ G("div", { className: it.alternativeLines, children: h !== null && /* @__PURE__ */ G(
      a0,
      {
        className: it.slider,
        label: e,
        max: y,
        min: 0,
        onValueChange: T,
        shouldShowBackground: !0,
        shouldShowLabel: !0,
        step: 0.5,
        value: [h]
      }
    ) }) })
  ] }) });
}
function OL({
  americanFormat: e = !1,
  barRadius: t = 0,
  customLabels: r = { All: "All", Home: "Home", Away: "Away", versus: "vs" },
  fullTabsWidth: n = !1,
  historyData: i,
  limit: a,
  oppositionTeam: o,
  trackEvent: u,
  variant: l = ri.DEFAULT
}) {
  const c = X(null), { changeFilterType: s, filteredData: f, maxBetStat: d, selectedFilterType: h, shouldShowVersusTab: v, yAxisWidth: p } = Xg({
    historyData: i,
    limit: a,
    oppositionTeam: o,
    trackEvent: u
  }), m = [-d, d], y = l === ri.COMPACT, b = Zg(c, 769), w = y ? { top: 0, right: 0, left: 0, bottom: 0 } : void 0;
  return /* @__PURE__ */ G("div", { className: it.wrapper, ref: c, children: /* @__PURE__ */ Wt("div", { children: [
    !y && /* @__PURE__ */ G(
      e0,
      {
        customLabels: r,
        fullTabsWidth: n,
        oppositionTeam: o,
        selectedFilterType: h,
        setSelectedFilterType: s,
        shouldShowVersusTab: v
      }
    ),
    /* @__PURE__ */ G("div", { className: y ? it.compactBidirectionalBarChartWrapper : it.bidirectionalBarChartWrapper, children: /* @__PURE__ */ G(vp, { height: "100%", width: "100%", children: /* @__PURE__ */ Wt(qg, { barCategoryGap: "5%", barGap: 0, data: f, margin: w, children: [
      /* @__PURE__ */ G(
        yC,
        {
          contentStyle: {
            backgroundColor: "var(--cxy-color-white)",
            border: "var(--cxy-border-default)"
          },
          cursor: { fill: "transparent" },
          formatter: (x, O, g) => {
            const S = g.payload;
            return S ? [`${S.participant.betResult}`, `${S.awayTeam.name} @ ${S.homeTeam.name}`] : null;
          },
          labelFormatter: () => "",
          labelStyle: {
            color: "var(--cxy-color-content-dark)"
          }
        }
      ),
      !y && /* @__PURE__ */ Wt(Ih, { children: [
        /* @__PURE__ */ G(ti, { ...Qg({ americanFormat: e, isContainerWide: b }) }),
        /* @__PURE__ */ G(ti, { ...Jg({ americanFormat: e, className: "dateAxis" }) })
      ] }),
      /* @__PURE__ */ G(Oc, { axisLine: !1, domain: m, fontSize: 12, tickLine: !1, width: p }),
      /* @__PURE__ */ G(Ac, { dataKey: "participant.betStat", radius: t, children: f.map((x, O) => /* @__PURE__ */ G(go, { className: x.participant.betStat > 0 ? "bar-above" : "bar-below" }, `cell-${O}`)) }),
      /* @__PURE__ */ G(yc, { stroke: "#666", y: 0 })
    ] }) }) })
  ] }) });
}
export {
  AL as BarChart,
  OL as BidirectionalBarChart,
  ri as ChartVariant
};
